



// import { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { useAuth } from "../context/AuthContext";
// import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";
// import api from "../api";
// import toast from "react-hot-toast";
// // import AdminGallary from "../admin/AdminGallery";

// const NAV = [
//   { label: "Dashboard", key: "dashboard" },
//   { label: "Members", key: "members", children: ["All Members", "Pending Approval", "Approved Members"] },
//   { label: "My Team", key: "myteam", children: ["Level Wise Report", "Network Tree"] },
//   { label: "Incentive", key: "incentive", children: ["Commission Report", "Level Income Report"] },
//   { label: "Wallet", key: "wallet", children: ["Withdrawal Requests", "Approved Payouts"] },
//   { label: "Salary", key: "salary", children: ["Salary List", "Generate Salary"] },
//   { label: "Admin Management", key: "admins", children: ["All Admins", "Create Admin"] },
//     // { label: "Gallery", key: "gallery" },   // 👈 ADD THIS

//   { label: "Reports", key: "reports", children: ["Business Report", "Daily Joins"] },
// ];

// export default function SuperAdminDashboard() {
//   const { admin, logout } = useAuth();
//   const navigate = useNavigate();
//   const [stats, setStats] = useState(null);
//   const [coupons, setCoupons] = useState([]);
//   const [withdrawals, setWithdrawals] = useState([]);
//   const [salaries, setSalaries] = useState([]);
//   const [adminList, setAdminList] = useState([]);
//   const [activeMenu, setActiveMenu] = useState("dashboard");
//   const [activeSubMenu, setActiveSubMenu] = useState("");
//   const [openNav, setOpenNav] = useState({});
//   const [search, setSearch] = useState("");
//   const [newAdmin, setNewAdmin] = useState({ username: "", password: "", full_name: "", mobile: "", role: "admin" });

//   useEffect(() => { fetchStats(); fetchCoupons(); fetchWithdrawals(); fetchSalaries(); }, []);

//   const fetchStats = async () => {
//     try { const r = await api.get("/mlm/super-stats"); setStats(r.data); } catch {}
//   };
//   const fetchCoupons = async (q = "") => {
//     try { const r = await api.get(`/coupons/all?search=${q}&limit=200`); setCoupons(r.data.rows || []); } catch {}
//   };
//   const fetchWithdrawals = async () => {
//     try { const r = await api.get("/wallet/withdrawals/all?status=pending"); setWithdrawals(r.data.rows || []); } catch {}
//   };
//   const fetchSalaries = async () => {
//     try { const r = await api.get("/mlm/salary/list"); setSalaries(r.data.rows || []); } catch {}
//   };
//   const fetchAdmins = async () => {
//     try { const r = await api.get("/auth/admins"); setAdminList(r.data || []); } catch {}
//   };


//   const [myTeam, setMyTeam] = useState([]);
//   const [networkTree, setNetworkTree] = useState([]);
  
  
//   // fetch when submenu clicked
//   const fetchMyTeam = async (child) => {
//     try {
//       if (child === "Level Wise Report") {
//         const r = await api.get("/mlm/myteam/level-wise");
//         setMyTeam(r.data || []);
//       } else if (child === "Network Tree") {
//         const r = await api.get("/mlm/myteam/network-tree");
//         setNetworkTree(r.data || []);
//       }
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   // const approveCoupon = async (id) => {
//   //   try { await api.post(`/coupons/approve/${id}`); toast.success("Approved!"); fetchCoupons(search); fetchStats(); }
//   //   catch (err) { toast.error(err.response?.data?.message || "Error"); }
//   // };
//   const approveCoupon = async (c) => {
//   try {
//     await api.post(`/coupons/approve/${c.id}`);

//     // WhatsApp message
//     const message = `Welcome ${c.receiver_name} 🎉

// Your ID ${c.receiver_coupon_no} has been approved successfully.

// Welcome to Meruram family 🚀`;

//     const whatsappURL = `https://wa.me/91${c.receiver_mobile}?text=${encodeURIComponent(message)}`;

//     window.open(whatsappURL, "_blank");

//     toast.success("Approved & WhatsApp Opened!");
//     fetchCoupons(search);
//     fetchStats();
//   } catch (err) {
//     toast.error("Error approving");
//   }
// };

//   const deleteCoupon = async (id) => {
//     if (!window.confirm("Delete this coupon?")) return;
//     try { await api.delete(`/coupons/delete/${id}`); toast.success("Deleted"); fetchCoupons(search); }
//     catch { toast.error("Delete failed"); }
//   };

//   const processWithdrawal = async (id, action) => {
//     try { await api.put(`/wallet/withdrawals/${id}`, { action }); toast.success(`${action}!`); fetchWithdrawals(); }
//     catch (err) { toast.error(err.response?.data?.message || "Error"); }
//   };

//   const approveSalary = async (id) => {
//     try { await api.put(`/mlm/salary/approve/${id}`); toast.success("Salary credited!"); fetchSalaries(); }
//     catch (err) { toast.error(err.response?.data?.message || "Error"); }
//   };

//   const generateSalary = async () => {
//     try { const r = await api.post("/mlm/salary/generate"); toast.success(r.data.message); fetchSalaries(); }
//     catch (err) { toast.error(err.response?.data?.message || "Error"); }
//   };

//   const createAdmin = async () => {
//     try { await api.post("/auth/create-admin", newAdmin); toast.success("Admin created!"); setNewAdmin({ username: "", password: "", full_name: "", mobile: "", role: "admin" }); fetchAdmins(); }
//     catch (err) { toast.error(err.response?.data?.message || "Error"); }
//   };

//   const handleNav = (key, child = "") => {
//     setActiveMenu(key);
//     setActiveSubMenu(child);
//     if (key === "admins") fetchAdmins();
//     if (child === "All Members" || child === "Pending Approval" || child === "Approved Members") fetchCoupons(search);
//     if (child === "Withdrawal Requests") fetchWithdrawals();
//     if (child === "Salary List" || child === "Generate Salary") fetchSalaries();
//     if (child === "myteam") fetchMyTeam(child);
//   };

//   const toggleNav = (key) => setOpenNav(p => ({ ...p, [key]: !p[key] }));

//   const filteredCoupons = activeSubMenu === "Pending Approval"
//     ? coupons.filter(c => !c.is_approved)
//     : activeSubMenu === "Approved Members"
//     ? coupons.filter(c => c.is_approved)
//     : coupons;

//   return (
//     <div style={S.shell}>
//       {/* TOPBAR */}
//       <div style={S.topbar}>
//         <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
//           <div style={S.logo}>▲</div>
//           <span style={{ fontSize: 11, color: "#aac", letterSpacing: 2 }}>Meruram</span>
//         </div>
//         <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
//           <span>🏠</span><span>➕</span>
//           <span style={{ fontSize: 12 }}>Welcome : <b>{admin?.full_name || admin?.username}(Super Admin)</b> ▾</span>
//         </div>
//       </div>

//       <div style={{ display: "flex", flex: 1 }}>
//         {/* SIDEBAR */}
//         <div style={S.sidebar}>
//           {NAV.map(nav => (
//             <div key={nav.key}>
//               <div style={{ ...S.navItem, ...(activeMenu === nav.key && !activeSubMenu && !nav.children ? S.navActive : {}) }}
//                 onClick={() => nav.children ? toggleNav(nav.key) : handleNav(nav.key)}>
//                 <span style={{ fontSize: 10, opacity: .5 }}>→</span>
//                 <span style={{ flex: 1 }}>{nav.label}</span>
//                 {nav.children && <span style={{ fontSize: 10 }}>{openNav[nav.key] ? "▼" : "▶"}</span>}
//               </div>
//               {nav.children && openNav[nav.key] && nav.children.map(child => (
//                 <div key={child} style={{ ...S.navSub, ...(activeSubMenu === child ? S.navSubActive : {}) }}
//                   onClick={() => handleNav(nav.key, child)}>{child}</div>
//               ))}
//             </div>
//           ))}
//           <div style={S.navItem} onClick={() => { logout(); navigate("/superadmin/login"); }}>
//             <span style={{ fontSize: 10, opacity: .5 }}>→</span> <span>Logout</span>
//           </div>
//         </div>

//         {/* CONTENT */}
//         <div style={S.main}>

//           {/* ─── DASHBOARD ─── */}
//           {activeMenu === "dashboard" && !activeSubMenu && stats && (
//             <div>
//               <h2 style={S.pageTitle}>Dashboard</h2>

//               {/* Row 1 */}
//               <div style={S.row}>
//                 {[
//                   ["Total Members", stats.total_members, "👥", "#e74c3c"],
//                   ["Approved", stats.approved, "✅", "#27ae60"],
//                   ["Pending", stats.pending, "⏳", "#f39c12"],
//                   ["Pending Payouts", stats.pending_payouts, "💸", "#8e44ad"],
//                 ].map(([label, val, icon, bg]) => (
//                   <div key={label} style={{ ...S.statCard, background: bg }}>
//                     <div style={{ fontSize: 24, fontWeight: 700 }}>{icon} {val}</div>
//                     <div style={{ fontSize: 11, marginTop: 4, opacity: .9 }}>{label}</div>
//                   </div>
//                 ))}
//               </div>

//               {/* Row 2 */}
//               <div style={S.row}>
//                 {[
//                   ["Total Wallet Balance", `₹${Number(stats.total_wallet || 0).toLocaleString()}`],
//                   ["Total Commission Paid", `₹${Number(stats.total_commission || 0).toLocaleString()}`],
//                   ["Pending Salary", stats.pending_salary],
//                   ["Total Admins", adminList.length || "—"],
//                 ].map(([label, val]) => (
//                   <div key={label} style={S.bonusCard}>
//                     <div style={{ fontSize: 11, color: "#777", marginBottom: 6 }}>{label}</div>
//                     <div style={{ fontSize: 20, fontWeight: 700, color: "#2c3e7a" }}>{val}</div>
//                   </div>
//                 ))}
//               </div>

//               {/* Charts */}
//               <div style={{ display: "flex", gap: 12, marginTop: 4, flexWrap: "wrap" }}>
//                 <div style={{ ...S.panel, flex: 2, minWidth: 300 }}>
//                   <div style={S.panelHead}>📅 Daily Joins (Last 14 Days)</div>
//                   <div style={{ padding: 16 }}>
//                     <ResponsiveContainer width="100%" height={200}>
//                       <BarChart data={stats.daily_joins || []}>
//                         <XAxis dataKey="date" tick={{ fontSize: 10 }} />
//                         <YAxis tick={{ fontSize: 10 }} />
//                         <Tooltip />
//                         <Bar dataKey="count" fill="#2c3e7a" radius={[3, 3, 0, 0]} />
//                       </BarChart>
//                     </ResponsiveContainer>
//                   </div>
//                 </div>

//                 {/* Rank dist */}
//                 <div style={{ ...S.panel, flex: 1, minWidth: 220 }}>
//                   <div style={S.panelHead}>🏆 Rank Distribution</div>
//                   <div style={{ padding: 16 }}>
//                     {(stats.rank_dist || []).map(r => (
//                       <div key={r.rank} style={{ display: "flex", justifyContent: "space-between", padding: "6px 0", borderBottom: "1px solid #eee", fontSize: 12 }}>
//                         <span style={{ textTransform: "capitalize" }}>{r.rank}</span>
//                         <span style={S.green}>{r.count}</span>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               </div>

//               {/* Recent coupons */}
//               <div style={{ ...S.panel, marginTop: 12 }}>
//                 <div style={S.panelHead}>🎟️ Recent Registrations</div>
//                 <table style={S.table}>
//                   <thead><tr style={S.thead}>
//                     {["Coupon#", "Name", "Mobile", "Giver", "Payment", "Status", "Date"].map(h => <th key={h} style={S.th}>{h}</th>)}
//                   </tr></thead>
//                   <tbody>
//                     {coupons.slice(0, 8).map((c, i) => (
//                       <tr key={c.id} style={i % 2 === 0 ? { background: "#f9f9f9" } : {}}>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#2c3e7a" }}>{c.receiver_coupon_no || "—"}</td>
//                         <td style={S.td}>{c.receiver_name}</td>
//                         <td style={S.td}>{c.receiver_mobile}</td>
//                         <td style={S.td}>{c.giver_name}</td>
//                         <td style={S.td}><span style={S.badge}>{c.payment_cash ? "Cash" : "Online"}</span></td>
//                         <td style={S.td}><span style={c.is_approved ? S.green : S.yellow}>{c.is_approved ? "Approved" : "Pending"}</span></td>
//                         <td style={S.td}>{new Date(c.created_at).toLocaleDateString()}</td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}

//           {/* ─── ALL / FILTERED MEMBERS ─── */}
//           {(activeSubMenu === "All Members" || activeSubMenu === "Pending Approval" || activeSubMenu === "Approved Members") && (
//             <div>
//               <div style={S.sectionHead}>🎟️ {activeSubMenu}</div>
//               <div style={S.panel}>
//                 <div style={{ padding: "12px 16px", display: "flex", gap: 10, alignItems: "center" }}>
//                   <input style={{ ...S.input, maxWidth: 280 }} placeholder="Search name, mobile, coupon#..." value={search}
//                     onChange={e => { setSearch(e.target.value); fetchCoupons(e.target.value); }} />
//                   <span style={{ fontSize: 12, color: "#777" }}>Total: {filteredCoupons.length}</span>
//                 </div>
//                 <table style={S.table}>
//                   <thead><tr style={S.thead}>
//                     {["SNo", "Coupon#", "Name", "Mobile", "Aadhaar", "Giver", "Payment", "Screenshot", "Status", "Rank", "Date", "Actions"].map(h => <th key={h} style={S.th}>{h}</th>)}
//                   </tr></thead>
//                   <tbody>
//                     {filteredCoupons.map((c, i) => (
//                       <tr key={c.id} style={i % 2 === 0 ? { background: "#f9f9f9" } : {}}>
//                         <td style={S.td}>{i + 1}</td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#2c3e7a" }}>{c.receiver_coupon_no || "—"}</td>
//                         <td style={S.td}>{c.receiver_name}</td>
//                         <td style={S.td}>{c.receiver_mobile}</td>
//                         <td style={S.td}>{c.receiver_aadhaar ? "••••" + c.receiver_aadhaar.slice(-4) : "—"}</td>
//                         <td style={S.td}>{c.giver_name}</td>
//                         <td style={S.td}><span style={S.badge}>{c.payment_cash ? "Cash" : "Online"}</span></td>
//                         <td style={S.td}>
//                           {c.screenshot
//                             ? <a href={`/uploads/${c.screenshot}`} target="_blank" rel="noreferrer" style={{ color: "#2c3e7a", fontSize: 12 }}>View SS</a>
//                             : "—"}
//                         </td>
//                         <td style={S.td}><span style={c.is_approved ? S.green : S.yellow}>{c.is_approved ? "Approved" : "Pending"}</span></td>
//                         <td style={S.td} >{c.rank}</td>
//                         <td style={S.td}>{new Date(c.created_at).toLocaleDateString()}</td>
//                         <td style={S.td}>
//                           <div style={{ display: "flex", gap: 4 }}>
//                             {!c.is_approved && (
//                               <button style={S.btnGreen} onClick={() => approveCoupon(c)}>
//   Approve
// </button>
//                             )}
//                             <button style={S.btnDanger} onClick={() => deleteCoupon(c.id)}>Del</button>
//                           </div>
//                         </td>
//                       </tr>
//                     ))}
//                     {filteredCoupons.length === 0 && <tr><td colSpan={12} style={{ ...S.td, textAlign: "center", color: "#aaa" }}>No records found</td></tr>}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}

//           {/* ─── WITHDRAWAL REQUESTS ─── */}
//           {activeSubMenu === "Withdrawal Requests" && (
//             <div>
//               <div style={S.sectionHead}>💸 Withdrawal Requests</div>
//               <div style={S.panel}>
//                 <table style={S.table}>
//                   <thead><tr style={S.thead}>
//                     {["#", "Member", "Mobile", "Amount", "Method", "Bank/UPI Details", "Date", "Actions"].map(h => <th key={h} style={S.th}>{h}</th>)}
//                   </tr></thead>
//                   <tbody>
//                     {withdrawals.map((w, i) => (
//                       <tr key={w.id} style={i % 2 === 0 ? { background: "#f9f9f9" } : {}}>
//                         <td style={S.td}>{w.id}</td>
//                         <td style={S.td}>{w.receiver_name}</td>
//                         <td style={S.td}>{w.receiver_mobile}</td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#27ae60" }}>₹{w.amount}</td>
//                         <td style={S.td}>{w.method?.toUpperCase()}</td>
//                         <td style={{ ...S.td, fontSize: 11 }}>
//                           {w.method === "bank"
//                             ? `${w.bank_name || "—"} | ${w.account_number || "—"} | ${w.ifsc || "—"}`
//                             : w.upi_id || "—"}
//                         </td>
//                         <td style={S.td}>{new Date(w.created_at).toLocaleDateString()}</td>
//                         <td style={S.td}>
//                           <div style={{ display: "flex", gap: 4 }}>
//                             <button style={S.btnGreen} onClick={() => processWithdrawal(w.id, "approved")}>Approve</button>
//                             <button style={S.btnDanger} onClick={() => processWithdrawal(w.id, "rejected")}>Reject</button>
//                           </div>
//                         </td>
//                       </tr>
//                     ))}
//                     {withdrawals.length === 0 && <tr><td colSpan={8} style={{ ...S.td, textAlign: "center", color: "#aaa" }}>No pending requests</td></tr>}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}

//           {/* ─── SALARY LIST ─── */}
//           {activeSubMenu === "Salary List" && (
//             <div>
//               <div style={S.sectionHead}>💰 Salary List</div>
//               <div style={S.panel}>
//                 <table style={S.table}>
//                   <thead><tr style={S.thead}>
//                     {["#", "Member", "Mobile", "Rank", "Amount", "Month", "Status", "Action"].map(h => <th key={h} style={S.th}>{h}</th>)}
//                   </tr></thead>
//                   <tbody>
//                     {salaries.map((s, i) => (
//                       <tr key={s.id} style={i % 2 === 0 ? { background: "#f9f9f9" } : {}}>
//                         <td style={S.td}>{i + 1}</td>
//                         <td style={S.td}>{s.receiver_name}</td>
//                         <td style={S.td}>{s.receiver_mobile}</td>
//                         <td style={S.td} >{s.rank}</td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#27ae60" }}>₹{s.amount}</td>
//                         <td style={S.td}>{s.month}</td>
//                         <td style={S.td}><span style={s.is_approved ? S.green : S.yellow}>{s.is_approved ? "Paid" : "Pending"}</span></td>
//                         <td style={S.td}>
//                           {!s.is_approved && <button style={S.btnGreen} onClick={() => approveSalary(s.id)}>Approve</button>}
//                         </td>
//                       </tr>
//                     ))}
//                     {salaries.length === 0 && <tr><td colSpan={8} style={{ ...S.td, textAlign: "center", color: "#aaa" }}>No salary records. Generate first.</td></tr>}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}

//           {/* ─── GENERATE SALARY ─── */}
//           {activeSubMenu === "Generate Salary" && (
//             <div>
//               <div style={S.sectionHead}>💰 Generate Salary</div>
//               <div style={S.panel}>
//                 <div style={{ padding: 24 }}>
//                   <p style={{ fontSize: 13, color: "#555", marginBottom: 16 }}>
//                     This will generate salary records for the current month for all eligible members (Silver and above ranks).
//                   </p>
//                   <button style={S.btnRed} onClick={generateSalary}>Generate This Month's Salary</button>
//                 </div>
//               </div>
//             </div>
//           )}
//           {activeMenu === "myteam" && activeSubMenu === "Level Wise Report" && (
//   <div>
//     <div style={S.sectionHead}>📊 Level Wise Report</div>
//     <div style={S.panel}>
//       <table style={S.table}>
//         <thead>
//           <tr style={S.thead}>
//             {["SNo", "Name", "Mobile", "Rank", "Sponsor", "Level", "Direct Downlines", "Screenshot", "Status"].map(h => <th key={h} style={S.th}>{h}</th>)}
//           </tr>
//         </thead>
//         <tbody>
//           {myTeam.map((m, i) => (
//             <tr key={m.token} style={i % 2 === 0 ? { background: "#f9f9f9" } : {}}>
//               <td style={S.td}>{i + 1}</td>
//               <td style={S.td}>{m.name}</td>
//               <td style={S.td}>{m.mobile}</td>
//               <td style={S.td}>{m.rank}</td>
//               <td style={S.td}>{m.sponsor}</td>
//               <td style={S.td}>{m.level}</td>
//               <td style={S.td}>{m.total_downlines}</td>
//               <td style={S.td}>
//                 {m.screenshot ? <a href={`/uploads/${m.screenshot}`} target="_blank" rel="noreferrer">View</a> : "—"}
//               </td>
//               <td style={S.td}>{m.is_approved ? "Approved" : "Pending"}</td>
//             </tr>
//           ))}
//           {myTeam.length === 0 && <tr><td colSpan={9} style={{ ...S.td, textAlign: "center" }}>No members found</td></tr>}
//         </tbody>
//       </table>
//     </div>
//   </div>
// )}

// {activeMenu === "myteam" && activeSubMenu === "Network Tree" && (
//   <div>
//     <div style={S.sectionHead}>🌳 Network Tree</div>
//     <div style={{ ...S.panel, padding: 16 }}>
//       {networkTree.map(member => (
//         <TreeNode key={member.token_number} node={member} />
//       ))}
//     </div>
//   </div>
// )}


//           {/* ─── ALL ADMINS ─── */}
//           {activeSubMenu === "All Admins" && (
//             <div>
//               <div style={S.sectionHead}>👥 All Admins</div>
//               <div style={S.panel}>
//                 <table style={S.table}>
//                   <thead><tr style={S.thead}>
//                     {["#", "Username", "Full Name", "Mobile", "Role", "Status", "Created"].map(h => <th key={h} style={S.th}>{h}</th>)}
//                   </tr></thead>
//                   <tbody>
//                     {adminList.map((a, i) => (
//                       <tr key={a.id} style={i % 2 === 0 ? { background: "#f9f9f9" } : {}}>
//                         <td style={S.td}>{i + 1}</td>
//                         <td style={S.td}><b>{a.username}</b></td>
//                         <td style={S.td}>{a.full_name}</td>
//                         <td style={S.td}>{a.mobile}</td>
//                         <td style={S.td}><span style={a.role === "superadmin" ? S.green : S.badge}>{a.role}</span></td>
//                         <td style={S.td}><span style={a.is_active ? S.green : S.red}>{a.is_active ? "Active" : "Inactive"}</span></td>
//                         <td style={S.td}>{new Date(a.created_at).toLocaleDateString()}</td>
//                       </tr>
//                     ))}
//                     {adminList.length === 0 && <tr><td colSpan={7} style={{ ...S.td, textAlign: "center", color: "#aaa" }}>No admins found</td></tr>}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}

//           {/* ─── CREATE ADMIN ─── */}
//           {activeSubMenu === "Create Admin" && (
//             <div>
//               <div style={S.sectionHead}>➕ Create New Admin</div>
//               <div style={S.panel}>
//                 <div style={{ padding: 24, maxWidth: 480 }}>
//                   {[
//                     ["Username *", "username", "text"],
//                     ["Password *", "password", "password"],
//                     ["Full Name", "full_name", "text"],
//                     ["Mobile", "mobile", "text"],
//                   ].map(([label, key, type]) => (
//                     <div key={key} style={S.formRow}>
//                       <label style={S.label}>{label}</label>
//                       <input style={S.input} type={type} value={newAdmin[key]}
//                         onChange={e => setNewAdmin({ ...newAdmin, [key]: e.target.value })} />
//                     </div>
//                   ))}
//                   <div style={S.formRow}>
//                     <label style={S.label}>Role</label>
//                     <select style={S.select} value={newAdmin.role}
//                       onChange={e => setNewAdmin({ ...newAdmin, role: e.target.value })}>
//                       <option value="admin">Admin</option>
//                       <option value="superadmin">Super Admin</option>
//                     </select>
//                   </div>
//                   <button style={S.btnRed} onClick={createAdmin}>Create Admin</button>
//                 </div>
//               </div>
//             </div>
//           )}

//           {activeMenu !== "dashboard" && !activeSubMenu && (
//             <div style={S.panel}><div style={{ padding: 20, color: "#999" }}>Select a submenu item.</div></div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }


// /* ── Styles ── */
// const S = {
//   shell: { display: "flex", flexDirection: "column", minHeight: "100vh", fontFamily: "Arial, sans-serif", fontSize: 13, background: "#f0f0f0" },
//   topbar: { background: "#2c3e7a", color: "#fff", display: "flex", justifyContent: "space-between", alignItems: "center", padding: "8px 16px", position: "sticky", top: 0, zIndex: 100 },
//   logo: { background: "#7d3c98", color: "#fff", width: 34, height: 34, borderRadius: 4, display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 900, fontSize: 18 },
//   sidebar: { width: 190, background: "#2c3e7a", minHeight: "calc(100vh - 52px)", flexShrink: 0 },
//   navItem: { color: "#c5cde8", padding: "11px 14px", cursor: "pointer", display: "flex", alignItems: "center", gap: 6, fontSize: 13, borderBottom: "1px solid rgba(255,255,255,.06)" },
//   navActive: { background: "#e74c3c", color: "#fff" },
//   navSub: { color: "#a0b0d0", padding: "9px 14px 9px 26px", cursor: "pointer", fontSize: 12, background: "rgba(0,0,0,.18)", borderBottom: "1px solid rgba(255,255,255,.04)" },
//   navSubActive: { background: "#e74c3c", color: "#fff" },
//   main: { flex: 1, padding: 16, overflowX: "auto" },
//   pageTitle: { fontSize: 22, fontWeight: 700, color: "#2c3e7a", marginBottom: 16 },
//   sectionHead: { background: "#e74c3c", color: "#fff", padding: "8px 14px", fontWeight: 600, borderRadius: "4px 4px 0 0" },
//   panel: { background: "#fff", border: "1px solid #ddd", borderRadius: 4, marginTop: 12 },
//   panelHead: { background: "#e74c3c", color: "#fff", padding: "8px 14px", fontWeight: 600, fontSize: 13 },
//   row: { display: "flex", gap: 10, marginBottom: 10, flexWrap: "wrap" },
//   statCard: { color: "#fff", borderRadius: 6, padding: "14px 18px", flex: 1, minWidth: 130 },
//   bonusCard: { background: "#fff", border: "1px solid #ddd", borderRadius: 6, padding: "14px 18px", flex: 1, minWidth: 130 },
//   table: { width: "100%", borderCollapse: "collapse" },
//   thead: { background: "#2c3e7a", color: "#fff" },
//   th: { padding: "8px 10px", textAlign: "left", fontSize: 12, fontWeight: 600, whiteSpace: "nowrap" },
//   td: { padding: "8px 10px", fontSize: 12, borderBottom: "1px solid #eee" },
//   green: { background: "#27ae60", color: "#fff", padding: "2px 8px", borderRadius: 3, fontSize: 11 },
//   red: { background: "#e74c3c", color: "#fff", padding: "2px 8px", borderRadius: 3, fontSize: 11 },
//   yellow: { background: "#f39c12", color: "#fff", padding: "2px 8px", borderRadius: 3, fontSize: 11 },
//   badge: { background: "#3498db", color: "#fff", padding: "2px 8px", borderRadius: 3, fontSize: 11 },
//   btnRed: { background: "#e74c3c", color: "#fff", border: "none", padding: "8px 20px", borderRadius: 3, cursor: "pointer", fontWeight: 600, fontSize: 13 },
//   btnGreen: { background: "#27ae60", color: "#fff", border: "none", padding: "5px 10px", borderRadius: 3, cursor: "pointer", fontSize: 12 },
//   btnDanger: { background: "#e74c3c", color: "#fff", border: "none", padding: "5px 10px", borderRadius: 3, cursor: "pointer", fontSize: 12 },
//   formRow: { marginBottom: 14 },
//   label: { display: "block", fontSize: 12, color: "#444", marginBottom: 4 },
//   input: { border: "1px solid #ccc", padding: "7px 10px", width: "100%", fontSize: 13, borderRadius: 3, outline: "none", boxSizing: "border-box" },
//   select: { border: "1px solid #ccc", padding: "7px 10px", fontSize: 13, borderRadius: 3 },
// };



// // Recursive tree node component
// function TreeNode({ node, level = 0 }) {
//   return (
//     <div style={{ marginLeft: level * 20, marginBottom: 4 }}>
//       <b>{node.receiver_name}</b> ({node.rank}) - {node.is_approved ? "✅" : "⏳"}
//       {node.children && node.children.map(c => <TreeNode key={c.token_number} node={c} level={level + 1} />)}
//     </div>
//   );
// }







// import { useState, useEffect, useCallback, useMemo } from "react";
// import { useNavigate } from "react-router-dom";
// import { useAuth } from "../context/AuthContext";
// import {
//   BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer,
//   PieChart, Pie, Cell, Legend, LineChart, Line
// } from "recharts";
// import api from "../api";
// import toast from "react-hot-toast";

// /* ─── Constants ─── */
// const LEVEL_RATE = { 1: 300, 2: 150, 3: 120, 4: 90, 5: 60, 6: 30 };
// const RANK_SALARY = { silver: 1000, gold: 3000, platinum: 7000, diamond: 15000 };
// const PIE_COLORS = ["#3b82f6", "#10b981", "#f59e0b", "#ef4444", "#8b5cf6", "#06b6d4"];
// const COMPANY = "Meruram Lucky Draw";
// const COMPANY_URL = "https://meruram.in";

// /* ─── WhatsApp helper ─── */
// const whatsapp = (mobile, msg) => {
//   if (!mobile) { toast.error("No mobile number!"); return; }
//   window.open(`https://wa.me/91${mobile.replace(/\D/g, "")}?text=${encodeURIComponent(msg)}`, "_blank");
// };

// /* ─── Format helpers ─── */
// const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
// const fmt = (d) => d ? new Date(d).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : "—";
// const fmtTime = (d) => d ? new Date(d).toLocaleString("en-IN") : "—";

// /* ─── Sidebar nav ─── */
// const NAV = [
//   { label: "📊 Dashboard", key: "dashboard" },
//   {
//     label: "🎟 Members", key: "members",
//     children: ["All Members", "Pending Approval", "Approved Members", "Member Detail"],
//   },
//   {
//     label: "💹 Income & Business", key: "income",
//     children: [
//       "Level Income Report",
//       "Level Wise Report",
//       "Commission Report",
//       "Direct Business Report",
//       "Business Report",
//       "Commission Summary",
//       "Daily Joins",
//       "Network Tree",
//     ],
//   },
//   {
//     label: "💸 Payments", key: "payments",
//     children: ["Withdrawal Requests", "Payment History", "Add Fund to Member"],
//   },
//   {
//     label: "💰 Salary", key: "salary",
//     children: ["Salary List", "Generate Salary"],
//   },
//   {
//     label: "🛡 Admin Mgmt", key: "admins",
//     children: ["All Admins", "Create Admin"],
//   },
// ];

// /* ══════════════════════════════════════════════
//    MAIN COMPONENT
// ══════════════════════════════════════════════ */
// export default function SuperAdminDashboard() {
//   const { admin, logout } = useAuth();
//   const navigate = useNavigate();

//   /* State */
//   const [stats, setStats] = useState(null);
//   const [allMembers, setAllMembers] = useState([]);
//   const [withdrawals, setWithdrawals] = useState([]);
//   const [payHistory, setPayHistory] = useState([]);
//   const [salaries, setSalaries] = useState([]);
//   const [adminList, setAdminList] = useState([]);
//   const [selectedMember, setSelectedMember] = useState(null);
//   const [memberDetail, setMemberDetail] = useState(null);
//   const [loadingDetail, setLoadingDetail] = useState(false);
//   const [commissions, setCommissions] = useState([]);
//   const [networkTree, setNetworkTree] = useState(null);
//   const [networkToken, setNetworkToken] = useState("");
//   const [dailyJoins, setDailyJoins] = useState([]);
//   const [generatingSalary, setGeneratingSalary] = useState(false);
//   const [repairing, setRepairing] = useState(false);
//   const [repairLog, setRepairLog] = useState([]);

//   const [tab, setTab] = useState("dashboard");
//   const [subTab, setSubTab] = useState("");
//   const [openNav, setOpenNav] = useState({ dashboard: true });
//   const [search, setSearch] = useState("");
//   const [approving, setApproving] = useState({});

//   const [addFundForm, setAddFundForm] = useState({ token_number: "", amount: "", description: "Fund added by admin" });
//   const [newAdmin, setNewAdmin] = useState({ username: "", password: "", full_name: "", mobile: "", role: "admin" });

//   /* ── Fetch functions ── */
//   const loadStats = useCallback(async () => {
//     try { const r = await api.get("/mlm/super-stats"); setStats(r.data); } catch { toast.error("Stats load failed"); }
//   }, []);

//   const loadMembers = useCallback(async (q = "") => {
//     try {
//       const r = await api.get(`/mlm/all-members-stats?search=${encodeURIComponent(q)}&limit=500`);
//       setAllMembers(r.data.rows || []);
//     } catch { toast.error("Members load failed"); }
//   }, []);

//   const loadWithdrawals = useCallback(async () => {
//     try { const r = await api.get("/wallet/withdrawals/all?status=pending"); setWithdrawals(r.data.rows || []); } catch {}
//   }, []);

//   const loadPayHistory = useCallback(async () => {
//     try { const r = await api.get("/mlm/payment-history"); setPayHistory(r.data.rows || []); } catch {}
//   }, []);

//   const loadSalaries = useCallback(async () => {
//     try { const r = await api.get("/mlm/salary/list"); setSalaries(r.data.rows || []); } catch {}
//   }, []);

//   const loadAdmins = useCallback(async () => {
//     try { const r = await api.get("/auth/admins"); setAdminList(r.data || []); } catch {}
//   }, []);

//   const loadMemberDetail = useCallback(async (token) => {
//     if (!token) return;
//     setLoadingDetail(true);
//     try {
//       const r = await api.get(`/mlm/member-detail/${token}`);
//       if (r.data.success) {
//         setMemberDetail(r.data);
//       } else {
//         toast.error("Member not found");
//       }
//     } catch { toast.error("Failed to load member detail"); }
//     setLoadingDetail(false);
//   }, []);

//   const loadCommissions = useCallback(async () => {
//     try {
//       const r = await api.get("/mlm/commissions/all?limit=500");
//       setCommissions(r.data.rows || []);
//     } catch { toast.error("Commissions load failed"); }
//   }, []);

//   const loadDailyJoins = useCallback(async () => {
//     try {
//       const r = await api.get("/mlm/daily-joins?days=30");
//       // Backend returns { success, rows, totals, best_day }
//       setDailyJoins(r.data.rows || []);
//     } catch (e) { toast.error("Daily joins load failed"); }
//   }, []);

//   const loadNetworkTree = useCallback(async (token) => {
//     if (!token) { toast.error("Enter a token/coupon number"); return; }
//     try {
//       const r = await api.get(`/mlm/network-tree/${token}`);
//       // Backend returns the node directly at root: { success, token_number, receiver_name, children... }
//       if (r.data.success && r.data.token_number) {
//         setNetworkTree(r.data); // whole response IS the node
//       } else if (r.data.tree) {
//         setNetworkTree(r.data.tree); // fallback for /tree/:token format
//       } else {
//         toast.error("Member not found");
//       }
//     } catch { toast.error("Network tree load failed"); }
//   }, []);

//   useEffect(() => {
//     // Load everything on mount so dashboard is fully populated
//     Promise.all([loadStats(), loadMembers(), loadWithdrawals()]);
//   }, []);

//   /* ── Navigation ── */
//   const goTo = useCallback((t, s = "") => {
//     setTab(t); setSubTab(s);
//     if (t === "admins") loadAdmins();
//     if (s === "Withdrawal Requests") loadWithdrawals();
//     if (s === "Payment History") loadPayHistory();
//     if (s === "Salary List" || s === "Generate Salary") loadSalaries();
//     if (s === "Commission Report") loadCommissions();
//     if (s === "Daily Joins") loadDailyJoins();
//     if (
//       s === "All Members" || s === "Pending Approval" || s === "Approved Members" ||
//       s === "Level Income Report" || s === "Level Wise Report" ||
//       s === "Direct Business Report" || s === "Business Report" ||
//       s === "Commission Summary" || s === "Commission Report"
//     ) loadMembers(search);
//   }, [search, loadAdmins, loadWithdrawals, loadPayHistory, loadSalaries, loadMembers, loadCommissions, loadDailyJoins]);

//   /* ── Actions ── */
//   const approveCoupon = async (id, row) => {
//     setApproving(p => ({ ...p, [id]: true }));
//     try {
//       await api.post(`/coupons/approve/${id}`);
//       toast.success("✅ Approved! Commission distributed.");
//       await Promise.all([loadMembers(search), loadStats()]);
//       if (row?.receiver_mobile) {
//         setTimeout(() => {
//           whatsapp(row.receiver_mobile,
//             `🎉 Namaste ${row.receiver_name}!\n\nYour ${COMPANY} Lucky Draw coupon *${row.receiver_coupon_no || ""}* has been *APPROVED* ✅\n\nLogin & check your dashboard:\n${COMPANY_URL}\n\n_Thank you for joining Meruram!_`
//           );
//         }, 500);
//       }
//     } catch (err) { toast.error(err.response?.data?.message || "Error"); }
//     setApproving(p => ({ ...p, [id]: false }));
//   };

//   const deleteCoupon = async (id) => {
//     if (!window.confirm("Delete this coupon permanently?")) return;
//     try { await api.delete(`/coupons/delete/${id}`); toast.success("Deleted"); loadMembers(search); loadStats(); }
//     catch { toast.error("Delete failed"); }
//   };

//   const processWithdrawal = async (id, action, row) => {
//     try {
//       await api.put(`/wallet/withdrawals/${id}`, { action });
//       if (action === "approved") {
//         toast.success("✅ Approved! Sending WhatsApp...");
//         whatsapp(row.receiver_mobile,
//           `💸 Namaste *${row.receiver_name}*!\n\nYour withdrawal request of *${inr(row.amount)}* has been *APPROVED & PROCESSED* ✅\n\nPayment via: *${(row.method || "").toUpperCase()}*\n${row.method === "upi" ? `UPI: ${row.upi_id || "—"}` : `Bank: ${row.bank_name || "—"} | Acc: ${row.account_number || "—"}`}\n\n_${COMPANY}_\n${COMPANY_URL}`
//         );
//       } else {
//         toast.error("❌ Withdrawal rejected");
//       }
//       loadWithdrawals(); loadPayHistory(); loadStats();
//     } catch (err) { toast.error(err.response?.data?.message || "Error"); }
//   };

//   const approveSalary = async (id, row) => {
//     try {
//       await api.put(`/mlm/salary/approve/${id}`);
//       toast.success("Salary credited!");
//       if (row?.receiver_mobile) {
//         whatsapp(row.receiver_mobile,
//           `💰 Namaste *${row.receiver_name}*!\n\nYour *${row.rank?.toUpperCase()} Rank Salary* of *${inr(row.amount)}* for ${row.month} has been credited to your wallet ✅\n\n_${COMPANY}_\n${COMPANY_URL}`
//         );
//       }
//       loadSalaries();
//     } catch (err) { toast.error(err.response?.data?.message || "Error"); }
//   };

//   const generateSalary = async () => {
//     setGeneratingSalary(true);
//     try {
//       const r = await api.post("/mlm/salary/generate");
//       toast.success(r.data.message || "Salary generated!");
//       loadSalaries();
//       goTo("salary", "Salary List");
//     } catch (err) { toast.error(err.response?.data?.message || "Error"); }
//     setGeneratingSalary(false);
//   };

//   /* ── One-click data repair (fixes referred_by → commissions → ranks) ── */
//   const runFullRepair = async () => {
//     if (!window.confirm(
//       "⚠️ This will:\n1. Fix referred_by for all members\n2. Redistribute missing commissions\n3. Recalculate all ranks\n\nSafe to run multiple times. Continue?"
//     )) return;

//     setRepairing(true);
//     setRepairLog([]);
//     const log = [];

//     try {
//       // Step 1: Fix referred_by
//       log.push("🔧 Step 1: Fixing referred_by links...");
//       setRepairLog([...log]);
//       const r1 = await api.post("/mlm/fix-referred-by");
//       log.push(`✅ Step 1 done: ${r1.data.fixed} members linked, ${r1.data.skipped} skipped`);
//       setRepairLog([...log]);

//       // Step 2: Redistribute commissions
//       log.push("💰 Step 2: Redistributing commissions...");
//       setRepairLog([...log]);
//       const r2 = await api.post("/mlm/redistribute-commissions");
//       log.push(`✅ Step 2 done: commissions distributed for ${r2.data.processed} members`);
//       if (r2.data.errors?.length) {
//         log.push(`⚠️ ${r2.data.errors.length} errors (check server logs)`);
//       }
//       setRepairLog([...log]);

//       // Step 3: Recalculate ranks
//       log.push("🏆 Step 3: Recalculating all ranks...");
//       setRepairLog([...log]);
//       const r3 = await api.post("/mlm/recalculate-all-ranks");
//       const rankSummary = Object.entries(r3.data.summary || {})
//         .map(([rank, count]) => `${rank}: ${count}`)
//         .join(", ");
//       log.push(`✅ Step 3 done: ${r3.data.message} → ${rankSummary}`);
//       setRepairLog([...log]);

//       log.push("🎉 All repairs complete! Reloading data...");
//       setRepairLog([...log]);

//       // Reload everything
//       await Promise.all([loadStats(), loadMembers()]);
//       toast.success("✅ Data repair complete!");
//     } catch (err) {
//       log.push(`❌ Error: ${err.response?.data?.message || err.message}`);
//       setRepairLog([...log]);
//       toast.error("Repair failed — check log");
//     }
//     setRepairing(false);
//   };

//   const addFund = async () => {
//     if (!addFundForm.token_number || !addFundForm.amount) { toast.error("Fill all fields"); return; }
//     try {
//       const r = await api.post("/mlm/add-fund", addFundForm);
//       toast.success(r.data.message);
//       setAddFundForm({ token_number: "", amount: "", description: "Fund added by admin" });
//       loadMembers(); loadStats();
//     } catch (err) { toast.error(err.response?.data?.message || "Error"); }
//   };

//   const createAdmin = async () => {
//     if (!newAdmin.username || !newAdmin.password) { toast.error("Username & password required"); return; }
//     try {
//       await api.post("/auth/create-admin", newAdmin);
//       toast.success("Admin created!");
//       setNewAdmin({ username: "", password: "", full_name: "", mobile: "", role: "admin" });
//       loadAdmins();
//     } catch (err) { toast.error(err.response?.data?.message || "Error"); }
//   };

//   const openDetail = async (row) => {
//     // Support rows from all-members-stats (token_number) and level-wise (token field)
//     const tokenToLoad = row.token_number || row.token;
//     setSelectedMember(row);
//     setTab("members"); setSubTab("Member Detail");
//     await loadMemberDetail(tokenToLoad);
//   };

//   /* ── Filtered member lists ── */
//   const filteredMembers = useMemo(() => {
//     if (subTab === "Pending Approval") return allMembers.filter(c => !c.is_approved);
//     if (subTab === "Approved Members") return allMembers.filter(c => c.is_approved);
//     return allMembers;
//   }, [allMembers, subTab]);

//   /* ── Top members by income ── */
//   const topByIncome = useMemo(() =>
//     [...allMembers].sort((a, b) => Number(b.total_income || 0) - Number(a.total_income || 0)).slice(0, 10),
//     [allMembers]
//   );

//   const topByDirect = useMemo(() =>
//     [...allMembers].sort((a, b) => Number(b.direct_count || 0) - Number(a.direct_count || 0)).slice(0, 10),
//     [allMembers]
//   );

//   /* ── Level summary (company-wide) ── */
//   const levelSummary = useMemo(() => {
//     const map = {};
//     allMembers.forEach(m => {
//       for (let l = 1; l <= 6; l++) {
//         const earned = Number(m[`level${l}_income`] || 0);
//         if (!map[l]) map[l] = { level: l, total: 0, members_paid: 0, rate: LEVEL_RATE[l] };
//         if (earned > 0) { map[l].total += earned; map[l].members_paid++; }
//       }
//     });
//     return Object.values(map);
//   }, [allMembers]);

//   /* ── Commission summary per level ── */
//   const commissionByLevel = useMemo(() => {
//     const map = {};
//     commissions.forEach(c => {
//       const l = c.level;
//       if (!map[l]) map[l] = { level: l, count: 0, total: 0 };
//       map[l].count++;
//       map[l].total += Number(c.amount || 0);
//     });
//     return Object.values(map).sort((a, b) => a.level - b.level);
//   }, [commissions]);

//   /* ── Network Tree recursive renderer ── */
//   const TreeNode = ({ node, depth = 0 }) => {
//     const [expanded, setExpanded] = useState(depth < 2);
//     if (!node) return null;
//     const hasChildren = node.children && node.children.length > 0;
//     return (
//       <div style={{ marginLeft: depth * 24, marginBottom: 4 }}>
//         <div
//           style={{
//             display: "flex", alignItems: "center", gap: 8, padding: "8px 12px",
//             background: depth === 0 ? "#1e3a8a" : depth === 1 ? "#1d4ed8" : depth === 2 ? "#3b82f6" : "#eff6ff",
//             color: depth < 3 ? "#fff" : "#1e3a8a",
//             borderRadius: 8, cursor: hasChildren ? "pointer" : "default",
//             border: "1px solid rgba(255,255,255,0.1)",
//             transition: "all 0.15s",
//           }}
//           onClick={() => hasChildren && setExpanded(e => !e)}
//         >
//           {hasChildren && <span style={{ fontSize: 10, minWidth: 14 }}>{expanded ? "▼" : "▶"}</span>}
//           {!hasChildren && <span style={{ fontSize: 10, minWidth: 14, opacity: 0.5 }}>●</span>}
//           <span style={{ fontWeight: 700, fontSize: 12 }}>{node.receiver_coupon_no || node.token_number}</span>
//           <span style={{ fontSize: 12 }}>{node.receiver_name}</span>
//           <span style={{ fontSize: 11, opacity: 0.75 }}>{node.receiver_mobile}</span>
//           {hasChildren && (
//             <span style={{ marginLeft: "auto", background: "rgba(255,255,255,0.2)", borderRadius: 99, padding: "1px 8px", fontSize: 11 }}>
//               {node.children.length} direct
//             </span>
//           )}
//           <span style={{
//             marginLeft: hasChildren ? 4 : "auto",
//             background: node.is_approved ? "#16a34a" : "#f59e0b",
//             borderRadius: 99, padding: "1px 8px", fontSize: 10, color: "#fff"
//           }}>
//             {node.is_approved ? "Active" : "Pending"}
//           </span>
//         </div>
//         {expanded && hasChildren && (
//           <div style={{ borderLeft: "2px solid #bfdbfe", marginLeft: 18, paddingLeft: 6, marginTop: 4 }}>
//             {node.children.map(child => (
//               <TreeNode key={child.id || child.token_number} node={child} depth={depth + 1} />
//             ))}
//           </div>
//         )}
//       </div>
//     );
//   };

//   /* ─────────────── RENDER ─────────────── */
//   return (
//     <div style={S.shell}>
//       {/* ══ TOP BAR ══ */}
//       <header style={S.topbar}>
//         <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
//           <div style={S.logoBadge}>मे</div>
//           <div>
//             <div style={{ fontWeight: 800, fontSize: 16, letterSpacing: .5, color: "#fff" }}>MERURAM</div>
//             <div style={{ fontSize: 9, color: "#93c5fd", letterSpacing: 3 }}>LUCKY DRAW · SUPER ADMIN</div>
//           </div>
//         </div>
//         <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
//           <span style={S.superBadge}>👑 SUPER ADMIN</span>
//           <span style={{ fontSize: 12, color: "#ddd" }}>
//             {admin?.full_name || admin?.username}
//           </span>
//           <button style={S.logoutBtn} onClick={() => { logout(); navigate("/superadmin/login"); }}>
//             Logout
//           </button>
//         </div>
//       </header>

//       <div style={{ display: "flex", flex: 1 }}>
//         {/* ══ SIDEBAR ══ */}
//         <nav style={S.sidebar}>
//           {NAV.map(n => (
//             <div key={n.key}>
//               <div
//                 style={{ ...S.navItem, ...(tab === n.key && !subTab && !n.children ? S.navActive : {}) }}
//                 onClick={() => n.children ? setOpenNav(p => ({ ...p, [n.key]: !p[n.key] })) : goTo(n.key)}
//               >
//                 <span style={{ flex: 1 }}>{n.label}</span>
//                 {n.children && <span style={{ fontSize: 10, opacity: .6 }}>{openNav[n.key] ? "▾" : "▸"}</span>}
//               </div>
//               {n.children && openNav[n.key] && n.children
//                 .filter(c => c !== "Member Detail")
//                 .map(child => (
//                   <div key={child}
//                     style={{
//                       ...S.navSub,
//                       ...(subTab === child ? S.navSubActive : {})
//                     }}
//                     onClick={() => goTo(n.key, child)}
//                   >{child}</div>
//                 ))}
//             </div>
//           ))}
//           <div style={S.navItem} onClick={() => { logout(); navigate("/superadmin/login"); }}>
//             🚪 Logout
//           </div>
//         </nav>

//         {/* ══ MAIN CONTENT ══ */}
//         <main style={S.content}>

//           {/* ══════════ DASHBOARD ══════════ */}
//           {tab === "dashboard" && stats && (
//             <div>
//               <PageHead title="Dashboard Overview" sub={COMPANY_URL} />

//               {/* KPI Grid */}
//               <div style={S.kpiGrid}>
//                 {[
//                   { label: "Total Coupons", val: stats.total_members, icon: "🎟", bg: "#1e40af" },
//                   { label: "Approved", val: stats.approved, icon: "✅", bg: "#065f46" },
//                   { label: "Pending", val: stats.pending, icon: "⏳", bg: "#92400e" },
//                   { label: "Pending Payouts", val: stats.pending_payouts, icon: "💸", bg: "#7f1d1d" },
//                   { label: "Total Wallet", val: inr(stats.total_wallet), icon: "💰", bg: "#4c1d95" },
//                   { label: "Commission Paid", val: inr(stats.total_commission), icon: "📈", bg: "#134e4a" },
//                   { label: "Payout Done", val: inr(stats.total_payout_done), icon: "🏦", bg: "#1e1b4b" },
//                   { label: "Pending Salary", val: stats.pending_salary, icon: "📋", bg: "#701a75" },
//                 ].map(c => (
//                   <div key={c.label} style={{ ...S.kpiCard, background: c.bg }}>
//                     <div style={{ fontSize: 22 }}>{c.icon}</div>
//                     <div style={{ fontSize: 20, fontWeight: 800 }}>{c.val}</div>
//                     <div style={{ fontSize: 10, opacity: .8 }}>{c.label}</div>
//                   </div>
//                 ))}
//               </div>

//               {/* ── DATA REPAIR PANEL ── */}
//               <div style={{
//                 background: "linear-gradient(135deg, #1e1b4b 0%, #312e81 100%)",
//                 borderRadius: 12, padding: "16px 20px", marginBottom: 16,
//                 border: "1px solid #4338ca", display: "flex", gap: 16,
//                 alignItems: "flex-start", flexWrap: "wrap"
//               }}>
//                 <div style={{ flex: 1, minWidth: 220 }}>
//                   <div style={{ fontWeight: 800, color: "#c7d2fe", fontSize: 13, marginBottom: 4 }}>
//                     🔧 Data Repair Tool
//                   </div>
//                   <div style={{ fontSize: 11, color: "#a5b4fc", lineHeight: 1.6 }}>
//                     Run once if members, commissions or ranks are showing blank/zero.
//                     Fixes <code style={{ background: "#1e1b4b", padding: "1px 4px", borderRadius: 3 }}>referred_by</code>,
//                     redistributes missing commissions, recalculates all ranks.
//                   </div>
//                 </div>
//                 <div style={{ display: "flex", flexDirection: "column", gap: 8, minWidth: 200 }}>
//                   <button
//                     style={{
//                       background: repairing ? "#4338ca" : "#6366f1",
//                       color: "#fff", border: "none", borderRadius: 8,
//                       padding: "10px 20px", fontWeight: 700, fontSize: 13,
//                       cursor: repairing ? "not-allowed" : "pointer",
//                       opacity: repairing ? 0.7 : 1,
//                     }}
//                     onClick={runFullRepair}
//                     disabled={repairing}
//                   >
//                     {repairing ? "⏳ Repairing..." : "🚀 Run Full Data Repair"}
//                   </button>
//                   {repairLog.length > 0 && (
//                     <div style={{
//                       background: "#0f172a", borderRadius: 8, padding: "10px 12px",
//                       fontSize: 11, fontFamily: "monospace", lineHeight: 1.8,
//                       maxHeight: 160, overflowY: "auto", border: "1px solid #334155"
//                     }}>
//                       {repairLog.map((line, i) => (
//                         <div key={i} style={{
//                           color: line.startsWith("✅") ? "#4ade80"
//                                : line.startsWith("❌") ? "#f87171"
//                                : line.startsWith("⚠️") ? "#fbbf24"
//                                : line.startsWith("🎉") ? "#818cf8"
//                                : "#94a3b8"
//                         }}>{line}</div>
//                       ))}
//                     </div>
//                   )}
//                 </div>
//               </div>

//               {/* Company-wide Level Summary */}
//               <SectionTitle>💹 Company-wide Level Commission Summary</SectionTitle>
//               <div style={S.tableWrap}>
//                 <table style={S.table}>
//                   <THead cols={["Level", "Rate/Join", "Members Benefiting", "Total Paid Out", "Chart"]} />
//                   <tbody>
//                     {levelSummary.map((l, i) => (
//                       <tr key={l.level} style={i % 2 === 0 ? S.trEven : {}}>
//                         <td style={S.td}><b>Level {l.level}</b></td>
//                         <td style={S.td}>₹{l.rate}</td>
//                         <td style={S.td}>{l.members_paid}</td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#16a34a" }}>{inr(l.total)}</td>
//                         <td style={S.td}>
//                           <div style={{ width: Math.min((l.total / (stats.total_commission || 1)) * 300, 200), height: 8, background: PIE_COLORS[i % PIE_COLORS.length], borderRadius: 99 }} />
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>

//               {/* Charts Row */}
//               <div style={{ display: "flex", gap: 14, marginTop: 4, flexWrap: "wrap" }}>
//                 <div style={{ ...S.card, flex: 2, minWidth: 280 }}>
//                   <CardHead>📅 Daily Registrations (14 days)</CardHead>
//                   <div style={{ padding: 16 }}>
//                     <ResponsiveContainer width="100%" height={180}>
//                       <BarChart data={stats.daily_joins || []}>
//                         <XAxis dataKey="date" tick={{ fontSize: 9 }} />
//                         <YAxis tick={{ fontSize: 9 }} />
//                         <Tooltip />
//                         <Bar dataKey="count" fill="#3b82f6" radius={[3, 3, 0, 0]} name="Joins" />
//                       </BarChart>
//                     </ResponsiveContainer>
//                   </div>
//                 </div>
//                 <div style={{ ...S.card, flex: 1, minWidth: 200 }}>
//                   <CardHead>🏆 Rank Distribution</CardHead>
//                   <div style={{ padding: "8px 0" }}>
//                     {(stats.rank_dist || []).map((r, i) => (
//                       <div key={r.rank} style={{ display: "flex", justifyContent: "space-between", padding: "8px 16px", borderBottom: "1px solid #f1f5f9", alignItems: "center" }}>
//                         <span style={{ fontSize: 12, textTransform: "capitalize", fontWeight: 600 }}>{r.rank}</span>
//                         <span style={{ ...S.badge, background: PIE_COLORS[i % PIE_COLORS.length], color: "#fff" }}>{r.count}</span>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               </div>

//               {/* Top 10 by Income */}
//               <SectionTitle>🥇 Top 10 Members by Total Income</SectionTitle>
//               <div style={S.tableWrap}>
//                 <table style={S.table}>
//                   <THead cols={["Rank", "Coupon", "Name", "Direct", "L1", "L2", "L3", "L4", "L5", "L6", "Total Income"]} />
//                   <tbody>
//                     {topByIncome.map((m, i) => (
//                       <tr key={m.id} style={i % 2 === 0 ? S.trEven : {}}>
//                         <td style={{ ...S.td, fontWeight: 800, color: i < 3 ? "#f59e0b" : "#64748b" }}>#{i + 1}</td>
//                         <td style={{ ...S.td, color: "#1d4ed8", fontWeight: 700, cursor: "pointer" }} onClick={() => openDetail(m)}>
//                           {m.receiver_coupon_no}
//                         </td>
//                         <td style={S.td}>{m.receiver_name}</td>
//                         <td style={S.td}>{m.direct_count}</td>
//                         {[1, 2, 3, 4, 5, 6].map(l => (
//                           <td key={l} style={{ ...S.td, fontSize: 11, color: m[`level${l}_income`] > 0 ? "#16a34a" : "#ccc" }}>
//                             {m[`level${l}_income`] > 0 ? inr(m[`level${l}_income`]) : "—"}
//                           </td>
//                         ))}
//                         <td style={{ ...S.td, fontWeight: 800, color: "#7c3aed" }}>{inr(m.total_income)}</td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>

//               {/* Top 10 by Direct */}
//               <SectionTitle>👥 Top 10 Members by Direct Connections</SectionTitle>
//               <div style={S.tableWrap}>
//                 <table style={S.table}>
//                   <THead cols={["Rank", "Coupon", "Name", "Mobile", "Direct", "Total Team", "Total Business"]} />
//                   <tbody>
//                     {topByDirect.map((m, i) => (
//                       <tr key={m.id} style={i % 2 === 0 ? S.trEven : {}}>
//                         <td style={{ ...S.td, fontWeight: 800, color: i < 3 ? "#f59e0b" : "#64748b" }}>#{i + 1}</td>
//                         <td style={{ ...S.td, color: "#1d4ed8", fontWeight: 700, cursor: "pointer" }} onClick={() => openDetail(m)}>
//                           {m.receiver_coupon_no}
//                         </td>
//                         <td style={S.td}>{m.receiver_name}</td>
//                         <td style={S.td}>{m.receiver_mobile}</td>
//                         <td style={{ ...S.td, fontWeight: 700 }}>{m.direct_count}</td>
//                         <td style={S.td}>{Number(m.direct_count || 0) + Number(m.indirect_count || 0)}</td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#16a34a" }}>{inr(m.total_income)}</td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}

//           {/* ══════════ ALL MEMBERS ══════════ */}
//           {(subTab === "All Members" || subTab === "Pending Approval" || subTab === "Approved Members") && (
//             <div>
//               <PageHead title={`🎟 ${subTab}`} />
//               <div style={{ display: "flex", gap: 10, marginBottom: 12, flexWrap: "wrap" }}>
//                 <input style={S.searchBox}
//                   placeholder="🔍 Search name, mobile, coupon..."
//                   value={search}
//                   onChange={e => { setSearch(e.target.value); loadMembers(e.target.value); }}
//                 />
//                 <span style={S.countBadge}>Total: {filteredMembers.length}</span>
//                 <span style={{ ...S.countBadge, background: "#dcfce7", color: "#15803d" }}>
//                   Active: {filteredMembers.filter(m => m.is_approved).length}
//                 </span>
//                 <span style={{ ...S.countBadge, background: "#fef9c3", color: "#854d0e" }}>
//                   Pending: {filteredMembers.filter(m => !m.is_approved).length}
//                 </span>
//               </div>
//               <div style={S.tableWrap}>
//                 <table style={S.table}>
//                   <THead cols={[
//                     "#", "Coupon", "Name", "Mobile", "Sponsor", "Direct", "Indirect",
//                     "L1", "L2", "L3", "L4", "L5", "L6",
//                     "Total Income", "Withdrawn", "Status", "Date", "Actions"
//                   ]} />
//                   <tbody>
//                     {filteredMembers.map((c, i) => (
//                       <tr key={c.id} style={i % 2 === 0 ? S.trEven : {}}>
//                         <td style={S.td}>{i + 1}</td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#1d4ed8", cursor: "pointer" }}
//                           onClick={() => openDetail(c)}>
//                           {c.receiver_coupon_no || "—"}
//                         </td>
//                         <td style={S.td}>{c.receiver_name}</td>
//                         <td style={S.td}>{c.receiver_mobile}</td>
//                         <td style={{ ...S.td, fontSize: 11 }}>
//                           {c.sponsor_name || "—"}
//                           <br /><span style={{ color: "#94a3b8" }}>{c.sponsor_coupon}</span>
//                         </td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#1d4ed8" }}>{c.direct_count}</td>
//                         <td style={{ ...S.td, color: "#6366f1" }}>{c.indirect_count || 0}</td>
//                         {[1, 2, 3, 4, 5, 6].map(l => (
//                           <td key={l} style={{ ...S.td, fontSize: 11, color: c[`level${l}_income`] > 0 ? "#16a34a" : "#d1d5db" }}>
//                             {c[`level${l}_income`] > 0 ? `₹${Number(c[`level${l}_income`]).toFixed(0)}` : "—"}
//                           </td>
//                         ))}
//                         <td style={{ ...S.td, fontWeight: 800, color: "#7c3aed" }}>{inr(c.total_income)}</td>
//                         <td style={{ ...S.td, color: "#dc2626" }}>{inr(c.total_withdrawn)}</td>
//                         <td style={S.td}>
//                           <span style={c.is_approved ? S.greenBadge : S.yellowBadge}>
//                             {c.is_approved ? "Active" : "Pending"}
//                           </span>
//                         </td>
//                         <td style={{ ...S.td, fontSize: 11 }}>{fmt(c.created_at)}</td>
//                         <td style={S.td}>
//                           <div style={{ display: "flex", gap: 3, flexWrap: "wrap" }}>
//                             {!c.is_approved && (
//                               <ActionBtn color="#16a34a" disabled={approving[c.id]}
//                                 onClick={() => approveCoupon(c.id, c)}>
//                                 {approving[c.id] ? "..." : "✅"}
//                               </ActionBtn>
//                             )}
//                             <ActionBtn color="#1d4ed8" onClick={() => openDetail(c)}>👁</ActionBtn>
//                             <ActionBtn color="#25D366" onClick={() =>
//                               whatsapp(c.receiver_mobile,
//                                 `Namaste *${c.receiver_name}*! Your coupon status: ${c.is_approved ? "Active ✅" : "Pending ⏳"}. Visit ${COMPANY_URL}`)
//                             }>📱</ActionBtn>
//                             <ActionBtn color="#dc2626" onClick={() => deleteCoupon(c.id)}>🗑</ActionBtn>
//                           </div>
//                         </td>
//                       </tr>
//                     ))}
//                     {filteredMembers.length === 0 && (
//                       <tr><td colSpan={18} style={{ ...S.td, textAlign: "center", color: "#94a3b8", padding: 40 }}>
//                         No records found
//                       </td></tr>
//                     )}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}

//           {/* ══════════ MEMBER DETAIL ══════════ */}
//           {subTab === "Member Detail" && (
//             <div>
//               <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
//                 <PageHead title={`👤 Member Detail${memberDetail ? " — " + memberDetail.member?.receiver_name : ""}`} />
//                 <button style={{ ...S.btn, background: "#64748b" }} onClick={() => goTo("members", "All Members")}>← Back</button>
//               </div>

//               {loadingDetail && <div style={{ textAlign: "center", padding: 48, color: "#94a3b8" }}>Loading...</div>}

//               {!loadingDetail && memberDetail && (() => {
//                 const m = memberDetail.member;
//                 const levelBreakdown = memberDetail.level_breakdown || [];
//                 const direct = memberDetail.direct || [];
//                 const memberCommissions = memberDetail.commissions || [];
//                 const wdrawals = memberDetail.withdrawals || [];
//                 const totalEarned = levelBreakdown.reduce((s, l) => s + Number(l.total || 0), 0);

//                 return (
//                   <div>
//                     <div style={{ display: "flex", flexWrap: "wrap", gap: 10, marginBottom: 16 }}>
//                       {[
//                         ["Coupon No", m.receiver_coupon_no],
//                         ["Name", m.receiver_name],
//                         ["Mobile", m.receiver_mobile],
//                         ["Rank", m.rank?.toUpperCase()],
//                         ["Wallet Balance", inr(m.wallet_balance)],
//                         ["Direct Members", direct.length],
//                         ["Total Team", memberDetail.total_team],
//                         ["Total Earned", inr(totalEarned)],
//                         ["Joined", fmt(m.created_at)],
//                         ["Status", m.is_approved ? "Active ✅" : "Pending ⏳"],
//                       ].map(([k, v]) => (
//                         <div key={k} style={S.infoChip}>
//                           <div style={{ fontSize: 10, color: "#64748b" }}>{k}</div>
//                           <div style={{ fontWeight: 700 }}>{v}</div>
//                         </div>
//                       ))}
//                     </div>

//                     <div style={{ display: "flex", gap: 8, marginBottom: 16, flexWrap: "wrap" }}>
//                       <button style={{ ...S.btn, background: "#25D366" }} onClick={() =>
//                         whatsapp(m.receiver_mobile, `Namaste *${m.receiver_name}*!\n\nYour Meruram Lucky Draw account is active ✅.\n\nCoupon: ${m.receiver_coupon_no}\nBalance: ${inr(m.wallet_balance)}\n\nVisit: ${COMPANY_URL}`)}>
//                         📱 Send Account Info
//                       </button>
//                       <button style={{ ...S.btn, background: "#25D366" }} onClick={() =>
//                         whatsapp(m.receiver_mobile, `Namaste *${m.receiver_name}*!\n\nYou have earned *${inr(totalEarned)}* in Level Income from Meruram Lucky Draw 🎉\n\nLogin to check: ${COMPANY_URL}`)}>
//                         📱 Send Income Info
//                       </button>
//                     </div>

//                     <SectionTitle>💹 Level-wise Income</SectionTitle>
//                     <div style={S.tableWrap}>
//                       <table style={S.table}>
//                         <THead cols={["Level", "Rate/Join", "Members Joined", "Direct Members", "Indirect Members", "Total Earned", "% Share"]} />
//                         <tbody>
//                           {[1, 2, 3, 4, 5, 6].map((level, i) => {
//                             const found = levelBreakdown.find(l => l.level === level);
//                             const earned = Number(found?.total || 0);
//                             const pct = totalEarned > 0 ? ((earned / totalEarned) * 100).toFixed(1) : "0";
//                             const isL1 = level === 1;
//                             return (
//                               <tr key={level} style={i % 2 === 0 ? S.trEven : {}}>
//                                 <td style={S.td}><strong>Level {level}</strong> {isL1 ? "🔴" : ""}</td>
//                                 <td style={S.td}>₹{LEVEL_RATE[level]}</td>
//                                 <td style={S.td}>{found?.count || 0}</td>
//                                 <td style={S.td}>{isL1 ? (found?.count || 0) : "—"}</td>
//                                 <td style={S.td}>{!isL1 ? (found?.count || 0) : "—"}</td>
//                                 <td style={{ ...S.td, fontWeight: 700, color: earned > 0 ? "#16a34a" : "#94a3b8" }}>
//                                   {earned > 0 ? inr(earned) : "₹0.00"}
//                                 </td>
//                                 <td style={S.td}>
//                                   <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
//                                     <div style={{ height: 6, borderRadius: 99, background: PIE_COLORS[i], width: `${Math.min(Number(pct), 100)}%`, minWidth: 2 }} />
//                                     <span style={{ fontSize: 11, color: "#64748b" }}>{pct}%</span>
//                                   </div>
//                                 </td>
//                               </tr>
//                             );
//                           })}
//                           <tr style={{ background: "#f0fdf4" }}>
//                             <td style={{ ...S.td, fontWeight: 800 }} colSpan={2}>TOTAL</td>
//                             <td style={{ ...S.td, fontWeight: 700 }}>{levelBreakdown.reduce((s, l) => s + l.count, 0)}</td>
//                             <td style={S.td}>{direct.length}</td>
//                             <td style={S.td}>{memberDetail.total_team - direct.length}</td>
//                             <td style={{ ...S.td, fontWeight: 800, color: "#15803d", fontSize: 15 }}>{inr(totalEarned)}</td>
//                             <td style={S.td}>100%</td>
//                           </tr>
//                         </tbody>
//                       </table>
//                     </div>

//                     <SectionTitle>👥 Direct Members</SectionTitle>
//                     <div style={S.tableWrap}>
//                       <table style={S.table}>
//                         <THead cols={["#", "Coupon", "Name", "Mobile", "Joined Date", "Their Direct", "Status", "WA"]} />
//                         <tbody>
//                           {direct.map((d, i) => (
//                             <tr key={d.id} style={i % 2 === 0 ? S.trEven : {}}>
//                               <td style={S.td}>{i + 1}</td>
//                               <td style={{ ...S.td, color: "#1d4ed8", fontWeight: 700 }}>{d.receiver_coupon_no}</td>
//                               <td style={S.td}>{d.receiver_name}</td>
//                               <td style={S.td}>{d.receiver_mobile}</td>
//                               <td style={{ ...S.td, fontSize: 11 }}>{fmtTime(d.created_at)}</td>
//                               <td style={{ ...S.td, fontWeight: 700 }}>{d.their_direct}</td>
//                               <td style={S.td}><span style={d.is_approved ? S.greenBadge : S.yellowBadge}>{d.is_approved ? "Active" : "Pending"}</span></td>
//                               <td style={S.td}>
//                                 <button style={{ ...S.btn, background: "#25D366", padding: "4px 8px" }}
//                                   onClick={() => whatsapp(d.receiver_mobile, `Namaste *${d.receiver_name}*! Welcome to Meruram Lucky Draw. Login: ${COMPANY_URL}`)}>
//                                   📱
//                                 </button>
//                               </td>
//                             </tr>
//                           ))}
//                           {direct.length === 0 && <tr><td colSpan={8} style={{ ...S.td, textAlign: "center", color: "#94a3b8" }}>No direct referrals</td></tr>}
//                         </tbody>
//                       </table>
//                     </div>

//                     <SectionTitle>📋 Commission History</SectionTitle>
//                     <div style={S.tableWrap}>
//                       <table style={S.table}>
//                         <THead cols={["#", "Date", "Level", "From Coupon", "From Member", "Amount Earned"]} />
//                         <tbody>
//                           {memberCommissions.slice(0, 100).map((c, i) => (
//                             <tr key={c.id} style={i % 2 === 0 ? S.trEven : {}}>
//                               <td style={S.td}>{i + 1}</td>
//                               <td style={{ ...S.td, fontSize: 11 }}>{fmtTime(c.created_at)}</td>
//                               <td style={S.td}><span style={S.pill}>L{c.level}</span></td>
//                               <td style={{ ...S.td, color: "#1d4ed8" }}>{c.from_coupon}</td>
//                               <td style={S.td}>{c.from_name}</td>
//                               <td style={{ ...S.td, fontWeight: 700, color: "#16a34a" }}>{inr(c.amount)}</td>
//                             </tr>
//                           ))}
//                           {memberCommissions.length === 0 && <tr><td colSpan={6} style={{ ...S.td, textAlign: "center", color: "#94a3b8" }}>No commissions yet</td></tr>}
//                         </tbody>
//                       </table>
//                     </div>

//                     <SectionTitle>💸 Withdrawal History</SectionTitle>
//                     <div style={S.tableWrap}>
//                       <table style={S.table}>
//                         <THead cols={["#", "Date", "Amount", "Method", "Bank/UPI", "Status"]} />
//                         <tbody>
//                           {wdrawals.map((w, i) => (
//                             <tr key={w.id} style={i % 2 === 0 ? S.trEven : {}}>
//                               <td style={S.td}>{i + 1}</td>
//                               <td style={{ ...S.td, fontSize: 11 }}>{fmt(w.created_at)}</td>
//                               <td style={{ ...S.td, fontWeight: 700 }}>{inr(w.amount)}</td>
//                               <td style={S.td}>{w.method?.toUpperCase()}</td>
//                               <td style={{ ...S.td, fontSize: 11 }}>{w.method === "upi" ? w.upi_id : `${w.bank_name || ""} ${w.account_number || ""}`}</td>
//                               <td style={S.td}><span style={w.status === "approved" ? S.greenBadge : w.status === "rejected" ? S.redBadge : S.yellowBadge}>{w.status}</span></td>
//                             </tr>
//                           ))}
//                           {wdrawals.length === 0 && <tr><td colSpan={6} style={{ ...S.td, textAlign: "center", color: "#94a3b8" }}>No withdrawals</td></tr>}
//                         </tbody>
//                       </table>
//                     </div>
//                   </div>
//                 );
//               })()}
//             </div>
//           )}

//           {/* ══════════ LEVEL INCOME REPORT ══════════ */}
//           {subTab === "Level Income Report" && (
//             <div>
//               <PageHead title="📈 Level Income Report — All Members" />

//               {/* Summary KPI */}
//               <div style={{ display: "flex", gap: 10, marginBottom: 16, flexWrap: "wrap" }}>
//                 {[1, 2, 3, 4, 5, 6].map((l, i) => (
//                   <div key={l} style={{ background: PIE_COLORS[i], color: "#fff", borderRadius: 10, padding: "12px 16px", minWidth: 110, textAlign: "center" }}>
//                     <div style={{ fontSize: 10, opacity: 0.8 }}>Level {l} · ₹{LEVEL_RATE[l]}/join</div>
//                     <div style={{ fontSize: 18, fontWeight: 800, marginTop: 4 }}>
//                       {inr(allMembers.reduce((s, m) => s + Number(m[`level${l}_income`] || 0), 0))}
//                     </div>
//                     <div style={{ fontSize: 10, opacity: 0.8, marginTop: 2 }}>
//                       {allMembers.filter(m => Number(m[`level${l}_income`]) > 0).length} members
//                     </div>
//                   </div>
//                 ))}
//               </div>

//               <div style={S.tableWrap}>
//                 <table style={S.table}>
//                   <THead cols={["#", "Coupon", "Name", "Mobile", "Sponsor", "Direct", "L1 ₹300", "L2 ₹150", "L3 ₹120", "L4 ₹90", "L5 ₹60", "L6 ₹30", "Total Income", "Withdrawn"]} />
//                   <tbody>
//                     {allMembers.filter(m => Number(m.total_income) > 0).map((m, i) => (
//                       <tr key={m.id} style={i % 2 === 0 ? S.trEven : {}}>
//                         <td style={S.td}>{i + 1}</td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#1d4ed8", cursor: "pointer" }} onClick={() => openDetail(m)}>{m.receiver_coupon_no}</td>
//                         <td style={S.td}>{m.receiver_name}</td>
//                         <td style={S.td}>{m.receiver_mobile}</td>
//                         <td style={{ ...S.td, fontSize: 11 }}>{m.sponsor_name || "—"}</td>
//                         <td style={S.td}>{m.direct_count}</td>
//                         {[1, 2, 3, 4, 5, 6].map(l => (
//                           <td key={l} style={{ ...S.td, color: m[`level${l}_income`] > 0 ? "#16a34a" : "#d1d5db", fontSize: 11 }}>
//                             {m[`level${l}_income`] > 0 ? inr(m[`level${l}_income`]) : "—"}
//                           </td>
//                         ))}
//                         <td style={{ ...S.td, fontWeight: 800, color: "#7c3aed" }}>{inr(m.total_income)}</td>
//                         <td style={{ ...S.td, color: "#dc2626" }}>{inr(m.total_withdrawn)}</td>
//                       </tr>
//                     ))}
//                     <tr style={{ background: "#eff6ff", fontWeight: 800 }}>
//                       <td style={S.td} colSpan={6}>COMPANY TOTAL</td>
//                       {[1, 2, 3, 4, 5, 6].map(l => (
//                         <td key={l} style={{ ...S.td, color: "#16a34a", fontWeight: 800 }}>
//                           {inr(allMembers.reduce((s, m) => s + Number(m[`level${l}_income`] || 0), 0))}
//                         </td>
//                       ))}
//                       <td style={{ ...S.td, color: "#7c3aed", fontSize: 14 }}>
//                         {inr(allMembers.reduce((s, m) => s + Number(m.total_income || 0), 0))}
//                       </td>
//                       <td style={{ ...S.td, color: "#dc2626" }}>
//                         {inr(allMembers.reduce((s, m) => s + Number(m.total_withdrawn || 0), 0))}
//                       </td>
//                     </tr>
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}

//           {/* ══════════ LEVEL WISE REPORT ══════════ */}
//           {subTab === "Level Wise Report" && (
//             <div>
//               <PageHead title="📊 Level Wise Report — Company Overview" />

//               {/* Chart */}
//               <div style={{ ...S.card, marginBottom: 16 }}>
//                 <CardHead>Level-wise Commission Distribution</CardHead>
//                 <div style={{ padding: 16 }}>
//                   <ResponsiveContainer width="100%" height={220}>
//                     <BarChart data={levelSummary}>
//                       <XAxis dataKey="level" tickFormatter={v => `L${v}`} tick={{ fontSize: 11 }} />
//                       <YAxis tick={{ fontSize: 10 }} tickFormatter={v => `₹${(v / 1000).toFixed(0)}k`} />
//                       <Tooltip formatter={(v) => inr(v)} labelFormatter={l => `Level ${l}`} />
//                       <Bar dataKey="total" name="Total Paid" radius={[4, 4, 0, 0]}>
//                         {levelSummary.map((entry, i) => (
//                           <Cell key={i} fill={PIE_COLORS[i % PIE_COLORS.length]} />
//                         ))}
//                       </Bar>
//                     </BarChart>
//                   </ResponsiveContainer>
//                 </div>
//               </div>

//               {/* Level wise detail table */}
//               <div style={S.tableWrap}>
//                 <table style={S.table}>
//                   <THead cols={["Level", "Rate per Join", "Members Benefiting", "Total Commissions Paid", "Avg per Member", "% of Total"]} />
//                   <tbody>
//                     {levelSummary.map((l, i) => {
//                       const grandTotal = levelSummary.reduce((s, x) => s + x.total, 0);
//                       const pct = grandTotal > 0 ? ((l.total / grandTotal) * 100).toFixed(1) : "0";
//                       const avg = l.members_paid > 0 ? l.total / l.members_paid : 0;
//                       return (
//                         <tr key={l.level} style={i % 2 === 0 ? S.trEven : {}}>
//                           <td style={S.td}>
//                             <span style={{ ...S.pill, background: PIE_COLORS[i], color: "#fff", fontSize: 12 }}>Level {l.level}</span>
//                           </td>
//                           <td style={{ ...S.td, fontWeight: 700 }}>₹{l.rate}</td>
//                           <td style={{ ...S.td, fontWeight: 700, color: "#1d4ed8" }}>{l.members_paid}</td>
//                           <td style={{ ...S.td, fontWeight: 800, color: "#16a34a", fontSize: 14 }}>{inr(l.total)}</td>
//                           <td style={{ ...S.td, color: "#7c3aed" }}>{inr(avg)}</td>
//                           <td style={S.td}>
//                             <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
//                               <div style={{ height: 8, borderRadius: 99, background: PIE_COLORS[i], width: `${Math.min(Number(pct) * 2, 150)}px` }} />
//                               <span style={{ fontSize: 12, fontWeight: 700 }}>{pct}%</span>
//                             </div>
//                           </td>
//                         </tr>
//                       );
//                     })}
//                     <tr style={{ background: "#f0fdf4", fontWeight: 800 }}>
//                       <td style={S.td} colSpan={2}>GRAND TOTAL</td>
//                       <td style={{ ...S.td, color: "#1d4ed8" }}>{levelSummary.reduce((s, l) => s + l.members_paid, 0)}</td>
//                       <td style={{ ...S.td, color: "#16a34a", fontSize: 15 }}>{inr(levelSummary.reduce((s, l) => s + l.total, 0))}</td>
//                       <td style={S.td}>—</td>
//                       <td style={S.td}>100%</td>
//                     </tr>
//                   </tbody>
//                 </table>
//               </div>

//               {/* Per-member level breakdown */}
//               <SectionTitle>👤 Member-wise Level Breakdown</SectionTitle>
//               <div style={S.tableWrap}>
//                 <table style={S.table}>
//                   <THead cols={["#", "Coupon", "Name", "L1", "L2", "L3", "L4", "L5", "L6", "Total", "Rank"]} />
//                   <tbody>
//                     {allMembers
//                       .filter(m => Number(m.total_income) > 0)
//                       .sort((a, b) => Number(b.total_income) - Number(a.total_income))
//                       .map((m, i) => (
//                         <tr key={m.id} style={i % 2 === 0 ? S.trEven : {}}>
//                           <td style={S.td}>{i + 1}</td>
//                           <td style={{ ...S.td, color: "#1d4ed8", fontWeight: 700, cursor: "pointer" }} onClick={() => openDetail(m)}>{m.receiver_coupon_no}</td>
//                           <td style={S.td}>{m.receiver_name}</td>
//                           {[1, 2, 3, 4, 5, 6].map(l => (
//                             <td key={l} style={{ ...S.td, fontSize: 11, color: Number(m[`level${l}_income`]) > 0 ? "#16a34a" : "#d1d5db" }}>
//                               {Number(m[`level${l}_income`]) > 0 ? `₹${Number(m[`level${l}_income`]).toFixed(0)}` : "—"}
//                             </td>
//                           ))}
//                           <td style={{ ...S.td, fontWeight: 800, color: "#7c3aed" }}>{inr(m.total_income)}</td>
//                           <td style={S.td}><span style={S.pill}>{m.rank || "—"}</span></td>
//                         </tr>
//                       ))}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}

//           {/* ══════════ COMMISSION REPORT ══════════ */}
//           {subTab === "Commission Report" && (
//             <div>
//               <PageHead title="💰 Commission Report — All Transactions" />

//               {/* Summary cards */}
//               <div style={{ display: "flex", gap: 10, marginBottom: 16, flexWrap: "wrap" }}>
//                 <div style={{ ...S.kpiCard, background: "#1e3a8a", minWidth: 150 }}>
//                   <div style={{ fontSize: 20 }}>💰</div>
//                   <div style={{ fontSize: 20, fontWeight: 800 }}>{inr(commissions.reduce((s, c) => s + Number(c.amount || 0), 0))}</div>
//                   <div style={{ fontSize: 10, opacity: .8 }}>Total Commission</div>
//                 </div>
//                 <div style={{ ...S.kpiCard, background: "#065f46", minWidth: 150 }}>
//                   <div style={{ fontSize: 20 }}>📋</div>
//                   <div style={{ fontSize: 20, fontWeight: 800 }}>{commissions.length}</div>
//                   <div style={{ fontSize: 10, opacity: .8 }}>Total Transactions</div>
//                 </div>
//                 {commissionByLevel.map((cl, i) => (
//                   <div key={cl.level} style={{ ...S.kpiCard, background: PIE_COLORS[i % PIE_COLORS.length], minWidth: 120 }}>
//                     <div style={{ fontSize: 14 }}>Level {cl.level}</div>
//                     <div style={{ fontSize: 16, fontWeight: 800 }}>{inr(cl.total)}</div>
//                     <div style={{ fontSize: 10, opacity: .8 }}>{cl.count} txns</div>
//                   </div>
//                 ))}
//               </div>

//               {/* Chart */}
//               <div style={{ ...S.card, marginBottom: 16 }}>
//                 <CardHead>Commission by Level</CardHead>
//                 <div style={{ padding: 16 }}>
//                   <ResponsiveContainer width="100%" height={180}>
//                     <BarChart data={commissionByLevel}>
//                       <XAxis dataKey="level" tickFormatter={v => `L${v}`} tick={{ fontSize: 11 }} />
//                       <YAxis tick={{ fontSize: 10 }} tickFormatter={v => `₹${(v / 1000).toFixed(0)}k`} />
//                       <Tooltip formatter={(v) => inr(v)} labelFormatter={l => `Level ${l}`} />
//                       <Bar dataKey="total" name="Commission" radius={[4, 4, 0, 0]}>
//                         {commissionByLevel.map((entry, i) => (
//                           <Cell key={i} fill={PIE_COLORS[i % PIE_COLORS.length]} />
//                         ))}
//                       </Bar>
//                     </BarChart>
//                   </ResponsiveContainer>
//                 </div>
//               </div>

//               <div style={S.tableWrap}>
//                 <table style={S.table}>
//                   <THead cols={["#", "Date & Time", "Level", "To Coupon", "To Member", "From Coupon", "From Member", "Amount"]} />
//                   <tbody>
//                     {commissions.length === 0 && (
//                       <tr><td colSpan={8} style={{ ...S.td, textAlign: "center", color: "#94a3b8", padding: 40 }}>
//                         No commission records found
//                       </td></tr>
//                     )}
//                     {commissions.map((c, i) => (
//                       <tr key={c.id} style={i % 2 === 0 ? S.trEven : {}}>
//                         <td style={S.td}>{i + 1}</td>
//                         <td style={{ ...S.td, fontSize: 11 }}>{fmtTime(c.created_at)}</td>
//                         <td style={S.td}>
//                           <span style={{ ...S.pill, background: PIE_COLORS[(c.level - 1) % PIE_COLORS.length], color: "#fff" }}>L{c.level}</span>
//                         </td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#1d4ed8" }}>{c.to_coupon || c.receiver_coupon_no}</td>
//                         <td style={S.td}>{c.to_name || c.receiver_name}</td>
//                         <td style={{ ...S.td, color: "#6366f1" }}>{c.from_coupon}</td>
//                         <td style={S.td}>{c.from_name}</td>
//                         <td style={{ ...S.td, fontWeight: 800, color: "#16a34a", fontSize: 14 }}>{inr(c.amount)}</td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}

//           {/* ══════════ DIRECT BUSINESS REPORT ══════════ */}
//           {subTab === "Direct Business Report" && (
//             <div>
//               <PageHead title="📊 Direct Business Report" />
//               <div style={S.tableWrap}>
//                 <table style={S.table}>
//                   <THead cols={["#", "Coupon", "Name", "Mobile", "Direct Members", "Indirect Members", "Total Team", "Direct Income", "Total Income"]} />
//                   <tbody>
//                     {[...allMembers].sort((a, b) => Number(b.direct_count) - Number(a.direct_count)).map((m, i) => (
//                       <tr key={m.id} style={i % 2 === 0 ? S.trEven : {}}>
//                         <td style={S.td}>{i + 1}</td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#1d4ed8", cursor: "pointer" }} onClick={() => openDetail(m)}>{m.receiver_coupon_no}</td>
//                         <td style={S.td}>{m.receiver_name}</td>
//                         <td style={S.td}>{m.receiver_mobile}</td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#1d4ed8" }}>{m.direct_count}</td>
//                         <td style={{ ...S.td, color: "#6366f1" }}>{m.indirect_count || 0}</td>
//                         <td style={S.td}>{Number(m.direct_count) + Number(m.indirect_count || 0)}</td>
//                         <td style={{ ...S.td, color: "#16a34a" }}>{inr(Number(m.direct_count) * LEVEL_RATE[1])}</td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#7c3aed" }}>{inr(m.total_income)}</td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}

//           {/* ══════════ BUSINESS REPORT ══════════ */}
//           {subTab === "Business Report" && (
//             <div>
//               <PageHead title="📈 Business Report — Full Company Overview" />

//               {/* Summary KPI row */}
//               <div style={S.kpiGrid}>
//                 {[
//                   { label: "Total Members", val: allMembers.length, icon: "👥", bg: "#1e3a8a" },
//                   { label: "Active Members", val: allMembers.filter(m => m.is_approved).length, icon: "✅", bg: "#065f46" },
//                   { label: "Total Business Vol.", val: inr(allMembers.length * 500), icon: "💼", bg: "#4c1d95" },
//                   { label: "Total Commission", val: inr(allMembers.reduce((s, m) => s + Number(m.total_income || 0), 0)), icon: "💰", bg: "#134e4a" },
//                   { label: "Total Withdrawn", val: inr(allMembers.reduce((s, m) => s + Number(m.total_withdrawn || 0), 0)), icon: "🏦", bg: "#7f1d1d" },
//                   { label: "Net in Wallets", val: inr(allMembers.reduce((s, m) => s + Number(m.total_income || 0) - Number(m.total_withdrawn || 0), 0)), icon: "💎", bg: "#1e1b4b" },
//                 ].map(c => (
//                   <div key={c.label} style={{ ...S.kpiCard, background: c.bg }}>
//                     <div style={{ fontSize: 22 }}>{c.icon}</div>
//                     <div style={{ fontSize: 18, fontWeight: 800 }}>{c.val}</div>
//                     <div style={{ fontSize: 10, opacity: .8 }}>{c.label}</div>
//                   </div>
//                 ))}
//               </div>

//               {/* Charts */}
//               <div style={{ display: "flex", gap: 14, marginBottom: 16, flexWrap: "wrap" }}>
//                 <div style={{ ...S.card, flex: 1, minWidth: 260 }}>
//                   <CardHead>🏆 Rank Distribution (Pie)</CardHead>
//                   <div style={{ padding: 16 }}>
//                     <ResponsiveContainer width="100%" height={200}>
//                       <PieChart>
//                         <Pie
//                           data={stats?.rank_dist || []}
//                           dataKey="count"
//                           nameKey="rank"
//                           cx="50%" cy="50%"
//                           outerRadius={75}
//                           label={({ rank, percent }) => `${rank} ${(percent * 100).toFixed(0)}%`}
//                         >
//                           {(stats?.rank_dist || []).map((entry, i) => (
//                             <Cell key={i} fill={PIE_COLORS[i % PIE_COLORS.length]} />
//                           ))}
//                         </Pie>
//                         <Tooltip />
//                         <Legend />
//                       </PieChart>
//                     </ResponsiveContainer>
//                   </div>
//                 </div>
//                 <div style={{ ...S.card, flex: 2, minWidth: 260 }}>
//                   <CardHead>📊 Income vs Withdrawal per Member (Top 15)</CardHead>
//                   <div style={{ padding: 16 }}>
//                     <ResponsiveContainer width="100%" height={200}>
//                       <BarChart data={topByIncome.slice(0, 15).map(m => ({
//                         name: m.receiver_coupon_no,
//                         Income: Number(m.total_income || 0),
//                         Withdrawn: Number(m.total_withdrawn || 0),
//                       }))}>
//                         <XAxis dataKey="name" tick={{ fontSize: 9 }} />
//                         <YAxis tick={{ fontSize: 9 }} tickFormatter={v => `₹${(v / 1000).toFixed(0)}k`} />
//                         <Tooltip formatter={v => inr(v)} />
//                         <Bar dataKey="Income" fill="#3b82f6" radius={[3, 3, 0, 0]} />
//                         <Bar dataKey="Withdrawn" fill="#ef4444" radius={[3, 3, 0, 0]} />
//                         <Legend />
//                       </BarChart>
//                     </ResponsiveContainer>
//                   </div>
//                 </div>
//               </div>

//               {/* Full table */}
//               <SectionTitle>📋 All Members Business Summary</SectionTitle>
//               <div style={S.tableWrap}>
//                 <table style={S.table}>
//                   <THead cols={["#", "Coupon", "Name", "Mobile", "Rank", "Direct", "Total Team", "Total Income", "Withdrawn", "Balance", "Status"]} />
//                   <tbody>
//                     {[...allMembers]
//                       .sort((a, b) => Number(b.total_income || 0) - Number(a.total_income || 0))
//                       .map((m, i) => (
//                         <tr key={m.id} style={i % 2 === 0 ? S.trEven : {}}>
//                           <td style={S.td}>{i + 1}</td>
//                           <td style={{ ...S.td, fontWeight: 700, color: "#1d4ed8", cursor: "pointer" }} onClick={() => openDetail(m)}>{m.receiver_coupon_no}</td>
//                           <td style={S.td}>{m.receiver_name}</td>
//                           <td style={S.td}>{m.receiver_mobile}</td>
//                           <td style={S.td}><span style={S.pill}>{m.rank || "—"}</span></td>
//                           <td style={{ ...S.td, fontWeight: 700 }}>{m.direct_count}</td>
//                           <td style={S.td}>{Number(m.direct_count || 0) + Number(m.indirect_count || 0)}</td>
//                           <td style={{ ...S.td, fontWeight: 800, color: "#16a34a" }}>{inr(m.total_income)}</td>
//                           <td style={{ ...S.td, color: "#dc2626" }}>{inr(m.total_withdrawn)}</td>
//                           <td style={{ ...S.td, fontWeight: 700, color: "#7c3aed" }}>
//                             {inr(Number(m.total_income || 0) - Number(m.total_withdrawn || 0))}
//                           </td>
//                           <td style={S.td}><span style={m.is_approved ? S.greenBadge : S.yellowBadge}>{m.is_approved ? "Active" : "Pending"}</span></td>
//                         </tr>
//                       ))}
//                     <tr style={{ background: "#eff6ff", fontWeight: 800 }}>
//                       <td style={S.td} colSpan={7}>TOTAL</td>
//                       <td style={{ ...S.td, color: "#16a34a", fontSize: 14 }}>{inr(allMembers.reduce((s, m) => s + Number(m.total_income || 0), 0))}</td>
//                       <td style={{ ...S.td, color: "#dc2626" }}>{inr(allMembers.reduce((s, m) => s + Number(m.total_withdrawn || 0), 0))}</td>
//                       <td style={{ ...S.td, color: "#7c3aed" }}>
//                         {inr(allMembers.reduce((s, m) => s + Number(m.total_income || 0) - Number(m.total_withdrawn || 0), 0))}
//                       </td>
//                       <td style={S.td}></td>
//                     </tr>
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}

//           {/* ══════════ COMMISSION SUMMARY ══════════ */}
//           {subTab === "Commission Summary" && (
//             <div>
//               <PageHead title="📋 Commission Summary" />

//               {/* Level totals */}
//               <SectionTitle>Level-wise Commission Totals</SectionTitle>
//               <div style={{ display: "flex", gap: 8, marginBottom: 16, flexWrap: "wrap" }}>
//                 {[1, 2, 3, 4, 5, 6].map((l, i) => (
//                   <div key={l} style={{ background: PIE_COLORS[i], color: "#fff", borderRadius: 10, padding: "12px 16px", minWidth: 120, textAlign: "center" }}>
//                     <div style={{ fontSize: 10, opacity: 0.8 }}>Level {l} (₹{LEVEL_RATE[l]}/join)</div>
//                     <div style={{ fontSize: 18, fontWeight: 800, marginTop: 4 }}>
//                       {inr(allMembers.reduce((s, m) => s + Number(m[`level${l}_income`] || 0), 0))}
//                     </div>
//                     <div style={{ fontSize: 10, opacity: 0.8, marginTop: 2 }}>
//                       {allMembers.filter(m => Number(m[`level${l}_income`]) > 0).length} earners
//                     </div>
//                   </div>
//                 ))}
//               </div>

//               {/* Top earners per level */}
//               {[1, 2, 3, 4, 5, 6].map((level, li) => (
//                 <div key={level}>
//                   <SectionTitle>🏆 Top 5 Earners — Level {level} (₹{LEVEL_RATE[level]}/join)</SectionTitle>
//                   <div style={S.tableWrap}>
//                     <table style={S.table}>
//                       <THead cols={["Rank", "Coupon", "Name", "Mobile", `L${level} Income`]} />
//                       <tbody>
//                         {[...allMembers]
//                           .filter(m => Number(m[`level${level}_income`]) > 0)
//                           .sort((a, b) => Number(b[`level${level}_income`]) - Number(a[`level${level}_income`]))
//                           .slice(0, 5)
//                           .map((m, i) => (
//                             <tr key={m.id} style={i % 2 === 0 ? S.trEven : {}}>
//                               <td style={{ ...S.td, fontWeight: 800, color: i < 3 ? "#f59e0b" : "#64748b" }}>#{i + 1}</td>
//                               <td style={{ ...S.td, color: "#1d4ed8", fontWeight: 700, cursor: "pointer" }} onClick={() => openDetail(m)}>{m.receiver_coupon_no}</td>
//                               <td style={S.td}>{m.receiver_name}</td>
//                               <td style={S.td}>{m.receiver_mobile}</td>
//                               <td style={{ ...S.td, fontWeight: 800, color: "#16a34a", fontSize: 14 }}>{inr(m[`level${level}_income`])}</td>
//                             </tr>
//                           ))}
//                       </tbody>
//                     </table>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           )}

//           {/* ══════════ DAILY JOINS ══════════ */}
//           {subTab === "Daily Joins" && (
//             <div>
//               <PageHead title="📅 Daily Joins Report — Last 30 Days" />

//               {dailyJoins.length === 0 ? (
//                 <div style={{ textAlign: "center", padding: 60, color: "#94a3b8", background: "#f8fafc", borderRadius: 8, border: "2px dashed #e2e8f0" }}>
//                   <div style={{ fontSize: 40, marginBottom: 12 }}>📅</div>
//                   <div style={{ fontWeight: 700, fontSize: 15 }}>Loading or no join data for last 30 days</div>
//                   <button style={{ ...S.btn, background: "#1e3a8a", marginTop: 16 }} onClick={loadDailyJoins}>🔄 Reload</button>
//                 </div>
//               ) : (
//                 <>
//                   {/* KPI cards — uses backend totals */}
//                   <div style={{ display: "flex", gap: 10, marginBottom: 16, flexWrap: "wrap" }}>
//                     {[
//                       { icon: "📅", label: "Total Joins", val: dailyJoins.reduce((s, d) => s + Number(d.count || 0), 0), bg: "#1e3a8a" },
//                       { icon: "✅", label: "Approved", val: dailyJoins.reduce((s, d) => s + Number(d.approved || 0), 0), bg: "#065f46" },
//                       { icon: "⏳", label: "Pending", val: dailyJoins.reduce((s, d) => s + Number(d.pending || 0), 0), bg: "#92400e" },
//                       {
//                         icon: "📈", label: "Avg / Day",
//                         val: dailyJoins.length > 0 ? Math.round(dailyJoins.reduce((s, d) => s + Number(d.count || 0), 0) / dailyJoins.length) : 0,
//                         bg: "#4c1d95"
//                       },
//                       {
//                         icon: "🏆", label: "Best Day",
//                         val: Math.max(...dailyJoins.map(d => Number(d.count || 0))),
//                         bg: "#134e4a"
//                       },
//                     ].map(c => (
//                       <div key={c.label} style={{ ...S.kpiCard, background: c.bg, minWidth: 130 }}>
//                         <div style={{ fontSize: 22 }}>{c.icon}</div>
//                         <div style={{ fontSize: 20, fontWeight: 800 }}>{c.val}</div>
//                         <div style={{ fontSize: 10, opacity: .8 }}>{c.label}</div>
//                       </div>
//                     ))}
//                   </div>

//                   {/* Chart — stacked approved + pending */}
//                   <div style={{ ...S.card, marginBottom: 16 }}>
//                     <CardHead>📈 Daily Registration Trend (Approved vs Pending)</CardHead>
//                     <div style={{ padding: 16 }}>
//                       <ResponsiveContainer width="100%" height={240}>
//                         <BarChart data={dailyJoins}>
//                           <XAxis dataKey="date" tick={{ fontSize: 9 }} />
//                           <YAxis tick={{ fontSize: 9 }} allowDecimals={false} />
//                           <Tooltip />
//                           <Legend />
//                           <Bar dataKey="approved" name="Approved" stackId="a" fill="#10b981" radius={[0, 0, 0, 0]} />
//                           <Bar dataKey="pending" name="Pending" stackId="a" fill="#f59e0b" radius={[4, 4, 0, 0]} />
//                         </BarChart>
//                       </ResponsiveContainer>
//                     </div>
//                   </div>

//                   {/* Table */}
//                   <div style={S.tableWrap}>
//                     <table style={S.table}>
//                       <THead cols={["#", "Date", "Total Joins", "Approved", "Pending", "Running Total", "Bar"]} />
//                       <tbody>
//                         {(() => {
//                           let running = 0;
//                           const maxCount = Math.max(...dailyJoins.map(d => Number(d.count || 0)), 1);
//                           return dailyJoins.map((d, i) => {
//                             running += Number(d.count || 0);
//                             const isMax = Number(d.count) === maxCount;
//                             return (
//                               <tr key={i} style={i % 2 === 0 ? S.trEven : {}}>
//                                 <td style={S.td}>{i + 1}</td>
//                                 <td style={{ ...S.td, fontWeight: 600 }}>{d.date}</td>
//                                 <td style={{ ...S.td, fontWeight: 800, color: isMax ? "#f59e0b" : "#1d4ed8", fontSize: 15 }}>
//                                   {d.count} {isMax ? "🏆" : ""}
//                                 </td>
//                                 <td style={{ ...S.td, color: "#16a34a", fontWeight: 700 }}>{d.approved || 0}</td>
//                                 <td style={{ ...S.td, color: "#f59e0b", fontWeight: 700 }}>{d.pending || 0}</td>
//                                 <td style={{ ...S.td, color: "#7c3aed" }}>{running}</td>
//                                 <td style={S.td}>
//                                   <div style={{ height: 10, borderRadius: 99, background: isMax ? "#f59e0b" : "#3b82f6", width: `${(Number(d.count) / maxCount) * 180}px`, minWidth: 4 }} />
//                                 </td>
//                               </tr>
//                             );
//                           });
//                         })()}
//                       </tbody>
//                     </table>
//                   </div>
//                 </>
//               )}
//             </div>
//           )}

//           {/* ══════════ NETWORK TREE ══════════ */}
//           {subTab === "Network Tree" && (
//             <div>
//               <PageHead title="🌳 Network Tree — Member Downline" />

//               {/* Search bar */}
//               <div style={{ ...S.card, marginBottom: 16 }}>
//                 <CardHead>Search Member Network</CardHead>
//                 <div style={{ padding: 16, display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
//                   <input
//                     style={{ ...S.searchBox, minWidth: 280 }}
//                     placeholder="Enter Coupon No (e.g. MR001) or Token Number..."
//                     value={networkToken}
//                     onChange={e => setNetworkToken(e.target.value)}
//                     onKeyDown={e => e.key === "Enter" && loadNetworkTree(networkToken)}
//                   />
//                   <button style={{ ...S.btn, background: "#1e3a8a", padding: "9px 20px" }}
//                     onClick={() => loadNetworkTree(networkToken)}>
//                     🔍 Load Tree
//                   </button>
//                   {networkTree && (
//                     <button style={{ ...S.btn, background: "#64748b" }}
//                       onClick={() => { setNetworkTree(null); setNetworkToken(""); }}>
//                       ✕ Clear
//                     </button>
//                   )}
//                   {networkTree && (
//                     <span style={{ ...S.countBadge, background: "#dcfce7", color: "#15803d" }}>
//                       Showing tree for: <b>{networkTree.receiver_coupon_no || networkTree.token_number}</b>
//                     </span>
//                   )}
//                 </div>
//               </div>

//               {/* Legend */}
//               <div style={{ display: "flex", gap: 12, marginBottom: 12, flexWrap: "wrap", alignItems: "center" }}>
//                 <span style={{ fontSize: 12, color: "#64748b", fontWeight: 600 }}>Depth:</span>
//                 {[
//                   { label: "Root", bg: "#1e3a8a" },
//                   { label: "Level 1 Direct", bg: "#1d4ed8" },
//                   { label: "Level 2", bg: "#3b82f6" },
//                   { label: "Level 3+", bg: "#eff6ff", color: "#1e3a8a", border: "1px solid #bfdbfe" },
//                 ].map(item => (
//                   <div key={item.label} style={{ display: "flex", alignItems: "center", gap: 6 }}>
//                     <div style={{ width: 14, height: 14, borderRadius: 3, background: item.bg, border: item.border }} />
//                     <span style={{ fontSize: 12, color: "#64748b" }}>{item.label}</span>
//                   </div>
//                 ))}
//                 <span style={{ fontSize: 11, color: "#94a3b8", marginLeft: "auto" }}>Click node to expand/collapse</span>
//               </div>

//               {/* Tree or empty state */}
//               {networkTree ? (
//                 <div style={{ ...S.card, padding: 16, maxHeight: 620, overflowY: "auto" }}>
//                   <TreeNode node={networkTree} depth={0} />
//                 </div>
//               ) : (
//                 <div style={{ textAlign: "center", padding: 60, color: "#94a3b8", background: "#f8fafc", borderRadius: 8, border: "2px dashed #e2e8f0" }}>
//                   <div style={{ fontSize: 48, marginBottom: 12 }}>🌳</div>
//                   <div style={{ fontWeight: 700, fontSize: 16, marginBottom: 6 }}>Enter a coupon number or token above</div>
//                   <div style={{ fontSize: 12 }}>Tree shows downline up to 6 levels deep. Click any node to expand.</div>
//                 </div>
//               )}
//             </div>
//           )}

//           {/* ══════════ WITHDRAWAL REQUESTS ══════════ */}
//           {subTab === "Withdrawal Requests" && (
//             <div>
//               <PageHead title="💸 Withdrawal Requests — Pending">
//                 <span style={{ ...S.countBadge, background: "#fee2e2", color: "#991b1b", marginLeft: "auto" }}>
//                   {withdrawals.length} Pending
//                 </span>
//               </PageHead>
//               <div style={S.tableWrap}>
//                 <table style={S.table}>
//                   <THead cols={["#", "Coupon", "Member", "Mobile", "Amount", "Method", "Bank/UPI Details", "Requested", "Actions"]} />
//                   <tbody>
//                     {withdrawals.map((w, i) => (
//                       <tr key={w.id} style={i % 2 === 0 ? S.trEven : {}}>
//                         <td style={S.td}>{i + 1}</td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#1d4ed8" }}>{w.receiver_coupon_no}</td>
//                         <td style={S.td}>{w.receiver_name}</td>
//                         <td style={S.td}>{w.receiver_mobile}</td>
//                         <td style={{ ...S.td, fontWeight: 800, color: "#16a34a", fontSize: 14 }}>{inr(w.amount)}</td>
//                         <td style={S.td}>{w.method?.toUpperCase()}</td>
//                         <td style={{ ...S.td, fontSize: 11 }}>
//                           {w.method === "bank"
//                             ? <><b>{w.bank_name}</b><br />A/c: {w.account_number}<br />IFSC: {w.ifsc}</>
//                             : <><b>UPI:</b> {w.upi_id}</>}
//                         </td>
//                         <td style={{ ...S.td, fontSize: 11 }}>{fmtTime(w.created_at)}</td>
//                         <td style={S.td}>
//                           <div style={{ display: "flex", gap: 4, flexDirection: "column" }}>
//                             <button style={{ ...S.btn, background: "#16a34a", fontSize: 11 }}
//                               onClick={() => processWithdrawal(w.id, "approved", w)}>
//                               ✅ Approve + 📱WA
//                             </button>
//                             <button style={{ ...S.btn, background: "#dc2626", fontSize: 11 }}
//                               onClick={() => processWithdrawal(w.id, "rejected", w)}>
//                               ❌ Reject
//                             </button>
//                           </div>
//                         </td>
//                       </tr>
//                     ))}
//                     {withdrawals.length === 0 && (
//                       <tr><td colSpan={9} style={{ ...S.td, textAlign: "center", color: "#94a3b8", padding: 40 }}>
//                         🎉 No pending withdrawal requests!
//                       </td></tr>
//                     )}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}

//           {/* ══════════ PAYMENT HISTORY ══════════ */}
//           {subTab === "Payment History" && (
//             <div>
//               <PageHead title="📋 Payment History — All Payouts" />
//               <SectionTitle>Level-wise Payment Breakdown</SectionTitle>
//               <div style={{ display: "flex", gap: 8, marginBottom: 16, flexWrap: "wrap" }}>
//                 {[1, 2, 3, 4, 5, 6].map(l => (
//                   <div key={l} style={{ background: "#1e3a8a", color: "#fff", borderRadius: 8, padding: "10px 14px", minWidth: 100, textAlign: "center" }}>
//                     <div style={{ fontSize: 10, opacity: .7 }}>Level {l} (₹{LEVEL_RATE[l]}/join)</div>
//                     <div style={{ fontSize: 16, fontWeight: 800 }}>
//                       {inr(allMembers.reduce((s, m) => s + Number(m[`level${l}_income`] || 0), 0))}
//                     </div>
//                     <div style={{ fontSize: 10, opacity: .7 }}>paid out</div>
//                   </div>
//                 ))}
//               </div>
//               <div style={S.tableWrap}>
//                 <table style={S.table}>
//                   <THead cols={["#", "Coupon", "Member", "Mobile", "Amount", "Method", "Status", "Processed", "Date", "WA"]} />
//                   <tbody>
//                     {payHistory.map((w, i) => (
//                       <tr key={w.id} style={i % 2 === 0 ? S.trEven : {}}>
//                         <td style={S.td}>{i + 1}</td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#1d4ed8" }}>{w.receiver_coupon_no}</td>
//                         <td style={S.td}>{w.receiver_name}</td>
//                         <td style={S.td}>{w.receiver_mobile}</td>
//                         <td style={{ ...S.td, fontWeight: 800, color: "#16a34a" }}>{inr(w.amount)}</td>
//                         <td style={S.td}>{w.method?.toUpperCase()}</td>
//                         <td style={S.td}>
//                           <span style={w.status === "approved" ? S.greenBadge : w.status === "rejected" ? S.redBadge : S.yellowBadge}>
//                             {w.status}
//                           </span>
//                         </td>
//                         <td style={{ ...S.td, fontSize: 11 }}>{w.processed_at ? fmt(w.processed_at) : "—"}</td>
//                         <td style={{ ...S.td, fontSize: 11 }}>{fmt(w.created_at)}</td>
//                         <td style={S.td}>
//                           <button style={{ ...S.btn, background: "#25D366", padding: "4px 8px" }}
//                             onClick={() => whatsapp(w.receiver_mobile,
//                               `💸 Namaste *${w.receiver_name}*!\n\nYour payout of *${inr(w.amount)}* is *${w.status.toUpperCase()}*.\n\n_${COMPANY}_\n${COMPANY_URL}`)}>
//                             📱
//                           </button>
//                         </td>
//                       </tr>
//                     ))}
//                     {payHistory.length === 0 && <tr><td colSpan={10} style={{ ...S.td, textAlign: "center", color: "#94a3b8", padding: 40 }}>No payment history</td></tr>}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}

//           {/* ══════════ ADD FUND TO MEMBER ══════════ */}
//           {subTab === "Add Fund to Member" && (
//             <div>
//               <PageHead title="➕ Add Fund to Member Wallet" />
//               <div style={{ ...S.card, maxWidth: 480 }}>
//                 <CardHead>Manually Add Amount (Received from Member)</CardHead>
//                 <div style={{ padding: 20 }}>
//                   <p style={{ fontSize: 12, color: "#64748b", marginBottom: 16, padding: "10px 14px", background: "#fefce8", borderRadius: 8, border: "1px solid #fde68a" }}>
//                     ⚠️ Use this to record an amount received from a member. It will be credited directly to their wallet and recorded as a transaction.
//                   </p>
//                   {[
//                     ["Member Token / Coupon No *", "token_number", "text", "Enter member token or coupon number"],
//                     ["Amount Received (₹) *", "amount", "number", "Enter amount"],
//                     ["Description *", "description", "text", "e.g. Cash received, Online payment ref #123"],
//                   ].map(([label, key, type, placeholder]) => (
//                     <div key={key} style={{ marginBottom: 14 }}>
//                       <label style={S.label}>{label}</label>
//                       <input style={S.input} type={type} placeholder={placeholder}
//                         value={addFundForm[key]} onChange={e => setAddFundForm({ ...addFundForm, [key]: e.target.value })} />
//                     </div>
//                   ))}
//                   <button style={{ ...S.btn, background: "#1e3a8a", width: "100%", padding: 12, fontSize: 14 }} onClick={addFund}>
//                     ➕ Credit to Member Wallet
//                   </button>
//                 </div>
//               </div>
//             </div>
//           )}

//           {/* ══════════ SALARY LIST ══════════ */}
//           {subTab === "Salary List" && (
//             <div>
//               <PageHead title="💰 Salary List" />

//               {/* Summary */}
//               <div style={{ display: "flex", gap: 10, marginBottom: 16, flexWrap: "wrap" }}>
//                 <div style={{ ...S.kpiCard, background: "#1e3a8a", minWidth: 150 }}>
//                   <div style={{ fontSize: 20 }}>📋</div>
//                   <div style={{ fontSize: 20, fontWeight: 800 }}>{salaries.length}</div>
//                   <div style={{ fontSize: 10, opacity: .8 }}>Total Records</div>
//                 </div>
//                 <div style={{ ...S.kpiCard, background: "#065f46", minWidth: 150 }}>
//                   <div style={{ fontSize: 20 }}>✅</div>
//                   <div style={{ fontSize: 20, fontWeight: 800 }}>{salaries.filter(s => s.is_approved).length}</div>
//                   <div style={{ fontSize: 10, opacity: .8 }}>Paid</div>
//                 </div>
//                 <div style={{ ...S.kpiCard, background: "#92400e", minWidth: 150 }}>
//                   <div style={{ fontSize: 20 }}>⏳</div>
//                   <div style={{ fontSize: 20, fontWeight: 800 }}>{salaries.filter(s => !s.is_approved).length}</div>
//                   <div style={{ fontSize: 10, opacity: .8 }}>Pending</div>
//                 </div>
//                 <div style={{ ...S.kpiCard, background: "#4c1d95", minWidth: 150 }}>
//                   <div style={{ fontSize: 20 }}>💰</div>
//                   <div style={{ fontSize: 18, fontWeight: 800 }}>{inr(salaries.reduce((s, x) => s + Number(x.amount || 0), 0))}</div>
//                   <div style={{ fontSize: 10, opacity: .8 }}>Total Amount</div>
//                 </div>
//               </div>

//               <div style={S.tableWrap}>
//                 <table style={S.table}>
//                   <THead cols={["#", "Coupon", "Member", "Mobile", "Rank", "Amount", "Month", "Status", "Action"]} />
//                   <tbody>
//                     {salaries.map((s, i) => (
//                       <tr key={s.id} style={i % 2 === 0 ? S.trEven : {}}>
//                         <td style={S.td}>{i + 1}</td>
//                         <td style={{ ...S.td, fontWeight: 700 }}>{s.receiver_coupon_no || s.token_number}</td>
//                         <td style={S.td}>{s.receiver_name}</td>
//                         <td style={S.td}>{s.receiver_mobile}</td>
//                         <td style={S.td}>
//                           <span style={{ ...S.pill, textTransform: "capitalize" }}>{s.rank}</span>
//                         </td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#16a34a" }}>{inr(s.amount)}</td>
//                         <td style={S.td}>{s.month}</td>
//                         <td style={S.td}>
//                           <span style={s.is_approved ? S.greenBadge : S.yellowBadge}>
//                             {s.is_approved ? "Paid ✅" : "Pending"}
//                           </span>
//                         </td>
//                         <td style={S.td}>
//                           {!s.is_approved && (
//                             <button style={{ ...S.btn, background: "#16a34a", fontSize: 11 }}
//                               onClick={() => approveSalary(s.id, s)}>
//                               Approve + 📱WA
//                             </button>
//                           )}
//                           {s.is_approved && (
//                             <button style={{ ...S.btn, background: "#25D366", fontSize: 11 }}
//                               onClick={() => whatsapp(s.receiver_mobile,
//                                 `💰 Namaste *${s.receiver_name}*!\n\nSalary of *${inr(s.amount)}* for ${s.month} credited ✅\n\n_${COMPANY}_`)}>
//                               📱 WA
//                             </button>
//                           )}
//                         </td>
//                       </tr>
//                     ))}
//                     {salaries.length === 0 && (
//                       <tr><td colSpan={9} style={{ ...S.td, textAlign: "center", color: "#94a3b8", padding: 40 }}>
//                         No records. Generate salary first.
//                       </td></tr>
//                     )}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}

//           {/* ══════════ GENERATE SALARY ══════════ */}
//           {subTab === "Generate Salary" && (
//             <div>
//               <PageHead title="💰 Generate Monthly Salary" />
//               <div style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
//                 <div style={{ ...S.card, maxWidth: 520, flex: 1 }}>
//                   <CardHead>Salary Generation</CardHead>
//                   <div style={{ padding: 20 }}>
//                     <p style={{ fontSize: 12, color: "#64748b", marginBottom: 16, padding: "10px 14px", background: "#f0fdf4", borderRadius: 8, border: "1px solid #bbf7d0" }}>
//                       ℹ️ This will generate salary records for all eligible members based on their current rank. Only generates if not already generated for this month.
//                     </p>
//                     <SectionTitle>Salary Rates by Rank</SectionTitle>
//                     {Object.entries(RANK_SALARY).map(([rank, amt]) => (
//                       <div key={rank} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 12px", borderBottom: "1px solid #f1f5f9", fontSize: 13 }}>
//                         <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
//                           <div style={{ width: 10, height: 10, borderRadius: "50%", background: rank === "diamond" ? "#06b6d4" : rank === "platinum" ? "#8b5cf6" : rank === "gold" ? "#f59e0b" : "#94a3b8" }} />
//                           <span style={{ textTransform: "capitalize", fontWeight: 600 }}>{rank}</span>
//                         </div>
//                         <span style={{ color: "#16a34a", fontWeight: 700 }}>{inr(amt)} / month</span>
//                       </div>
//                     ))}
//                     <div style={{ marginTop: 20 }}>
//                       <button
//                         style={{ ...S.btn, background: generatingSalary ? "#64748b" : "#1e3a8a", width: "100%", padding: 14, fontSize: 15 }}
//                         onClick={generateSalary}
//                         disabled={generatingSalary}
//                       >
//                         {generatingSalary ? "⏳ Generating..." : "🚀 Generate This Month's Salary"}
//                       </button>
//                     </div>
//                     {salaries.length > 0 && (
//                       <div style={{ marginTop: 12 }}>
//                         <button style={{ ...S.btn, background: "#7c3aed", width: "100%", padding: 10 }}
//                           onClick={() => goTo("salary", "Salary List")}>
//                           📋 View Salary List ({salaries.length} records)
//                         </button>
//                       </div>
//                     )}
//                   </div>
//                 </div>

//                 {/* Eligible members preview */}
//                 <div style={{ ...S.card, flex: 1, minWidth: 280 }}>
//                   <CardHead>👥 Eligible Members Preview</CardHead>
//                   <div style={{ padding: "8px 0", maxHeight: 380, overflowY: "auto" }}>
//                     {Object.keys(RANK_SALARY).map(rank => {
//                       const eligible = allMembers.filter(m => m.rank === rank && m.is_approved);
//                       if (eligible.length === 0) return null;
//                       return (
//                         <div key={rank}>
//                           <div style={{ padding: "8px 16px", background: "#f8fafc", fontSize: 11, fontWeight: 700, color: "#475569", textTransform: "uppercase", letterSpacing: 1 }}>
//                             {rank} — {inr(RANK_SALARY[rank])}/mo × {eligible.length} members = {inr(RANK_SALARY[rank] * eligible.length)}
//                           </div>
//                           {eligible.slice(0, 3).map(m => (
//                             <div key={m.id} style={{ padding: "6px 16px", borderBottom: "1px solid #f1f5f9", fontSize: 12, display: "flex", justifyContent: "space-between" }}>
//                               <span>{m.receiver_name}</span>
//                               <span style={{ color: "#16a34a", fontWeight: 700 }}>{inr(RANK_SALARY[rank])}</span>
//                             </div>
//                           ))}
//                           {eligible.length > 3 && (
//                             <div style={{ padding: "4px 16px", fontSize: 11, color: "#94a3b8" }}>
//                               +{eligible.length - 3} more...
//                             </div>
//                           )}
//                         </div>
//                       );
//                     })}
//                     {Object.keys(RANK_SALARY).every(rank => allMembers.filter(m => m.rank === rank && m.is_approved).length === 0) && (
//                       <div style={{ padding: 20, textAlign: "center", color: "#94a3b8", fontSize: 12 }}>
//                         No eligible members found
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               </div>
//             </div>
//           )}

//           {/* ══════════ ALL ADMINS ══════════ */}
//           {subTab === "All Admins" && (
//             <div>
//               <PageHead title="🛡 All Admins" />
//               <div style={S.tableWrap}>
//                 <table style={S.table}>
//                   <THead cols={["#", "Username", "Full Name", "Mobile", "Role", "Status", "Created"]} />
//                   <tbody>
//                     {adminList.map((a, i) => (
//                       <tr key={a.id} style={i % 2 === 0 ? S.trEven : {}}>
//                         <td style={S.td}>{i + 1}</td>
//                         <td style={{ ...S.td, fontWeight: 700 }}>{a.username}</td>
//                         <td style={S.td}>{a.full_name}</td>
//                         <td style={S.td}>{a.mobile}</td>
//                         <td style={S.td}><span style={a.role === "superadmin" ? S.greenBadge : S.pill}>{a.role}</span></td>
//                         <td style={S.td}><span style={a.is_active ? S.greenBadge : S.redBadge}>{a.is_active ? "Active" : "Inactive"}</span></td>
//                         <td style={{ ...S.td, fontSize: 11 }}>{fmt(a.created_at)}</td>
//                       </tr>
//                     ))}
//                     {adminList.length === 0 && <tr><td colSpan={7} style={{ ...S.td, textAlign: "center", color: "#94a3b8" }}>No admins</td></tr>}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}

//           {/* ══════════ CREATE ADMIN ══════════ */}
//           {subTab === "Create Admin" && (
//             <div>
//               <PageHead title="➕ Create New Admin" />
//               <div style={{ ...S.card, maxWidth: 480 }}>
//                 <CardHead>Admin Account Details</CardHead>
//                 <div style={{ padding: 20 }}>
//                   {[["Username *", "username", "text"], ["Password *", "password", "password"],
//                   ["Full Name", "full_name", "text"], ["Mobile", "mobile", "text"]].map(([label, key, type]) => (
//                     <div key={key} style={{ marginBottom: 14 }}>
//                       <label style={S.label}>{label}</label>
//                       <input style={S.input} type={type} value={newAdmin[key]}
//                         onChange={e => setNewAdmin({ ...newAdmin, [key]: e.target.value })} />
//                     </div>
//                   ))}
//                   <div style={{ marginBottom: 16 }}>
//                     <label style={S.label}>Role</label>
//                     <select style={S.input} value={newAdmin.role} onChange={e => setNewAdmin({ ...newAdmin, role: e.target.value })}>
//                       <option value="admin">Admin</option>
//                       <option value="superadmin">Super Admin</option>
//                     </select>
//                   </div>
//                   <button style={{ ...S.btn, background: "#1e3a8a", width: "100%", padding: 12 }} onClick={createAdmin}>
//                     Create Admin Account
//                   </button>
//                 </div>
//               </div>
//             </div>
//           )}

//           {/* Fallback */}
//           {tab !== "dashboard" && !subTab && (
//             <div style={{ padding: 60, textAlign: "center", color: "#94a3b8" }}>
//               Select a submenu item from the sidebar.
//             </div>
//           )}
//         </main>
//       </div>
//     </div>
//   );
// }

// /* ── Sub-components ── */
// function PageHead({ title, sub, children }) {
//   return (
//     <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 16, paddingBottom: 12, borderBottom: "2px solid #e2e8f0" }}>
//       <div style={{ width: 4, height: 20, background: "#ea580c", borderRadius: 99 }} />
//       <span style={{ fontWeight: 700, fontSize: 16, color: "#1e293b" }}>{title}</span>
//       {sub && <span style={{ fontSize: 11, color: "#94a3b8", marginLeft: 4 }}>{sub}</span>}
//       {children}
//     </div>
//   );
// }
// function SectionTitle({ children }) {
//   return <div style={{ fontWeight: 700, fontSize: 13, color: "#1e3a8a", margin: "18px 0 8px", borderLeft: "4px solid #ea580c", paddingLeft: 10 }}>{children}</div>;
// }
// function CardHead({ children }) {
//   return <div style={{ background: "#1e3a8a", color: "#fff", padding: "10px 16px", fontWeight: 700, fontSize: 13 }}>{children}</div>;
// }
// function THead({ cols }) {
//   return (
//     <thead>
//       <tr style={{ background: "#1e3a8a", color: "#fff" }}>
//         {cols.map(c => <th key={c} style={{ padding: "10px 12px", textAlign: "left", fontSize: 11, fontWeight: 700, whiteSpace: "nowrap" }}>{c}</th>)}
//       </tr>
//     </thead>
//   );
// }
// function ActionBtn({ color, onClick, disabled, children }) {
//   return (
//     <button onClick={onClick} disabled={disabled}
//       style={{ background: color, color: "#fff", border: "none", padding: "5px 9px", borderRadius: 5, cursor: "pointer", fontSize: 12, fontWeight: 700, opacity: disabled ? .6 : 1 }}>
//       {children}
//     </button>
//   );
// }

// /* ── Styles ── */
// const S = {
//   shell: { display: "flex", flexDirection: "column", minHeight: "100vh", fontFamily: "'Segoe UI', system-ui, sans-serif", fontSize: 13, background: "#f1f5f9" },
//   topbar: { background: "linear-gradient(90deg,#1e3a8a 0%,#1e40af 100%)", color: "#fff", display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 20px", position: "sticky", top: 0, zIndex: 100, boxShadow: "0 2px 10px rgba(0,0,0,.3)" },
//   logoBadge: { width: 40, height: 40, borderRadius: 10, background: "linear-gradient(135deg,#f97316,#ea580c)", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 900, fontSize: 18, color: "#fff", boxShadow: "0 2px 8px rgba(234,88,12,.4)" },
//   superBadge: { background: "rgba(255,255,255,.15)", border: "1px solid rgba(255,255,255,.3)", borderRadius: 99, padding: "3px 12px", fontSize: 11, fontWeight: 700, color: "#fef3c7", letterSpacing: .5 },
//   logoutBtn: { background: "rgba(239,68,68,.85)", border: "none", color: "#fff", padding: "6px 14px", borderRadius: 6, cursor: "pointer", fontWeight: 600, fontSize: 12 },
//   sidebar: { width: 205, background: "#1e3a8a", minHeight: "calc(100vh - 60px)", flexShrink: 0, overflowY: "auto" },
//   navItem: { color: "#bfdbfe", padding: "11px 16px", cursor: "pointer", display: "flex", alignItems: "center", fontSize: 13, borderBottom: "1px solid rgba(255,255,255,.06)", fontWeight: 500 },
//   navActive: { background: "#ea580c", color: "#fff" },
//   navSub: { color: "#93c5fd", padding: "9px 16px 9px 28px", cursor: "pointer", fontSize: 12, background: "rgba(0,0,0,.25)", borderBottom: "1px solid rgba(255,255,255,.04)" },
//   navSubActive: { background: "#ea580c", color: "#fff", fontWeight: 700 },
//   content: { flex: 1, padding: 20, overflowX: "auto" },
//   kpiGrid: { display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))", gap: 10, marginBottom: 16 },
//   kpiCard: { color: "#fff", borderRadius: 10, padding: "14px 16px", display: "flex", flexDirection: "column", gap: 4, boxShadow: "0 2px 8px rgba(0,0,0,.15)" },
//   card: { background: "#fff", border: "1px solid #e2e8f0", borderRadius: 8, overflow: "hidden" },
//   tableWrap: { background: "#fff", borderRadius: 8, border: "1px solid #e2e8f0", overflow: "auto", marginBottom: 16 },
//   table: { width: "100%", borderCollapse: "collapse", minWidth: 600 },
//   td: { padding: "9px 12px", fontSize: 12, borderBottom: "1px solid #f1f5f9", verticalAlign: "middle" },
//   trEven: { background: "#f8fafc" },
//   infoChip: { background: "#f0f9ff", border: "1px solid #bae6fd", borderRadius: 8, padding: "8px 12px", minWidth: 90 },
//   searchBox: { border: "1px solid #e2e8f0", borderRadius: 6, padding: "8px 12px", fontSize: 13, outline: "none", minWidth: 260, background: "#fff" },
//   countBadge: { background: "#eff6ff", color: "#1d4ed8", padding: "5px 12px", borderRadius: 99, fontWeight: 700, fontSize: 12 },
//   pill: { background: "#eff6ff", color: "#1d4ed8", padding: "2px 8px", borderRadius: 99, fontSize: 11, fontWeight: 600 },
//   greenBadge: { background: "#dcfce7", color: "#15803d", padding: "2px 8px", borderRadius: 99, fontSize: 11, fontWeight: 700 },
//   yellowBadge: { background: "#fef9c3", color: "#854d0e", padding: "2px 8px", borderRadius: 99, fontSize: 11, fontWeight: 700 },
//   redBadge: { background: "#fee2e2", color: "#991b1b", padding: "2px 8px", borderRadius: 99, fontSize: 11, fontWeight: 700 },
//   badge: { padding: "2px 8px", borderRadius: 99, fontSize: 11, fontWeight: 600 },
//   label: { display: "block", fontSize: 12, color: "#475569", marginBottom: 4, fontWeight: 600 },
//   input: { border: "1px solid #e2e8f0", padding: "9px 12px", width: "100%", fontSize: 13, borderRadius: 6, outline: "none", boxSizing: "border-box" },
//   btn: { color: "#fff", border: "none", padding: "7px 14px", borderRadius: 6, cursor: "pointer", fontWeight: 600, fontSize: 13, display: "inline-flex", alignItems: "center", gap: 4 },
// };



// import { useState, useEffect, useCallback, useMemo } from "react";
// import { useNavigate } from "react-router-dom";
// import { useAuth } from "../context/AuthContext";
// import {
//   BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer,
//   PieChart, Pie, Cell, Legend, LineChart, Line
// } from "recharts";
// import api from "../api";
// import toast from "react-hot-toast";

// /* ─── Constants ─── */
// const LEVEL_RATE = { 1: 300, 2: 150, 3: 120, 4: 90, 5: 60, 6: 30 };
// const RANK_SALARY = { silver: 1000, gold: 3000, platinum: 7000, diamond: 15000 };
// const PIE_COLORS = ["#3b82f6", "#10b981", "#f59e0b", "#ef4444", "#8b5cf6", "#06b6d4"];
// const COMPANY = "Meruram Lucky Draw";
// const COMPANY_URL = "https://meruram.in";

// /* ─── WhatsApp helper ─── */
// const whatsapp = (mobile, msg) => {
//   if (!mobile) { toast.error("No mobile number!"); return; }
//   window.open(`https://wa.me/91${mobile.replace(/\D/g, "")}?text=${encodeURIComponent(msg)}`, "_blank");
// };

// /* ─── Format helpers ─── */
// const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
// const fmt = (d) => d ? new Date(d).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : "—";
// const fmtTime = (d) => d ? new Date(d).toLocaleString("en-IN") : "—";

// /* ─── Sidebar nav ─── */
// const NAV = [
//   { label: "📊 Dashboard", key: "dashboard" },
//   {
//     label: "🎟 Members", key: "members",
//     children: ["All Members", "Pending Approval", "Approved Members", "Member Detail"],
//   },
//   {
//     label: "💹 Income & Business", key: "income",
//     children: [
//       "Level Income Report",
//       "Level Wise Report",
//       "Commission Report",
//       "Direct Business Report",
//       "Business Report",
//       "Commission Summary",
//       "Daily Joins",
//       "Network Tree",
//     ],
//   },
//   {
//     label: "💸 Payments", key: "payments",
//     children: ["Withdrawal Requests", "Payment History", "Add Fund to Member"],
//   },
//   {
//     label: "💰 Salary", key: "salary",
//     children: ["Salary List", "Generate Salary"],
//   },
//   {
//     label: "🛡 Admin Mgmt", key: "admins",
//     children: ["All Admins", "Create Admin"],
//   },
// ];

// /* ══════════════════════════════════════════════
//    MAIN COMPONENT
// ══════════════════════════════════════════════ */
// export default function SuperAdminDashboard() {
//   const { admin, logout } = useAuth();
//   const navigate = useNavigate();

//   /* State */
//   const [stats, setStats] = useState(null);
//   const [allMembers, setAllMembers] = useState([]);
//   const [withdrawals, setWithdrawals] = useState([]);
//   const [payHistory, setPayHistory] = useState([]);
//   const [salaries, setSalaries] = useState([]);
//   const [adminList, setAdminList] = useState([]);
//   const [selectedMember, setSelectedMember] = useState(null);
//   const [memberDetail, setMemberDetail] = useState(null);
//   const [loadingDetail, setLoadingDetail] = useState(false);
//   const [commissions, setCommissions] = useState([]);
//   const [networkTree, setNetworkTree] = useState(null);
//   const [networkToken, setNetworkToken] = useState("");
//   const [dailyJoins, setDailyJoins] = useState([]);
//   const [generatingSalary, setGeneratingSalary] = useState(false);
//   const [repairing, setRepairing] = useState(false);
//   const [repairLog, setRepairLog] = useState([]);

//   const [tab, setTab] = useState("dashboard");
//   const [subTab, setSubTab] = useState("");
//   const [openNav, setOpenNav] = useState({ dashboard: true });
//   const [search, setSearch] = useState("");
//   const [approving, setApproving] = useState({});

//   const [addFundForm, setAddFundForm] = useState({ token_number: "", amount: "", description: "Fund added by admin" });
//   const [newAdmin, setNewAdmin] = useState({ username: "", password: "", full_name: "", mobile: "", role: "admin" });

//   /* ── Fetch functions ── */
//   const loadStats = useCallback(async () => {
//     try { const r = await api.get("/mlm/super-stats"); setStats(r.data); } catch { toast.error("Stats load failed"); }
//   }, []);

//   const loadMembers = useCallback(async (q = "") => {
//     try {
//       // Use /coupons/all (same as working original code)
//       const r = await api.get(`/coupons/all?search=${encodeURIComponent(q)}&limit=500`);
//       setAllMembers(r.data.rows || []);
//     } catch { toast.error("Members load failed"); }
//   }, []);

//   const loadWithdrawals = useCallback(async () => {
//     try { const r = await api.get("/wallet/withdrawals/all?status=pending"); setWithdrawals(r.data.rows || []); } catch {}
//   }, []);

//   const loadPayHistory = useCallback(async () => {
//     try { const r = await api.get("/mlm/payment-history"); setPayHistory(r.data.rows || []); } catch {}
//   }, []);

//   const loadSalaries = useCallback(async () => {
//     try { const r = await api.get("/mlm/salary/list"); setSalaries(r.data.rows || []); } catch {}
//   }, []);

//   const loadAdmins = useCallback(async () => {
//     try { const r = await api.get("/auth/admins"); setAdminList(r.data || []); } catch {}
//   }, []);

//   const loadMemberDetail = useCallback(async (token) => {
//     if (!token) return;
//     setLoadingDetail(true);
//     try {
//       const r = await api.get(`/mlm/member-detail/${token}`);
//       if (r.data.success) {
//         setMemberDetail(r.data);
//       } else {
//         toast.error("Member not found");
//       }
//     } catch { toast.error("Failed to load member detail"); }
//     setLoadingDetail(false);
//   }, []);

//   const loadCommissions = useCallback(async () => {
//     try {
//       const r = await api.get("/mlm/commissions/all?limit=500");
//       setCommissions(r.data.rows || []);
//     } catch { toast.error("Commissions load failed"); }
//   }, []);

//   const loadDailyJoins = useCallback(async () => {
//     try {
//       const r = await api.get("/mlm/daily-joins?days=30");
//       // Backend returns { success, rows, totals, best_day }
//       setDailyJoins(r.data.rows || []);
//     } catch (e) { toast.error("Daily joins load failed"); }
//   }, []);

//   const loadNetworkTree = useCallback(async (token) => {
//     if (!token) { toast.error("Enter a token/coupon number"); return; }
//     try {
//       const r = await api.get(`/mlm/network-tree/${token}`);
//       // Backend returns the node directly at root: { success, token_number, receiver_name, children... }
//       if (r.data.success && r.data.token_number) {
//         setNetworkTree(r.data); // whole response IS the node
//       } else if (r.data.tree) {
//         setNetworkTree(r.data.tree); // fallback for /tree/:token format
//       } else {
//         toast.error("Member not found");
//       }
//     } catch { toast.error("Network tree load failed"); }
//   }, []);

//   useEffect(() => {
//     // Load everything on mount so dashboard is fully populated
//     Promise.all([loadStats(), loadMembers(), loadWithdrawals()]);
//   }, []);

//   /* ── Navigation ── */
//   const goTo = useCallback((t, s = "") => {
//     setTab(t); setSubTab(s);
//     if (t === "admins") loadAdmins();
//     if (s === "Withdrawal Requests") loadWithdrawals();
//     if (s === "Payment History") loadPayHistory();
//     if (s === "Salary List" || s === "Generate Salary") loadSalaries();
//     if (s === "Commission Report") loadCommissions();
//     if (s === "Daily Joins") loadDailyJoins();
//     if (
//       s === "All Members" || s === "Pending Approval" || s === "Approved Members" ||
//       s === "Level Income Report" || s === "Level Wise Report" ||
//       s === "Direct Business Report" || s === "Business Report" ||
//       s === "Commission Summary" || s === "Commission Report"
//     ) loadMembers(search);
//   }, [search, loadAdmins, loadWithdrawals, loadPayHistory, loadSalaries, loadMembers, loadCommissions, loadDailyJoins]);

//   /* ── Actions ── */
//   const approveCoupon = async (id, row) => {
//     setApproving(p => ({ ...p, [id]: true }));
//     try {
//       await api.post(`/coupons/approve/${id}`);
//       toast.success("✅ Approved!");
//       await Promise.all([loadMembers(search), loadStats()]);
//       if (row?.receiver_mobile) {
//         const message = `Welcome ${row.receiver_name} 🎉\n\nYour ID ${row.receiver_coupon_no || ""} has been approved successfully.\n\nWelcome to Meruram family 🚀\n\n${COMPANY_URL}`;
//         window.open(`https://wa.me/91${row.receiver_mobile.replace(/\D/g, "")}?text=${encodeURIComponent(message)}`, "_blank");
//       }
//     } catch (err) { toast.error(err.response?.data?.message || "Error"); }
//     setApproving(p => ({ ...p, [id]: false }));
//   };

//   const deleteCoupon = async (id) => {
//     if (!window.confirm("Delete this coupon permanently?")) return;
//     try { await api.delete(`/coupons/delete/${id}`); toast.success("Deleted"); loadMembers(search); loadStats(); }
//     catch { toast.error("Delete failed"); }
//   };

//   const processWithdrawal = async (id, action, row) => {
//     try {
//       await api.put(`/wallet/withdrawals/${id}`, { action });
//       if (action === "approved") {
//         toast.success("✅ Approved! Sending WhatsApp...");
//         whatsapp(row.receiver_mobile,
//           `💸 Namaste *${row.receiver_name}*!\n\nYour withdrawal request of *${inr(row.amount)}* has been *APPROVED & PROCESSED* ✅\n\nPayment via: *${(row.method || "").toUpperCase()}*\n${row.method === "upi" ? `UPI: ${row.upi_id || "—"}` : `Bank: ${row.bank_name || "—"} | Acc: ${row.account_number || "—"}`}\n\n_${COMPANY}_\n${COMPANY_URL}`
//         );
//       } else {
//         toast.error("❌ Withdrawal rejected");
//       }
//       loadWithdrawals(); loadPayHistory(); loadStats();
//     } catch (err) { toast.error(err.response?.data?.message || "Error"); }
//   };

//   const approveSalary = async (id, row) => {
//     try {
//       await api.put(`/mlm/salary/approve/${id}`);
//       toast.success("Salary credited!");
//       if (row?.receiver_mobile) {
//         whatsapp(row.receiver_mobile,
//           `💰 Namaste *${row.receiver_name}*!\n\nYour *${row.rank?.toUpperCase()} Rank Salary* of *${inr(row.amount)}* for ${row.month} has been credited to your wallet ✅\n\n_${COMPANY}_\n${COMPANY_URL}`
//         );
//       }
//       loadSalaries();
//     } catch (err) { toast.error(err.response?.data?.message || "Error"); }
//   };

//   const generateSalary = async () => {
//     setGeneratingSalary(true);
//     try {
//       const r = await api.post("/mlm/salary/generate");
//       toast.success(r.data.message || "Salary generated!");
//       loadSalaries();
//       goTo("salary", "Salary List");
//     } catch (err) { toast.error(err.response?.data?.message || "Error"); }
//     setGeneratingSalary(false);
//   };

//   /* ── One-click data repair (fixes referred_by → commissions → ranks) ── */
//   const runFullRepair = async () => {
//     if (!window.confirm(
//       "⚠️ This will:\n1. Fix referred_by for all members\n2. Redistribute missing commissions\n3. Recalculate all ranks\n\nSafe to run multiple times. Continue?"
//     )) return;

//     setRepairing(true);
//     setRepairLog([]);
//     const log = [];

//     try {
//       // Step 1: Fix referred_by
//       log.push("🔧 Step 1: Fixing referred_by links...");
//       setRepairLog([...log]);
//       const r1 = await api.post("/mlm/fix-referred-by");
//       log.push(`✅ Step 1 done: ${r1.data.fixed} members linked, ${r1.data.skipped} skipped`);
//       setRepairLog([...log]);

//       // Step 2: Redistribute commissions
//       log.push("💰 Step 2: Redistributing commissions...");
//       setRepairLog([...log]);
//       const r2 = await api.post("/mlm/redistribute-commissions");
//       log.push(`✅ Step 2 done: commissions distributed for ${r2.data.processed} members`);
//       if (r2.data.errors?.length) {
//         log.push(`⚠️ ${r2.data.errors.length} errors (check server logs)`);
//       }
//       setRepairLog([...log]);

//       // Step 3: Recalculate ranks
//       log.push("🏆 Step 3: Recalculating all ranks...");
//       setRepairLog([...log]);
//       const r3 = await api.post("/mlm/recalculate-all-ranks");
//       const rankSummary = Object.entries(r3.data.summary || {})
//         .map(([rank, count]) => `${rank}: ${count}`)
//         .join(", ");
//       log.push(`✅ Step 3 done: ${r3.data.message} → ${rankSummary}`);
//       setRepairLog([...log]);

//       log.push("🎉 All repairs complete! Reloading data...");
//       setRepairLog([...log]);

//       // Reload everything
//       await Promise.all([loadStats(), loadMembers()]);
//       toast.success("✅ Data repair complete!");
//     } catch (err) {
//       log.push(`❌ Error: ${err.response?.data?.message || err.message}`);
//       setRepairLog([...log]);
//       toast.error("Repair failed — check log");
//     }
//     setRepairing(false);
//   };

//   const addFund = async () => {
//     if (!addFundForm.token_number || !addFundForm.amount) { toast.error("Fill all fields"); return; }
//     try {
//       const r = await api.post("/mlm/add-fund", addFundForm);
//       toast.success(r.data.message);
//       setAddFundForm({ token_number: "", amount: "", description: "Fund added by admin" });
//       loadMembers(); loadStats();
//     } catch (err) { toast.error(err.response?.data?.message || "Error"); }
//   };

//   const createAdmin = async () => {
//     if (!newAdmin.username || !newAdmin.password) { toast.error("Username & password required"); return; }
//     try {
//       await api.post("/auth/create-admin", newAdmin);
//       toast.success("Admin created!");
//       setNewAdmin({ username: "", password: "", full_name: "", mobile: "", role: "admin" });
//       loadAdmins();
//     } catch (err) { toast.error(err.response?.data?.message || "Error"); }
//   };

//   const openDetail = async (row) => {
//     // Support rows from all-members-stats (token_number) and level-wise (token field)
//     const tokenToLoad = row.token_number || row.token;
//     setSelectedMember(row);
//     setTab("members"); setSubTab("Member Detail");
//     await loadMemberDetail(tokenToLoad);
//   };

//   /* ── Filtered member lists ── */
//   const filteredMembers = useMemo(() => {
//     if (subTab === "Pending Approval") return allMembers.filter(c => !c.is_approved);
//     if (subTab === "Approved Members") return allMembers.filter(c => c.is_approved);
//     return allMembers;
//   }, [allMembers, subTab]);

//   /* ── Top members by income ── */
//   const topByIncome = useMemo(() =>
//     [...allMembers].sort((a, b) => Number(b.total_income || 0) - Number(a.total_income || 0)).slice(0, 10),
//     [allMembers]
//   );

//   const topByDirect = useMemo(() =>
//     [...allMembers].sort((a, b) => Number(b.direct_count || 0) - Number(a.direct_count || 0)).slice(0, 10),
//     [allMembers]
//   );

//   /* ── Level summary (company-wide) ── */
//   const levelSummary = useMemo(() => {
//     const map = {};
//     allMembers.forEach(m => {
//       for (let l = 1; l <= 6; l++) {
//         const earned = Number(m[`level${l}_income`] || 0);
//         if (!map[l]) map[l] = { level: l, total: 0, members_paid: 0, rate: LEVEL_RATE[l] };
//         if (earned > 0) { map[l].total += earned; map[l].members_paid++; }
//       }
//     });
//     return Object.values(map);
//   }, [allMembers]);

//   /* ── Commission summary per level ── */
//   const commissionByLevel = useMemo(() => {
//     const map = {};
//     commissions.forEach(c => {
//       const l = c.level;
//       if (!map[l]) map[l] = { level: l, count: 0, total: 0 };
//       map[l].count++;
//       map[l].total += Number(c.amount || 0);
//     });
//     return Object.values(map).sort((a, b) => a.level - b.level);
//   }, [commissions]);

//   /* ── Network Tree recursive renderer ── */
//   const TreeNode = ({ node, depth = 0 }) => {
//     const [expanded, setExpanded] = useState(depth < 2);
//     if (!node) return null;
//     const hasChildren = node.children && node.children.length > 0;
//     return (
//       <div style={{ marginLeft: depth * 24, marginBottom: 4 }}>
//         <div
//           style={{
//             display: "flex", alignItems: "center", gap: 8, padding: "8px 12px",
//             background: depth === 0 ? "#1e3a8a" : depth === 1 ? "#1d4ed8" : depth === 2 ? "#3b82f6" : "#eff6ff",
//             color: depth < 3 ? "#fff" : "#1e3a8a",
//             borderRadius: 8, cursor: hasChildren ? "pointer" : "default",
//             border: "1px solid rgba(255,255,255,0.1)",
//             transition: "all 0.15s",
//           }}
//           onClick={() => hasChildren && setExpanded(e => !e)}
//         >
//           {hasChildren && <span style={{ fontSize: 10, minWidth: 14 }}>{expanded ? "▼" : "▶"}</span>}
//           {!hasChildren && <span style={{ fontSize: 10, minWidth: 14, opacity: 0.5 }}>●</span>}
//           <span style={{ fontWeight: 700, fontSize: 12 }}>{node.receiver_coupon_no || node.token_number}</span>
//           <span style={{ fontSize: 12 }}>{node.receiver_name}</span>
//           <span style={{ fontSize: 11, opacity: 0.75 }}>{node.receiver_mobile}</span>
//           {hasChildren && (
//             <span style={{ marginLeft: "auto", background: "rgba(255,255,255,0.2)", borderRadius: 99, padding: "1px 8px", fontSize: 11 }}>
//               {node.children.length} direct
//             </span>
//           )}
//           <span style={{
//             marginLeft: hasChildren ? 4 : "auto",
//             background: node.is_approved ? "#16a34a" : "#f59e0b",
//             borderRadius: 99, padding: "1px 8px", fontSize: 10, color: "#fff"
//           }}>
//             {node.is_approved ? "Active" : "Pending"}
//           </span>
//         </div>
//         {expanded && hasChildren && (
//           <div style={{ borderLeft: "2px solid #bfdbfe", marginLeft: 18, paddingLeft: 6, marginTop: 4 }}>
//             {node.children.map(child => (
//               <TreeNode key={child.id || child.token_number} node={child} depth={depth + 1} />
//             ))}
//           </div>
//         )}
//       </div>
//     );
//   };

//   /* ─────────────── RENDER ─────────────── */
//   return (
//     <div style={S.shell}>
//       {/* ══ TOP BAR ══ */}
//       <header style={S.topbar}>
//         <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
//           <div style={S.logoBadge}>मे</div>
//           <div>
//             <div style={{ fontWeight: 800, fontSize: 16, letterSpacing: .5, color: "#fff" }}>MERURAM</div>
//             <div style={{ fontSize: 9, color: "#93c5fd", letterSpacing: 3 }}>LUCKY DRAW · SUPER ADMIN</div>
//           </div>
//         </div>
//         <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
//           <span style={S.superBadge}>👑 SUPER ADMIN</span>
//           <span style={{ fontSize: 12, color: "#ddd" }}>
//             {admin?.full_name || admin?.username}
//           </span>
//           <button style={S.logoutBtn} onClick={() => { logout(); navigate("/superadmin/login"); }}>
//             Logout
//           </button>
//         </div>
//       </header>

//       <div style={{ display: "flex", flex: 1 }}>
//         {/* ══ SIDEBAR ══ */}
//         <nav style={S.sidebar}>
//           {NAV.map(n => (
//             <div key={n.key}>
//               <div
//                 style={{ ...S.navItem, ...(tab === n.key && !subTab && !n.children ? S.navActive : {}) }}
//                 onClick={() => n.children ? setOpenNav(p => ({ ...p, [n.key]: !p[n.key] })) : goTo(n.key)}
//               >
//                 <span style={{ flex: 1 }}>{n.label}</span>
//                 {n.children && <span style={{ fontSize: 10, opacity: .6 }}>{openNav[n.key] ? "▾" : "▸"}</span>}
//               </div>
//               {n.children && openNav[n.key] && n.children
//                 .filter(c => c !== "Member Detail")
//                 .map(child => (
//                   <div key={child}
//                     style={{
//                       ...S.navSub,
//                       ...(subTab === child ? S.navSubActive : {})
//                     }}
//                     onClick={() => goTo(n.key, child)}
//                   >{child}</div>
//                 ))}
//             </div>
//           ))}
//           <div style={S.navItem} onClick={() => { logout(); navigate("/superadmin/login"); }}>
//             🚪 Logout
//           </div>
//         </nav>

//         {/* ══ MAIN CONTENT ══ */}
//         <main style={S.content}>

//           {/* ══════════ DASHBOARD ══════════ */}
//           {tab === "dashboard" && stats && (
//             <div>
//               <PageHead title="Dashboard Overview" sub={COMPANY_URL} />

//               {/* KPI Grid */}
//               <div style={S.kpiGrid}>
//                 {[
//                   { label: "Total Coupons", val: stats.total_members, icon: "🎟", bg: "#1e40af" },
//                   { label: "Approved", val: stats.approved, icon: "✅", bg: "#065f46" },
//                   { label: "Pending", val: stats.pending, icon: "⏳", bg: "#92400e" },
//                   { label: "Pending Payouts", val: stats.pending_payouts, icon: "💸", bg: "#7f1d1d" },
//                   { label: "Total Wallet", val: inr(stats.total_wallet), icon: "💰", bg: "#4c1d95" },
//                   { label: "Commission Paid", val: inr(stats.total_commission), icon: "📈", bg: "#134e4a" },
//                   { label: "Payout Done", val: inr(stats.total_payout_done), icon: "🏦", bg: "#1e1b4b" },
//                   { label: "Pending Salary", val: stats.pending_salary, icon: "📋", bg: "#701a75" },
//                 ].map(c => (
//                   <div key={c.label} style={{ ...S.kpiCard, background: c.bg }}>
//                     <div style={{ fontSize: 22 }}>{c.icon}</div>
//                     <div style={{ fontSize: 20, fontWeight: 800 }}>{c.val}</div>
//                     <div style={{ fontSize: 10, opacity: .8 }}>{c.label}</div>
//                   </div>
//                 ))}
//               </div>

//               {/* ── DATA REPAIR PANEL ── */}
//               <div style={{
//                 background: "linear-gradient(135deg, #1e1b4b 0%, #312e81 100%)",
//                 borderRadius: 12, padding: "16px 20px", marginBottom: 16,
//                 border: "1px solid #4338ca", display: "flex", gap: 16,
//                 alignItems: "flex-start", flexWrap: "wrap"
//               }}>
//                 <div style={{ flex: 1, minWidth: 220 }}>
//                   <div style={{ fontWeight: 800, color: "#c7d2fe", fontSize: 13, marginBottom: 4 }}>
//                     🔧 Data Repair Tool
//                   </div>
//                   <div style={{ fontSize: 11, color: "#a5b4fc", lineHeight: 1.6 }}>
//                     Run once if members, commissions or ranks are showing blank/zero.
//                     Fixes <code style={{ background: "#1e1b4b", padding: "1px 4px", borderRadius: 3 }}>referred_by</code>,
//                     redistributes missing commissions, recalculates all ranks.
//                   </div>
//                 </div>
//                 <div style={{ display: "flex", flexDirection: "column", gap: 8, minWidth: 200 }}>
//                   <button
//                     style={{
//                       background: repairing ? "#4338ca" : "#6366f1",
//                       color: "#fff", border: "none", borderRadius: 8,
//                       padding: "10px 20px", fontWeight: 700, fontSize: 13,
//                       cursor: repairing ? "not-allowed" : "pointer",
//                       opacity: repairing ? 0.7 : 1,
//                     }}
//                     onClick={runFullRepair}
//                     disabled={repairing}
//                   >
//                     {repairing ? "⏳ Repairing..." : "🚀 Run Full Data Repair"}
//                   </button>
//                   {repairLog.length > 0 && (
//                     <div style={{
//                       background: "#0f172a", borderRadius: 8, padding: "10px 12px",
//                       fontSize: 11, fontFamily: "monospace", lineHeight: 1.8,
//                       maxHeight: 160, overflowY: "auto", border: "1px solid #334155"
//                     }}>
//                       {repairLog.map((line, i) => (
//                         <div key={i} style={{
//                           color: line.startsWith("✅") ? "#4ade80"
//                                : line.startsWith("❌") ? "#f87171"
//                                : line.startsWith("⚠️") ? "#fbbf24"
//                                : line.startsWith("🎉") ? "#818cf8"
//                                : "#94a3b8"
//                         }}>{line}</div>
//                       ))}
//                     </div>
//                   )}
//                 </div>
//               </div>

//               {/* Company-wide Level Summary */}
//               <SectionTitle>💹 Company-wide Level Commission Summary</SectionTitle>
//               <div style={S.tableWrap}>
//                 <table style={S.table}>
//                   <THead cols={["Level", "Rate/Join", "Members Benefiting", "Total Paid Out", "Chart"]} />
//                   <tbody>
//                     {levelSummary.map((l, i) => (
//                       <tr key={l.level} style={i % 2 === 0 ? S.trEven : {}}>
//                         <td style={S.td}><b>Level {l.level}</b></td>
//                         <td style={S.td}>₹{l.rate}</td>
//                         <td style={S.td}>{l.members_paid}</td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#16a34a" }}>{inr(l.total)}</td>
//                         <td style={S.td}>
//                           <div style={{ width: Math.min((l.total / (stats.total_commission || 1)) * 300, 200), height: 8, background: PIE_COLORS[i % PIE_COLORS.length], borderRadius: 99 }} />
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>

//               {/* Charts Row */}
//               <div style={{ display: "flex", gap: 14, marginTop: 4, flexWrap: "wrap" }}>
//                 <div style={{ ...S.card, flex: 2, minWidth: 280 }}>
//                   <CardHead>📅 Daily Registrations (14 days)</CardHead>
//                   <div style={{ padding: 16 }}>
//                     <ResponsiveContainer width="100%" height={180}>
//                       <BarChart data={stats.daily_joins || []}>
//                         <XAxis dataKey="date" tick={{ fontSize: 9 }} />
//                         <YAxis tick={{ fontSize: 9 }} />
//                         <Tooltip />
//                         <Bar dataKey="count" fill="#3b82f6" radius={[3, 3, 0, 0]} name="Joins" />
//                       </BarChart>
//                     </ResponsiveContainer>
//                   </div>
//                 </div>
//                 <div style={{ ...S.card, flex: 1, minWidth: 200 }}>
//                   <CardHead>🏆 Rank Distribution</CardHead>
//                   <div style={{ padding: "8px 0" }}>
//                     {(stats.rank_dist || []).map((r, i) => (
//                       <div key={r.rank} style={{ display: "flex", justifyContent: "space-between", padding: "8px 16px", borderBottom: "1px solid #f1f5f9", alignItems: "center" }}>
//                         <span style={{ fontSize: 12, textTransform: "capitalize", fontWeight: 600 }}>{r.rank}</span>
//                         <span style={{ ...S.badge, background: PIE_COLORS[i % PIE_COLORS.length], color: "#fff" }}>{r.count}</span>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               </div>

//               {/* Top 10 by Income */}
//               <SectionTitle>🥇 Top 10 Members by Total Income</SectionTitle>
//               <div style={S.tableWrap}>
//                 <table style={S.table}>
//                   <THead cols={["Rank", "Coupon", "Name", "Direct", "L1", "L2", "L3", "L4", "L5", "L6", "Total Income"]} />
//                   <tbody>
//                     {topByIncome.map((m, i) => (
//                       <tr key={m.id} style={i % 2 === 0 ? S.trEven : {}}>
//                         <td style={{ ...S.td, fontWeight: 800, color: i < 3 ? "#f59e0b" : "#64748b" }}>#{i + 1}</td>
//                         <td style={{ ...S.td, color: "#1d4ed8", fontWeight: 700, cursor: "pointer" }} onClick={() => openDetail(m)}>
//                           {m.receiver_coupon_no}
//                         </td>
//                         <td style={S.td}>{m.receiver_name}</td>
//                         <td style={S.td}>{m.direct_count}</td>
//                         {[1, 2, 3, 4, 5, 6].map(l => (
//                           <td key={l} style={{ ...S.td, fontSize: 11, color: m[`level${l}_income`] > 0 ? "#16a34a" : "#ccc" }}>
//                             {m[`level${l}_income`] > 0 ? inr(m[`level${l}_income`]) : "—"}
//                           </td>
//                         ))}
//                         <td style={{ ...S.td, fontWeight: 800, color: "#7c3aed" }}>{inr(m.total_income)}</td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>

//               {/* Top 10 by Direct */}
//               <SectionTitle>👥 Top 10 Members by Direct Connections</SectionTitle>
//               <div style={S.tableWrap}>
//                 <table style={S.table}>
//                   <THead cols={["Rank", "Coupon", "Name", "Mobile", "Direct", "Total Team", "Total Business"]} />
//                   <tbody>
//                     {topByDirect.map((m, i) => (
//                       <tr key={m.id} style={i % 2 === 0 ? S.trEven : {}}>
//                         <td style={{ ...S.td, fontWeight: 800, color: i < 3 ? "#f59e0b" : "#64748b" }}>#{i + 1}</td>
//                         <td style={{ ...S.td, color: "#1d4ed8", fontWeight: 700, cursor: "pointer" }} onClick={() => openDetail(m)}>
//                           {m.receiver_coupon_no}
//                         </td>
//                         <td style={S.td}>{m.receiver_name}</td>
//                         <td style={S.td}>{m.receiver_mobile}</td>
//                         <td style={{ ...S.td, fontWeight: 700 }}>{m.direct_count}</td>
//                         <td style={S.td}>{Number(m.direct_count || 0) + Number(m.indirect_count || 0)}</td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#16a34a" }}>{inr(m.total_income)}</td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}

//           {/* ══════════ ALL MEMBERS ══════════ */}
//           {(subTab === "All Members" || subTab === "Pending Approval" || subTab === "Approved Members") && (
//             <div>
//               <PageHead title={`🎟 ${subTab}`} />
//               <div style={{ display: "flex", gap: 10, marginBottom: 12, flexWrap: "wrap" }}>
//                 <input style={S.searchBox}
//                   placeholder="🔍 Search name, mobile, coupon..."
//                   value={search}
//                   onChange={e => { setSearch(e.target.value); loadMembers(e.target.value); }}
//                 />
//                 <span style={S.countBadge}>Total: {filteredMembers.length}</span>
//                 <span style={{ ...S.countBadge, background: "#dcfce7", color: "#15803d" }}>
//                   Active: {filteredMembers.filter(m => m.is_approved).length}
//                 </span>
//                 <span style={{ ...S.countBadge, background: "#fef9c3", color: "#854d0e" }}>
//                   Pending: {filteredMembers.filter(m => !m.is_approved).length}
//                 </span>
//               </div>
//               <div style={S.tableWrap}>
//                 <table style={S.table}>
//                   <THead cols={[
//                     "#", "Coupon", "Name", "Mobile", "Aadhaar", "Giver",
//                     "Payment", "Screenshot", "Wallet", "Rank", "Status", "Date", "Actions"
//                   ]} />
//                   <tbody>
//                     {filteredMembers.map((c, i) => (
//                       <tr key={c.id} style={i % 2 === 0 ? S.trEven : {}}>
//                         <td style={S.td}>{i + 1}</td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#1d4ed8", cursor: "pointer" }}
//                           onClick={() => openDetail(c)}>
//                           {c.receiver_coupon_no || "—"}
//                         </td>
//                         <td style={S.td}>{c.receiver_name}</td>
//                         <td style={S.td}>{c.receiver_mobile}</td>
//                         <td style={{ ...S.td, fontSize: 11 }}>
//                           {c.receiver_aadhaar ? "••••" + String(c.receiver_aadhaar).slice(-4) : "—"}
//                         </td>
//                         <td style={S.td}>{c.giver_name || "—"}</td>
//                         <td style={S.td}>
//                           <span style={S.pill}>{c.payment_cash ? "Cash" : "Online"}</span>
//                         </td>
//                         <td style={S.td}>
//                           {c.screenshot
//                             ? <a href={`/uploads/${c.screenshot}`} target="_blank" rel="noreferrer"
//                                 style={{ color: "#1d4ed8", fontWeight: 600, fontSize: 11 }}>View 📷</a>
//                             : "—"}
//                         </td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#7c3aed" }}>{inr(c.wallet_balance)}</td>
//                         <td style={S.td}>
//                           <span style={S.pill}>{c.rank || "member"}</span>
//                         </td>
//                         <td style={S.td}>
//                           <span style={c.is_approved ? S.greenBadge : S.yellowBadge}>
//                             {c.is_approved ? "Active" : "Pending"}
//                           </span>
//                         </td>
//                         <td style={{ ...S.td, fontSize: 11 }}>{fmt(c.created_at)}</td>
//                         <td style={S.td}>
//                           <div style={{ display: "flex", gap: 3, flexWrap: "wrap" }}>
//                             {!c.is_approved && (
//                               <ActionBtn color="#16a34a" disabled={approving[c.id]}
//                                 onClick={() => approveCoupon(c.id, c)}>
//                                 {approving[c.id] ? "..." : "✅"}
//                               </ActionBtn>
//                             )}
//                             <ActionBtn color="#1d4ed8" onClick={() => openDetail(c)}>👁</ActionBtn>
//                             <ActionBtn color="#25D366" onClick={() =>
//                               whatsapp(c.receiver_mobile,
//                                 `Namaste *${c.receiver_name}*! Your coupon status: ${c.is_approved ? "Active ✅" : "Pending ⏳"}. Visit ${COMPANY_URL}`)
//                             }>📱</ActionBtn>
//                             <ActionBtn color="#dc2626" onClick={() => deleteCoupon(c.id)}>🗑</ActionBtn>
//                           </div>
//                         </td>
//                       </tr>
//                     ))}
//                     {filteredMembers.length === 0 && (
//                       <tr><td colSpan={13} style={{ ...S.td, textAlign: "center", color: "#94a3b8", padding: 40 }}>
//                         No records found
//                       </td></tr>
//                     )}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}

//           {/* ══════════ MEMBER DETAIL ══════════ */}
//           {subTab === "Member Detail" && (
//             <div>
//               <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
//                 <PageHead title={`👤 Member Detail${memberDetail ? " — " + memberDetail.member?.receiver_name : ""}`} />
//                 <button style={{ ...S.btn, background: "#64748b" }} onClick={() => goTo("members", "All Members")}>← Back</button>
//               </div>

//               {loadingDetail && <div style={{ textAlign: "center", padding: 48, color: "#94a3b8" }}>Loading...</div>}

//               {!loadingDetail && memberDetail && (() => {
//                 const m = memberDetail.member;
//                 const levelBreakdown = memberDetail.level_breakdown || [];
//                 const direct = memberDetail.direct || [];
//                 const memberCommissions = memberDetail.commissions || [];
//                 const wdrawals = memberDetail.withdrawals || [];
//                 const totalEarned = levelBreakdown.reduce((s, l) => s + Number(l.total || 0), 0);

//                 return (
//                   <div>
//                     <div style={{ display: "flex", flexWrap: "wrap", gap: 10, marginBottom: 16 }}>
//                       {[
//                         ["Coupon No", m.receiver_coupon_no],
//                         ["Name", m.receiver_name],
//                         ["Mobile", m.receiver_mobile],
//                         ["Rank", m.rank?.toUpperCase()],
//                         ["Wallet Balance", inr(m.wallet_balance)],
//                         ["Direct Members", direct.length],
//                         ["Total Team", memberDetail.total_team],
//                         ["Total Earned", inr(totalEarned)],
//                         ["Joined", fmt(m.created_at)],
//                         ["Status", m.is_approved ? "Active ✅" : "Pending ⏳"],
//                       ].map(([k, v]) => (
//                         <div key={k} style={S.infoChip}>
//                           <div style={{ fontSize: 10, color: "#64748b" }}>{k}</div>
//                           <div style={{ fontWeight: 700 }}>{v}</div>
//                         </div>
//                       ))}
//                     </div>

//                     <div style={{ display: "flex", gap: 8, marginBottom: 16, flexWrap: "wrap" }}>
//                       <button style={{ ...S.btn, background: "#25D366" }} onClick={() =>
//                         whatsapp(m.receiver_mobile, `Namaste *${m.receiver_name}*!\n\nYour Meruram Lucky Draw account is active ✅.\n\nCoupon: ${m.receiver_coupon_no}\nBalance: ${inr(m.wallet_balance)}\n\nVisit: ${COMPANY_URL}`)}>
//                         📱 Send Account Info
//                       </button>
//                       <button style={{ ...S.btn, background: "#25D366" }} onClick={() =>
//                         whatsapp(m.receiver_mobile, `Namaste *${m.receiver_name}*!\n\nYou have earned *${inr(totalEarned)}* in Level Income from Meruram Lucky Draw 🎉\n\nLogin to check: ${COMPANY_URL}`)}>
//                         📱 Send Income Info
//                       </button>
//                     </div>

//                     <SectionTitle>💹 Level-wise Income</SectionTitle>
//                     <div style={S.tableWrap}>
//                       <table style={S.table}>
//                         <THead cols={["Level", "Rate/Join", "Members Joined", "Direct Members", "Indirect Members", "Total Earned", "% Share"]} />
//                         <tbody>
//                           {[1, 2, 3, 4, 5, 6].map((level, i) => {
//                             const found = levelBreakdown.find(l => l.level === level);
//                             const earned = Number(found?.total || 0);
//                             const pct = totalEarned > 0 ? ((earned / totalEarned) * 100).toFixed(1) : "0";
//                             const isL1 = level === 1;
//                             return (
//                               <tr key={level} style={i % 2 === 0 ? S.trEven : {}}>
//                                 <td style={S.td}><strong>Level {level}</strong> {isL1 ? "🔴" : ""}</td>
//                                 <td style={S.td}>₹{LEVEL_RATE[level]}</td>
//                                 <td style={S.td}>{found?.count || 0}</td>
//                                 <td style={S.td}>{isL1 ? (found?.count || 0) : "—"}</td>
//                                 <td style={S.td}>{!isL1 ? (found?.count || 0) : "—"}</td>
//                                 <td style={{ ...S.td, fontWeight: 700, color: earned > 0 ? "#16a34a" : "#94a3b8" }}>
//                                   {earned > 0 ? inr(earned) : "₹0.00"}
//                                 </td>
//                                 <td style={S.td}>
//                                   <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
//                                     <div style={{ height: 6, borderRadius: 99, background: PIE_COLORS[i], width: `${Math.min(Number(pct), 100)}%`, minWidth: 2 }} />
//                                     <span style={{ fontSize: 11, color: "#64748b" }}>{pct}%</span>
//                                   </div>
//                                 </td>
//                               </tr>
//                             );
//                           })}
//                           <tr style={{ background: "#f0fdf4" }}>
//                             <td style={{ ...S.td, fontWeight: 800 }} colSpan={2}>TOTAL</td>
//                             <td style={{ ...S.td, fontWeight: 700 }}>{levelBreakdown.reduce((s, l) => s + l.count, 0)}</td>
//                             <td style={S.td}>{direct.length}</td>
//                             <td style={S.td}>{memberDetail.total_team - direct.length}</td>
//                             <td style={{ ...S.td, fontWeight: 800, color: "#15803d", fontSize: 15 }}>{inr(totalEarned)}</td>
//                             <td style={S.td}>100%</td>
//                           </tr>
//                         </tbody>
//                       </table>
//                     </div>

//                     <SectionTitle>👥 Direct Members</SectionTitle>
//                     <div style={S.tableWrap}>
//                       <table style={S.table}>
//                         <THead cols={["#", "Coupon", "Name", "Mobile", "Joined Date", "Their Direct", "Status", "WA"]} />
//                         <tbody>
//                           {direct.map((d, i) => (
//                             <tr key={d.id} style={i % 2 === 0 ? S.trEven : {}}>
//                               <td style={S.td}>{i + 1}</td>
//                               <td style={{ ...S.td, color: "#1d4ed8", fontWeight: 700 }}>{d.receiver_coupon_no}</td>
//                               <td style={S.td}>{d.receiver_name}</td>
//                               <td style={S.td}>{d.receiver_mobile}</td>
//                               <td style={{ ...S.td, fontSize: 11 }}>{fmtTime(d.created_at)}</td>
//                               <td style={{ ...S.td, fontWeight: 700 }}>{d.their_direct}</td>
//                               <td style={S.td}><span style={d.is_approved ? S.greenBadge : S.yellowBadge}>{d.is_approved ? "Active" : "Pending"}</span></td>
//                               <td style={S.td}>
//                                 <button style={{ ...S.btn, background: "#25D366", padding: "4px 8px" }}
//                                   onClick={() => whatsapp(d.receiver_mobile, `Namaste *${d.receiver_name}*! Welcome to Meruram Lucky Draw. Login: ${COMPANY_URL}`)}>
//                                   📱
//                                 </button>
//                               </td>
//                             </tr>
//                           ))}
//                           {direct.length === 0 && <tr><td colSpan={8} style={{ ...S.td, textAlign: "center", color: "#94a3b8" }}>No direct referrals</td></tr>}
//                         </tbody>
//                       </table>
//                     </div>

//                     <SectionTitle>📋 Commission History</SectionTitle>
//                     <div style={S.tableWrap}>
//                       <table style={S.table}>
//                         <THead cols={["#", "Date", "Level", "From Coupon", "From Member", "Amount Earned"]} />
//                         <tbody>
//                           {memberCommissions.slice(0, 100).map((c, i) => (
//                             <tr key={c.id} style={i % 2 === 0 ? S.trEven : {}}>
//                               <td style={S.td}>{i + 1}</td>
//                               <td style={{ ...S.td, fontSize: 11 }}>{fmtTime(c.created_at)}</td>
//                               <td style={S.td}><span style={S.pill}>L{c.level}</span></td>
//                               <td style={{ ...S.td, color: "#1d4ed8" }}>{c.from_coupon}</td>
//                               <td style={S.td}>{c.from_name}</td>
//                               <td style={{ ...S.td, fontWeight: 700, color: "#16a34a" }}>{inr(c.amount)}</td>
//                             </tr>
//                           ))}
//                           {memberCommissions.length === 0 && <tr><td colSpan={6} style={{ ...S.td, textAlign: "center", color: "#94a3b8" }}>No commissions yet</td></tr>}
//                         </tbody>
//                       </table>
//                     </div>

//                     <SectionTitle>💸 Withdrawal History</SectionTitle>
//                     <div style={S.tableWrap}>
//                       <table style={S.table}>
//                         <THead cols={["#", "Date", "Amount", "Method", "Bank/UPI", "Status"]} />
//                         <tbody>
//                           {wdrawals.map((w, i) => (
//                             <tr key={w.id} style={i % 2 === 0 ? S.trEven : {}}>
//                               <td style={S.td}>{i + 1}</td>
//                               <td style={{ ...S.td, fontSize: 11 }}>{fmt(w.created_at)}</td>
//                               <td style={{ ...S.td, fontWeight: 700 }}>{inr(w.amount)}</td>
//                               <td style={S.td}>{w.method?.toUpperCase()}</td>
//                               <td style={{ ...S.td, fontSize: 11 }}>{w.method === "upi" ? w.upi_id : `${w.bank_name || ""} ${w.account_number || ""}`}</td>
//                               <td style={S.td}><span style={w.status === "approved" ? S.greenBadge : w.status === "rejected" ? S.redBadge : S.yellowBadge}>{w.status}</span></td>
//                             </tr>
//                           ))}
//                           {wdrawals.length === 0 && <tr><td colSpan={6} style={{ ...S.td, textAlign: "center", color: "#94a3b8" }}>No withdrawals</td></tr>}
//                         </tbody>
//                       </table>
//                     </div>
//                   </div>
//                 );
//               })()}
//             </div>
//           )}

//           {/* ══════════ LEVEL INCOME REPORT ══════════ */}
//           {subTab === "Level Income Report" && (
//             <div>
//               <PageHead title="📈 Level Income Report — All Members" />

//               {/* Summary KPI */}
//               <div style={{ display: "flex", gap: 10, marginBottom: 16, flexWrap: "wrap" }}>
//                 {[1, 2, 3, 4, 5, 6].map((l, i) => (
//                   <div key={l} style={{ background: PIE_COLORS[i], color: "#fff", borderRadius: 10, padding: "12px 16px", minWidth: 110, textAlign: "center" }}>
//                     <div style={{ fontSize: 10, opacity: 0.8 }}>Level {l} · ₹{LEVEL_RATE[l]}/join</div>
//                     <div style={{ fontSize: 18, fontWeight: 800, marginTop: 4 }}>
//                       {inr(allMembers.reduce((s, m) => s + Number(m[`level${l}_income`] || 0), 0))}
//                     </div>
//                     <div style={{ fontSize: 10, opacity: 0.8, marginTop: 2 }}>
//                       {allMembers.filter(m => Number(m[`level${l}_income`]) > 0).length} members
//                     </div>
//                   </div>
//                 ))}
//               </div>

//               <div style={S.tableWrap}>
//                 <table style={S.table}>
//                   <THead cols={["#", "Coupon", "Name", "Mobile", "Sponsor", "Direct", "L1 ₹300", "L2 ₹150", "L3 ₹120", "L4 ₹90", "L5 ₹60", "L6 ₹30", "Total Income", "Withdrawn"]} />
//                   <tbody>
//                     {allMembers.filter(m => Number(m.total_income) > 0).map((m, i) => (
//                       <tr key={m.id} style={i % 2 === 0 ? S.trEven : {}}>
//                         <td style={S.td}>{i + 1}</td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#1d4ed8", cursor: "pointer" }} onClick={() => openDetail(m)}>{m.receiver_coupon_no}</td>
//                         <td style={S.td}>{m.receiver_name}</td>
//                         <td style={S.td}>{m.receiver_mobile}</td>
//                         <td style={{ ...S.td, fontSize: 11 }}>{m.sponsor_name || "—"}</td>
//                         <td style={S.td}>{m.direct_count}</td>
//                         {[1, 2, 3, 4, 5, 6].map(l => (
//                           <td key={l} style={{ ...S.td, color: m[`level${l}_income`] > 0 ? "#16a34a" : "#d1d5db", fontSize: 11 }}>
//                             {m[`level${l}_income`] > 0 ? inr(m[`level${l}_income`]) : "—"}
//                           </td>
//                         ))}
//                         <td style={{ ...S.td, fontWeight: 800, color: "#7c3aed" }}>{inr(m.total_income)}</td>
//                         <td style={{ ...S.td, color: "#dc2626" }}>{inr(m.total_withdrawn)}</td>
//                       </tr>
//                     ))}
//                     <tr style={{ background: "#eff6ff", fontWeight: 800 }}>
//                       <td style={S.td} colSpan={6}>COMPANY TOTAL</td>
//                       {[1, 2, 3, 4, 5, 6].map(l => (
//                         <td key={l} style={{ ...S.td, color: "#16a34a", fontWeight: 800 }}>
//                           {inr(allMembers.reduce((s, m) => s + Number(m[`level${l}_income`] || 0), 0))}
//                         </td>
//                       ))}
//                       <td style={{ ...S.td, color: "#7c3aed", fontSize: 14 }}>
//                         {inr(allMembers.reduce((s, m) => s + Number(m.total_income || 0), 0))}
//                       </td>
//                       <td style={{ ...S.td, color: "#dc2626" }}>
//                         {inr(allMembers.reduce((s, m) => s + Number(m.total_withdrawn || 0), 0))}
//                       </td>
//                     </tr>
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}

//           {/* ══════════ LEVEL WISE REPORT ══════════ */}
//           {subTab === "Level Wise Report" && (
//             <div>
//               <PageHead title="📊 Level Wise Report — Company Overview" />

//               {/* Chart */}
//               <div style={{ ...S.card, marginBottom: 16 }}>
//                 <CardHead>Level-wise Commission Distribution</CardHead>
//                 <div style={{ padding: 16 }}>
//                   <ResponsiveContainer width="100%" height={220}>
//                     <BarChart data={levelSummary}>
//                       <XAxis dataKey="level" tickFormatter={v => `L${v}`} tick={{ fontSize: 11 }} />
//                       <YAxis tick={{ fontSize: 10 }} tickFormatter={v => `₹${(v / 1000).toFixed(0)}k`} />
//                       <Tooltip formatter={(v) => inr(v)} labelFormatter={l => `Level ${l}`} />
//                       <Bar dataKey="total" name="Total Paid" radius={[4, 4, 0, 0]}>
//                         {levelSummary.map((entry, i) => (
//                           <Cell key={i} fill={PIE_COLORS[i % PIE_COLORS.length]} />
//                         ))}
//                       </Bar>
//                     </BarChart>
//                   </ResponsiveContainer>
//                 </div>
//               </div>

//               {/* Level wise detail table */}
//               <div style={S.tableWrap}>
//                 <table style={S.table}>
//                   <THead cols={["Level", "Rate per Join", "Members Benefiting", "Total Commissions Paid", "Avg per Member", "% of Total"]} />
//                   <tbody>
//                     {levelSummary.map((l, i) => {
//                       const grandTotal = levelSummary.reduce((s, x) => s + x.total, 0);
//                       const pct = grandTotal > 0 ? ((l.total / grandTotal) * 100).toFixed(1) : "0";
//                       const avg = l.members_paid > 0 ? l.total / l.members_paid : 0;
//                       return (
//                         <tr key={l.level} style={i % 2 === 0 ? S.trEven : {}}>
//                           <td style={S.td}>
//                             <span style={{ ...S.pill, background: PIE_COLORS[i], color: "#fff", fontSize: 12 }}>Level {l.level}</span>
//                           </td>
//                           <td style={{ ...S.td, fontWeight: 700 }}>₹{l.rate}</td>
//                           <td style={{ ...S.td, fontWeight: 700, color: "#1d4ed8" }}>{l.members_paid}</td>
//                           <td style={{ ...S.td, fontWeight: 800, color: "#16a34a", fontSize: 14 }}>{inr(l.total)}</td>
//                           <td style={{ ...S.td, color: "#7c3aed" }}>{inr(avg)}</td>
//                           <td style={S.td}>
//                             <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
//                               <div style={{ height: 8, borderRadius: 99, background: PIE_COLORS[i], width: `${Math.min(Number(pct) * 2, 150)}px` }} />
//                               <span style={{ fontSize: 12, fontWeight: 700 }}>{pct}%</span>
//                             </div>
//                           </td>
//                         </tr>
//                       );
//                     })}
//                     <tr style={{ background: "#f0fdf4", fontWeight: 800 }}>
//                       <td style={S.td} colSpan={2}>GRAND TOTAL</td>
//                       <td style={{ ...S.td, color: "#1d4ed8" }}>{levelSummary.reduce((s, l) => s + l.members_paid, 0)}</td>
//                       <td style={{ ...S.td, color: "#16a34a", fontSize: 15 }}>{inr(levelSummary.reduce((s, l) => s + l.total, 0))}</td>
//                       <td style={S.td}>—</td>
//                       <td style={S.td}>100%</td>
//                     </tr>
//                   </tbody>
//                 </table>
//               </div>

//               {/* Per-member level breakdown */}
//               <SectionTitle>👤 Member-wise Level Breakdown</SectionTitle>
//               <div style={S.tableWrap}>
//                 <table style={S.table}>
//                   <THead cols={["#", "Coupon", "Name", "L1", "L2", "L3", "L4", "L5", "L6", "Total", "Rank"]} />
//                   <tbody>
//                     {allMembers
//                       .filter(m => Number(m.total_income) > 0)
//                       .sort((a, b) => Number(b.total_income) - Number(a.total_income))
//                       .map((m, i) => (
//                         <tr key={m.id} style={i % 2 === 0 ? S.trEven : {}}>
//                           <td style={S.td}>{i + 1}</td>
//                           <td style={{ ...S.td, color: "#1d4ed8", fontWeight: 700, cursor: "pointer" }} onClick={() => openDetail(m)}>{m.receiver_coupon_no}</td>
//                           <td style={S.td}>{m.receiver_name}</td>
//                           {[1, 2, 3, 4, 5, 6].map(l => (
//                             <td key={l} style={{ ...S.td, fontSize: 11, color: Number(m[`level${l}_income`]) > 0 ? "#16a34a" : "#d1d5db" }}>
//                               {Number(m[`level${l}_income`]) > 0 ? `₹${Number(m[`level${l}_income`]).toFixed(0)}` : "—"}
//                             </td>
//                           ))}
//                           <td style={{ ...S.td, fontWeight: 800, color: "#7c3aed" }}>{inr(m.total_income)}</td>
//                           <td style={S.td}><span style={S.pill}>{m.rank || "—"}</span></td>
//                         </tr>
//                       ))}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}

//           {/* ══════════ COMMISSION REPORT ══════════ */}
//           {subTab === "Commission Report" && (
//             <div>
//               <PageHead title="💰 Commission Report — All Transactions" />

//               {/* Summary cards */}
//               <div style={{ display: "flex", gap: 10, marginBottom: 16, flexWrap: "wrap" }}>
//                 <div style={{ ...S.kpiCard, background: "#1e3a8a", minWidth: 150 }}>
//                   <div style={{ fontSize: 20 }}>💰</div>
//                   <div style={{ fontSize: 20, fontWeight: 800 }}>{inr(commissions.reduce((s, c) => s + Number(c.amount || 0), 0))}</div>
//                   <div style={{ fontSize: 10, opacity: .8 }}>Total Commission</div>
//                 </div>
//                 <div style={{ ...S.kpiCard, background: "#065f46", minWidth: 150 }}>
//                   <div style={{ fontSize: 20 }}>📋</div>
//                   <div style={{ fontSize: 20, fontWeight: 800 }}>{commissions.length}</div>
//                   <div style={{ fontSize: 10, opacity: .8 }}>Total Transactions</div>
//                 </div>
//                 {commissionByLevel.map((cl, i) => (
//                   <div key={cl.level} style={{ ...S.kpiCard, background: PIE_COLORS[i % PIE_COLORS.length], minWidth: 120 }}>
//                     <div style={{ fontSize: 14 }}>Level {cl.level}</div>
//                     <div style={{ fontSize: 16, fontWeight: 800 }}>{inr(cl.total)}</div>
//                     <div style={{ fontSize: 10, opacity: .8 }}>{cl.count} txns</div>
//                   </div>
//                 ))}
//               </div>

//               {/* Chart */}
//               <div style={{ ...S.card, marginBottom: 16 }}>
//                 <CardHead>Commission by Level</CardHead>
//                 <div style={{ padding: 16 }}>
//                   <ResponsiveContainer width="100%" height={180}>
//                     <BarChart data={commissionByLevel}>
//                       <XAxis dataKey="level" tickFormatter={v => `L${v}`} tick={{ fontSize: 11 }} />
//                       <YAxis tick={{ fontSize: 10 }} tickFormatter={v => `₹${(v / 1000).toFixed(0)}k`} />
//                       <Tooltip formatter={(v) => inr(v)} labelFormatter={l => `Level ${l}`} />
//                       <Bar dataKey="total" name="Commission" radius={[4, 4, 0, 0]}>
//                         {commissionByLevel.map((entry, i) => (
//                           <Cell key={i} fill={PIE_COLORS[i % PIE_COLORS.length]} />
//                         ))}
//                       </Bar>
//                     </BarChart>
//                   </ResponsiveContainer>
//                 </div>
//               </div>

//               <div style={S.tableWrap}>
//                 <table style={S.table}>
//                   <THead cols={["#", "Date & Time", "Level", "To Coupon", "To Member", "From Coupon", "From Member", "Amount"]} />
//                   <tbody>
//                     {commissions.length === 0 && (
//                       <tr><td colSpan={8} style={{ ...S.td, textAlign: "center", color: "#94a3b8", padding: 40 }}>
//                         No commission records found
//                       </td></tr>
//                     )}
//                     {commissions.map((c, i) => (
//                       <tr key={c.id} style={i % 2 === 0 ? S.trEven : {}}>
//                         <td style={S.td}>{i + 1}</td>
//                         <td style={{ ...S.td, fontSize: 11 }}>{fmtTime(c.created_at)}</td>
//                         <td style={S.td}>
//                           <span style={{ ...S.pill, background: PIE_COLORS[(c.level - 1) % PIE_COLORS.length], color: "#fff" }}>L{c.level}</span>
//                         </td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#1d4ed8" }}>{c.to_coupon || c.receiver_coupon_no}</td>
//                         <td style={S.td}>{c.to_name || c.receiver_name}</td>
//                         <td style={{ ...S.td, color: "#6366f1" }}>{c.from_coupon}</td>
//                         <td style={S.td}>{c.from_name}</td>
//                         <td style={{ ...S.td, fontWeight: 800, color: "#16a34a", fontSize: 14 }}>{inr(c.amount)}</td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}

//           {/* ══════════ DIRECT BUSINESS REPORT ══════════ */}
//           {subTab === "Direct Business Report" && (
//             <div>
//               <PageHead title="📊 Direct Business Report" />
//               <div style={S.tableWrap}>
//                 <table style={S.table}>
//                   <THead cols={["#", "Coupon", "Name", "Mobile", "Direct Members", "Indirect Members", "Total Team", "Direct Income", "Total Income"]} />
//                   <tbody>
//                     {[...allMembers].sort((a, b) => Number(b.direct_count) - Number(a.direct_count)).map((m, i) => (
//                       <tr key={m.id} style={i % 2 === 0 ? S.trEven : {}}>
//                         <td style={S.td}>{i + 1}</td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#1d4ed8", cursor: "pointer" }} onClick={() => openDetail(m)}>{m.receiver_coupon_no}</td>
//                         <td style={S.td}>{m.receiver_name}</td>
//                         <td style={S.td}>{m.receiver_mobile}</td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#1d4ed8" }}>{m.direct_count}</td>
//                         <td style={{ ...S.td, color: "#6366f1" }}>{m.indirect_count || 0}</td>
//                         <td style={S.td}>{Number(m.direct_count) + Number(m.indirect_count || 0)}</td>
//                         <td style={{ ...S.td, color: "#16a34a" }}>{inr(Number(m.direct_count) * LEVEL_RATE[1])}</td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#7c3aed" }}>{inr(m.total_income)}</td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}

//           {/* ══════════ BUSINESS REPORT ══════════ */}
//           {subTab === "Business Report" && (
//             <div>
//               <PageHead title="📈 Business Report — Full Company Overview" />

//               {/* Summary KPI row */}
//               <div style={S.kpiGrid}>
//                 {[
//                   { label: "Total Members", val: allMembers.length, icon: "👥", bg: "#1e3a8a" },
//                   { label: "Active Members", val: allMembers.filter(m => m.is_approved).length, icon: "✅", bg: "#065f46" },
//                   { label: "Total Business Vol.", val: inr(allMembers.length * 500), icon: "💼", bg: "#4c1d95" },
//                   { label: "Total Commission", val: inr(allMembers.reduce((s, m) => s + Number(m.total_income || 0), 0)), icon: "💰", bg: "#134e4a" },
//                   { label: "Total Withdrawn", val: inr(allMembers.reduce((s, m) => s + Number(m.total_withdrawn || 0), 0)), icon: "🏦", bg: "#7f1d1d" },
//                   { label: "Net in Wallets", val: inr(allMembers.reduce((s, m) => s + Number(m.total_income || 0) - Number(m.total_withdrawn || 0), 0)), icon: "💎", bg: "#1e1b4b" },
//                 ].map(c => (
//                   <div key={c.label} style={{ ...S.kpiCard, background: c.bg }}>
//                     <div style={{ fontSize: 22 }}>{c.icon}</div>
//                     <div style={{ fontSize: 18, fontWeight: 800 }}>{c.val}</div>
//                     <div style={{ fontSize: 10, opacity: .8 }}>{c.label}</div>
//                   </div>
//                 ))}
//               </div>

//               {/* Charts */}
//               <div style={{ display: "flex", gap: 14, marginBottom: 16, flexWrap: "wrap" }}>
//                 <div style={{ ...S.card, flex: 1, minWidth: 260 }}>
//                   <CardHead>🏆 Rank Distribution (Pie)</CardHead>
//                   <div style={{ padding: 16 }}>
//                     <ResponsiveContainer width="100%" height={200}>
//                       <PieChart>
//                         <Pie
//                           data={stats?.rank_dist || []}
//                           dataKey="count"
//                           nameKey="rank"
//                           cx="50%" cy="50%"
//                           outerRadius={75}
//                           label={({ rank, percent }) => `${rank} ${(percent * 100).toFixed(0)}%`}
//                         >
//                           {(stats?.rank_dist || []).map((entry, i) => (
//                             <Cell key={i} fill={PIE_COLORS[i % PIE_COLORS.length]} />
//                           ))}
//                         </Pie>
//                         <Tooltip />
//                         <Legend />
//                       </PieChart>
//                     </ResponsiveContainer>
//                   </div>
//                 </div>
//                 <div style={{ ...S.card, flex: 2, minWidth: 260 }}>
//                   <CardHead>📊 Income vs Withdrawal per Member (Top 15)</CardHead>
//                   <div style={{ padding: 16 }}>
//                     <ResponsiveContainer width="100%" height={200}>
//                       <BarChart data={topByIncome.slice(0, 15).map(m => ({
//                         name: m.receiver_coupon_no,
//                         Income: Number(m.total_income || 0),
//                         Withdrawn: Number(m.total_withdrawn || 0),
//                       }))}>
//                         <XAxis dataKey="name" tick={{ fontSize: 9 }} />
//                         <YAxis tick={{ fontSize: 9 }} tickFormatter={v => `₹${(v / 1000).toFixed(0)}k`} />
//                         <Tooltip formatter={v => inr(v)} />
//                         <Bar dataKey="Income" fill="#3b82f6" radius={[3, 3, 0, 0]} />
//                         <Bar dataKey="Withdrawn" fill="#ef4444" radius={[3, 3, 0, 0]} />
//                         <Legend />
//                       </BarChart>
//                     </ResponsiveContainer>
//                   </div>
//                 </div>
//               </div>

//               {/* Full table */}
//               <SectionTitle>📋 All Members Business Summary</SectionTitle>
//               <div style={S.tableWrap}>
//                 <table style={S.table}>
//                   <THead cols={["#", "Coupon", "Name", "Mobile", "Rank", "Direct", "Total Team", "Total Income", "Withdrawn", "Balance", "Status"]} />
//                   <tbody>
//                     {[...allMembers]
//                       .sort((a, b) => Number(b.total_income || 0) - Number(a.total_income || 0))
//                       .map((m, i) => (
//                         <tr key={m.id} style={i % 2 === 0 ? S.trEven : {}}>
//                           <td style={S.td}>{i + 1}</td>
//                           <td style={{ ...S.td, fontWeight: 700, color: "#1d4ed8", cursor: "pointer" }} onClick={() => openDetail(m)}>{m.receiver_coupon_no}</td>
//                           <td style={S.td}>{m.receiver_name}</td>
//                           <td style={S.td}>{m.receiver_mobile}</td>
//                           <td style={S.td}><span style={S.pill}>{m.rank || "—"}</span></td>
//                           <td style={{ ...S.td, fontWeight: 700 }}>{m.direct_count}</td>
//                           <td style={S.td}>{Number(m.direct_count || 0) + Number(m.indirect_count || 0)}</td>
//                           <td style={{ ...S.td, fontWeight: 800, color: "#16a34a" }}>{inr(m.total_income)}</td>
//                           <td style={{ ...S.td, color: "#dc2626" }}>{inr(m.total_withdrawn)}</td>
//                           <td style={{ ...S.td, fontWeight: 700, color: "#7c3aed" }}>
//                             {inr(Number(m.total_income || 0) - Number(m.total_withdrawn || 0))}
//                           </td>
//                           <td style={S.td}><span style={m.is_approved ? S.greenBadge : S.yellowBadge}>{m.is_approved ? "Active" : "Pending"}</span></td>
//                         </tr>
//                       ))}
//                     <tr style={{ background: "#eff6ff", fontWeight: 800 }}>
//                       <td style={S.td} colSpan={7}>TOTAL</td>
//                       <td style={{ ...S.td, color: "#16a34a", fontSize: 14 }}>{inr(allMembers.reduce((s, m) => s + Number(m.total_income || 0), 0))}</td>
//                       <td style={{ ...S.td, color: "#dc2626" }}>{inr(allMembers.reduce((s, m) => s + Number(m.total_withdrawn || 0), 0))}</td>
//                       <td style={{ ...S.td, color: "#7c3aed" }}>
//                         {inr(allMembers.reduce((s, m) => s + Number(m.total_income || 0) - Number(m.total_withdrawn || 0), 0))}
//                       </td>
//                       <td style={S.td}></td>
//                     </tr>
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}

//           {/* ══════════ COMMISSION SUMMARY ══════════ */}
//           {subTab === "Commission Summary" && (
//             <div>
//               <PageHead title="📋 Commission Summary" />

//               {/* Level totals */}
//               <SectionTitle>Level-wise Commission Totals</SectionTitle>
//               <div style={{ display: "flex", gap: 8, marginBottom: 16, flexWrap: "wrap" }}>
//                 {[1, 2, 3, 4, 5, 6].map((l, i) => (
//                   <div key={l} style={{ background: PIE_COLORS[i], color: "#fff", borderRadius: 10, padding: "12px 16px", minWidth: 120, textAlign: "center" }}>
//                     <div style={{ fontSize: 10, opacity: 0.8 }}>Level {l} (₹{LEVEL_RATE[l]}/join)</div>
//                     <div style={{ fontSize: 18, fontWeight: 800, marginTop: 4 }}>
//                       {inr(allMembers.reduce((s, m) => s + Number(m[`level${l}_income`] || 0), 0))}
//                     </div>
//                     <div style={{ fontSize: 10, opacity: 0.8, marginTop: 2 }}>
//                       {allMembers.filter(m => Number(m[`level${l}_income`]) > 0).length} earners
//                     </div>
//                   </div>
//                 ))}
//               </div>

//               {/* Top earners per level */}
//               {[1, 2, 3, 4, 5, 6].map((level, li) => (
//                 <div key={level}>
//                   <SectionTitle>🏆 Top 5 Earners — Level {level} (₹{LEVEL_RATE[level]}/join)</SectionTitle>
//                   <div style={S.tableWrap}>
//                     <table style={S.table}>
//                       <THead cols={["Rank", "Coupon", "Name", "Mobile", `L${level} Income`]} />
//                       <tbody>
//                         {[...allMembers]
//                           .filter(m => Number(m[`level${level}_income`]) > 0)
//                           .sort((a, b) => Number(b[`level${level}_income`]) - Number(a[`level${level}_income`]))
//                           .slice(0, 5)
//                           .map((m, i) => (
//                             <tr key={m.id} style={i % 2 === 0 ? S.trEven : {}}>
//                               <td style={{ ...S.td, fontWeight: 800, color: i < 3 ? "#f59e0b" : "#64748b" }}>#{i + 1}</td>
//                               <td style={{ ...S.td, color: "#1d4ed8", fontWeight: 700, cursor: "pointer" }} onClick={() => openDetail(m)}>{m.receiver_coupon_no}</td>
//                               <td style={S.td}>{m.receiver_name}</td>
//                               <td style={S.td}>{m.receiver_mobile}</td>
//                               <td style={{ ...S.td, fontWeight: 800, color: "#16a34a", fontSize: 14 }}>{inr(m[`level${level}_income`])}</td>
//                             </tr>
//                           ))}
//                       </tbody>
//                     </table>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           )}

//           {/* ══════════ DAILY JOINS ══════════ */}
//           {subTab === "Daily Joins" && (
//             <div>
//               <PageHead title="📅 Daily Joins Report — Last 30 Days" />

//               {dailyJoins.length === 0 ? (
//                 <div style={{ textAlign: "center", padding: 60, color: "#94a3b8", background: "#f8fafc", borderRadius: 8, border: "2px dashed #e2e8f0" }}>
//                   <div style={{ fontSize: 40, marginBottom: 12 }}>📅</div>
//                   <div style={{ fontWeight: 700, fontSize: 15 }}>Loading or no join data for last 30 days</div>
//                   <button style={{ ...S.btn, background: "#1e3a8a", marginTop: 16 }} onClick={loadDailyJoins}>🔄 Reload</button>
//                 </div>
//               ) : (
//                 <>
//                   {/* KPI cards — uses backend totals */}
//                   <div style={{ display: "flex", gap: 10, marginBottom: 16, flexWrap: "wrap" }}>
//                     {[
//                       { icon: "📅", label: "Total Joins", val: dailyJoins.reduce((s, d) => s + Number(d.count || 0), 0), bg: "#1e3a8a" },
//                       { icon: "✅", label: "Approved", val: dailyJoins.reduce((s, d) => s + Number(d.approved || 0), 0), bg: "#065f46" },
//                       { icon: "⏳", label: "Pending", val: dailyJoins.reduce((s, d) => s + Number(d.pending || 0), 0), bg: "#92400e" },
//                       {
//                         icon: "📈", label: "Avg / Day",
//                         val: dailyJoins.length > 0 ? Math.round(dailyJoins.reduce((s, d) => s + Number(d.count || 0), 0) / dailyJoins.length) : 0,
//                         bg: "#4c1d95"
//                       },
//                       {
//                         icon: "🏆", label: "Best Day",
//                         val: Math.max(...dailyJoins.map(d => Number(d.count || 0))),
//                         bg: "#134e4a"
//                       },
//                     ].map(c => (
//                       <div key={c.label} style={{ ...S.kpiCard, background: c.bg, minWidth: 130 }}>
//                         <div style={{ fontSize: 22 }}>{c.icon}</div>
//                         <div style={{ fontSize: 20, fontWeight: 800 }}>{c.val}</div>
//                         <div style={{ fontSize: 10, opacity: .8 }}>{c.label}</div>
//                       </div>
//                     ))}
//                   </div>

//                   {/* Chart — stacked approved + pending */}
//                   <div style={{ ...S.card, marginBottom: 16 }}>
//                     <CardHead>📈 Daily Registration Trend (Approved vs Pending)</CardHead>
//                     <div style={{ padding: 16 }}>
//                       <ResponsiveContainer width="100%" height={240}>
//                         <BarChart data={dailyJoins}>
//                           <XAxis dataKey="date" tick={{ fontSize: 9 }} />
//                           <YAxis tick={{ fontSize: 9 }} allowDecimals={false} />
//                           <Tooltip />
//                           <Legend />
//                           <Bar dataKey="approved" name="Approved" stackId="a" fill="#10b981" radius={[0, 0, 0, 0]} />
//                           <Bar dataKey="pending" name="Pending" stackId="a" fill="#f59e0b" radius={[4, 4, 0, 0]} />
//                         </BarChart>
//                       </ResponsiveContainer>
//                     </div>
//                   </div>

//                   {/* Table */}
//                   <div style={S.tableWrap}>
//                     <table style={S.table}>
//                       <THead cols={["#", "Date", "Total Joins", "Approved", "Pending", "Running Total", "Bar"]} />
//                       <tbody>
//                         {(() => {
//                           let running = 0;
//                           const maxCount = Math.max(...dailyJoins.map(d => Number(d.count || 0)), 1);
//                           return dailyJoins.map((d, i) => {
//                             running += Number(d.count || 0);
//                             const isMax = Number(d.count) === maxCount;
//                             return (
//                               <tr key={i} style={i % 2 === 0 ? S.trEven : {}}>
//                                 <td style={S.td}>{i + 1}</td>
//                                 <td style={{ ...S.td, fontWeight: 600 }}>{d.date}</td>
//                                 <td style={{ ...S.td, fontWeight: 800, color: isMax ? "#f59e0b" : "#1d4ed8", fontSize: 15 }}>
//                                   {d.count} {isMax ? "🏆" : ""}
//                                 </td>
//                                 <td style={{ ...S.td, color: "#16a34a", fontWeight: 700 }}>{d.approved || 0}</td>
//                                 <td style={{ ...S.td, color: "#f59e0b", fontWeight: 700 }}>{d.pending || 0}</td>
//                                 <td style={{ ...S.td, color: "#7c3aed" }}>{running}</td>
//                                 <td style={S.td}>
//                                   <div style={{ height: 10, borderRadius: 99, background: isMax ? "#f59e0b" : "#3b82f6", width: `${(Number(d.count) / maxCount) * 180}px`, minWidth: 4 }} />
//                                 </td>
//                               </tr>
//                             );
//                           });
//                         })()}
//                       </tbody>
//                     </table>
//                   </div>
//                 </>
//               )}
//             </div>
//           )}

//           {/* ══════════ NETWORK TREE ══════════ */}
//           {subTab === "Network Tree" && (
//             <div>
//               <PageHead title="🌳 Network Tree — Member Downline" />

//               {/* Search bar */}
//               <div style={{ ...S.card, marginBottom: 16 }}>
//                 <CardHead>Search Member Network</CardHead>
//                 <div style={{ padding: 16, display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
//                   <input
//                     style={{ ...S.searchBox, minWidth: 280 }}
//                     placeholder="Enter Coupon No (e.g. MR001) or Token Number..."
//                     value={networkToken}
//                     onChange={e => setNetworkToken(e.target.value)}
//                     onKeyDown={e => e.key === "Enter" && loadNetworkTree(networkToken)}
//                   />
//                   <button style={{ ...S.btn, background: "#1e3a8a", padding: "9px 20px" }}
//                     onClick={() => loadNetworkTree(networkToken)}>
//                     🔍 Load Tree
//                   </button>
//                   {networkTree && (
//                     <button style={{ ...S.btn, background: "#64748b" }}
//                       onClick={() => { setNetworkTree(null); setNetworkToken(""); }}>
//                       ✕ Clear
//                     </button>
//                   )}
//                   {networkTree && (
//                     <span style={{ ...S.countBadge, background: "#dcfce7", color: "#15803d" }}>
//                       Showing tree for: <b>{networkTree.receiver_coupon_no || networkTree.token_number}</b>
//                     </span>
//                   )}
//                 </div>
//               </div>

//               {/* Legend */}
//               <div style={{ display: "flex", gap: 12, marginBottom: 12, flexWrap: "wrap", alignItems: "center" }}>
//                 <span style={{ fontSize: 12, color: "#64748b", fontWeight: 600 }}>Depth:</span>
//                 {[
//                   { label: "Root", bg: "#1e3a8a" },
//                   { label: "Level 1 Direct", bg: "#1d4ed8" },
//                   { label: "Level 2", bg: "#3b82f6" },
//                   { label: "Level 3+", bg: "#eff6ff", color: "#1e3a8a", border: "1px solid #bfdbfe" },
//                 ].map(item => (
//                   <div key={item.label} style={{ display: "flex", alignItems: "center", gap: 6 }}>
//                     <div style={{ width: 14, height: 14, borderRadius: 3, background: item.bg, border: item.border }} />
//                     <span style={{ fontSize: 12, color: "#64748b" }}>{item.label}</span>
//                   </div>
//                 ))}
//                 <span style={{ fontSize: 11, color: "#94a3b8", marginLeft: "auto" }}>Click node to expand/collapse</span>
//               </div>

//               {/* Tree or empty state */}
//               {networkTree ? (
//                 <div style={{ ...S.card, padding: 16, maxHeight: 620, overflowY: "auto" }}>
//                   <TreeNode node={networkTree} depth={0} />
//                 </div>
//               ) : (
//                 <div style={{ textAlign: "center", padding: 60, color: "#94a3b8", background: "#f8fafc", borderRadius: 8, border: "2px dashed #e2e8f0" }}>
//                   <div style={{ fontSize: 48, marginBottom: 12 }}>🌳</div>
//                   <div style={{ fontWeight: 700, fontSize: 16, marginBottom: 6 }}>Enter a coupon number or token above</div>
//                   <div style={{ fontSize: 12 }}>Tree shows downline up to 6 levels deep. Click any node to expand.</div>
//                 </div>
//               )}
//             </div>
//           )}

//           {/* ══════════ WITHDRAWAL REQUESTS ══════════ */}
//           {subTab === "Withdrawal Requests" && (
//             <div>
//               <PageHead title="💸 Withdrawal Requests — Pending">
//                 <span style={{ ...S.countBadge, background: "#fee2e2", color: "#991b1b", marginLeft: "auto" }}>
//                   {withdrawals.length} Pending
//                 </span>
//               </PageHead>
//               <div style={S.tableWrap}>
//                 <table style={S.table}>
//                   <THead cols={["#", "Coupon", "Member", "Mobile", "Amount", "Method", "Bank/UPI Details", "Requested", "Actions"]} />
//                   <tbody>
//                     {withdrawals.map((w, i) => (
//                       <tr key={w.id} style={i % 2 === 0 ? S.trEven : {}}>
//                         <td style={S.td}>{i + 1}</td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#1d4ed8" }}>{w.receiver_coupon_no}</td>
//                         <td style={S.td}>{w.receiver_name}</td>
//                         <td style={S.td}>{w.receiver_mobile}</td>
//                         <td style={{ ...S.td, fontWeight: 800, color: "#16a34a", fontSize: 14 }}>{inr(w.amount)}</td>
//                         <td style={S.td}>{w.method?.toUpperCase()}</td>
//                         <td style={{ ...S.td, fontSize: 11 }}>
//                           {w.method === "bank"
//                             ? <><b>{w.bank_name}</b><br />A/c: {w.account_number}<br />IFSC: {w.ifsc}</>
//                             : <><b>UPI:</b> {w.upi_id}</>}
//                         </td>
//                         <td style={{ ...S.td, fontSize: 11 }}>{fmtTime(w.created_at)}</td>
//                         <td style={S.td}>
//                           <div style={{ display: "flex", gap: 4, flexDirection: "column" }}>
//                             <button style={{ ...S.btn, background: "#16a34a", fontSize: 11 }}
//                               onClick={() => processWithdrawal(w.id, "approved", w)}>
//                               ✅ Approve + 📱WA
//                             </button>
//                             <button style={{ ...S.btn, background: "#dc2626", fontSize: 11 }}
//                               onClick={() => processWithdrawal(w.id, "rejected", w)}>
//                               ❌ Reject
//                             </button>
//                           </div>
//                         </td>
//                       </tr>
//                     ))}
//                     {withdrawals.length === 0 && (
//                       <tr><td colSpan={9} style={{ ...S.td, textAlign: "center", color: "#94a3b8", padding: 40 }}>
//                         🎉 No pending withdrawal requests!
//                       </td></tr>
//                     )}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}

//           {/* ══════════ PAYMENT HISTORY ══════════ */}
//           {subTab === "Payment History" && (
//             <div>
//               <PageHead title="📋 Payment History — All Payouts" />
//               <SectionTitle>Level-wise Payment Breakdown</SectionTitle>
//               <div style={{ display: "flex", gap: 8, marginBottom: 16, flexWrap: "wrap" }}>
//                 {[1, 2, 3, 4, 5, 6].map(l => (
//                   <div key={l} style={{ background: "#1e3a8a", color: "#fff", borderRadius: 8, padding: "10px 14px", minWidth: 100, textAlign: "center" }}>
//                     <div style={{ fontSize: 10, opacity: .7 }}>Level {l} (₹{LEVEL_RATE[l]}/join)</div>
//                     <div style={{ fontSize: 16, fontWeight: 800 }}>
//                       {inr(allMembers.reduce((s, m) => s + Number(m[`level${l}_income`] || 0), 0))}
//                     </div>
//                     <div style={{ fontSize: 10, opacity: .7 }}>paid out</div>
//                   </div>
//                 ))}
//               </div>
//               <div style={S.tableWrap}>
//                 <table style={S.table}>
//                   <THead cols={["#", "Coupon", "Member", "Mobile", "Amount", "Method", "Status", "Processed", "Date", "WA"]} />
//                   <tbody>
//                     {payHistory.map((w, i) => (
//                       <tr key={w.id} style={i % 2 === 0 ? S.trEven : {}}>
//                         <td style={S.td}>{i + 1}</td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#1d4ed8" }}>{w.receiver_coupon_no}</td>
//                         <td style={S.td}>{w.receiver_name}</td>
//                         <td style={S.td}>{w.receiver_mobile}</td>
//                         <td style={{ ...S.td, fontWeight: 800, color: "#16a34a" }}>{inr(w.amount)}</td>
//                         <td style={S.td}>{w.method?.toUpperCase()}</td>
//                         <td style={S.td}>
//                           <span style={w.status === "approved" ? S.greenBadge : w.status === "rejected" ? S.redBadge : S.yellowBadge}>
//                             {w.status}
//                           </span>
//                         </td>
//                         <td style={{ ...S.td, fontSize: 11 }}>{w.processed_at ? fmt(w.processed_at) : "—"}</td>
//                         <td style={{ ...S.td, fontSize: 11 }}>{fmt(w.created_at)}</td>
//                         <td style={S.td}>
//                           <button style={{ ...S.btn, background: "#25D366", padding: "4px 8px" }}
//                             onClick={() => whatsapp(w.receiver_mobile,
//                               `💸 Namaste *${w.receiver_name}*!\n\nYour payout of *${inr(w.amount)}* is *${w.status.toUpperCase()}*.\n\n_${COMPANY}_\n${COMPANY_URL}`)}>
//                             📱
//                           </button>
//                         </td>
//                       </tr>
//                     ))}
//                     {payHistory.length === 0 && <tr><td colSpan={10} style={{ ...S.td, textAlign: "center", color: "#94a3b8", padding: 40 }}>No payment history</td></tr>}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}

//           {/* ══════════ ADD FUND TO MEMBER ══════════ */}
//           {subTab === "Add Fund to Member" && (
//             <div>
//               <PageHead title="➕ Add Fund to Member Wallet" />
//               <div style={{ ...S.card, maxWidth: 480 }}>
//                 <CardHead>Manually Add Amount (Received from Member)</CardHead>
//                 <div style={{ padding: 20 }}>
//                   <p style={{ fontSize: 12, color: "#64748b", marginBottom: 16, padding: "10px 14px", background: "#fefce8", borderRadius: 8, border: "1px solid #fde68a" }}>
//                     ⚠️ Use this to record an amount received from a member. It will be credited directly to their wallet and recorded as a transaction.
//                   </p>
//                   {[
//                     ["Member Token / Coupon No *", "token_number", "text", "Enter member token or coupon number"],
//                     ["Amount Received (₹) *", "amount", "number", "Enter amount"],
//                     ["Description *", "description", "text", "e.g. Cash received, Online payment ref #123"],
//                   ].map(([label, key, type, placeholder]) => (
//                     <div key={key} style={{ marginBottom: 14 }}>
//                       <label style={S.label}>{label}</label>
//                       <input style={S.input} type={type} placeholder={placeholder}
//                         value={addFundForm[key]} onChange={e => setAddFundForm({ ...addFundForm, [key]: e.target.value })} />
//                     </div>
//                   ))}
//                   <button style={{ ...S.btn, background: "#1e3a8a", width: "100%", padding: 12, fontSize: 14 }} onClick={addFund}>
//                     ➕ Credit to Member Wallet
//                   </button>
//                 </div>
//               </div>
//             </div>
//           )}

//           {/* ══════════ SALARY LIST ══════════ */}
//           {subTab === "Salary List" && (
//             <div>
//               <PageHead title="💰 Salary List" />

//               {/* Summary */}
//               <div style={{ display: "flex", gap: 10, marginBottom: 16, flexWrap: "wrap" }}>
//                 <div style={{ ...S.kpiCard, background: "#1e3a8a", minWidth: 150 }}>
//                   <div style={{ fontSize: 20 }}>📋</div>
//                   <div style={{ fontSize: 20, fontWeight: 800 }}>{salaries.length}</div>
//                   <div style={{ fontSize: 10, opacity: .8 }}>Total Records</div>
//                 </div>
//                 <div style={{ ...S.kpiCard, background: "#065f46", minWidth: 150 }}>
//                   <div style={{ fontSize: 20 }}>✅</div>
//                   <div style={{ fontSize: 20, fontWeight: 800 }}>{salaries.filter(s => s.is_approved).length}</div>
//                   <div style={{ fontSize: 10, opacity: .8 }}>Paid</div>
//                 </div>
//                 <div style={{ ...S.kpiCard, background: "#92400e", minWidth: 150 }}>
//                   <div style={{ fontSize: 20 }}>⏳</div>
//                   <div style={{ fontSize: 20, fontWeight: 800 }}>{salaries.filter(s => !s.is_approved).length}</div>
//                   <div style={{ fontSize: 10, opacity: .8 }}>Pending</div>
//                 </div>
//                 <div style={{ ...S.kpiCard, background: "#4c1d95", minWidth: 150 }}>
//                   <div style={{ fontSize: 20 }}>💰</div>
//                   <div style={{ fontSize: 18, fontWeight: 800 }}>{inr(salaries.reduce((s, x) => s + Number(x.amount || 0), 0))}</div>
//                   <div style={{ fontSize: 10, opacity: .8 }}>Total Amount</div>
//                 </div>
//               </div>

//               <div style={S.tableWrap}>
//                 <table style={S.table}>
//                   <THead cols={["#", "Coupon", "Member", "Mobile", "Rank", "Amount", "Month", "Status", "Action"]} />
//                   <tbody>
//                     {salaries.map((s, i) => (
//                       <tr key={s.id} style={i % 2 === 0 ? S.trEven : {}}>
//                         <td style={S.td}>{i + 1}</td>
//                         <td style={{ ...S.td, fontWeight: 700 }}>{s.receiver_coupon_no || s.token_number}</td>
//                         <td style={S.td}>{s.receiver_name}</td>
//                         <td style={S.td}>{s.receiver_mobile}</td>
//                         <td style={S.td}>
//                           <span style={{ ...S.pill, textTransform: "capitalize" }}>{s.rank}</span>
//                         </td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#16a34a" }}>{inr(s.amount)}</td>
//                         <td style={S.td}>{s.month}</td>
//                         <td style={S.td}>
//                           <span style={s.is_approved ? S.greenBadge : S.yellowBadge}>
//                             {s.is_approved ? "Paid ✅" : "Pending"}
//                           </span>
//                         </td>
//                         <td style={S.td}>
//                           {!s.is_approved && (
//                             <button style={{ ...S.btn, background: "#16a34a", fontSize: 11 }}
//                               onClick={() => approveSalary(s.id, s)}>
//                               Approve + 📱WA
//                             </button>
//                           )}
//                           {s.is_approved && (
//                             <button style={{ ...S.btn, background: "#25D366", fontSize: 11 }}
//                               onClick={() => whatsapp(s.receiver_mobile,
//                                 `💰 Namaste *${s.receiver_name}*!\n\nSalary of *${inr(s.amount)}* for ${s.month} credited ✅\n\n_${COMPANY}_`)}>
//                               📱 WA
//                             </button>
//                           )}
//                         </td>
//                       </tr>
//                     ))}
//                     {salaries.length === 0 && (
//                       <tr><td colSpan={9} style={{ ...S.td, textAlign: "center", color: "#94a3b8", padding: 40 }}>
//                         No records. Generate salary first.
//                       </td></tr>
//                     )}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}

//           {/* ══════════ GENERATE SALARY ══════════ */}
//           {subTab === "Generate Salary" && (
//             <div>
//               <PageHead title="💰 Generate Monthly Salary" />
//               <div style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
//                 <div style={{ ...S.card, maxWidth: 520, flex: 1 }}>
//                   <CardHead>Salary Generation</CardHead>
//                   <div style={{ padding: 20 }}>
//                     <p style={{ fontSize: 12, color: "#64748b", marginBottom: 16, padding: "10px 14px", background: "#f0fdf4", borderRadius: 8, border: "1px solid #bbf7d0" }}>
//                       ℹ️ This will generate salary records for all eligible members based on their current rank. Only generates if not already generated for this month.
//                     </p>
//                     <SectionTitle>Salary Rates by Rank</SectionTitle>
//                     {Object.entries(RANK_SALARY).map(([rank, amt]) => (
//                       <div key={rank} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 12px", borderBottom: "1px solid #f1f5f9", fontSize: 13 }}>
//                         <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
//                           <div style={{ width: 10, height: 10, borderRadius: "50%", background: rank === "diamond" ? "#06b6d4" : rank === "platinum" ? "#8b5cf6" : rank === "gold" ? "#f59e0b" : "#94a3b8" }} />
//                           <span style={{ textTransform: "capitalize", fontWeight: 600 }}>{rank}</span>
//                         </div>
//                         <span style={{ color: "#16a34a", fontWeight: 700 }}>{inr(amt)} / month</span>
//                       </div>
//                     ))}
//                     <div style={{ marginTop: 20 }}>
//                       <button
//                         style={{ ...S.btn, background: generatingSalary ? "#64748b" : "#1e3a8a", width: "100%", padding: 14, fontSize: 15 }}
//                         onClick={generateSalary}
//                         disabled={generatingSalary}
//                       >
//                         {generatingSalary ? "⏳ Generating..." : "🚀 Generate This Month's Salary"}
//                       </button>
//                     </div>
//                     {salaries.length > 0 && (
//                       <div style={{ marginTop: 12 }}>
//                         <button style={{ ...S.btn, background: "#7c3aed", width: "100%", padding: 10 }}
//                           onClick={() => goTo("salary", "Salary List")}>
//                           📋 View Salary List ({salaries.length} records)
//                         </button>
//                       </div>
//                     )}
//                   </div>
//                 </div>

//                 {/* Eligible members preview */}
//                 <div style={{ ...S.card, flex: 1, minWidth: 280 }}>
//                   <CardHead>👥 Eligible Members Preview</CardHead>
//                   <div style={{ padding: "8px 0", maxHeight: 380, overflowY: "auto" }}>
//                     {Object.keys(RANK_SALARY).map(rank => {
//                       const eligible = allMembers.filter(m => m.rank === rank && m.is_approved);
//                       if (eligible.length === 0) return null;
//                       return (
//                         <div key={rank}>
//                           <div style={{ padding: "8px 16px", background: "#f8fafc", fontSize: 11, fontWeight: 700, color: "#475569", textTransform: "uppercase", letterSpacing: 1 }}>
//                             {rank} — {inr(RANK_SALARY[rank])}/mo × {eligible.length} members = {inr(RANK_SALARY[rank] * eligible.length)}
//                           </div>
//                           {eligible.slice(0, 3).map(m => (
//                             <div key={m.id} style={{ padding: "6px 16px", borderBottom: "1px solid #f1f5f9", fontSize: 12, display: "flex", justifyContent: "space-between" }}>
//                               <span>{m.receiver_name}</span>
//                               <span style={{ color: "#16a34a", fontWeight: 700 }}>{inr(RANK_SALARY[rank])}</span>
//                             </div>
//                           ))}
//                           {eligible.length > 3 && (
//                             <div style={{ padding: "4px 16px", fontSize: 11, color: "#94a3b8" }}>
//                               +{eligible.length - 3} more...
//                             </div>
//                           )}
//                         </div>
//                       );
//                     })}
//                     {Object.keys(RANK_SALARY).every(rank => allMembers.filter(m => m.rank === rank && m.is_approved).length === 0) && (
//                       <div style={{ padding: 20, textAlign: "center", color: "#94a3b8", fontSize: 12 }}>
//                         No eligible members found
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               </div>
//             </div>
//           )}

//           {/* ══════════ ALL ADMINS ══════════ */}
//           {subTab === "All Admins" && (
//             <div>
//               <PageHead title="🛡 All Admins" />
//               <div style={S.tableWrap}>
//                 <table style={S.table}>
//                   <THead cols={["#", "Username", "Full Name", "Mobile", "Role", "Status", "Created"]} />
//                   <tbody>
//                     {adminList.map((a, i) => (
//                       <tr key={a.id} style={i % 2 === 0 ? S.trEven : {}}>
//                         <td style={S.td}>{i + 1}</td>
//                         <td style={{ ...S.td, fontWeight: 700 }}>{a.username}</td>
//                         <td style={S.td}>{a.full_name}</td>
//                         <td style={S.td}>{a.mobile}</td>
//                         <td style={S.td}><span style={a.role === "superadmin" ? S.greenBadge : S.pill}>{a.role}</span></td>
//                         <td style={S.td}><span style={a.is_active ? S.greenBadge : S.redBadge}>{a.is_active ? "Active" : "Inactive"}</span></td>
//                         <td style={{ ...S.td, fontSize: 11 }}>{fmt(a.created_at)}</td>
//                       </tr>
//                     ))}
//                     {adminList.length === 0 && <tr><td colSpan={7} style={{ ...S.td, textAlign: "center", color: "#94a3b8" }}>No admins</td></tr>}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}

//           {/* ══════════ CREATE ADMIN ══════════ */}
//           {subTab === "Create Admin" && (
//             <div>
//               <PageHead title="➕ Create New Admin" />
//               <div style={{ ...S.card, maxWidth: 480 }}>
//                 <CardHead>Admin Account Details</CardHead>
//                 <div style={{ padding: 20 }}>
//                   {[["Username *", "username", "text"], ["Password *", "password", "password"],
//                   ["Full Name", "full_name", "text"], ["Mobile", "mobile", "text"]].map(([label, key, type]) => (
//                     <div key={key} style={{ marginBottom: 14 }}>
//                       <label style={S.label}>{label}</label>
//                       <input style={S.input} type={type} value={newAdmin[key]}
//                         onChange={e => setNewAdmin({ ...newAdmin, [key]: e.target.value })} />
//                     </div>
//                   ))}
//                   <div style={{ marginBottom: 16 }}>
//                     <label style={S.label}>Role</label>
//                     <select style={S.input} value={newAdmin.role} onChange={e => setNewAdmin({ ...newAdmin, role: e.target.value })}>
//                       <option value="admin">Admin</option>
//                       <option value="superadmin">Super Admin</option>
//                     </select>
//                   </div>
//                   <button style={{ ...S.btn, background: "#1e3a8a", width: "100%", padding: 12 }} onClick={createAdmin}>
//                     Create Admin Account
//                   </button>
//                 </div>
//               </div>
//             </div>
//           )}

//           {/* Fallback */}
//           {tab !== "dashboard" && !subTab && (
//             <div style={{ padding: 60, textAlign: "center", color: "#94a3b8" }}>
//               Select a submenu item from the sidebar.
//             </div>
//           )}
//         </main>
//       </div>
//     </div>
//   );
// }

// /* ── Sub-components ── */
// function PageHead({ title, sub, children }) {
//   return (
//     <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 16, paddingBottom: 12, borderBottom: "2px solid #e2e8f0" }}>
//       <div style={{ width: 4, height: 20, background: "#ea580c", borderRadius: 99 }} />
//       <span style={{ fontWeight: 700, fontSize: 16, color: "#1e293b" }}>{title}</span>
//       {sub && <span style={{ fontSize: 11, color: "#94a3b8", marginLeft: 4 }}>{sub}</span>}
//       {children}
//     </div>
//   );
// }
// function SectionTitle({ children }) {
//   return <div style={{ fontWeight: 700, fontSize: 13, color: "#1e3a8a", margin: "18px 0 8px", borderLeft: "4px solid #ea580c", paddingLeft: 10 }}>{children}</div>;
// }
// function CardHead({ children }) {
//   return <div style={{ background: "#1e3a8a", color: "#fff", padding: "10px 16px", fontWeight: 700, fontSize: 13 }}>{children}</div>;
// }
// function THead({ cols }) {
//   return (
//     <thead>
//       <tr style={{ background: "#1e3a8a", color: "#fff" }}>
//         {cols.map(c => <th key={c} style={{ padding: "10px 12px", textAlign: "left", fontSize: 11, fontWeight: 700, whiteSpace: "nowrap" }}>{c}</th>)}
//       </tr>
//     </thead>
//   );
// }
// function ActionBtn({ color, onClick, disabled, children }) {
//   return (
//     <button onClick={onClick} disabled={disabled}
//       style={{ background: color, color: "#fff", border: "none", padding: "5px 9px", borderRadius: 5, cursor: "pointer", fontSize: 12, fontWeight: 700, opacity: disabled ? .6 : 1 }}>
//       {children}
//     </button>
//   );
// }

// /* ── Styles ── */
// const S = {
//   shell: { display: "flex", flexDirection: "column", minHeight: "100vh", fontFamily: "'Segoe UI', system-ui, sans-serif", fontSize: 13, background: "#f1f5f9" },
//   topbar: { background: "linear-gradient(90deg,#1e3a8a 0%,#1e40af 100%)", color: "#fff", display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 20px", position: "sticky", top: 0, zIndex: 100, boxShadow: "0 2px 10px rgba(0,0,0,.3)" },
//   logoBadge: { width: 40, height: 40, borderRadius: 10, background: "linear-gradient(135deg,#f97316,#ea580c)", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 900, fontSize: 18, color: "#fff", boxShadow: "0 2px 8px rgba(234,88,12,.4)" },
//   superBadge: { background: "rgba(255,255,255,.15)", border: "1px solid rgba(255,255,255,.3)", borderRadius: 99, padding: "3px 12px", fontSize: 11, fontWeight: 700, color: "#fef3c7", letterSpacing: .5 },
//   logoutBtn: { background: "rgba(239,68,68,.85)", border: "none", color: "#fff", padding: "6px 14px", borderRadius: 6, cursor: "pointer", fontWeight: 600, fontSize: 12 },
//   sidebar: { width: 205, background: "#1e3a8a", minHeight: "calc(100vh - 60px)", flexShrink: 0, overflowY: "auto" },
//   navItem: { color: "#bfdbfe", padding: "11px 16px", cursor: "pointer", display: "flex", alignItems: "center", fontSize: 13, borderBottom: "1px solid rgba(255,255,255,.06)", fontWeight: 500 },
//   navActive: { background: "#ea580c", color: "#fff" },
//   navSub: { color: "#93c5fd", padding: "9px 16px 9px 28px", cursor: "pointer", fontSize: 12, background: "rgba(0,0,0,.25)", borderBottom: "1px solid rgba(255,255,255,.04)" },
//   navSubActive: { background: "#ea580c", color: "#fff", fontWeight: 700 },
//   content: { flex: 1, padding: 20, overflowX: "auto" },
//   kpiGrid: { display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))", gap: 10, marginBottom: 16 },
//   kpiCard: { color: "#fff", borderRadius: 10, padding: "14px 16px", display: "flex", flexDirection: "column", gap: 4, boxShadow: "0 2px 8px rgba(0,0,0,.15)" },
//   card: { background: "#fff", border: "1px solid #e2e8f0", borderRadius: 8, overflow: "hidden" },
//   tableWrap: { background: "#fff", borderRadius: 8, border: "1px solid #e2e8f0", overflow: "auto", marginBottom: 16 },
//   table: { width: "100%", borderCollapse: "collapse", minWidth: 600 },
//   td: { padding: "9px 12px", fontSize: 12, borderBottom: "1px solid #f1f5f9", verticalAlign: "middle" },
//   trEven: { background: "#f8fafc" },
//   infoChip: { background: "#f0f9ff", border: "1px solid #bae6fd", borderRadius: 8, padding: "8px 12px", minWidth: 90 },
//   searchBox: { border: "1px solid #e2e8f0", borderRadius: 6, padding: "8px 12px", fontSize: 13, outline: "none", minWidth: 260, background: "#fff" },
//   countBadge: { background: "#eff6ff", color: "#1d4ed8", padding: "5px 12px", borderRadius: 99, fontWeight: 700, fontSize: 12 },
//   pill: { background: "#eff6ff", color: "#1d4ed8", padding: "2px 8px", borderRadius: 99, fontSize: 11, fontWeight: 600 },
//   greenBadge: { background: "#dcfce7", color: "#15803d", padding: "2px 8px", borderRadius: 99, fontSize: 11, fontWeight: 700 },
//   yellowBadge: { background: "#fef9c3", color: "#854d0e", padding: "2px 8px", borderRadius: 99, fontSize: 11, fontWeight: 700 },
//   redBadge: { background: "#fee2e2", color: "#991b1b", padding: "2px 8px", borderRadius: 99, fontSize: 11, fontWeight: 700 },
//   badge: { padding: "2px 8px", borderRadius: 99, fontSize: 11, fontWeight: 600 },
//   label: { display: "block", fontSize: 12, color: "#475569", marginBottom: 4, fontWeight: 600 },
//   input: { border: "1px solid #e2e8f0", padding: "9px 12px", width: "100%", fontSize: 13, borderRadius: 6, outline: "none", boxSizing: "border-box" },
//   btn: { color: "#fff", border: "none", padding: "7px 14px", borderRadius: 6, cursor: "pointer", fontWeight: 600, fontSize: 13, display: "inline-flex", alignItems: "center", gap: 4 },
// };





// import { useState, useEffect, useCallback, useMemo } from "react";
// import { useNavigate } from "react-router-dom";
// import { useAuth } from "../context/AuthContext";
// import {
//   BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer,
//   PieChart, Pie, Cell, Legend, LineChart, Line
// } from "recharts";
// import api from "../api";
// import toast from "react-hot-toast";

// /* ─── Constants ─── */
// const LEVEL_RATE = { 1: 300, 2: 150, 3: 120, 4: 90, 5: 60, 6: 30 };
// const RANK_SALARY = { silver: 1000, gold: 3000, platinum: 7000, diamond: 15000 };
// const PIE_COLORS = ["#3b82f6", "#10b981", "#f59e0b", "#ef4444", "#8b5cf6", "#06b6d4"];
// const COMPANY = "Meruram Lucky Draw";
// const COMPANY_URL = "https://meruram.in";

// /* ─── WhatsApp helper ─── */
// const whatsapp = (mobile, msg) => {
//   if (!mobile) { toast.error("No mobile number!"); return; }
//   window.open(`https://wa.me/91${mobile.replace(/\D/g, "")}?text=${encodeURIComponent(msg)}`, "_blank");
// };

// /* ─── Format helpers ─── */
// const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
// const fmt = (d) => d ? new Date(d).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : "—";
// const fmtTime = (d) => d ? new Date(d).toLocaleString("en-IN") : "—";

// /* ─── Sidebar nav ─── */
// const NAV = [
//   { label: "📊 Dashboard", key: "dashboard" },
//   {
//     label: "🎟 Members", key: "members",
//     children: ["All Members", "Pending Approval", "Approved Members", "Member Detail"],
//   },
//   {
//     label: "💹 Income & Business", key: "income",
//     children: [
//       "Level Income Report",
//       "Level Wise Report",
//       "Commission Report",
//       "Direct Business Report",
//       "Business Report",
//       "Commission Summary",
//       "Daily Joins",
//       "Network Tree",
//     ],
//   },
//   {
//     label: "💸 Payments", key: "payments",
//     children: ["Withdrawal Requests", "Payment History", "Add Fund to Member"],
//   },
//   {
//     label: "💰 Salary", key: "salary",
//     children: ["Salary List", "Generate Salary"],
//   },
//   {
//     label: "🛡 Admin Mgmt", key: "admins",
//     children: ["All Admins", "Create Admin"],
//   },
// ];

// /* ══════════════════════════════════════════════
//    MAIN COMPONENT
// ══════════════════════════════════════════════ */
// export default function SuperAdminDashboard() {
//   const { admin, logout } = useAuth();
//   const navigate = useNavigate();

//   /* State */
//   const [stats, setStats] = useState(null);
//   const [allMembers, setAllMembers] = useState([]);
//   const [withdrawals, setWithdrawals] = useState([]);
//   const [payHistory, setPayHistory] = useState([]);
//   const [salaries, setSalaries] = useState([]);
//   const [adminList, setAdminList] = useState([]);
//   const [selectedMember, setSelectedMember] = useState(null);
//   const [memberDetail, setMemberDetail] = useState(null);
//   const [loadingDetail, setLoadingDetail] = useState(false);
//   const [commissions, setCommissions] = useState([]);
//   const [networkTree, setNetworkTree] = useState(null);
//   const [networkToken, setNetworkToken] = useState("");
//   const [dailyJoins, setDailyJoins] = useState([]);
//   const [generatingSalary, setGeneratingSalary] = useState(false);
//   const [repairing, setRepairing] = useState(false);
//   const [repairLog, setRepairLog] = useState([]);

//   const [tab, setTab] = useState("dashboard");
//   const [subTab, setSubTab] = useState("");
//   const [openNav, setOpenNav] = useState({ dashboard: true });
//   const [search, setSearch] = useState("");
//   const [approving, setApproving] = useState({});

//   const [addFundForm, setAddFundForm] = useState({ token_number: "", amount: "", description: "Fund added by admin" });
//   const [newAdmin, setNewAdmin] = useState({ username: "", password: "", full_name: "", mobile: "", role: "admin" });

//   /* ── Fetch functions ── */
//   const loadStats = useCallback(async () => {
//     try { const r = await api.get("/mlm/super-stats"); setStats(r.data); } catch { toast.error("Stats load failed"); }
//   }, []);

//   const loadMembers = useCallback(async (q = "") => {
//     try {
//       // Use /coupons/all (same as working original code)
//       const r = await api.get(`/coupons/all?search=${encodeURIComponent(q)}&limit=500`);
//       setAllMembers(r.data.rows || []);
//     } catch { toast.error("Members load failed"); }
//   }, []);

//   const loadWithdrawals = useCallback(async () => {
//     try { const r = await api.get("/wallet/withdrawals/all?status=pending"); setWithdrawals(r.data.rows || []); } catch {}
//   }, []);

//   const loadPayHistory = useCallback(async () => {
//     try { const r = await api.get("/mlm/payment-history"); setPayHistory(r.data.rows || []); } catch {}
//   }, []);

//   const loadSalaries = useCallback(async () => {
//     try { const r = await api.get("/mlm/salary/list"); setSalaries(r.data.rows || []); } catch {}
//   }, []);

//   const loadAdmins = useCallback(async () => {
//     try { const r = await api.get("/auth/admins"); setAdminList(r.data || []); } catch {}
//   }, []);

//   const loadMemberDetail = useCallback(async (token) => {
//     if (!token) return;
//     setLoadingDetail(true);
//     try {
//       const r = await api.get(`/mlm/member-detail/${token}`);
//       if (r.data.success) {
//         setMemberDetail(r.data);
//       } else {
//         toast.error("Member not found");
//       }
//     } catch { toast.error("Failed to load member detail"); }
//     setLoadingDetail(false);
//   }, []);

//   const loadCommissions = useCallback(async () => {
//     try {
//       const r = await api.get("/mlm/commissions/all?limit=500");
//       setCommissions(r.data.rows || []);
//     } catch { toast.error("Commissions load failed"); }
//   }, []);

//   const loadDailyJoins = useCallback(async () => {
//     try {
//       const r = await api.get("/mlm/daily-joins?days=30");
//       // Backend returns { success, rows, totals, best_day }
//       setDailyJoins(r.data.rows || []);
//     } catch (e) { toast.error("Daily joins load failed"); }
//   }, []);

//   const loadNetworkTree = useCallback(async (token) => {
//     if (!token) { toast.error("Enter a token/coupon number"); return; }
//     try {
//       const r = await api.get(`/mlm/network-tree/${token}`);
//       // Backend returns the node directly at root: { success, token_number, receiver_name, children... }
//       if (r.data.success && r.data.token_number) {
//         setNetworkTree(r.data); // whole response IS the node
//       } else if (r.data.tree) {
//         setNetworkTree(r.data.tree); // fallback for /tree/:token format
//       } else {
//         toast.error("Member not found");
//       }
//     } catch { toast.error("Network tree load failed"); }
//   }, []);

//   useEffect(() => {
//     // Load everything on mount so dashboard is fully populated
//     Promise.all([loadStats(), loadMembers(), loadWithdrawals()]);
//   }, []);

//   /* ── Navigation ── */
//   const goTo = useCallback((t, s = "") => {
//     setTab(t); setSubTab(s);
//     if (t === "admins") loadAdmins();
//     if (s === "Withdrawal Requests") loadWithdrawals();
//     if (s === "Payment History") loadPayHistory();
//     if (s === "Salary List" || s === "Generate Salary") loadSalaries();
//     if (s === "Commission Report") loadCommissions();
//     if (s === "Daily Joins") loadDailyJoins();
//     if (
//       s === "All Members" || s === "Pending Approval" || s === "Approved Members" ||
//       s === "Level Income Report" || s === "Level Wise Report" ||
//       s === "Direct Business Report" || s === "Business Report" ||
//       s === "Commission Summary" || s === "Commission Report"
//     ) loadMembers(search);
//   }, [search, loadAdmins, loadWithdrawals, loadPayHistory, loadSalaries, loadMembers, loadCommissions, loadDailyJoins]);

//   /* ── Actions ── */
//   const approveCoupon = async (id, row) => {
//     setApproving(p => ({ ...p, [id]: true }));
//     try {
//       await api.post(`/coupons/approve/${id}`);
//       toast.success("✅ Approved!");
//       await Promise.all([loadMembers(search), loadStats()]);
//       if (row?.receiver_mobile) {
//         const message = `Welcome ${row.receiver_name} 🎉\n\nYour ID ${row.receiver_coupon_no || ""} has been approved successfully.\n\nWelcome to Meruram family 🚀\n\n${COMPANY_URL}`;
//         window.open(`https://wa.me/91${row.receiver_mobile.replace(/\D/g, "")}?text=${encodeURIComponent(message)}`, "_blank");
//       }
//     } catch (err) { toast.error(err.response?.data?.message || "Error"); }
//     setApproving(p => ({ ...p, [id]: false }));
//   };

//   const deleteCoupon = async (id) => {
//     if (!window.confirm("Delete this coupon permanently?")) return;
//     try { await api.delete(`/coupons/delete/${id}`); toast.success("Deleted"); loadMembers(search); loadStats(); }
//     catch { toast.error("Delete failed"); }
//   };

//   const processWithdrawal = async (id, action, row) => {
//     try {
//       await api.put(`/wallet/withdrawals/${id}`, { action });
//       if (action === "approved") {
//         toast.success("✅ Approved! Sending WhatsApp...");
//         whatsapp(row.receiver_mobile,
//           `💸 Namaste *${row.receiver_name}*!\n\nYour withdrawal request of *${inr(row.amount)}* has been *APPROVED & PROCESSED* ✅\n\nPayment via: *${(row.method || "").toUpperCase()}*\n${row.method === "upi" ? `UPI: ${row.upi_id || "—"}` : `Bank: ${row.bank_name || "—"} | Acc: ${row.account_number || "—"}`}\n\n_${COMPANY}_\n${COMPANY_URL}`
//         );
//       } else {
//         toast.error("❌ Withdrawal rejected");
//       }
//       loadWithdrawals(); loadPayHistory(); loadStats();
//     } catch (err) { toast.error(err.response?.data?.message || "Error"); }
//   };

//   const approveSalary = async (id, row) => {
//     try {
//       await api.put(`/mlm/salary/approve/${id}`);
//       toast.success("Salary credited!");
//       if (row?.receiver_mobile) {
//         whatsapp(row.receiver_mobile,
//           `💰 Namaste *${row.receiver_name}*!\n\nYour *${row.rank?.toUpperCase()} Rank Salary* of *${inr(row.amount)}* for ${row.month} has been credited to your wallet ✅\n\n_${COMPANY}_\n${COMPANY_URL}`
//         );
//       }
//       loadSalaries();
//     } catch (err) { toast.error(err.response?.data?.message || "Error"); }
//   };

//   const generateSalary = async () => {
//     setGeneratingSalary(true);
//     try {
//       const r = await api.post("/mlm/salary/generate");
//       toast.success(r.data.message || "Salary generated!");
//       loadSalaries();
//       goTo("salary", "Salary List");
//     } catch (err) { toast.error(err.response?.data?.message || "Error"); }
//     setGeneratingSalary(false);
//   };

//   /* ── One-click data repair (fixes referred_by → commissions → ranks) ── */
//   const runFullRepair = async () => {
//     if (!window.confirm(
//       "⚠️ This will:\n1. Fix referred_by for all members\n2. Redistribute missing commissions\n3. Recalculate all ranks\n\nSafe to run multiple times. Continue?"
//     )) return;

//     setRepairing(true);
//     setRepairLog([]);
//     const log = [];

//     try {
//       // Step 1: Fix referred_by
//       log.push("🔧 Step 1: Fixing referred_by links...");
//       setRepairLog([...log]);
//       const r1 = await api.post("/mlm/fix-referred-by");
//       log.push(`✅ Step 1 done: ${r1.data.fixed} members linked, ${r1.data.skipped} skipped`);
//       setRepairLog([...log]);

//       // Step 2: Redistribute commissions
//       log.push("💰 Step 2: Redistributing commissions...");
//       setRepairLog([...log]);
//       const r2 = await api.post("/mlm/redistribute-commissions");
//       log.push(`✅ Step 2 done: commissions distributed for ${r2.data.processed} members`);
//       if (r2.data.errors?.length) {
//         log.push(`⚠️ ${r2.data.errors.length} errors (check server logs)`);
//       }
//       setRepairLog([...log]);

//       // Step 3: Recalculate ranks
//       log.push("🏆 Step 3: Recalculating all ranks...");
//       setRepairLog([...log]);
//       const r3 = await api.post("/mlm/recalculate-all-ranks");
//       const rankSummary = Object.entries(r3.data.summary || {})
//         .map(([rank, count]) => `${rank}: ${count}`)
//         .join(", ");
//       log.push(`✅ Step 3 done: ${r3.data.message} → ${rankSummary}`);
//       setRepairLog([...log]);

//       log.push("🎉 All repairs complete! Reloading data...");
//       setRepairLog([...log]);

//       // Reload everything
//       await Promise.all([loadStats(), loadMembers()]);
//       toast.success("✅ Data repair complete!");
//     } catch (err) {
//       log.push(`❌ Error: ${err.response?.data?.message || err.message}`);
//       setRepairLog([...log]);
//       toast.error("Repair failed — check log");
//     }
//     setRepairing(false);
//   };

//   const addFund = async () => {
//     if (!addFundForm.token_number || !addFundForm.amount) { toast.error("Fill all fields"); return; }
//     try {
//       const r = await api.post("/mlm/add-fund", addFundForm);
//       toast.success(r.data.message);
//       setAddFundForm({ token_number: "", amount: "", description: "Fund added by admin" });
//       loadMembers(); loadStats();
//     } catch (err) { toast.error(err.response?.data?.message || "Error"); }
//   };

//   const createAdmin = async () => {
//     if (!newAdmin.username || !newAdmin.password) { toast.error("Username & password required"); return; }
//     try {
//       await api.post("/auth/create-admin", newAdmin);
//       toast.success("Admin created!");
//       setNewAdmin({ username: "", password: "", full_name: "", mobile: "", role: "admin" });
//       loadAdmins();
//     } catch (err) { toast.error(err.response?.data?.message || "Error"); }
//   };

//   const openDetail = async (row) => {
//     // Support rows from all-members-stats (token_number) and level-wise (token field)
//     const tokenToLoad = row.token_number || row.token;
//     setSelectedMember(row);
//     setTab("members"); setSubTab("Member Detail");
//     await loadMemberDetail(tokenToLoad);
//   };

//   /* ── Filtered member lists ── */
//   const filteredMembers = useMemo(() => {
//     if (subTab === "Pending Approval") return allMembers.filter(c => !c.is_approved);
//     if (subTab === "Approved Members") return allMembers.filter(c => c.is_approved);
//     return allMembers;
//   }, [allMembers, subTab]);

//   /* ── Top members by income ── */
//   const topByIncome = useMemo(() =>
//     [...allMembers].sort((a, b) => Number(b.total_income || 0) - Number(a.total_income || 0)).slice(0, 10),
//     [allMembers]
//   );

//   const topByDirect = useMemo(() =>
//     [...allMembers].sort((a, b) => Number(b.direct_count || 0) - Number(a.direct_count || 0)).slice(0, 10),
//     [allMembers]
//   );

//   /* ── Level summary (company-wide) ── */
//   const levelSummary = useMemo(() => {
//     const map = {};
//     allMembers.forEach(m => {
//       for (let l = 1; l <= 6; l++) {
//         const earned = Number(m[`level${l}_income`] || 0);
//         if (!map[l]) map[l] = { level: l, total: 0, members_paid: 0, rate: LEVEL_RATE[l] };
//         if (earned > 0) { map[l].total += earned; map[l].members_paid++; }
//       }
//     });
//     return Object.values(map);
//   }, [allMembers]);

//   /* ── Commission summary per level ── */
//   const commissionByLevel = useMemo(() => {
//     const map = {};
//     commissions.forEach(c => {
//       const l = c.level;
//       if (!map[l]) map[l] = { level: l, count: 0, total: 0 };
//       map[l].count++;
//       map[l].total += Number(c.amount || 0);
//     });
//     return Object.values(map).sort((a, b) => a.level - b.level);
//   }, [commissions]);

//   /* ── Network Tree recursive renderer ── */
//   const TreeNode = ({ node, depth = 0 }) => {
//     const [expanded, setExpanded] = useState(depth < 2);
//     if (!node) return null;
//     const hasChildren = node.children && node.children.length > 0;
//     return (
//       <div style={{ marginLeft: depth * 24, marginBottom: 4 }}>
//         <div
//           style={{
//             display: "flex", alignItems: "center", gap: 8, padding: "8px 12px",
//             background: depth === 0 ? "#1e3a8a" : depth === 1 ? "#1d4ed8" : depth === 2 ? "#3b82f6" : "#eff6ff",
//             color: depth < 3 ? "#fff" : "#1e3a8a",
//             borderRadius: 8, cursor: hasChildren ? "pointer" : "default",
//             border: "1px solid rgba(255,255,255,0.1)",
//             transition: "all 0.15s",
//           }}
//           onClick={() => hasChildren && setExpanded(e => !e)}
//         >
//           {hasChildren && <span style={{ fontSize: 10, minWidth: 14 }}>{expanded ? "▼" : "▶"}</span>}
//           {!hasChildren && <span style={{ fontSize: 10, minWidth: 14, opacity: 0.5 }}>●</span>}
//           <span style={{ fontWeight: 700, fontSize: 12 }}>{node.receiver_coupon_no || node.token_number}</span>
//           <span style={{ fontSize: 12 }}>{node.receiver_name}</span>
//           <span style={{ fontSize: 11, opacity: 0.75 }}>{node.receiver_mobile}</span>
//           {hasChildren && (
//             <span style={{ marginLeft: "auto", background: "rgba(255,255,255,0.2)", borderRadius: 99, padding: "1px 8px", fontSize: 11 }}>
//               {node.children.length} direct
//             </span>
//           )}
//           <span style={{
//             marginLeft: hasChildren ? 4 : "auto",
//             background: node.is_approved ? "#16a34a" : "#f59e0b",
//             borderRadius: 99, padding: "1px 8px", fontSize: 10, color: "#fff"
//           }}>
//             {node.is_approved ? "Active" : "Pending"}
//           </span>
//         </div>
//         {expanded && hasChildren && (
//           <div style={{ borderLeft: "2px solid #bfdbfe", marginLeft: 18, paddingLeft: 6, marginTop: 4 }}>
//             {node.children.map(child => (
//               <TreeNode key={child.id || child.token_number} node={child} depth={depth + 1} />
//             ))}
//           </div>
//         )}
//       </div>
//     );
//   };

//   /* ─────────────── RENDER ─────────────── */
//   return (
//     <div style={S.shell}>
//       {/* ══ TOP BAR ══ */}
//       <header style={S.topbar}>
//         <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
//           <div style={S.logoBadge}>मे</div>
//           <div>
//             <div style={{ fontWeight: 800, fontSize: 16, letterSpacing: .5, color: "#fff" }}>MERURAM</div>
//             <div style={{ fontSize: 9, color: "#93c5fd", letterSpacing: 3 }}> SUPER ADMIN</div>
//           </div>
//         </div>
//         <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
//           <span style={S.superBadge}>👑 SUPER ADMIN</span>
//           <span style={{ fontSize: 12, color: "#ddd" }}>
//             {admin?.full_name || admin?.username}
//           </span>
//           <button style={S.logoutBtn} onClick={() => { logout(); navigate("/superadmin/login"); }}>
//             Logout
//           </button>
//         </div>
//       </header>

//       <div style={{ display: "flex", flex: 1 }}>
//         {/* ══ SIDEBAR ══ */}
//         <nav style={S.sidebar}>
//           {NAV.map(n => (
//             <div key={n.key}>
//               <div
//                 style={{ ...S.navItem, ...(tab === n.key && !subTab && !n.children ? S.navActive : {}) }}
//                 onClick={() => n.children ? setOpenNav(p => ({ ...p, [n.key]: !p[n.key] })) : goTo(n.key)}
//               >
//                 <span style={{ flex: 1 }}>{n.label}</span>
//                 {n.children && <span style={{ fontSize: 10, opacity: .6 }}>{openNav[n.key] ? "▾" : "▸"}</span>}
//               </div>
//               {n.children && openNav[n.key] && n.children
//                 .filter(c => c !== "Member Detail")
//                 .map(child => (
//                   <div key={child}
//                     style={{
//                       ...S.navSub,
//                       ...(subTab === child ? S.navSubActive : {})
//                     }}
//                     onClick={() => goTo(n.key, child)}
//                   >{child}</div>
//                 ))}
//             </div>
//           ))}
//           <div style={S.navItem} onClick={() => { logout(); navigate("/superadmin/login"); }}>
//             🚪 Logout
//           </div>
//         </nav>

//         {/* ══ MAIN CONTENT ══ */}
//         <main style={S.content}>

//           {/* ══════════ DASHBOARD ══════════ */}
//           {tab === "dashboard" && stats && (
//             <div>
//               <PageHead title="Dashboard Overview" sub={COMPANY_URL} />

//               {/* KPI Grid */}
//               <div style={S.kpiGrid}>
//                 {[
//                   { label: "Total Coupons", val: stats.total_members, icon: "🎟", bg: "#1e40af" },
//                   { label: "Approved", val: stats.approved, icon: "✅", bg: "#065f46" },
//                   { label: "Pending", val: stats.pending, icon: "⏳", bg: "#92400e" },
//                   { label: "Pending Payouts", val: stats.pending_payouts, icon: "💸", bg: "#7f1d1d" },
//                   { label: "Total Wallet", val: inr(stats.total_wallet), icon: "💰", bg: "#4c1d95" },
//                   { label: "Commission Paid", val: inr(stats.total_commission), icon: "📈", bg: "#134e4a" },
//                   { label: "Payout Done", val: inr(stats.total_payout_done), icon: "🏦", bg: "#1e1b4b" },
//                   { label: "Pending Salary", val: stats.pending_salary, icon: "📋", bg: "#701a75" },
//                 ].map(c => (
//                   <div key={c.label} style={{ ...S.kpiCard, background: c.bg }}>
//                     <div style={{ fontSize: 22 }}>{c.icon}</div>
//                     <div style={{ fontSize: 20, fontWeight: 800 }}>{c.val}</div>
//                     <div style={{ fontSize: 10, opacity: .8 }}>{c.label}</div>
//                   </div>
//                 ))}
//               </div>

//               {/* ── DATA REPAIR PANEL ── */}
//               <div style={{
//                 background: "linear-gradient(135deg, #1e1b4b 0%, #312e81 100%)",
//                 borderRadius: 12, padding: "16px 20px", marginBottom: 16,
//                 border: "1px solid #4338ca", display: "flex", gap: 16,
//                 alignItems: "flex-start", flexWrap: "wrap"
//               }}>
//                 <div style={{ flex: 1, minWidth: 220 }}>
//                   <div style={{ fontWeight: 800, color: "#c7d2fe", fontSize: 13, marginBottom: 4 }}>
//                     🔧 Data Repair Tool
//                   </div>
//                   <div style={{ fontSize: 11, color: "#a5b4fc", lineHeight: 1.6 }}>
//                     Run once if members, commissions or ranks are showing blank/zero.
//                     Fixes <code style={{ background: "#1e1b4b", padding: "1px 4px", borderRadius: 3 }}>referred_by</code>,
//                     redistributes missing commissions, recalculates all ranks.
//                   </div>
//                 </div>
//                 <div style={{ display: "flex", flexDirection: "column", gap: 8, minWidth: 200 }}>
//                   <button
//                     style={{
//                       background: repairing ? "#4338ca" : "#6366f1",
//                       color: "#fff", border: "none", borderRadius: 8,
//                       padding: "10px 20px", fontWeight: 700, fontSize: 13,
//                       cursor: repairing ? "not-allowed" : "pointer",
//                       opacity: repairing ? 0.7 : 1,
//                     }}
//                     onClick={runFullRepair}
//                     disabled={repairing}
//                   >
//                     {repairing ? "⏳ Repairing..." : "🚀 Run Full Data Repair"}
//                   </button>
//                   {repairLog.length > 0 && (
//                     <div style={{
//                       background: "#0f172a", borderRadius: 8, padding: "10px 12px",
//                       fontSize: 11, fontFamily: "monospace", lineHeight: 1.8,
//                       maxHeight: 160, overflowY: "auto", border: "1px solid #334155"
//                     }}>
//                       {repairLog.map((line, i) => (
//                         <div key={i} style={{
//                           color: line.startsWith("✅") ? "#4ade80"
//                                : line.startsWith("❌") ? "#f87171"
//                                : line.startsWith("⚠️") ? "#fbbf24"
//                                : line.startsWith("🎉") ? "#818cf8"
//                                : "#94a3b8"
//                         }}>{line}</div>
//                       ))}
//                     </div>
//                   )}
//                 </div>
//               </div>

//               {/* Company-wide Level Summary */}
//               <SectionTitle>💹 Company-wide Level Commission Summary</SectionTitle>
//               <div style={S.tableWrap}>
//                 <table style={S.table}>
//                   <THead cols={["Level", "Rate/Join", "Members Benefiting", "Total Paid Out", "Chart"]} />
//                   <tbody>
//                     {levelSummary.map((l, i) => (
//                       <tr key={l.level} style={i % 2 === 0 ? S.trEven : {}}>
//                         <td style={S.td}><b>Level {l.level}</b></td>
//                         <td style={S.td}>₹{l.rate}</td>
//                         <td style={S.td}>{l.members_paid}</td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#16a34a" }}>{inr(l.total)}</td>
//                         <td style={S.td}>
//                           <div style={{ width: Math.min((l.total / (stats.total_commission || 1)) * 300, 200), height: 8, background: PIE_COLORS[i % PIE_COLORS.length], borderRadius: 99 }} />
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>

//               {/* Charts Row */}
//               <div style={{ display: "flex", gap: 14, marginTop: 4, flexWrap: "wrap" }}>
//                 <div style={{ ...S.card, flex: 2, minWidth: 280 }}>
//                   <CardHead>📅 Daily Registrations (14 days)</CardHead>
//                   <div style={{ padding: 16 }}>
//                     <ResponsiveContainer width="100%" height={180}>
//                       <BarChart data={stats.daily_joins || []}>
//                         <XAxis dataKey="date" tick={{ fontSize: 9 }} />
//                         <YAxis tick={{ fontSize: 9 }} />
//                         <Tooltip />
//                         <Bar dataKey="count" fill="#3b82f6" radius={[3, 3, 0, 0]} name="Joins" />
//                       </BarChart>
//                     </ResponsiveContainer>
//                   </div>
//                 </div>
//                 <div style={{ ...S.card, flex: 1, minWidth: 200 }}>
//                   <CardHead>🏆 Rank Distribution</CardHead>
//                   <div style={{ padding: "8px 0" }}>
//                     {(stats.rank_dist || []).map((r, i) => (
//                       <div key={r.rank} style={{ display: "flex", justifyContent: "space-between", padding: "8px 16px", borderBottom: "1px solid #f1f5f9", alignItems: "center" }}>
//                         <span style={{ fontSize: 12, textTransform: "capitalize", fontWeight: 600 }}>{r.rank}</span>
//                         <span style={{ ...S.badge, background: PIE_COLORS[i % PIE_COLORS.length], color: "#fff" }}>{r.count}</span>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               </div>

//               {/* Top 10 by Income */}
//               <SectionTitle>🥇 Top 10 Members by Total Income</SectionTitle>
//               <div style={S.tableWrap}>
//                 <table style={S.table}>
//                   <THead cols={["Rank", "Coupon", "Name", "Direct", "L1", "L2", "L3", "L4", "L5", "L6", "Total Income"]} />
//                   <tbody>
//                     {topByIncome.map((m, i) => (
//                       <tr key={m.id} style={i % 2 === 0 ? S.trEven : {}}>
//                         <td style={{ ...S.td, fontWeight: 800, color: i < 3 ? "#f59e0b" : "#64748b" }}>#{i + 1}</td>
//                         <td style={{ ...S.td, color: "#1d4ed8", fontWeight: 700, cursor: "pointer" }} onClick={() => openDetail(m)}>
//                           {m.receiver_coupon_no}
//                         </td>
//                         <td style={S.td}>{m.receiver_name}</td>
//                         <td style={S.td}>{m.direct_count}</td>
//                         {[1, 2, 3, 4, 5, 6].map(l => (
//                           <td key={l} style={{ ...S.td, fontSize: 11, color: m[`level${l}_income`] > 0 ? "#16a34a" : "#ccc" }}>
//                             {m[`level${l}_income`] > 0 ? inr(m[`level${l}_income`]) : "—"}
//                           </td>
//                         ))}
//                         <td style={{ ...S.td, fontWeight: 800, color: "#7c3aed" }}>{inr(m.total_income)}</td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>

//               {/* Top 10 by Direct */}
//               <SectionTitle>👥 Top 10 Members by Direct Connections</SectionTitle>
//               <div style={S.tableWrap}>
//                 <table style={S.table}>
//                   <THead cols={["Rank", "Coupon", "Name", "Mobile", "Direct", "Total Team", "Total Business"]} />
//                   <tbody>
//                     {topByDirect.map((m, i) => (
//                       <tr key={m.id} style={i % 2 === 0 ? S.trEven : {}}>
//                         <td style={{ ...S.td, fontWeight: 800, color: i < 3 ? "#f59e0b" : "#64748b" }}>#{i + 1}</td>
//                         <td style={{ ...S.td, color: "#1d4ed8", fontWeight: 700, cursor: "pointer" }} onClick={() => openDetail(m)}>
//                           {m.receiver_coupon_no}
//                         </td>
//                         <td style={S.td}>{m.receiver_name}</td>
//                         <td style={S.td}>{m.receiver_mobile}</td>
//                         <td style={{ ...S.td, fontWeight: 700 }}>{m.direct_count}</td>
//                         <td style={S.td}>{Number(m.direct_count || 0) + Number(m.indirect_count || 0)}</td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#16a34a" }}>{inr(m.total_income)}</td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}

//           {/* ══════════ ALL MEMBERS ══════════ */}
//           {(subTab === "All Members" || subTab === "Pending Approval" || subTab === "Approved Members") && (
//             <div>
//               <PageHead title={`🎟 ${subTab}`} />
//               <div style={{ display: "flex", gap: 10, marginBottom: 12, flexWrap: "wrap" }}>
//                 <input style={S.searchBox}
//                   placeholder="🔍 Search name, mobile, coupon..."
//                   value={search}
//                   onChange={e => { setSearch(e.target.value); loadMembers(e.target.value); }}
//                 />
//                 <span style={S.countBadge}>Total: {filteredMembers.length}</span>
//                 <span style={{ ...S.countBadge, background: "#dcfce7", color: "#15803d" }}>
//                   Active: {filteredMembers.filter(m => m.is_approved).length}
//                 </span>
//                 <span style={{ ...S.countBadge, background: "#fef9c3", color: "#854d0e" }}>
//                   Pending: {filteredMembers.filter(m => !m.is_approved).length}
//                 </span>
//               </div>
//               <div style={S.tableWrap}>
//                 <table style={S.table}>
//                   <THead cols={[
//                     "#", "Coupon", "Name", "Mobile", "Aadhaar", "Giver",
//                     "Payment", "Screenshot", "Wallet", "Rank", "Status", "Date", "Actions"
//                   ]} />
//                   <tbody>
//                     {filteredMembers.map((c, i) => (
//                       <tr key={c.id} style={i % 2 === 0 ? S.trEven : {}}>
//                         <td style={S.td}>{i + 1}</td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#1d4ed8", cursor: "pointer" }}
//                           onClick={() => openDetail(c)}>
//                           {c.receiver_coupon_no || "—"}
//                         </td>
//                         <td style={S.td}>{c.receiver_name}</td>
//                         <td style={S.td}>{c.receiver_mobile}</td>
//                         <td style={{ ...S.td, fontSize: 11 }}>
//                           {c.receiver_aadhaar ? "••••" + String(c.receiver_aadhaar).slice(-4) : "—"}
//                         </td>
//                         <td style={S.td}>{c.giver_name || "—"}</td>
//                         <td style={S.td}>
//                           <span style={S.pill}>{c.payment_cash ? "Cash" : "Online"}</span>
//                         </td>
//                         <td style={S.td}>
//                           {c.screenshot
//                             ? <a href={`/uploads/${c.screenshot}`} target="_blank" rel="noreferrer"
//                                 style={{ color: "#1d4ed8", fontWeight: 600, fontSize: 11 }}>View 📷</a>
//                             : "—"}
//                         </td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#7c3aed" }}>{inr(c.wallet_balance)}</td>
//                         <td style={S.td}>
//                           <span style={S.pill}>{c.rank || "member"}</span>
//                         </td>
//                         <td style={S.td}>
//                           <span style={c.is_approved ? S.greenBadge : S.yellowBadge}>
//                             {c.is_approved ? "Active" : "Pending"}
//                           </span>
//                         </td>
//                         <td style={{ ...S.td, fontSize: 11 }}>{fmt(c.created_at)}</td>
//                         <td style={S.td}>
//                           <div style={{ display: "flex", gap: 3, flexWrap: "wrap" }}>
//                             {!c.is_approved && (
//                               <ActionBtn color="#16a34a" disabled={approving[c.id]}
//                                 onClick={() => approveCoupon(c.id, c)}>
//                                 {approving[c.id] ? "..." : "✅"}
//                               </ActionBtn>
//                             )}
//                             <ActionBtn color="#1d4ed8" onClick={() => openDetail(c)}>👁</ActionBtn>
//                             <ActionBtn color="#25D366" onClick={() =>
//                               whatsapp(c.receiver_mobile,
//                                 `Namaste *${c.receiver_name}*! Your coupon status: ${c.is_approved ? "Active ✅" : "Pending ⏳"}. Visit ${COMPANY_URL}`)
//                             }>📱</ActionBtn>
//                             <ActionBtn color="#dc2626" onClick={() => deleteCoupon(c.id)}>🗑</ActionBtn>
//                           </div>
//                         </td>
//                       </tr>
//                     ))}
//                     {filteredMembers.length === 0 && (
//                       <tr><td colSpan={13} style={{ ...S.td, textAlign: "center", color: "#94a3b8", padding: 40 }}>
//                         No records found
//                       </td></tr>
//                     )}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}

//           {/* ══════════ MEMBER DETAIL ══════════ */}
//           {subTab === "Member Detail" && (
//             <div>
//               <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
//                 <PageHead title={`👤 Member Detail${memberDetail ? " — " + memberDetail.member?.receiver_name : ""}`} />
//                 <button style={{ ...S.btn, background: "#64748b" }} onClick={() => goTo("members", "All Members")}>← Back</button>
//               </div>

//               {loadingDetail && <div style={{ textAlign: "center", padding: 48, color: "#94a3b8" }}>Loading...</div>}

//               {!loadingDetail && memberDetail && (() => {
//                 const m = memberDetail.member;
//                 const levelBreakdown = memberDetail.level_breakdown || [];
//                 const direct = memberDetail.direct || [];
//                 const memberCommissions = memberDetail.commissions || [];
//                 const wdrawals = memberDetail.withdrawals || [];
//                 const totalEarned = levelBreakdown.reduce((s, l) => s + Number(l.total || 0), 0);
//                 const referralLink = m.reference_token
//                   ? `${COMPANY_URL}/register/${m.reference_token}`
//                   : null;

//                 return (
//                   <div>
//                     {/* ── Info Chips ── */}
//                     <div style={{ display: "flex", flexWrap: "wrap", gap: 10, marginBottom: 16 }}>
//                       {[
//                         ["Coupon No", m.receiver_coupon_no],
//                         ["Name", m.receiver_name],
//                         ["Mobile", m.receiver_mobile],
//                         ["Aadhaar", m.receiver_aadhaar || "—"],
//                         ["Address", m.receiver_address || "—"],
//                         ["Rank", m.rank?.toUpperCase()],
//                         ["Wallet Balance", inr(m.wallet_balance)],
//                         ["Direct Members", direct.length],
//                         ["Total Team", memberDetail.total_team],
//                         ["Total Earned", inr(totalEarned)],
//                         ["Joined", fmt(m.created_at)],
//                         ["Status", m.is_approved ? "Active ✅" : "Pending ⏳"],
//                       ].map(([k, v]) => (
//                         <div key={k} style={S.infoChip}>
//                           <div style={{ fontSize: 10, color: "#64748b" }}>{k}</div>
//                           <div style={{ fontWeight: 700, wordBreak: "break-all" }}>{v}</div>
//                         </div>
//                       ))}
//                     </div>

//                     {/* ── Referral Link Box ── */}
//                     {referralLink && (
//                       <div style={{
//                         background: "linear-gradient(135deg,#1e3a8a,#1d4ed8)",
//                         borderRadius: 10, padding: "14px 18px", marginBottom: 16,
//                         display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap"
//                       }}>
//                         <div style={{ flex: 1 }}>
//                           <div style={{ fontSize: 11, color: "#93c5fd", fontWeight: 700, marginBottom: 4 }}>
//                             🔗 MEMBER REFERRAL LINK
//                           </div>
//                           <div style={{
//                             background: "rgba(0,0,0,.3)", borderRadius: 6, padding: "8px 12px",
//                             fontSize: 12, color: "#e0f2fe", fontFamily: "monospace", wordBreak: "break-all"
//                           }}>
//                             {referralLink}
//                           </div>
//                         </div>
//                         <button
//                           style={{ ...S.btn, background: "#f59e0b", color: "#000", fontWeight: 800, whiteSpace: "nowrap" }}
//                           onClick={() => {
//                             navigator.clipboard.writeText(referralLink);
//                             toast.success("✅ Referral link copied!");
//                           }}>
//                           📋 Copy Link
//                         </button>
//                         <button
//                           style={{ ...S.btn, background: "#25D366", whiteSpace: "nowrap" }}
//                           onClick={() => whatsapp(m.receiver_mobile,
//                             `Namaste *${m.receiver_name}* 👋\n\nHere is your personal Meruram  referral link:\n\n🔗 ${referralLink}\n\nShare this with your friends & family to earn level income! 💰\n\n_${COMPANY}_`)}>
//                           📱 Send via WhatsApp
//                         </button>
//                       </div>
//                     )}

//                     {/* ── Screenshot & Aadhaar row ── */}
//                     <div style={{ display: "flex", gap: 12, marginBottom: 16, flexWrap: "wrap" }}>
//                       {m.screenshot && (
//                         <div style={{ ...S.card, padding: 14, flex: 1, minWidth: 200 }}>
//                           <div style={{ fontSize: 11, fontWeight: 700, color: "#64748b", marginBottom: 8 }}>📷 PAYMENT SCREENSHOT</div>
//                           <a href={`/uploads/${m.screenshot}`} target="_blank" rel="noreferrer">
//                             <img
//                               src={`/uploads/${m.screenshot}`}
//                               alt="Payment screenshot"
//                               style={{ maxWidth: "100%", maxHeight: 180, borderRadius: 6, border: "1px solid #e2e8f0", cursor: "pointer" }}
//                             />
//                           </a>
//                           <div style={{ marginTop: 8 }}>
//                             <a href={`/uploads/${m.screenshot}`} target="_blank" rel="noreferrer"
//                               style={{ ...S.btn, background: "#1d4ed8", fontSize: 11, textDecoration: "none", display: "inline-flex" }}>
//                               🔍 View Full Size
//                             </a>
//                           </div>
//                         </div>
//                       )}
//                       <div style={{ ...S.card, padding: 14, flex: 1, minWidth: 200 }}>
//                         <div style={{ fontSize: 11, fontWeight: 700, color: "#64748b", marginBottom: 8 }}>🪪 AADHAAR DETAILS</div>
//                         <div style={{ fontSize: 13, marginBottom: 6 }}>
//                           <span style={{ color: "#94a3b8", fontSize: 11 }}>Full Aadhaar Number:</span><br />
//                           <span style={{ fontWeight: 800, fontSize: 16, letterSpacing: 2, color: "#1e3a8a" }}>
//                             {m.receiver_aadhaar || "Not provided"}
//                           </span>
//                         </div>
//                         <div style={{ fontSize: 12, color: "#64748b" }}>
//                           <div><b>Name:</b> {m.receiver_name}</div>
//                           <div><b>Address:</b> {m.receiver_address || "—"}</div>
//                           <div><b>Mobile:</b> {m.receiver_mobile}</div>
//                         </div>
//                       </div>
//                       <div style={{ ...S.card, padding: 14, flex: 1, minWidth: 200 }}>
//                         <div style={{ fontSize: 11, fontWeight: 700, color: "#64748b", marginBottom: 8 }}>🏦 BANK / UPI DETAILS</div>
//                         {(m.bank_name || m.account_number || m.upi_id) ? (
//                           <div style={{ fontSize: 13 }}>
//                             {m.bank_name && <div><span style={{ color: "#94a3b8", fontSize: 11 }}>Bank:</span> <b>{m.bank_name}</b></div>}
//                             {m.account_number && <div><span style={{ color: "#94a3b8", fontSize: 11 }}>A/C No:</span> <b>{m.account_number}</b></div>}
//                             {m.ifsc && <div><span style={{ color: "#94a3b8", fontSize: 11 }}>IFSC:</span> <b>{m.ifsc}</b></div>}
//                             {m.upi_id && <div><span style={{ color: "#94a3b8", fontSize: 11 }}>UPI ID:</span> <b>{m.upi_id}</b></div>}
//                           </div>
//                         ) : (
//                           <div style={{ color: "#94a3b8", fontSize: 12 }}>No bank/UPI details added yet</div>
//                         )}
//                       </div>
//                     </div>

//                     {/* ── Action buttons ── */}
//                     <div style={{ display: "flex", gap: 8, marginBottom: 16, flexWrap: "wrap" }}>
//                       <button style={{ ...S.btn, background: "#25D366" }} onClick={() =>
//                         whatsapp(m.receiver_mobile, `Namaste *${m.receiver_name}*!\n\nYour Meruram  account is active ✅.\n\nCoupon: ${m.receiver_coupon_no}\nBalance: ${inr(m.wallet_balance)}\n\nVisit: ${COMPANY_URL}`)}>
//                         📱 Send Account Info
//                       </button>
//                       <button style={{ ...S.btn, background: "#25D366" }} onClick={() =>
//                         whatsapp(m.receiver_mobile, `Namaste *${m.receiver_name}*!\n\nYou have earned *${inr(totalEarned)}* in Level Income from Meruram Lucky Draw 🎉\n\nLogin to check: ${COMPANY_URL}`)}>
//                         📱 Send Income Info
//                       </button>
//                     </div>

//                     <SectionTitle>💹 Level-wise Income</SectionTitle>
//                     <div style={S.tableWrap}>
//                       <table style={S.table}>
//                         <THead cols={["Level", "Rate/Join", "Members Joined", "Direct Members", "Indirect Members", "Total Earned", "% Share"]} />
//                         <tbody>
//                           {[1, 2, 3, 4, 5, 6].map((level, i) => {
//                             const found = levelBreakdown.find(l => l.level === level);
//                             const earned = Number(found?.total || 0);
//                             const pct = totalEarned > 0 ? ((earned / totalEarned) * 100).toFixed(1) : "0";
//                             const isL1 = level === 1;
//                             return (
//                               <tr key={level} style={i % 2 === 0 ? S.trEven : {}}>
//                                 <td style={S.td}><strong>Level {level}</strong> {isL1 ? "🔴" : ""}</td>
//                                 <td style={S.td}>₹{LEVEL_RATE[level]}</td>
//                                 <td style={S.td}>{found?.count || 0}</td>
//                                 <td style={S.td}>{isL1 ? (found?.count || 0) : "—"}</td>
//                                 <td style={S.td}>{!isL1 ? (found?.count || 0) : "—"}</td>
//                                 <td style={{ ...S.td, fontWeight: 700, color: earned > 0 ? "#16a34a" : "#94a3b8" }}>
//                                   {earned > 0 ? inr(earned) : "₹0.00"}
//                                 </td>
//                                 <td style={S.td}>
//                                   <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
//                                     <div style={{ height: 6, borderRadius: 99, background: PIE_COLORS[i], width: `${Math.min(Number(pct), 100)}%`, minWidth: 2 }} />
//                                     <span style={{ fontSize: 11, color: "#64748b" }}>{pct}%</span>
//                                   </div>
//                                 </td>
//                               </tr>
//                             );
//                           })}
//                           <tr style={{ background: "#f0fdf4" }}>
//                             <td style={{ ...S.td, fontWeight: 800 }} colSpan={2}>TOTAL</td>
//                             <td style={{ ...S.td, fontWeight: 700 }}>{levelBreakdown.reduce((s, l) => s + l.count, 0)}</td>
//                             <td style={S.td}>{direct.length}</td>
//                             <td style={S.td}>{memberDetail.total_team - direct.length}</td>
//                             <td style={{ ...S.td, fontWeight: 800, color: "#15803d", fontSize: 15 }}>{inr(totalEarned)}</td>
//                             <td style={S.td}>100%</td>
//                           </tr>
//                         </tbody>
//                       </table>
//                     </div>

//                     <SectionTitle>👥 Direct Members</SectionTitle>
//                     <div style={S.tableWrap}>
//                       <table style={S.table}>
//                         <THead cols={["#", "Coupon", "Name", "Mobile", "Joined Date", "Their Direct", "Status", "WA"]} />
//                         <tbody>
//                           {direct.map((d, i) => (
//                             <tr key={d.id} style={i % 2 === 0 ? S.trEven : {}}>
//                               <td style={S.td}>{i + 1}</td>
//                               <td style={{ ...S.td, color: "#1d4ed8", fontWeight: 700 }}>{d.receiver_coupon_no}</td>
//                               <td style={S.td}>{d.receiver_name}</td>
//                               <td style={S.td}>{d.receiver_mobile}</td>
//                               <td style={{ ...S.td, fontSize: 11 }}>{fmtTime(d.created_at)}</td>
//                               <td style={{ ...S.td, fontWeight: 700 }}>{d.their_direct}</td>
//                               <td style={S.td}><span style={d.is_approved ? S.greenBadge : S.yellowBadge}>{d.is_approved ? "Active" : "Pending"}</span></td>
//                               <td style={S.td}>
//                                 <button style={{ ...S.btn, background: "#25D366", padding: "4px 8px" }}
//                                   onClick={() => whatsapp(d.receiver_mobile, `Namaste *${d.receiver_name}*! Welcome to Meruram Lucky Draw. Login: ${COMPANY_URL}`)}>
//                                   📱
//                                 </button>
//                               </td>
//                             </tr>
//                           ))}
//                           {direct.length === 0 && <tr><td colSpan={8} style={{ ...S.td, textAlign: "center", color: "#94a3b8" }}>No direct referrals</td></tr>}
//                         </tbody>
//                       </table>
//                     </div>

//                     <SectionTitle>📋 Commission History</SectionTitle>
//                     <div style={S.tableWrap}>
//                       <table style={S.table}>
//                         <THead cols={["#", "Date", "Level", "From Coupon", "From Member", "Amount Earned"]} />
//                         <tbody>
//                           {memberCommissions.slice(0, 100).map((c, i) => (
//                             <tr key={c.id} style={i % 2 === 0 ? S.trEven : {}}>
//                               <td style={S.td}>{i + 1}</td>
//                               <td style={{ ...S.td, fontSize: 11 }}>{fmtTime(c.created_at)}</td>
//                               <td style={S.td}><span style={S.pill}>L{c.level}</span></td>
//                               <td style={{ ...S.td, color: "#1d4ed8" }}>{c.from_coupon}</td>
//                               <td style={S.td}>{c.from_name}</td>
//                               <td style={{ ...S.td, fontWeight: 700, color: "#16a34a" }}>{inr(c.amount)}</td>
//                             </tr>
//                           ))}
//                           {memberCommissions.length === 0 && <tr><td colSpan={6} style={{ ...S.td, textAlign: "center", color: "#94a3b8" }}>No commissions yet</td></tr>}
//                         </tbody>
//                       </table>
//                     </div>

//                     <SectionTitle>💸 Withdrawal History</SectionTitle>
//                     <div style={S.tableWrap}>
//                       <table style={S.table}>
//                         <THead cols={["#", "Date", "Amount", "Method", "Bank/UPI", "Status"]} />
//                         <tbody>
//                           {wdrawals.map((w, i) => (
//                             <tr key={w.id} style={i % 2 === 0 ? S.trEven : {}}>
//                               <td style={S.td}>{i + 1}</td>
//                               <td style={{ ...S.td, fontSize: 11 }}>{fmt(w.created_at)}</td>
//                               <td style={{ ...S.td, fontWeight: 700 }}>{inr(w.amount)}</td>
//                               <td style={S.td}>{w.method?.toUpperCase()}</td>
//                               <td style={{ ...S.td, fontSize: 11 }}>{w.method === "upi" ? w.upi_id : `${w.bank_name || ""} ${w.account_number || ""}`}</td>
//                               <td style={S.td}><span style={w.status === "approved" ? S.greenBadge : w.status === "rejected" ? S.redBadge : S.yellowBadge}>{w.status}</span></td>
//                             </tr>
//                           ))}
//                           {wdrawals.length === 0 && <tr><td colSpan={6} style={{ ...S.td, textAlign: "center", color: "#94a3b8" }}>No withdrawals</td></tr>}
//                         </tbody>
//                       </table>
//                     </div>
//                   </div>
//                 );
//               })()}
//             </div>
//           )}

//           {/* ══════════ LEVEL INCOME REPORT ══════════ */}
//           {subTab === "Level Income Report" && (
//             <div>
//               <PageHead title="📈 Level Income Report — All Members" />

//               {/* Summary KPI */}
//               <div style={{ display: "flex", gap: 10, marginBottom: 16, flexWrap: "wrap" }}>
//                 {[1, 2, 3, 4, 5, 6].map((l, i) => (
//                   <div key={l} style={{ background: PIE_COLORS[i], color: "#fff", borderRadius: 10, padding: "12px 16px", minWidth: 110, textAlign: "center" }}>
//                     <div style={{ fontSize: 10, opacity: 0.8 }}>Level {l} · ₹{LEVEL_RATE[l]}/join</div>
//                     <div style={{ fontSize: 18, fontWeight: 800, marginTop: 4 }}>
//                       {inr(allMembers.reduce((s, m) => s + Number(m[`level${l}_income`] || 0), 0))}
//                     </div>
//                     <div style={{ fontSize: 10, opacity: 0.8, marginTop: 2 }}>
//                       {allMembers.filter(m => Number(m[`level${l}_income`]) > 0).length} members
//                     </div>
//                   </div>
//                 ))}
//               </div>

//               <div style={S.tableWrap}>
//                 <table style={S.table}>
//                   <THead cols={["#", "Coupon", "Name", "Mobile", "Sponsor", "Direct", "L1 ₹300", "L2 ₹150", "L3 ₹120", "L4 ₹90", "L5 ₹60", "L6 ₹30", "Total Income", "Withdrawn"]} />
//                   <tbody>
//                     {allMembers.filter(m => Number(m.total_income) > 0).map((m, i) => (
//                       <tr key={m.id} style={i % 2 === 0 ? S.trEven : {}}>
//                         <td style={S.td}>{i + 1}</td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#1d4ed8", cursor: "pointer" }} onClick={() => openDetail(m)}>{m.receiver_coupon_no}</td>
//                         <td style={S.td}>{m.receiver_name}</td>
//                         <td style={S.td}>{m.receiver_mobile}</td>
//                         <td style={{ ...S.td, fontSize: 11 }}>{m.sponsor_name || "—"}</td>
//                         <td style={S.td}>{m.direct_count}</td>
//                         {[1, 2, 3, 4, 5, 6].map(l => (
//                           <td key={l} style={{ ...S.td, color: m[`level${l}_income`] > 0 ? "#16a34a" : "#d1d5db", fontSize: 11 }}>
//                             {m[`level${l}_income`] > 0 ? inr(m[`level${l}_income`]) : "—"}
//                           </td>
//                         ))}
//                         <td style={{ ...S.td, fontWeight: 800, color: "#7c3aed" }}>{inr(m.total_income)}</td>
//                         <td style={{ ...S.td, color: "#dc2626" }}>{inr(m.total_withdrawn)}</td>
//                       </tr>
//                     ))}
//                     <tr style={{ background: "#eff6ff", fontWeight: 800 }}>
//                       <td style={S.td} colSpan={6}>COMPANY TOTAL</td>
//                       {[1, 2, 3, 4, 5, 6].map(l => (
//                         <td key={l} style={{ ...S.td, color: "#16a34a", fontWeight: 800 }}>
//                           {inr(allMembers.reduce((s, m) => s + Number(m[`level${l}_income`] || 0), 0))}
//                         </td>
//                       ))}
//                       <td style={{ ...S.td, color: "#7c3aed", fontSize: 14 }}>
//                         {inr(allMembers.reduce((s, m) => s + Number(m.total_income || 0), 0))}
//                       </td>
//                       <td style={{ ...S.td, color: "#dc2626" }}>
//                         {inr(allMembers.reduce((s, m) => s + Number(m.total_withdrawn || 0), 0))}
//                       </td>
//                     </tr>
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}

//           {/* ══════════ LEVEL WISE REPORT ══════════ */}
//           {subTab === "Level Wise Report" && (
//             <div>
//               <PageHead title="📊 Level Wise Report — Company Overview" />

//               {/* Chart */}
//               <div style={{ ...S.card, marginBottom: 16 }}>
//                 <CardHead>Level-wise Commission Distribution</CardHead>
//                 <div style={{ padding: 16 }}>
//                   <ResponsiveContainer width="100%" height={220}>
//                     <BarChart data={levelSummary}>
//                       <XAxis dataKey="level" tickFormatter={v => `L${v}`} tick={{ fontSize: 11 }} />
//                       <YAxis tick={{ fontSize: 10 }} tickFormatter={v => `₹${(v / 1000).toFixed(0)}k`} />
//                       <Tooltip formatter={(v) => inr(v)} labelFormatter={l => `Level ${l}`} />
//                       <Bar dataKey="total" name="Total Paid" radius={[4, 4, 0, 0]}>
//                         {levelSummary.map((entry, i) => (
//                           <Cell key={i} fill={PIE_COLORS[i % PIE_COLORS.length]} />
//                         ))}
//                       </Bar>
//                     </BarChart>
//                   </ResponsiveContainer>
//                 </div>
//               </div>

//               {/* Level wise detail table */}
//               <div style={S.tableWrap}>
//                 <table style={S.table}>
//                   <THead cols={["Level", "Rate per Join", "Members Benefiting", "Total Commissions Paid", "Avg per Member", "% of Total"]} />
//                   <tbody>
//                     {levelSummary.map((l, i) => {
//                       const grandTotal = levelSummary.reduce((s, x) => s + x.total, 0);
//                       const pct = grandTotal > 0 ? ((l.total / grandTotal) * 100).toFixed(1) : "0";
//                       const avg = l.members_paid > 0 ? l.total / l.members_paid : 0;
//                       return (
//                         <tr key={l.level} style={i % 2 === 0 ? S.trEven : {}}>
//                           <td style={S.td}>
//                             <span style={{ ...S.pill, background: PIE_COLORS[i], color: "#fff", fontSize: 12 }}>Level {l.level}</span>
//                           </td>
//                           <td style={{ ...S.td, fontWeight: 700 }}>₹{l.rate}</td>
//                           <td style={{ ...S.td, fontWeight: 700, color: "#1d4ed8" }}>{l.members_paid}</td>
//                           <td style={{ ...S.td, fontWeight: 800, color: "#16a34a", fontSize: 14 }}>{inr(l.total)}</td>
//                           <td style={{ ...S.td, color: "#7c3aed" }}>{inr(avg)}</td>
//                           <td style={S.td}>
//                             <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
//                               <div style={{ height: 8, borderRadius: 99, background: PIE_COLORS[i], width: `${Math.min(Number(pct) * 2, 150)}px` }} />
//                               <span style={{ fontSize: 12, fontWeight: 700 }}>{pct}%</span>
//                             </div>
//                           </td>
//                         </tr>
//                       );
//                     })}
//                     <tr style={{ background: "#f0fdf4", fontWeight: 800 }}>
//                       <td style={S.td} colSpan={2}>GRAND TOTAL</td>
//                       <td style={{ ...S.td, color: "#1d4ed8" }}>{levelSummary.reduce((s, l) => s + l.members_paid, 0)}</td>
//                       <td style={{ ...S.td, color: "#16a34a", fontSize: 15 }}>{inr(levelSummary.reduce((s, l) => s + l.total, 0))}</td>
//                       <td style={S.td}>—</td>
//                       <td style={S.td}>100%</td>
//                     </tr>
//                   </tbody>
//                 </table>
//               </div>

//               {/* Per-member level breakdown */}
//               <SectionTitle>👤 Member-wise Level Breakdown</SectionTitle>
//               <div style={S.tableWrap}>
//                 <table style={S.table}>
//                   <THead cols={["#", "Coupon", "Name", "L1", "L2", "L3", "L4", "L5", "L6", "Total", "Rank"]} />
//                   <tbody>
//                     {allMembers
//                       .filter(m => Number(m.total_income) > 0)
//                       .sort((a, b) => Number(b.total_income) - Number(a.total_income))
//                       .map((m, i) => (
//                         <tr key={m.id} style={i % 2 === 0 ? S.trEven : {}}>
//                           <td style={S.td}>{i + 1}</td>
//                           <td style={{ ...S.td, color: "#1d4ed8", fontWeight: 700, cursor: "pointer" }} onClick={() => openDetail(m)}>{m.receiver_coupon_no}</td>
//                           <td style={S.td}>{m.receiver_name}</td>
//                           {[1, 2, 3, 4, 5, 6].map(l => (
//                             <td key={l} style={{ ...S.td, fontSize: 11, color: Number(m[`level${l}_income`]) > 0 ? "#16a34a" : "#d1d5db" }}>
//                               {Number(m[`level${l}_income`]) > 0 ? `₹${Number(m[`level${l}_income`]).toFixed(0)}` : "—"}
//                             </td>
//                           ))}
//                           <td style={{ ...S.td, fontWeight: 800, color: "#7c3aed" }}>{inr(m.total_income)}</td>
//                           <td style={S.td}><span style={S.pill}>{m.rank || "—"}</span></td>
//                         </tr>
//                       ))}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}

//           {/* ══════════ COMMISSION REPORT ══════════ */}
//           {subTab === "Commission Report" && (
//             <div>
//               <PageHead title="💰 Commission Report — All Transactions" />

//               {/* Summary cards */}
//               <div style={{ display: "flex", gap: 10, marginBottom: 16, flexWrap: "wrap" }}>
//                 <div style={{ ...S.kpiCard, background: "#1e3a8a", minWidth: 150 }}>
//                   <div style={{ fontSize: 20 }}>💰</div>
//                   <div style={{ fontSize: 20, fontWeight: 800 }}>{inr(commissions.reduce((s, c) => s + Number(c.amount || 0), 0))}</div>
//                   <div style={{ fontSize: 10, opacity: .8 }}>Total Commission</div>
//                 </div>
//                 <div style={{ ...S.kpiCard, background: "#065f46", minWidth: 150 }}>
//                   <div style={{ fontSize: 20 }}>📋</div>
//                   <div style={{ fontSize: 20, fontWeight: 800 }}>{commissions.length}</div>
//                   <div style={{ fontSize: 10, opacity: .8 }}>Total Transactions</div>
//                 </div>
//                 {commissionByLevel.map((cl, i) => (
//                   <div key={cl.level} style={{ ...S.kpiCard, background: PIE_COLORS[i % PIE_COLORS.length], minWidth: 120 }}>
//                     <div style={{ fontSize: 14 }}>Level {cl.level}</div>
//                     <div style={{ fontSize: 16, fontWeight: 800 }}>{inr(cl.total)}</div>
//                     <div style={{ fontSize: 10, opacity: .8 }}>{cl.count} txns</div>
//                   </div>
//                 ))}
//               </div>

//               {/* Chart */}
//               <div style={{ ...S.card, marginBottom: 16 }}>
//                 <CardHead>Commission by Level</CardHead>
//                 <div style={{ padding: 16 }}>
//                   <ResponsiveContainer width="100%" height={180}>
//                     <BarChart data={commissionByLevel}>
//                       <XAxis dataKey="level" tickFormatter={v => `L${v}`} tick={{ fontSize: 11 }} />
//                       <YAxis tick={{ fontSize: 10 }} tickFormatter={v => `₹${(v / 1000).toFixed(0)}k`} />
//                       <Tooltip formatter={(v) => inr(v)} labelFormatter={l => `Level ${l}`} />
//                       <Bar dataKey="total" name="Commission" radius={[4, 4, 0, 0]}>
//                         {commissionByLevel.map((entry, i) => (
//                           <Cell key={i} fill={PIE_COLORS[i % PIE_COLORS.length]} />
//                         ))}
//                       </Bar>
//                     </BarChart>
//                   </ResponsiveContainer>
//                 </div>
//               </div>

//               <div style={S.tableWrap}>
//                 <table style={S.table}>
//                   <THead cols={["#", "Date & Time", "Level", "To Coupon", "To Member", "From Coupon", "From Member", "Amount"]} />
//                   <tbody>
//                     {commissions.length === 0 && (
//                       <tr><td colSpan={8} style={{ ...S.td, textAlign: "center", color: "#94a3b8", padding: 40 }}>
//                         No commission records found
//                       </td></tr>
//                     )}
//                     {commissions.map((c, i) => (
//                       <tr key={c.id} style={i % 2 === 0 ? S.trEven : {}}>
//                         <td style={S.td}>{i + 1}</td>
//                         <td style={{ ...S.td, fontSize: 11 }}>{fmtTime(c.created_at)}</td>
//                         <td style={S.td}>
//                           <span style={{ ...S.pill, background: PIE_COLORS[(c.level - 1) % PIE_COLORS.length], color: "#fff" }}>L{c.level}</span>
//                         </td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#1d4ed8" }}>{c.to_coupon || c.receiver_coupon_no}</td>
//                         <td style={S.td}>{c.to_name || c.receiver_name}</td>
//                         <td style={{ ...S.td, color: "#6366f1" }}>{c.from_coupon}</td>
//                         <td style={S.td}>{c.from_name}</td>
//                         <td style={{ ...S.td, fontWeight: 800, color: "#16a34a", fontSize: 14 }}>{inr(c.amount)}</td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}

//           {/* ══════════ DIRECT BUSINESS REPORT ══════════ */}
//           {subTab === "Direct Business Report" && (
//             <div>
//               <PageHead title="📊 Direct Business Report" />
//               <div style={S.tableWrap}>
//                 <table style={S.table}>
//                   <THead cols={["#", "Coupon", "Name", "Mobile", "Direct Members", "Indirect Members", "Total Team", "Direct Income", "Total Income"]} />
//                   <tbody>
//                     {[...allMembers].sort((a, b) => Number(b.direct_count) - Number(a.direct_count)).map((m, i) => (
//                       <tr key={m.id} style={i % 2 === 0 ? S.trEven : {}}>
//                         <td style={S.td}>{i + 1}</td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#1d4ed8", cursor: "pointer" }} onClick={() => openDetail(m)}>{m.receiver_coupon_no}</td>
//                         <td style={S.td}>{m.receiver_name}</td>
//                         <td style={S.td}>{m.receiver_mobile}</td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#1d4ed8" }}>{m.direct_count}</td>
//                         <td style={{ ...S.td, color: "#6366f1" }}>{m.indirect_count || 0}</td>
//                         <td style={S.td}>{Number(m.direct_count) + Number(m.indirect_count || 0)}</td>
//                         <td style={{ ...S.td, color: "#16a34a" }}>{inr(Number(m.direct_count) * LEVEL_RATE[1])}</td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#7c3aed" }}>{inr(m.total_income)}</td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}

//           {/* ══════════ BUSINESS REPORT ══════════ */}
//           {subTab === "Business Report" && (
//             <div>
//               <PageHead title="📈 Business Report — Full Company Overview & Profit Analysis" />

//               {/* ── PROFIT CALCULATOR CONSTANTS ── */}
//               {(() => {
//                 const JOINING = 3000;
//                 const PRODUCT_COST = 1200;
//                 const MLM_PAYOUT = 750; // 300+150+120+90+60+30
//                 const SALARY_AVG = 100;
//                 const REWARDS_AVG = 50;
//                 const TOTAL_EXPENSE = PRODUCT_COST + MLM_PAYOUT + SALARY_AVG + REWARDS_AVG; // 2100
//                 const PROFIT_PER = JOINING - TOTAL_EXPENSE; // 900

//                 const totalMembers = allMembers.length;
//                 const activeMembers = allMembers.filter(m => m.is_approved).length;
//                 const totalCollection = activeMembers * JOINING;
//                 const totalMLMPaid = allMembers.reduce((s, m) => s + Number(m.total_income || 0), 0);
//                 const totalWithdrawn = allMembers.reduce((s, m) => s + Number(m.total_withdrawn || 0), 0);
//                 const estimatedProfit = activeMembers * PROFIT_PER;

//                 return (
//                   <div>
//                     {/* ── KPI Grid ── */}
//                     <div style={S.kpiGrid}>
//                       {[
//                         { label: "Total Members", val: totalMembers, icon: "👥", bg: "#1e3a8a" },
//                         { label: "Active Members", val: activeMembers, icon: "✅", bg: "#065f46" },
//                         { label: "Total Collection", val: inr(totalCollection), icon: "💼", bg: "#4c1d95" },
//                         { label: "MLM Paid Out", val: inr(totalMLMPaid), icon: "💰", bg: "#134e4a" },
//                         { label: "Total Withdrawn", val: inr(totalWithdrawn), icon: "🏦", bg: "#7f1d1d" },
//                         { label: "Est. Net Profit", val: inr(estimatedProfit), icon: "📈", bg: "#14532d" },
//                       ].map(c => (
//                         <div key={c.label} style={{ ...S.kpiCard, background: c.bg }}>
//                           <div style={{ fontSize: 22 }}>{c.icon}</div>
//                           <div style={{ fontSize: 18, fontWeight: 800 }}>{c.val}</div>
//                           <div style={{ fontSize: 10, opacity: .8 }}>{c.label}</div>
//                         </div>
//                       ))}
//                     </div>

//                     {/* ══ PROFIT ANALYSIS PANEL ══ */}
//                     <div style={{ display: "flex", gap: 14, marginBottom: 16, flexWrap: "wrap" }}>

//                       {/* Left: Per-member breakdown */}
//                       <div style={{ flex: 1, minWidth: 300, display: "flex", flexDirection: "column", gap: 12 }}>

//                         {/* Collection */}
//                         <div style={{ background: "linear-gradient(135deg,#1e3a8a,#1d4ed8)", borderRadius: 10, padding: "14px 18px", color: "#fff" }}>
//                           <div style={{ fontSize: 13, fontWeight: 800, marginBottom: 10, borderBottom: "1px solid rgba(255,255,255,.2)", paddingBottom: 8 }}>
//                             💸 COMPANY COLLECTION (PER MEMBER)
//                           </div>
//                           <div style={{ display: "flex", justifyContent: "space-between", fontSize: 14 }}>
//                             <span>Joining Amount</span>
//                             <span style={{ fontWeight: 900, fontSize: 18, color: "#fbbf24" }}>= ₹{JOINING.toLocaleString()}</span>
//                           </div>
//                         </div>

//                         {/* Expense breakdown */}
//                         <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 10, overflow: "hidden" }}>
//                           <div style={{ background: "#dc2626", color: "#fff", padding: "10px 16px", fontWeight: 800, fontSize: 13 }}>
//                             🧾 COMPANY GIVES (PER PERSON)
//                           </div>
//                           <div style={{ padding: "12px 16px" }}>
//                             {/* Item 1 */}
//                             <div style={{ marginBottom: 12 }}>
//                               <div style={{ fontWeight: 700, fontSize: 12, color: "#374151", marginBottom: 6 }}>1) Product / Service Cost</div>
//                               <div style={{ background: "#fef2f2", borderRadius: 6, padding: "8px 12px", display: "flex", justifyContent: "space-between" }}>
//                                 <span style={{ fontSize: 12 }}>Product / Service</span>
//                                 <span style={{ fontWeight: 800, color: "#dc2626" }}>₹{PRODUCT_COST.toLocaleString()}</span>
//                               </div>
//                             </div>

//                             {/* Item 2 — MLM */}
//                             <div style={{ marginBottom: 12 }}>
//                               <div style={{ fontWeight: 700, fontSize: 12, color: "#374151", marginBottom: 6 }}>2) All Level Income (MLM Distribution)</div>
//                               <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
//                                 <thead>
//                                   <tr style={{ background: "#eff6ff" }}>
//                                     <th style={{ padding: "5px 10px", textAlign: "left", color: "#1d4ed8" }}>Level</th>
//                                     <th style={{ padding: "5px 10px", textAlign: "right", color: "#1d4ed8" }}>Amount</th>
//                                   </tr>
//                                 </thead>
//                                 <tbody>
//                                   {Object.entries(LEVEL_RATE).map(([l, r], i) => (
//                                     <tr key={l} style={{ background: i % 2 === 0 ? "#f8fafc" : "#fff" }}>
//                                       <td style={{ padding: "5px 10px" }}>Level {l}</td>
//                                       <td style={{ padding: "5px 10px", textAlign: "right", fontWeight: 700, color: "#16a34a" }}>₹{r}</td>
//                                     </tr>
//                                   ))}
//                                   <tr style={{ background: "#f0fdf4", fontWeight: 800 }}>
//                                     <td style={{ padding: "6px 10px" }}>👉 Total MLM payout</td>
//                                     <td style={{ padding: "6px 10px", textAlign: "right", color: "#15803d", fontSize: 14 }}>= ₹{MLM_PAYOUT}</td>
//                                   </tr>
//                                 </tbody>
//                               </table>
//                             </div>

//                             {/* Item 3 — Salary */}
//                             <div style={{ marginBottom: 12 }}>
//                               <div style={{ fontWeight: 700, fontSize: 12, color: "#374151", marginBottom: 6 }}>3) Salary Targets (Company Pays)</div>
//                               <div style={{ background: "#fefce8", borderRadius: 6, padding: "8px 12px", fontSize: 12 }}>
//                                 <div style={{ color: "#854d0e", marginBottom: 4 }}>3 Month Target Salary system (averaged per person)</div>
//                                 <div style={{ display: "flex", justifyContent: "space-between", fontWeight: 700 }}>
//                                   <span>➡ ₹{SALARY_AVG} per person</span>
//                                   <span style={{ color: "#92400e" }}>₹{SALARY_AVG}</span>
//                                 </div>
//                               </div>
//                             </div>

//                             {/* Item 4 — Rewards */}
//                             <div>
//                               <div style={{ fontWeight: 700, fontSize: 12, color: "#374151", marginBottom: 6 }}>4) One-Time Rewards</div>
//                               <div style={{ background: "#f0f9ff", borderRadius: 6, padding: "8px 12px", fontSize: 12 }}>
//                                 <div style={{ color: "#0369a1", marginBottom: 4 }}>(averaged per person)</div>
//                                 <div style={{ display: "flex", justifyContent: "space-between", fontWeight: 700 }}>
//                                   <span>➡ ₹{REWARDS_AVG} per person</span>
//                                   <span style={{ color: "#0369a1" }}>₹{REWARDS_AVG}</span>
//                                 </div>
//                               </div>
//                             </div>
//                           </div>
//                         </div>

//                         {/* Total expense */}
//                         <div style={{ background: "#fff", border: "2px solid #e2e8f0", borderRadius: 10, overflow: "hidden" }}>
//                           <div style={{ background: "#374151", color: "#fff", padding: "10px 16px", fontWeight: 800, fontSize: 13 }}>
//                             📊 TOTAL COMPANY EXPENSE (PER PERSON)
//                           </div>
//                           <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
//                             <thead>
//                               <tr style={{ background: "#f1f5f9" }}>
//                                 <th style={{ padding: "8px 14px", textAlign: "left", color: "#374151" }}>Item</th>
//                                 <th style={{ padding: "8px 14px", textAlign: "right", color: "#374151" }}>Amount</th>
//                               </tr>
//                             </thead>
//                             <tbody>
//                               {[
//                                 ["Product cost", PRODUCT_COST],
//                                 ["MLM income", MLM_PAYOUT],
//                                 ["Salary", SALARY_AVG],
//                                 ["Rewards", REWARDS_AVG],
//                               ].map(([label, amt], i) => (
//                                 <tr key={label} style={{ background: i % 2 === 0 ? "#f8fafc" : "#fff" }}>
//                                   <td style={{ padding: "8px 14px" }}>{label}</td>
//                                   <td style={{ padding: "8px 14px", textAlign: "right", color: "#dc2626", fontWeight: 700 }}>₹{amt}</td>
//                                 </tr>
//                               ))}
//                               <tr style={{ background: "#fef2f2", fontWeight: 800 }}>
//                                 <td style={{ padding: "10px 14px", fontSize: 14 }}>Total Given</td>
//                                 <td style={{ padding: "10px 14px", textAlign: "right", color: "#dc2626", fontSize: 16 }}>₹{TOTAL_EXPENSE}</td>
//                               </tr>
//                             </tbody>
//                           </table>
//                         </div>
//                       </div>

//                       {/* Right: Profit & Scale */}
//                       <div style={{ flex: 1, minWidth: 300, display: "flex", flexDirection: "column", gap: 12 }}>

//                         {/* Profit per person */}
//                         <div style={{ background: "linear-gradient(135deg,#14532d,#16a34a)", borderRadius: 10, padding: "20px 20px", color: "#fff", textAlign: "center" }}>
//                           <div style={{ fontSize: 13, opacity: .9, marginBottom: 8 }}>💰 COMPANY PROFIT (PER PERSON)</div>
//                           <div style={{ fontSize: 16, marginBottom: 8 }}>
//                             ₹{JOINING.toLocaleString()} – ₹{TOTAL_EXPENSE.toLocaleString()} =
//                           </div>
//                           <div style={{ fontSize: 36, fontWeight: 900, color: "#bbf7d0" }}>
//                             ₹{PROFIT_PER.toLocaleString()}
//                           </div>
//                           <div style={{ fontSize: 12, opacity: .8, marginTop: 6 }}>NET PROFIT PER MEMBER</div>
//                         </div>

//                         {/* Simple view */}
//                         <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 10, overflow: "hidden" }}>
//                           <div style={{ background: "#1e3a8a", color: "#fff", padding: "10px 16px", fontWeight: 800, fontSize: 13 }}>
//                             🏦 SIMPLE COMPANY VIEW
//                           </div>
//                           <div style={{ padding: "14px 16px", fontSize: 13 }}>
//                             <div style={{ marginBottom: 10, color: "#374151" }}>From ₹{JOINING.toLocaleString()} company gives:</div>
//                             {[
//                               ["🛍 Product", `₹${PRODUCT_COST.toLocaleString()}`],
//                               ["📊 Level income", `₹${MLM_PAYOUT}`],
//                               ["💰 Salary", `₹${SALARY_AVG}`],
//                               ["🎁 Rewards", `₹${REWARDS_AVG}`],
//                             ].map(([label, val]) => (
//                               <div key={label} style={{ display: "flex", justifyContent: "space-between", padding: "6px 0", borderBottom: "1px solid #f1f5f9", fontSize: 13 }}>
//                                 <span style={{ color: "#374151" }}>{label}</span>
//                                 <span style={{ fontWeight: 700, color: "#dc2626" }}>{val}</span>
//                               </div>
//                             ))}
//                             <div style={{ display: "flex", justifyContent: "space-between", padding: "8px 0", borderBottom: "2px solid #e2e8f0", fontWeight: 800 }}>
//                               <span>Total given</span>
//                               <span style={{ color: "#dc2626" }}>= ₹{TOTAL_EXPENSE}</span>
//                             </div>
//                             <div style={{ display: "flex", justifyContent: "space-between", padding: "10px 0", fontWeight: 900, fontSize: 15 }}>
//                               <span style={{ color: "#16a34a" }}>✅ COMPANY KEEPS</span>
//                               <span style={{ color: "#16a34a", fontSize: 18 }}>₹{PROFIT_PER} per member</span>
//                             </div>
//                           </div>
//                         </div>

//                         {/* Scale projections */}
//                         <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 10, overflow: "hidden" }}>
//                           <div style={{ background: "#7c3aed", color: "#fff", padding: "10px 16px", fontWeight: 800, fontSize: 13 }}>
//                             📈 AT SCALE — PROFIT PROJECTIONS
//                           </div>
//                           <div style={{ padding: "12px 16px" }}>
//                             {[
//                               [activeMembers || 1, "Current members"],
//                               [1000, "1,000 members"],
//                               [10000, "10,000 members"],
//                               [100000, "1,00,000 members"],
//                             ].map(([count, label], i) => {
//                               const profit = count * PROFIT_PER;
//                               const isActive = i === 0;
//                               return (
//                                 <div key={label} style={{
//                                   display: "flex", justifyContent: "space-between", alignItems: "center",
//                                   padding: "10px 12px", borderRadius: 8, marginBottom: 6,
//                                   background: isActive ? "#f0fdf4" : "#f8fafc",
//                                   border: isActive ? "2px solid #16a34a" : "1px solid #e2e8f0"
//                                 }}>
//                                   <div>
//                                     <div style={{ fontWeight: isActive ? 800 : 600, fontSize: 13, color: isActive ? "#15803d" : "#374151" }}>
//                                       {isActive ? "🔴 " : ""}{label}
//                                     </div>
//                                     <div style={{ fontSize: 11, color: "#94a3b8" }}>
//                                       ₹{PROFIT_PER} × {count.toLocaleString()}
//                                     </div>
//                                   </div>
//                                   <div style={{ fontWeight: 900, fontSize: 16, color: isActive ? "#16a34a" : "#7c3aed" }}>
//                                     {profit >= 10000000
//                                       ? `₹${(profit / 10000000).toFixed(2)} Cr`
//                                       : profit >= 100000
//                                       ? `₹${(profit / 100000).toFixed(1)} Lakh`
//                                       : `₹${profit.toLocaleString()}`}
//                                   </div>
//                                 </div>
//                               );
//                             })}
//                           </div>
//                         </div>

//                         {/* Final summary */}
//                         <div style={{ background: "linear-gradient(135deg,#1e1b4b,#312e81)", borderRadius: 10, padding: "16px 18px", color: "#fff" }}>
//                           <div style={{ fontSize: 12, color: "#a5b4fc", marginBottom: 8, fontWeight: 700 }}>🎯 FINAL ONE-LINE ANSWER</div>
//                           <div style={{ fontSize: 13, color: "#e0e7ff", lineHeight: 1.7 }}>
//                             Company gives <b style={{ color: "#fbbf24" }}>₹{TOTAL_EXPENSE.toLocaleString()}</b> and keeps{" "}
//                             <b style={{ color: "#4ade80", fontSize: 16 }}>₹{PROFIT_PER} profit</b> per member.
//                           </div>
//                           <div style={{ marginTop: 10, paddingTop: 10, borderTop: "1px solid rgba(255,255,255,.2)", fontSize: 12, color: "#93c5fd" }}>
//                             With <b style={{ color: "#fff" }}>{activeMembers.toLocaleString()}</b> active members today →{" "}
//                             <b style={{ color: "#4ade80", fontSize: 15 }}>
//                               {estimatedProfit >= 10000000
//                                 ? `₹${(estimatedProfit / 10000000).toFixed(2)} Crore`
//                                 : estimatedProfit >= 100000
//                                 ? `₹${(estimatedProfit / 100000).toFixed(1)} Lakh`
//                                 : `₹${estimatedProfit.toLocaleString()}`} estimated net profit
//                             </b>
//                           </div>
//                         </div>
//                       </div>
//                     </div>

//                     {/* Charts */}
//                     <div style={{ display: "flex", gap: 14, marginBottom: 16, flexWrap: "wrap" }}>
//                       <div style={{ ...S.card, flex: 1, minWidth: 260 }}>
//                         <CardHead>🏆 Rank Distribution</CardHead>
//                         <div style={{ padding: 16 }}>
//                           <ResponsiveContainer width="100%" height={200}>
//                             <PieChart>
//                               <Pie data={stats?.rank_dist || []} dataKey="count" nameKey="rank"
//                                 cx="50%" cy="50%" outerRadius={75}
//                                 label={({ rank, percent }) => `${rank} ${(percent * 100).toFixed(0)}%`}>
//                                 {(stats?.rank_dist || []).map((entry, i) => (
//                                   <Cell key={i} fill={PIE_COLORS[i % PIE_COLORS.length]} />
//                                 ))}
//                               </Pie>
//                               <Tooltip /><Legend />
//                             </PieChart>
//                           </ResponsiveContainer>
//                         </div>
//                       </div>
//                       <div style={{ ...S.card, flex: 2, minWidth: 260 }}>
//                         <CardHead>📊 Income vs Withdrawal (Top 15)</CardHead>
//                         <div style={{ padding: 16 }}>
//                           <ResponsiveContainer width="100%" height={200}>
//                             <BarChart data={topByIncome.slice(0, 15).map(m => ({
//                               name: m.receiver_coupon_no,
//                               Income: Number(m.total_income || 0),
//                               Withdrawn: Number(m.total_withdrawn || 0),
//                             }))}>
//                               <XAxis dataKey="name" tick={{ fontSize: 9 }} />
//                               <YAxis tick={{ fontSize: 9 }} tickFormatter={v => `₹${(v / 1000).toFixed(0)}k`} />
//                               <Tooltip formatter={v => inr(v)} />
//                               <Bar dataKey="Income" fill="#3b82f6" radius={[3, 3, 0, 0]} />
//                               <Bar dataKey="Withdrawn" fill="#ef4444" radius={[3, 3, 0, 0]} />
//                               <Legend />
//                             </BarChart>
//                           </ResponsiveContainer>
//                         </div>
//                       </div>
//                     </div>

//                     {/* Full table */}
//                     <SectionTitle>📋 All Members Business Summary</SectionTitle>
//                     <div style={S.tableWrap}>
//                       <table style={S.table}>
//                         <THead cols={["#", "Coupon", "Name", "Mobile", "Rank", "Direct", "Total Team", "Total Income", "Withdrawn", "Balance", "Status"]} />
//                         <tbody>
//                           {[...allMembers]
//                             .sort((a, b) => Number(b.total_income || 0) - Number(a.total_income || 0))
//                             .map((m, i) => (
//                               <tr key={m.id} style={i % 2 === 0 ? S.trEven : {}}>
//                                 <td style={S.td}>{i + 1}</td>
//                                 <td style={{ ...S.td, fontWeight: 700, color: "#1d4ed8", cursor: "pointer" }} onClick={() => openDetail(m)}>{m.receiver_coupon_no}</td>
//                                 <td style={S.td}>{m.receiver_name}</td>
//                                 <td style={S.td}>{m.receiver_mobile}</td>
//                                 <td style={S.td}><span style={S.pill}>{m.rank || "member"}</span></td>
//                                 <td style={{ ...S.td, fontWeight: 700 }}>{m.direct_count || 0}</td>
//                                 <td style={S.td}>{Number(m.direct_count || 0) + Number(m.indirect_count || 0)}</td>
//                                 <td style={{ ...S.td, fontWeight: 800, color: "#16a34a" }}>{inr(m.total_income)}</td>
//                                 <td style={{ ...S.td, color: "#dc2626" }}>{inr(m.total_withdrawn)}</td>
//                                 <td style={{ ...S.td, fontWeight: 700, color: "#7c3aed" }}>
//                                   {inr(Number(m.total_income || 0) - Number(m.total_withdrawn || 0))}
//                                 </td>
//                                 <td style={S.td}><span style={m.is_approved ? S.greenBadge : S.yellowBadge}>{m.is_approved ? "Active" : "Pending"}</span></td>
//                               </tr>
//                             ))}
//                           <tr style={{ background: "#eff6ff", fontWeight: 800 }}>
//                             <td style={S.td} colSpan={7}>TOTAL</td>
//                             <td style={{ ...S.td, color: "#16a34a", fontSize: 14 }}>{inr(allMembers.reduce((s, m) => s + Number(m.total_income || 0), 0))}</td>
//                             <td style={{ ...S.td, color: "#dc2626" }}>{inr(allMembers.reduce((s, m) => s + Number(m.total_withdrawn || 0), 0))}</td>
//                             <td style={{ ...S.td, color: "#7c3aed" }}>
//                               {inr(allMembers.reduce((s, m) => s + Number(m.total_income || 0) - Number(m.total_withdrawn || 0), 0))}
//                             </td>
//                             <td style={S.td}></td>
//                           </tr>
//                         </tbody>
//                       </table>
//                     </div>
//                   </div>
//                 );
//               })()}
//             </div>
//           )}

//           {/* ══════════ COMMISSION SUMMARY ══════════ */}
//           {subTab === "Commission Summary" && (
//             <div>
//               <PageHead title="📋 Commission Summary" />

//               {/* Level totals */}
//               <SectionTitle>Level-wise Commission Totals</SectionTitle>
//               <div style={{ display: "flex", gap: 8, marginBottom: 16, flexWrap: "wrap" }}>
//                 {[1, 2, 3, 4, 5, 6].map((l, i) => (
//                   <div key={l} style={{ background: PIE_COLORS[i], color: "#fff", borderRadius: 10, padding: "12px 16px", minWidth: 120, textAlign: "center" }}>
//                     <div style={{ fontSize: 10, opacity: 0.8 }}>Level {l} (₹{LEVEL_RATE[l]}/join)</div>
//                     <div style={{ fontSize: 18, fontWeight: 800, marginTop: 4 }}>
//                       {inr(allMembers.reduce((s, m) => s + Number(m[`level${l}_income`] || 0), 0))}
//                     </div>
//                     <div style={{ fontSize: 10, opacity: 0.8, marginTop: 2 }}>
//                       {allMembers.filter(m => Number(m[`level${l}_income`]) > 0).length} earners
//                     </div>
//                   </div>
//                 ))}
//               </div>

//               {/* Top earners per level */}
//               {[1, 2, 3, 4, 5, 6].map((level, li) => (
//                 <div key={level}>
//                   <SectionTitle>🏆 Top 5 Earners — Level {level} (₹{LEVEL_RATE[level]}/join)</SectionTitle>
//                   <div style={S.tableWrap}>
//                     <table style={S.table}>
//                       <THead cols={["Rank", "Coupon", "Name", "Mobile", `L${level} Income`]} />
//                       <tbody>
//                         {[...allMembers]
//                           .filter(m => Number(m[`level${level}_income`]) > 0)
//                           .sort((a, b) => Number(b[`level${level}_income`]) - Number(a[`level${level}_income`]))
//                           .slice(0, 5)
//                           .map((m, i) => (
//                             <tr key={m.id} style={i % 2 === 0 ? S.trEven : {}}>
//                               <td style={{ ...S.td, fontWeight: 800, color: i < 3 ? "#f59e0b" : "#64748b" }}>#{i + 1}</td>
//                               <td style={{ ...S.td, color: "#1d4ed8", fontWeight: 700, cursor: "pointer" }} onClick={() => openDetail(m)}>{m.receiver_coupon_no}</td>
//                               <td style={S.td}>{m.receiver_name}</td>
//                               <td style={S.td}>{m.receiver_mobile}</td>
//                               <td style={{ ...S.td, fontWeight: 800, color: "#16a34a", fontSize: 14 }}>{inr(m[`level${level}_income`])}</td>
//                             </tr>
//                           ))}
//                       </tbody>
//                     </table>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           )}

//           {/* ══════════ DAILY JOINS ══════════ */}
//           {subTab === "Daily Joins" && (
//             <div>
//               <PageHead title="📅 Daily Joins Report — Last 30 Days" />

//               {dailyJoins.length === 0 ? (
//                 <div style={{ textAlign: "center", padding: 60, color: "#94a3b8", background: "#f8fafc", borderRadius: 8, border: "2px dashed #e2e8f0" }}>
//                   <div style={{ fontSize: 40, marginBottom: 12 }}>📅</div>
//                   <div style={{ fontWeight: 700, fontSize: 15 }}>Loading or no join data for last 30 days</div>
//                   <button style={{ ...S.btn, background: "#1e3a8a", marginTop: 16 }} onClick={loadDailyJoins}>🔄 Reload</button>
//                 </div>
//               ) : (
//                 <>
//                   {/* KPI cards — uses backend totals */}
//                   <div style={{ display: "flex", gap: 10, marginBottom: 16, flexWrap: "wrap" }}>
//                     {[
//                       { icon: "📅", label: "Total Joins", val: dailyJoins.reduce((s, d) => s + Number(d.count || 0), 0), bg: "#1e3a8a" },
//                       { icon: "✅", label: "Approved", val: dailyJoins.reduce((s, d) => s + Number(d.approved || 0), 0), bg: "#065f46" },
//                       { icon: "⏳", label: "Pending", val: dailyJoins.reduce((s, d) => s + Number(d.pending || 0), 0), bg: "#92400e" },
//                       {
//                         icon: "📈", label: "Avg / Day",
//                         val: dailyJoins.length > 0 ? Math.round(dailyJoins.reduce((s, d) => s + Number(d.count || 0), 0) / dailyJoins.length) : 0,
//                         bg: "#4c1d95"
//                       },
//                       {
//                         icon: "🏆", label: "Best Day",
//                         val: Math.max(...dailyJoins.map(d => Number(d.count || 0))),
//                         bg: "#134e4a"
//                       },
//                     ].map(c => (
//                       <div key={c.label} style={{ ...S.kpiCard, background: c.bg, minWidth: 130 }}>
//                         <div style={{ fontSize: 22 }}>{c.icon}</div>
//                         <div style={{ fontSize: 20, fontWeight: 800 }}>{c.val}</div>
//                         <div style={{ fontSize: 10, opacity: .8 }}>{c.label}</div>
//                       </div>
//                     ))}
//                   </div>

//                   {/* Chart — stacked approved + pending */}
//                   <div style={{ ...S.card, marginBottom: 16 }}>
//                     <CardHead>📈 Daily Registration Trend (Approved vs Pending)</CardHead>
//                     <div style={{ padding: 16 }}>
//                       <ResponsiveContainer width="100%" height={240}>
//                         <BarChart data={dailyJoins}>
//                           <XAxis dataKey="date" tick={{ fontSize: 9 }} />
//                           <YAxis tick={{ fontSize: 9 }} allowDecimals={false} />
//                           <Tooltip />
//                           <Legend />
//                           <Bar dataKey="approved" name="Approved" stackId="a" fill="#10b981" radius={[0, 0, 0, 0]} />
//                           <Bar dataKey="pending" name="Pending" stackId="a" fill="#f59e0b" radius={[4, 4, 0, 0]} />
//                         </BarChart>
//                       </ResponsiveContainer>
//                     </div>
//                   </div>

//                   {/* Table */}
//                   <div style={S.tableWrap}>
//                     <table style={S.table}>
//                       <THead cols={["#", "Date", "Total Joins", "Approved", "Pending", "Running Total", "Bar"]} />
//                       <tbody>
//                         {(() => {
//                           let running = 0;
//                           const maxCount = Math.max(...dailyJoins.map(d => Number(d.count || 0)), 1);
//                           return dailyJoins.map((d, i) => {
//                             running += Number(d.count || 0);
//                             const isMax = Number(d.count) === maxCount;
//                             return (
//                               <tr key={i} style={i % 2 === 0 ? S.trEven : {}}>
//                                 <td style={S.td}>{i + 1}</td>
//                                 <td style={{ ...S.td, fontWeight: 600 }}>{d.date}</td>
//                                 <td style={{ ...S.td, fontWeight: 800, color: isMax ? "#f59e0b" : "#1d4ed8", fontSize: 15 }}>
//                                   {d.count} {isMax ? "🏆" : ""}
//                                 </td>
//                                 <td style={{ ...S.td, color: "#16a34a", fontWeight: 700 }}>{d.approved || 0}</td>
//                                 <td style={{ ...S.td, color: "#f59e0b", fontWeight: 700 }}>{d.pending || 0}</td>
//                                 <td style={{ ...S.td, color: "#7c3aed" }}>{running}</td>
//                                 <td style={S.td}>
//                                   <div style={{ height: 10, borderRadius: 99, background: isMax ? "#f59e0b" : "#3b82f6", width: `${(Number(d.count) / maxCount) * 180}px`, minWidth: 4 }} />
//                                 </td>
//                               </tr>
//                             );
//                           });
//                         })()}
//                       </tbody>
//                     </table>
//                   </div>
//                 </>
//               )}
//             </div>
//           )}

//           {/* ══════════ NETWORK TREE ══════════ */}
//           {subTab === "Network Tree" && (
//             <div>
//               <PageHead title="🌳 Network Tree — Member Downline" />

//               {/* Search bar */}
//               <div style={{ ...S.card, marginBottom: 16 }}>
//                 <CardHead>Search Member Network</CardHead>
//                 <div style={{ padding: 16, display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
//                   <input
//                     style={{ ...S.searchBox, minWidth: 280 }}
//                     placeholder="Enter Coupon No (e.g. MR001) or Token Number..."
//                     value={networkToken}
//                     onChange={e => setNetworkToken(e.target.value)}
//                     onKeyDown={e => e.key === "Enter" && loadNetworkTree(networkToken)}
//                   />
//                   <button style={{ ...S.btn, background: "#1e3a8a", padding: "9px 20px" }}
//                     onClick={() => loadNetworkTree(networkToken)}>
//                     🔍 Load Tree
//                   </button>
//                   {networkTree && (
//                     <button style={{ ...S.btn, background: "#64748b" }}
//                       onClick={() => { setNetworkTree(null); setNetworkToken(""); }}>
//                       ✕ Clear
//                     </button>
//                   )}
//                   {networkTree && (
//                     <span style={{ ...S.countBadge, background: "#dcfce7", color: "#15803d" }}>
//                       Showing tree for: <b>{networkTree.receiver_coupon_no || networkTree.token_number}</b>
//                     </span>
//                   )}
//                 </div>
//               </div>

//               {/* Legend */}
//               <div style={{ display: "flex", gap: 12, marginBottom: 12, flexWrap: "wrap", alignItems: "center" }}>
//                 <span style={{ fontSize: 12, color: "#64748b", fontWeight: 600 }}>Depth:</span>
//                 {[
//                   { label: "Root", bg: "#1e3a8a" },
//                   { label: "Level 1 Direct", bg: "#1d4ed8" },
//                   { label: "Level 2", bg: "#3b82f6" },
//                   { label: "Level 3+", bg: "#eff6ff", color: "#1e3a8a", border: "1px solid #bfdbfe" },
//                 ].map(item => (
//                   <div key={item.label} style={{ display: "flex", alignItems: "center", gap: 6 }}>
//                     <div style={{ width: 14, height: 14, borderRadius: 3, background: item.bg, border: item.border }} />
//                     <span style={{ fontSize: 12, color: "#64748b" }}>{item.label}</span>
//                   </div>
//                 ))}
//                 <span style={{ fontSize: 11, color: "#94a3b8", marginLeft: "auto" }}>Click node to expand/collapse</span>
//               </div>

//               {/* Tree or empty state */}
//               {networkTree ? (
//                 <div style={{ ...S.card, padding: 16, maxHeight: 620, overflowY: "auto" }}>
//                   <TreeNode node={networkTree} depth={0} />
//                 </div>
//               ) : (
//                 <div style={{ textAlign: "center", padding: 60, color: "#94a3b8", background: "#f8fafc", borderRadius: 8, border: "2px dashed #e2e8f0" }}>
//                   <div style={{ fontSize: 48, marginBottom: 12 }}>🌳</div>
//                   <div style={{ fontWeight: 700, fontSize: 16, marginBottom: 6 }}>Enter a coupon number or token above</div>
//                   <div style={{ fontSize: 12 }}>Tree shows downline up to 6 levels deep. Click any node to expand.</div>
//                 </div>
//               )}
//             </div>
//           )}

//           {/* ══════════ WITHDRAWAL REQUESTS ══════════ */}
//           {subTab === "Withdrawal Requests" && (
//             <div>
//               <PageHead title="💸 Withdrawal Requests — Pending">
//                 <span style={{ ...S.countBadge, background: "#fee2e2", color: "#991b1b", marginLeft: "auto" }}>
//                   {withdrawals.length} Pending
//                 </span>
//               </PageHead>
//               <div style={S.tableWrap}>
//                 <table style={S.table}>
//                   <THead cols={["#", "Coupon", "Member", "Mobile", "Amount", "Method", "Bank/UPI Details", "Requested", "Actions"]} />
//                   <tbody>
//                     {withdrawals.map((w, i) => (
//                       <tr key={w.id} style={i % 2 === 0 ? S.trEven : {}}>
//                         <td style={S.td}>{i + 1}</td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#1d4ed8" }}>{w.receiver_coupon_no}</td>
//                         <td style={S.td}>{w.receiver_name}</td>
//                         <td style={S.td}>{w.receiver_mobile}</td>
//                         <td style={{ ...S.td, fontWeight: 800, color: "#16a34a", fontSize: 14 }}>{inr(w.amount)}</td>
//                         <td style={S.td}>{w.method?.toUpperCase()}</td>
//                         <td style={{ ...S.td, fontSize: 11 }}>
//                           {w.method === "bank"
//                             ? <><b>{w.bank_name}</b><br />A/c: {w.account_number}<br />IFSC: {w.ifsc}</>
//                             : <><b>UPI:</b> {w.upi_id}</>}
//                         </td>
//                         <td style={{ ...S.td, fontSize: 11 }}>{fmtTime(w.created_at)}</td>
//                         <td style={S.td}>
//                           <div style={{ display: "flex", gap: 4, flexDirection: "column" }}>
//                             <button style={{ ...S.btn, background: "#16a34a", fontSize: 11 }}
//                               onClick={() => processWithdrawal(w.id, "approved", w)}>
//                               ✅ Approve + 📱WA
//                             </button>
//                             <button style={{ ...S.btn, background: "#dc2626", fontSize: 11 }}
//                               onClick={() => processWithdrawal(w.id, "rejected", w)}>
//                               ❌ Reject
//                             </button>
//                           </div>
//                         </td>
//                       </tr>
//                     ))}
//                     {withdrawals.length === 0 && (
//                       <tr><td colSpan={9} style={{ ...S.td, textAlign: "center", color: "#94a3b8", padding: 40 }}>
//                         🎉 No pending withdrawal requests!
//                       </td></tr>
//                     )}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}

//           {/* ══════════ PAYMENT HISTORY ══════════ */}
//           {subTab === "Payment History" && (
//             <div>
//               <PageHead title="📋 Payment History — All Payouts" />
//               <SectionTitle>Level-wise Payment Breakdown</SectionTitle>
//               <div style={{ display: "flex", gap: 8, marginBottom: 16, flexWrap: "wrap" }}>
//                 {[1, 2, 3, 4, 5, 6].map(l => (
//                   <div key={l} style={{ background: "#1e3a8a", color: "#fff", borderRadius: 8, padding: "10px 14px", minWidth: 100, textAlign: "center" }}>
//                     <div style={{ fontSize: 10, opacity: .7 }}>Level {l} (₹{LEVEL_RATE[l]}/join)</div>
//                     <div style={{ fontSize: 16, fontWeight: 800 }}>
//                       {inr(allMembers.reduce((s, m) => s + Number(m[`level${l}_income`] || 0), 0))}
//                     </div>
//                     <div style={{ fontSize: 10, opacity: .7 }}>paid out</div>
//                   </div>
//                 ))}
//               </div>
//               <div style={S.tableWrap}>
//                 <table style={S.table}>
//                   <THead cols={["#", "Coupon", "Member", "Mobile", "Amount", "Method", "Status", "Processed", "Date", "WA"]} />
//                   <tbody>
//                     {payHistory.map((w, i) => (
//                       <tr key={w.id} style={i % 2 === 0 ? S.trEven : {}}>
//                         <td style={S.td}>{i + 1}</td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#1d4ed8" }}>{w.receiver_coupon_no}</td>
//                         <td style={S.td}>{w.receiver_name}</td>
//                         <td style={S.td}>{w.receiver_mobile}</td>
//                         <td style={{ ...S.td, fontWeight: 800, color: "#16a34a" }}>{inr(w.amount)}</td>
//                         <td style={S.td}>{w.method?.toUpperCase()}</td>
//                         <td style={S.td}>
//                           <span style={w.status === "approved" ? S.greenBadge : w.status === "rejected" ? S.redBadge : S.yellowBadge}>
//                             {w.status}
//                           </span>
//                         </td>
//                         <td style={{ ...S.td, fontSize: 11 }}>{w.processed_at ? fmt(w.processed_at) : "—"}</td>
//                         <td style={{ ...S.td, fontSize: 11 }}>{fmt(w.created_at)}</td>
//                         <td style={S.td}>
//                           <button style={{ ...S.btn, background: "#25D366", padding: "4px 8px" }}
//                             onClick={() => whatsapp(w.receiver_mobile,
//                               `💸 Namaste *${w.receiver_name}*!\n\nYour payout of *${inr(w.amount)}* is *${w.status.toUpperCase()}*.\n\n_${COMPANY}_\n${COMPANY_URL}`)}>
//                             📱
//                           </button>
//                         </td>
//                       </tr>
//                     ))}
//                     {payHistory.length === 0 && <tr><td colSpan={10} style={{ ...S.td, textAlign: "center", color: "#94a3b8", padding: 40 }}>No payment history</td></tr>}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}

//           {/* ══════════ ADD FUND TO MEMBER ══════════ */}
//           {subTab === "Add Fund to Member" && (
//             <div>
//               <PageHead title="➕ Add Fund to Member Wallet" />
//               <div style={{ ...S.card, maxWidth: 480 }}>
//                 <CardHead>Manually Add Amount (Received from Member)</CardHead>
//                 <div style={{ padding: 20 }}>
//                   <p style={{ fontSize: 12, color: "#64748b", marginBottom: 16, padding: "10px 14px", background: "#fefce8", borderRadius: 8, border: "1px solid #fde68a" }}>
//                     ⚠️ Use this to record an amount received from a member. It will be credited directly to their wallet and recorded as a transaction.
//                   </p>
//                   {[
//                     ["Member Token / Coupon No *", "token_number", "text", "Enter member token or coupon number"],
//                     ["Amount Received (₹) *", "amount", "number", "Enter amount"],
//                     ["Description *", "description", "text", "e.g. Cash received, Online payment ref #123"],
//                   ].map(([label, key, type, placeholder]) => (
//                     <div key={key} style={{ marginBottom: 14 }}>
//                       <label style={S.label}>{label}</label>
//                       <input style={S.input} type={type} placeholder={placeholder}
//                         value={addFundForm[key]} onChange={e => setAddFundForm({ ...addFundForm, [key]: e.target.value })} />
//                     </div>
//                   ))}
//                   <button style={{ ...S.btn, background: "#1e3a8a", width: "100%", padding: 12, fontSize: 14 }} onClick={addFund}>
//                     ➕ Credit to Member Wallet
//                   </button>
//                 </div>
//               </div>
//             </div>
//           )}

//           {/* ══════════ SALARY LIST ══════════ */}
//           {subTab === "Salary List" && (
//             <div>
//               <PageHead title="💰 Salary List" />

//               {/* Summary */}
//               <div style={{ display: "flex", gap: 10, marginBottom: 16, flexWrap: "wrap" }}>
//                 <div style={{ ...S.kpiCard, background: "#1e3a8a", minWidth: 150 }}>
//                   <div style={{ fontSize: 20 }}>📋</div>
//                   <div style={{ fontSize: 20, fontWeight: 800 }}>{salaries.length}</div>
//                   <div style={{ fontSize: 10, opacity: .8 }}>Total Records</div>
//                 </div>
//                 <div style={{ ...S.kpiCard, background: "#065f46", minWidth: 150 }}>
//                   <div style={{ fontSize: 20 }}>✅</div>
//                   <div style={{ fontSize: 20, fontWeight: 800 }}>{salaries.filter(s => s.is_approved).length}</div>
//                   <div style={{ fontSize: 10, opacity: .8 }}>Paid</div>
//                 </div>
//                 <div style={{ ...S.kpiCard, background: "#92400e", minWidth: 150 }}>
//                   <div style={{ fontSize: 20 }}>⏳</div>
//                   <div style={{ fontSize: 20, fontWeight: 800 }}>{salaries.filter(s => !s.is_approved).length}</div>
//                   <div style={{ fontSize: 10, opacity: .8 }}>Pending</div>
//                 </div>
//                 <div style={{ ...S.kpiCard, background: "#4c1d95", minWidth: 150 }}>
//                   <div style={{ fontSize: 20 }}>💰</div>
//                   <div style={{ fontSize: 18, fontWeight: 800 }}>{inr(salaries.reduce((s, x) => s + Number(x.amount || 0), 0))}</div>
//                   <div style={{ fontSize: 10, opacity: .8 }}>Total Amount</div>
//                 </div>
//               </div>

//               <div style={S.tableWrap}>
//                 <table style={S.table}>
//                   <THead cols={["#", "Coupon", "Member", "Mobile", "Rank", "Amount", "Month", "Status", "Action"]} />
//                   <tbody>
//                     {salaries.map((s, i) => (
//                       <tr key={s.id} style={i % 2 === 0 ? S.trEven : {}}>
//                         <td style={S.td}>{i + 1}</td>
//                         <td style={{ ...S.td, fontWeight: 700 }}>{s.receiver_coupon_no || s.token_number}</td>
//                         <td style={S.td}>{s.receiver_name}</td>
//                         <td style={S.td}>{s.receiver_mobile}</td>
//                         <td style={S.td}>
//                           <span style={{ ...S.pill, textTransform: "capitalize" }}>{s.rank}</span>
//                         </td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#16a34a" }}>{inr(s.amount)}</td>
//                         <td style={S.td}>{s.month}</td>
//                         <td style={S.td}>
//                           <span style={s.is_approved ? S.greenBadge : S.yellowBadge}>
//                             {s.is_approved ? "Paid ✅" : "Pending"}
//                           </span>
//                         </td>
//                         <td style={S.td}>
//                           {!s.is_approved && (
//                             <button style={{ ...S.btn, background: "#16a34a", fontSize: 11 }}
//                               onClick={() => approveSalary(s.id, s)}>
//                               Approve + 📱WA
//                             </button>
//                           )}
//                           {s.is_approved && (
//                             <button style={{ ...S.btn, background: "#25D366", fontSize: 11 }}
//                               onClick={() => whatsapp(s.receiver_mobile,
//                                 `💰 Namaste *${s.receiver_name}*!\n\nSalary of *${inr(s.amount)}* for ${s.month} credited ✅\n\n_${COMPANY}_`)}>
//                               📱 WA
//                             </button>
//                           )}
//                         </td>
//                       </tr>
//                     ))}
//                     {salaries.length === 0 && (
//                       <tr><td colSpan={9} style={{ ...S.td, textAlign: "center", color: "#94a3b8", padding: 40 }}>
//                         No records. Generate salary first.
//                       </td></tr>
//                     )}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}

//           {/* ══════════ GENERATE SALARY ══════════ */}
//           {subTab === "Generate Salary" && (
//             <div>
//               <PageHead title="💰 Generate Monthly Salary" />
//               <div style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
//                 <div style={{ ...S.card, maxWidth: 520, flex: 1 }}>
//                   <CardHead>Salary Generation</CardHead>
//                   <div style={{ padding: 20 }}>
//                     <p style={{ fontSize: 12, color: "#64748b", marginBottom: 16, padding: "10px 14px", background: "#f0fdf4", borderRadius: 8, border: "1px solid #bbf7d0" }}>
//                       ℹ️ This will generate salary records for all eligible members based on their current rank. Only generates if not already generated for this month.
//                     </p>
//                     <SectionTitle>Salary Rates by Rank</SectionTitle>
//                     {Object.entries(RANK_SALARY).map(([rank, amt]) => (
//                       <div key={rank} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 12px", borderBottom: "1px solid #f1f5f9", fontSize: 13 }}>
//                         <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
//                           <div style={{ width: 10, height: 10, borderRadius: "50%", background: rank === "diamond" ? "#06b6d4" : rank === "platinum" ? "#8b5cf6" : rank === "gold" ? "#f59e0b" : "#94a3b8" }} />
//                           <span style={{ textTransform: "capitalize", fontWeight: 600 }}>{rank}</span>
//                         </div>
//                         <span style={{ color: "#16a34a", fontWeight: 700 }}>{inr(amt)} / month</span>
//                       </div>
//                     ))}
//                     <div style={{ marginTop: 20 }}>
//                       <button
//                         style={{ ...S.btn, background: generatingSalary ? "#64748b" : "#1e3a8a", width: "100%", padding: 14, fontSize: 15 }}
//                         onClick={generateSalary}
//                         disabled={generatingSalary}
//                       >
//                         {generatingSalary ? "⏳ Generating..." : "🚀 Generate This Month's Salary"}
//                       </button>
//                     </div>
//                     {salaries.length > 0 && (
//                       <div style={{ marginTop: 12 }}>
//                         <button style={{ ...S.btn, background: "#7c3aed", width: "100%", padding: 10 }}
//                           onClick={() => goTo("salary", "Salary List")}>
//                           📋 View Salary List ({salaries.length} records)
//                         </button>
//                       </div>
//                     )}
//                   </div>
//                 </div>

//                 {/* Eligible members preview */}
//                 <div style={{ ...S.card, flex: 1, minWidth: 280 }}>
//                   <CardHead>👥 Eligible Members Preview</CardHead>
//                   <div style={{ padding: "8px 0", maxHeight: 380, overflowY: "auto" }}>
//                     {Object.keys(RANK_SALARY).map(rank => {
//                       const eligible = allMembers.filter(m => m.rank === rank && m.is_approved);
//                       if (eligible.length === 0) return null;
//                       return (
//                         <div key={rank}>
//                           <div style={{ padding: "8px 16px", background: "#f8fafc", fontSize: 11, fontWeight: 700, color: "#475569", textTransform: "uppercase", letterSpacing: 1 }}>
//                             {rank} — {inr(RANK_SALARY[rank])}/mo × {eligible.length} members = {inr(RANK_SALARY[rank] * eligible.length)}
//                           </div>
//                           {eligible.slice(0, 3).map(m => (
//                             <div key={m.id} style={{ padding: "6px 16px", borderBottom: "1px solid #f1f5f9", fontSize: 12, display: "flex", justifyContent: "space-between" }}>
//                               <span>{m.receiver_name}</span>
//                               <span style={{ color: "#16a34a", fontWeight: 700 }}>{inr(RANK_SALARY[rank])}</span>
//                             </div>
//                           ))}
//                           {eligible.length > 3 && (
//                             <div style={{ padding: "4px 16px", fontSize: 11, color: "#94a3b8" }}>
//                               +{eligible.length - 3} more...
//                             </div>
//                           )}
//                         </div>
//                       );
//                     })}
//                     {Object.keys(RANK_SALARY).every(rank => allMembers.filter(m => m.rank === rank && m.is_approved).length === 0) && (
//                       <div style={{ padding: 20, textAlign: "center", color: "#94a3b8", fontSize: 12 }}>
//                         No eligible members found
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               </div>
//             </div>
//           )}

//           {/* ══════════ ALL ADMINS ══════════ */}
//           {subTab === "All Admins" && (
//             <div>
//               <PageHead title="🛡 All Admins" />
//               <div style={S.tableWrap}>
//                 <table style={S.table}>
//                   <THead cols={["#", "Username", "Full Name", "Mobile", "Role", "Status", "Created"]} />
//                   <tbody>
//                     {adminList.map((a, i) => (
//                       <tr key={a.id} style={i % 2 === 0 ? S.trEven : {}}>
//                         <td style={S.td}>{i + 1}</td>
//                         <td style={{ ...S.td, fontWeight: 700 }}>{a.username}</td>
//                         <td style={S.td}>{a.full_name}</td>
//                         <td style={S.td}>{a.mobile}</td>
//                         <td style={S.td}><span style={a.role === "superadmin" ? S.greenBadge : S.pill}>{a.role}</span></td>
//                         <td style={S.td}><span style={a.is_active ? S.greenBadge : S.redBadge}>{a.is_active ? "Active" : "Inactive"}</span></td>
//                         <td style={{ ...S.td, fontSize: 11 }}>{fmt(a.created_at)}</td>
//                       </tr>
//                     ))}
//                     {adminList.length === 0 && <tr><td colSpan={7} style={{ ...S.td, textAlign: "center", color: "#94a3b8" }}>No admins</td></tr>}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}

//           {/* ══════════ CREATE ADMIN ══════════ */}
//           {subTab === "Create Admin" && (
//             <div>
//               <PageHead title="➕ Create New Admin" />
//               <div style={{ ...S.card, maxWidth: 480 }}>
//                 <CardHead>Admin Account Details</CardHead>
//                 <div style={{ padding: 20 }}>
//                   {[["Username *", "username", "text"], ["Password *", "password", "password"],
//                   ["Full Name", "full_name", "text"], ["Mobile", "mobile", "text"]].map(([label, key, type]) => (
//                     <div key={key} style={{ marginBottom: 14 }}>
//                       <label style={S.label}>{label}</label>
//                       <input style={S.input} type={type} value={newAdmin[key]}
//                         onChange={e => setNewAdmin({ ...newAdmin, [key]: e.target.value })} />
//                     </div>
//                   ))}
//                   <div style={{ marginBottom: 16 }}>
//                     <label style={S.label}>Role</label>
//                     <select style={S.input} value={newAdmin.role} onChange={e => setNewAdmin({ ...newAdmin, role: e.target.value })}>
//                       <option value="admin">Admin</option>
//                       <option value="superadmin">Super Admin</option>
//                     </select>
//                   </div>
//                   <button style={{ ...S.btn, background: "#1e3a8a", width: "100%", padding: 12 }} onClick={createAdmin}>
//                     Create Admin Account
//                   </button>
//                 </div>
//               </div>
//             </div>
//           )}

//           {/* Fallback */}
//           {tab !== "dashboard" && !subTab && (
//             <div style={{ padding: 60, textAlign: "center", color: "#94a3b8" }}>
//               Select a submenu item from the sidebar.
//             </div>
//           )}
//         </main>
//       </div>
//     </div>
//   );
// }

// /* ── Sub-components ── */
// function PageHead({ title, sub, children }) {
//   return (
//     <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 16, paddingBottom: 12, borderBottom: "2px solid #e2e8f0" }}>
//       <div style={{ width: 4, height: 20, background: "#ea580c", borderRadius: 99 }} />
//       <span style={{ fontWeight: 700, fontSize: 16, color: "#1e293b" }}>{title}</span>
//       {sub && <span style={{ fontSize: 11, color: "#94a3b8", marginLeft: 4 }}>{sub}</span>}
//       {children}
//     </div>
//   );
// }
// function SectionTitle({ children }) {
//   return <div style={{ fontWeight: 700, fontSize: 13, color: "#1e3a8a", margin: "18px 0 8px", borderLeft: "4px solid #ea580c", paddingLeft: 10 }}>{children}</div>;
// }
// function CardHead({ children }) {
//   return <div style={{ background: "#1e3a8a", color: "#fff", padding: "10px 16px", fontWeight: 700, fontSize: 13 }}>{children}</div>;
// }
// function THead({ cols }) {
//   return (
//     <thead>
//       <tr style={{ background: "#1e3a8a", color: "#fff" }}>
//         {cols.map(c => <th key={c} style={{ padding: "10px 12px", textAlign: "left", fontSize: 11, fontWeight: 700, whiteSpace: "nowrap" }}>{c}</th>)}
//       </tr>
//     </thead>
//   );
// }
// function ActionBtn({ color, onClick, disabled, children }) {
//   return (
//     <button onClick={onClick} disabled={disabled}
//       style={{ background: color, color: "#fff", border: "none", padding: "5px 9px", borderRadius: 5, cursor: "pointer", fontSize: 12, fontWeight: 700, opacity: disabled ? .6 : 1 }}>
//       {children}
//     </button>
//   );
// }

// /* ── Styles ── */
// const S = {
//   shell: { display: "flex", flexDirection: "column", minHeight: "100vh", fontFamily: "'Segoe UI', system-ui, sans-serif", fontSize: 13, background: "#f1f5f9" },
//   topbar: { background: "linear-gradient(90deg,#1e3a8a 0%,#1e40af 100%)", color: "#fff", display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 20px", position: "sticky", top: 0, zIndex: 100, boxShadow: "0 2px 10px rgba(0,0,0,.3)" },
//   logoBadge: { width: 40, height: 40, borderRadius: 10, background: "linear-gradient(135deg,#f97316,#ea580c)", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 900, fontSize: 18, color: "#fff", boxShadow: "0 2px 8px rgba(234,88,12,.4)" },
//   superBadge: { background: "rgba(255,255,255,.15)", border: "1px solid rgba(255,255,255,.3)", borderRadius: 99, padding: "3px 12px", fontSize: 11, fontWeight: 700, color: "#fef3c7", letterSpacing: .5 },
//   logoutBtn: { background: "rgba(239,68,68,.85)", border: "none", color: "#fff", padding: "6px 14px", borderRadius: 6, cursor: "pointer", fontWeight: 600, fontSize: 12 },
//   sidebar: { width: 205, background: "#1e3a8a", minHeight: "calc(100vh - 60px)", flexShrink: 0, overflowY: "auto" },
//   navItem: { color: "#bfdbfe", padding: "11px 16px", cursor: "pointer", display: "flex", alignItems: "center", fontSize: 13, borderBottom: "1px solid rgba(255,255,255,.06)", fontWeight: 500 },
//   navActive: { background: "#ea580c", color: "#fff" },
//   navSub: { color: "#93c5fd", padding: "9px 16px 9px 28px", cursor: "pointer", fontSize: 12, background: "rgba(0,0,0,.25)", borderBottom: "1px solid rgba(255,255,255,.04)" },
//   navSubActive: { background: "#ea580c", color: "#fff", fontWeight: 700 },
//   content: { flex: 1, padding: 20, overflowX: "auto" },
//   kpiGrid: { display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))", gap: 10, marginBottom: 16 },
//   kpiCard: { color: "#fff", borderRadius: 10, padding: "14px 16px", display: "flex", flexDirection: "column", gap: 4, boxShadow: "0 2px 8px rgba(0,0,0,.15)" },
//   card: { background: "#fff", border: "1px solid #e2e8f0", borderRadius: 8, overflow: "hidden" },
//   tableWrap: { background: "#fff", borderRadius: 8, border: "1px solid #e2e8f0", overflow: "auto", marginBottom: 16 },
//   table: { width: "100%", borderCollapse: "collapse", minWidth: 600 },
//   td: { padding: "9px 12px", fontSize: 12, borderBottom: "1px solid #f1f5f9", verticalAlign: "middle" },
//   trEven: { background: "#f8fafc" },
//   infoChip: { background: "#f0f9ff", border: "1px solid #bae6fd", borderRadius: 8, padding: "8px 12px", minWidth: 90 },
//   searchBox: { border: "1px solid #e2e8f0", borderRadius: 6, padding: "8px 12px", fontSize: 13, outline: "none", minWidth: 260, background: "#fff" },
//   countBadge: { background: "#eff6ff", color: "#1d4ed8", padding: "5px 12px", borderRadius: 99, fontWeight: 700, fontSize: 12 },
//   pill: { background: "#eff6ff", color: "#1d4ed8", padding: "2px 8px", borderRadius: 99, fontSize: 11, fontWeight: 600 },
//   greenBadge: { background: "#dcfce7", color: "#15803d", padding: "2px 8px", borderRadius: 99, fontSize: 11, fontWeight: 700 },
//   yellowBadge: { background: "#fef9c3", color: "#854d0e", padding: "2px 8px", borderRadius: 99, fontSize: 11, fontWeight: 700 },
//   redBadge: { background: "#fee2e2", color: "#991b1b", padding: "2px 8px", borderRadius: 99, fontSize: 11, fontWeight: 700 },
//   badge: { padding: "2px 8px", borderRadius: 99, fontSize: 11, fontWeight: 600 },
//   label: { display: "block", fontSize: 12, color: "#475569", marginBottom: 4, fontWeight: 600 },
//   input: { border: "1px solid #e2e8f0", padding: "9px 12px", width: "100%", fontSize: 13, borderRadius: 6, outline: "none", boxSizing: "border-box" },
//   btn: { color: "#fff", border: "none", padding: "7px 14px", borderRadius: 6, cursor: "pointer", fontWeight: 600, fontSize: 13, display: "inline-flex", alignItems: "center", gap: 4 },
// };




// import { useState, useEffect, useCallback, useMemo } from "react";
// import { useNavigate } from "react-router-dom";
// import { useAuth } from "../context/AuthContext";
// import {
//   BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer,
//   PieChart, Pie, Cell, Legend, LineChart, Line
// } from "recharts";
// import api from "../api";
// import toast from "react-hot-toast";

// /* ─── Constants ─── */
// const LEVEL_RATE = { 1: 300, 2: 150, 3: 120, 4: 90, 5: 60, 6: 30 };
// const RANK_SALARY = { silver: 1000, gold: 3000, platinum: 7000, diamond: 15000 };
// const PIE_COLORS = ["#3b82f6", "#10b981", "#f59e0b", "#ef4444", "#8b5cf6", "#06b6d4"];
// const COMPANY = "Meruram Lucky Draw";
// const COMPANY_URL = "https://meruram.in";

// /* ─── WhatsApp helper ─── */
// const whatsapp = (mobile, msg) => {
//   if (!mobile) { toast.error("No mobile number!"); return; }
//   window.open(`https://wa.me/91${mobile.replace(/\D/g, "")}?text=${encodeURIComponent(msg)}`, "_blank");
// };

// /* ─── Format helpers ─── */
// const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
// const fmt = (d) => d ? new Date(d).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : "—";
// const fmtTime = (d) => d ? new Date(d).toLocaleString("en-IN") : "—";

// /* ─── Sidebar nav ─── */
// const NAV = [
//   { label: "📊 Dashboard", key: "dashboard" },
//   {
//     label: "🎟 Members", key: "members",
//     children: ["All Members", "Pending Approval", "Approved Members", "Member Detail"],
//   },
//   {
//     label: "💹 Income & Business", key: "income",
//     children: [
//       "Level Income Report",
//       "Level Wise Report",
//       "Commission Report",
//       "Direct Business Report",
//       "Business Report",
//       "Commission Summary",
//       "Daily Joins",
//       "Network Tree",
//     ],
//   },
//   {
//     label: "💸 Payments", key: "payments",
//     children: ["Withdrawal Requests", "Payment History", "Add Fund to Member"],
//   },
//   {
//     label: "💰 Salary", key: "salary",
//     children: ["Salary List", "Generate Salary"],
//   },
//   {
//     label: "🛡 Admin Mgmt", key: "admins",
//     children: ["All Admins", "Create Admin"],
//   },
// ];

// /* ══════════════════════════════════════════════
//    RESPONSIVE STYLES (injected once)
// ══════════════════════════════════════════════ */
// const GLOBAL_CSS = `
//   * { box-sizing: border-box; }
//   body { margin: 0; }

//   /* ── Scrollable table wrapper ── */
//   .table-scroll { overflow-x: auto; -webkit-overflow-scrolling: touch; }
//   .table-scroll table { min-width: 600px; }

//   /* ── Mobile sidebar overlay ── */
//   .sidebar-overlay {
//     display: none;
//     position: fixed; inset: 0;
//     background: rgba(0,0,0,.5);
//     z-index: 200;
//   }
//   .sidebar-overlay.open { display: block; }

//   /* ── Sidebar drawer ── */
//   .sidebar-drawer {
//     position: fixed;
//     top: 0; left: 0; bottom: 0;
//     width: 220px;
//     background: #1e3a8a;
//     z-index: 201;
//     overflow-y: auto;
//     transform: translateX(-100%);
//     transition: transform .25s ease;
//   }
//   .sidebar-drawer.open { transform: translateX(0); }

//   /* ── Hamburger button ── */
//   .hamburger {
//     display: none;
//     background: rgba(255,255,255,.15);
//     border: none;
//     color: #fff;
//     font-size: 20px;
//     padding: 6px 10px;
//     border-radius: 6px;
//     cursor: pointer;
//     line-height: 1;
//   }

//   /* ── Desktop sidebar ── */
//   .sidebar-desktop {
//     width: 205px;
//     background: #1e3a8a;
//     min-height: calc(100vh - 60px);
//     flex-shrink: 0;
//     overflow-y: auto;
//   }

//   /* ── KPI grid responsive ── */
//   .kpi-grid {
//     display: grid;
//     grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
//     gap: 10px;
//     margin-bottom: 16px;
//   }

//   /* ── Info chip grid ── */
//   .chip-grid {
//     display: flex;
//     flex-wrap: wrap;
//     gap: 10px;
//     margin-bottom: 16px;
//   }
//   .info-chip {
//     background: #f0f9ff;
//     border: 1px solid #bae6fd;
//     border-radius: 8px;
//     padding: 8px 12px;
//     min-width: 120px;
//     flex: 1 1 120px;
//     max-width: 200px;
//   }

//   /* ── Flex row that wraps on mobile ── */
//   .flex-wrap-row {
//     display: flex;
//     gap: 14px;
//     flex-wrap: wrap;
//   }
//   .flex-wrap-row > * { min-width: 260px; flex: 1; }

//   /* ── Action buttons in table ── */
//   .action-cell { display: flex; gap: 4px; flex-wrap: wrap; }

//   /* ── Search bar row ── */
//   .search-row {
//     display: flex;
//     gap: 10px;
//     margin-bottom: 12px;
//     flex-wrap: wrap;
//     align-items: center;
//   }
//   .search-row input { flex: 1; min-width: 200px; }

//   /* ── Page head ── */
//   .page-head {
//     display: flex;
//     align-items: center;
//     gap: 10px;
//     margin-bottom: 16px;
//     padding-bottom: 12px;
//     border-bottom: 2px solid #e2e8f0;
//     flex-wrap: wrap;
//   }

//   /* ── Card row wraps ── */
//   .card-row {
//     display: flex;
//     gap: 14px;
//     margin-top: 4px;
//     flex-wrap: wrap;
//   }
//   .card-row .chart-card { flex: 2; min-width: 260px; }
//   .card-row .dist-card  { flex: 1; min-width: 200px; }

//   /* ── Responsive topbar ── */
//   .topbar-left { display: flex; align-items: center; gap: 12px; }
//   .topbar-right { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }
//   .super-badge-hide { display: inline; }

//   /* ── Level cards row ── */
//   .level-cards {
//     display: flex;
//     gap: 8px;
//     margin-bottom: 16px;
//     flex-wrap: wrap;
//   }
//   .level-cards > div { min-width: 100px; flex: 1; }

//   /* ── Repair panel ── */
//   .repair-panel {
//     display: flex;
//     gap: 16px;
//     align-items: flex-start;
//     flex-wrap: wrap;
//   }
//   .repair-panel .repair-left  { flex: 1; min-width: 220px; }
//   .repair-panel .repair-right { display: flex; flex-direction: column; gap: 8px; min-width: 200px; }

//   /* ─────────── MOBILE BREAKPOINT ─────────── */
//   @media (max-width: 768px) {
//     .hamburger { display: block; }
//     .sidebar-desktop { display: none; }

//     .super-badge-hide { display: none; }

//     .kpi-grid {
//       grid-template-columns: repeat(2, 1fr);
//     }

//     .info-chip { max-width: 100%; }

//     .flex-wrap-row > * { min-width: 100%; }

//     .card-row .chart-card,
//     .card-row .dist-card { min-width: 100%; }

//     .level-cards > div { min-width: calc(50% - 8px); }

//     .repair-panel { flex-direction: column; }
//     .repair-panel .repair-right { min-width: 100%; }

//     /* Make table font smaller on mobile */
//     .table-scroll table { font-size: 11px; }
//     .table-scroll th, .table-scroll td { padding: 7px 8px !important; }
//   }

//   @media (max-width: 480px) {
//     .kpi-grid { grid-template-columns: repeat(2, 1fr); }
//     .level-cards > div { min-width: 100%; }
//     .topbar-right .logout-text { display: none; }
//   }
// `;

// function GlobalStyles() {
//   useEffect(() => {
//     const id = "sad-responsive-styles";
//     if (!document.getElementById(id)) {
//       const el = document.createElement("style");
//       el.id = id;
//       el.textContent = GLOBAL_CSS;
//       document.head.appendChild(el);
//     }
//     return () => {
//       const el = document.getElementById(id);
//       if (el) el.remove();
//     };
//   }, []);
//   return null;
// }

// /* ══════════════════════════════════════════════
//    SIDEBAR CONTENT (shared between desktop + mobile drawer)
// ══════════════════════════════════════════════ */
// function SidebarContent({ tab, subTab, openNav, setOpenNav, goTo, logout, navigate, onNavClick }) {
//   return (
//     <>
//       {NAV.map(n => (
//         <div key={n.key}>
//           <div
//             style={{ ...S.navItem, ...(tab === n.key && !subTab && !n.children ? S.navActive : {}) }}
//             onClick={() => {
//               if (n.children) {
//                 setOpenNav(p => ({ ...p, [n.key]: !p[n.key] }));
//               } else {
//                 goTo(n.key);
//                 onNavClick && onNavClick();
//               }
//             }}
//           >
//             <span style={{ flex: 1 }}>{n.label}</span>
//             {n.children && <span style={{ fontSize: 10, opacity: .6 }}>{openNav[n.key] ? "▾" : "▸"}</span>}
//           </div>
//           {n.children && openNav[n.key] && n.children
//             .filter(c => c !== "Member Detail")
//             .map(child => (
//               <div key={child}
//                 style={{ ...S.navSub, ...(subTab === child ? S.navSubActive : {}) }}
//                 onClick={() => { goTo(n.key, child); onNavClick && onNavClick(); }}
//               >{child}</div>
//             ))}
//         </div>
//       ))}
//       <div style={S.navItem} onClick={() => { logout(); navigate("/superadmin/login"); }}>
//         🚪 Logout
//       </div>
//     </>
//   );
// }

// /* ══════════════════════════════════════════════
//    MAIN COMPONENT
// ══════════════════════════════════════════════ */
// export default function SuperAdminDashboard() {
//   const { admin, logout } = useAuth();
//   const navigate = useNavigate();

//   /* State */
//   const [stats, setStats] = useState(null);
//   const [allMembers, setAllMembers] = useState([]);
//   const [withdrawals, setWithdrawals] = useState([]);
//   const [payHistory, setPayHistory] = useState([]);
//   const [salaries, setSalaries] = useState([]);
//   const [adminList, setAdminList] = useState([]);
//   const [selectedMember, setSelectedMember] = useState(null);
//   const [memberDetail, setMemberDetail] = useState(null);
//   const [loadingDetail, setLoadingDetail] = useState(false);
//   const [commissions, setCommissions] = useState([]);
//   const [networkTree, setNetworkTree] = useState(null);
//   const [networkToken, setNetworkToken] = useState("");
//   const [dailyJoins, setDailyJoins] = useState([]);
//   const [generatingSalary, setGeneratingSalary] = useState(false);
//   const [repairing, setRepairing] = useState(false);
//   const [repairLog, setRepairLog] = useState([]);

//   const [tab, setTab] = useState("dashboard");
//   const [subTab, setSubTab] = useState("");
//   const [openNav, setOpenNav] = useState({ dashboard: true });
//   const [search, setSearch] = useState("");
//   const [approving, setApproving] = useState({});
//   const [sidebarOpen, setSidebarOpen] = useState(false);

//   const [addFundForm, setAddFundForm] = useState({ token_number: "", amount: "", description: "Fund added by admin" });
//   const [newAdmin, setNewAdmin] = useState({ username: "", password: "", full_name: "", mobile: "", role: "admin" });

//   /* ── Fetch functions ── */
//   const loadStats = useCallback(async () => {
//     try { const r = await api.get("/mlm/super-stats"); setStats(r.data); } catch { toast.error("Stats load failed"); }
//   }, []);

//   const loadMembers = useCallback(async (q = "") => {
//     try {
//       const r = await api.get(`/coupons/all?search=${encodeURIComponent(q)}&limit=500`);
//       setAllMembers(r.data.rows || []);
//     } catch { toast.error("Members load failed"); }
//   }, []);

//   const loadWithdrawals = useCallback(async () => {
//     try { const r = await api.get("/wallet/withdrawals/all?status=pending"); setWithdrawals(r.data.rows || []); } catch {}
//   }, []);

//   const loadPayHistory = useCallback(async () => {
//     try { const r = await api.get("/mlm/payment-history"); setPayHistory(r.data.rows || []); } catch {}
//   }, []);

//   const loadSalaries = useCallback(async () => {
//     try { const r = await api.get("/mlm/salary/list"); setSalaries(r.data.rows || []); } catch {}
//   }, []);

//   const loadAdmins = useCallback(async () => {
//     try { const r = await api.get("/auth/admins"); setAdminList(r.data || []); } catch {}
//   }, []);

//   const loadMemberDetail = useCallback(async (token) => {
//     if (!token) return;
//     setLoadingDetail(true);
//     try {
//       const r = await api.get(`/mlm/member-detail/${token}`);
//       if (r.data.success) {
//         setMemberDetail(r.data);
//       } else {
//         toast.error("Member not found");
//       }
//     } catch { toast.error("Failed to load member detail"); }
//     setLoadingDetail(false);
//   }, []);

//   const loadCommissions = useCallback(async () => {
//     try {
//       const r = await api.get("/mlm/commissions/all?limit=500");
//       setCommissions(r.data.rows || []);
//     } catch { toast.error("Commissions load failed"); }
//   }, []);

//   const loadDailyJoins = useCallback(async () => {
//     try {
//       const r = await api.get("/mlm/daily-joins?days=30");
//       setDailyJoins(r.data.rows || []);
//     } catch (e) { toast.error("Daily joins load failed"); }
//   }, []);

//   const loadNetworkTree = useCallback(async (token) => {
//     if (!token) { toast.error("Enter a token/coupon number"); return; }
//     try {
//       const r = await api.get(`/mlm/network-tree/${token}`);
//       if (r.data.success && r.data.token_number) {
//         setNetworkTree(r.data);
//       } else if (r.data.tree) {
//         setNetworkTree(r.data.tree);
//       } else {
//         toast.error("Member not found");
//       }
//     } catch { toast.error("Network tree load failed"); }
//   }, []);

//   useEffect(() => {
//     Promise.all([loadStats(), loadMembers(), loadWithdrawals()]);
//   }, []);

//   /* ── Navigation ── */
//   const goTo = useCallback((t, s = "") => {
//     setTab(t); setSubTab(s);
//     if (t === "admins") loadAdmins();
//     if (s === "Withdrawal Requests") loadWithdrawals();
//     if (s === "Payment History") loadPayHistory();
//     if (s === "Salary List" || s === "Generate Salary") loadSalaries();
//     if (s === "Commission Report") loadCommissions();
//     if (s === "Daily Joins") loadDailyJoins();
//     if (
//       s === "All Members" || s === "Pending Approval" || s === "Approved Members" ||
//       s === "Level Income Report" || s === "Level Wise Report" ||
//       s === "Direct Business Report" || s === "Business Report" ||
//       s === "Commission Summary" || s === "Commission Report"
//     ) loadMembers(search);
//   }, [search, loadAdmins, loadWithdrawals, loadPayHistory, loadSalaries, loadMembers, loadCommissions, loadDailyJoins]);

//   /* ── Actions ── */
//   const approveCoupon = async (id, row) => {
//     setApproving(p => ({ ...p, [id]: true }));
//     try {
//       await api.post(`/coupons/approve/${id}`);
//       toast.success("✅ Approved!");
//       await Promise.all([loadMembers(search), loadStats()]);
//       if (row?.receiver_mobile) {
//         const message = `Welcome ${row.receiver_name} 🎉\n\nYour ID ${row.receiver_coupon_no || ""} has been approved successfully.\n\nWelcome to Meruram family 🚀\n\n${COMPANY_URL}`;
//         window.open(`https://wa.me/91${row.receiver_mobile.replace(/\D/g, "")}?text=${encodeURIComponent(message)}`, "_blank");
//       }
//     } catch (err) { toast.error(err.response?.data?.message || "Error"); }
//     setApproving(p => ({ ...p, [id]: false }));
//   };

//   const deleteCoupon = async (id) => {
//     if (!window.confirm("Delete this coupon permanently?")) return;
//     try { await api.delete(`/coupons/delete/${id}`); toast.success("Deleted"); loadMembers(search); loadStats(); }
//     catch { toast.error("Delete failed"); }
//   };

//   const processWithdrawal = async (id, action, row) => {
//     try {
//       await api.put(`/wallet/withdrawals/${id}`, { action });
//       if (action === "approved") {
//         toast.success("✅ Approved! Sending WhatsApp...");
//         whatsapp(row.receiver_mobile,
//           `💸 Namaste *${row.receiver_name}*!\n\nYour withdrawal request of *${inr(row.amount)}* has been *APPROVED & PROCESSED* ✅\n\nPayment via: *${(row.method || "").toUpperCase()}*\n${row.method === "upi" ? `UPI: ${row.upi_id || "—"}` : `Bank: ${row.bank_name || "—"} | Acc: ${row.account_number || "—"}`}\n\n_${COMPANY}_\n${COMPANY_URL}`
//         );
//       } else {
//         toast.error("❌ Withdrawal rejected");
//       }
//       loadWithdrawals(); loadPayHistory(); loadStats();
//     } catch (err) { toast.error(err.response?.data?.message || "Error"); }
//   };

//   const approveSalary = async (id, row) => {
//     try {
//       await api.put(`/mlm/salary/approve/${id}`);
//       toast.success("Salary credited!");
//       if (row?.receiver_mobile) {
//         whatsapp(row.receiver_mobile,
//           `💰 Namaste *${row.receiver_name}*!\n\nYour *${row.rank?.toUpperCase()} Rank Salary* of *${inr(row.amount)}* for ${row.month} has been credited to your wallet ✅\n\n_${COMPANY}_\n${COMPANY_URL}`
//         );
//       }
//       loadSalaries();
//     } catch (err) { toast.error(err.response?.data?.message || "Error"); }
//   };

//   const generateSalary = async () => {
//     setGeneratingSalary(true);
//     try {
//       const r = await api.post("/mlm/salary/generate");
//       toast.success(r.data.message || "Salary generated!");
//       loadSalaries();
//       goTo("salary", "Salary List");
//     } catch (err) { toast.error(err.response?.data?.message || "Error"); }
//     setGeneratingSalary(false);
//   };

//   const runFullRepair = async () => {
//     if (!window.confirm(
//       "⚠️ This will:\n1. Fix referred_by for all members\n2. Redistribute missing commissions\n3. Recalculate all ranks\n\nSafe to run multiple times. Continue?"
//     )) return;

//     setRepairing(true);
//     setRepairLog([]);
//     const log = [];

//     try {
//       log.push("🔧 Step 1: Fixing referred_by links...");
//       setRepairLog([...log]);
//       const r1 = await api.post("/mlm/fix-referred-by");
//       log.push(`✅ Step 1 done: ${r1.data.fixed} members linked, ${r1.data.skipped} skipped`);
//       setRepairLog([...log]);

//       log.push("💰 Step 2: Redistributing commissions...");
//       setRepairLog([...log]);
//       const r2 = await api.post("/mlm/redistribute-commissions");
//       log.push(`✅ Step 2 done: commissions distributed for ${r2.data.processed} members`);
//       if (r2.data.errors?.length) log.push(`⚠️ ${r2.data.errors.length} errors (check server logs)`);
//       setRepairLog([...log]);

//       log.push("🏆 Step 3: Recalculating all ranks...");
//       setRepairLog([...log]);
//       const r3 = await api.post("/mlm/recalculate-all-ranks");
//       const rankSummary = Object.entries(r3.data.summary || {}).map(([rank, count]) => `${rank}: ${count}`).join(", ");
//       log.push(`✅ Step 3 done: ${r3.data.message} → ${rankSummary}`);
//       setRepairLog([...log]);

//       log.push("🎉 All repairs complete! Reloading data...");
//       setRepairLog([...log]);

//       await Promise.all([loadStats(), loadMembers()]);
//       toast.success("✅ Data repair complete!");
//     } catch (err) {
//       log.push(`❌ Error: ${err.response?.data?.message || err.message}`);
//       setRepairLog([...log]);
//       toast.error("Repair failed — check log");
//     }
//     setRepairing(false);
//   };

//   const addFund = async () => {
//     if (!addFundForm.token_number || !addFundForm.amount) { toast.error("Fill all fields"); return; }
//     try {
//       const r = await api.post("/mlm/add-fund", addFundForm);
//       toast.success(r.data.message);
//       setAddFundForm({ token_number: "", amount: "", description: "Fund added by admin" });
//       loadMembers(); loadStats();
//     } catch (err) { toast.error(err.response?.data?.message || "Error"); }
//   };

//   const createAdmin = async () => {
//     if (!newAdmin.username || !newAdmin.password) { toast.error("Username & password required"); return; }
//     try {
//       await api.post("/auth/create-admin", newAdmin);
//       toast.success("Admin created!");
//       setNewAdmin({ username: "", password: "", full_name: "", mobile: "", role: "admin" });
//       loadAdmins();
//     } catch (err) { toast.error(err.response?.data?.message || "Error"); }
//   };

//   const openDetail = async (row) => {
//     const tokenToLoad = row.token_number || row.token;
//     setSelectedMember(row);
//     setTab("members"); setSubTab("Member Detail");
//     await loadMemberDetail(tokenToLoad);
//   };

//   /* ── Filtered member lists ── */
//   const filteredMembers = useMemo(() => {
//     if (subTab === "Pending Approval") return allMembers.filter(c => !c.is_approved);
//     if (subTab === "Approved Members") return allMembers.filter(c => c.is_approved);
//     return allMembers;
//   }, [allMembers, subTab]);

//   const topByIncome = useMemo(() =>
//     [...allMembers].sort((a, b) => Number(b.total_income || 0) - Number(a.total_income || 0)).slice(0, 10),
//     [allMembers]
//   );

//   const topByDirect = useMemo(() =>
//     [...allMembers].sort((a, b) => Number(b.direct_count || 0) - Number(a.direct_count || 0)).slice(0, 10),
//     [allMembers]
//   );

//   const levelSummary = useMemo(() => {
//     const map = {};
//     allMembers.forEach(m => {
//       for (let l = 1; l <= 6; l++) {
//         const earned = Number(m[`level${l}_income`] || 0);
//         if (!map[l]) map[l] = { level: l, total: 0, members_paid: 0, rate: LEVEL_RATE[l] };
//         if (earned > 0) { map[l].total += earned; map[l].members_paid++; }
//       }
//     });
//     return Object.values(map);
//   }, [allMembers]);

//   const commissionByLevel = useMemo(() => {
//     const map = {};
//     commissions.forEach(c => {
//       const l = c.level;
//       if (!map[l]) map[l] = { level: l, count: 0, total: 0 };
//       map[l].count++;
//       map[l].total += Number(c.amount || 0);
//     });
//     return Object.values(map).sort((a, b) => a.level - b.level);
//   }, [commissions]);

//   /* ── Network Tree recursive renderer ── */
//   const TreeNode = ({ node, depth = 0 }) => {
//     const [expanded, setExpanded] = useState(depth < 2);
//     if (!node) return null;
//     const hasChildren = node.children && node.children.length > 0;
//     return (
//       <div style={{ marginLeft: depth * 16, marginBottom: 4 }}>
//         <div
//           style={{
//             display: "flex", alignItems: "center", gap: 6, padding: "8px 10px",
//             background: depth === 0 ? "#1e3a8a" : depth === 1 ? "#1d4ed8" : depth === 2 ? "#3b82f6" : "#eff6ff",
//             color: depth < 3 ? "#fff" : "#1e3a8a",
//             borderRadius: 8, cursor: hasChildren ? "pointer" : "default",
//             border: "1px solid rgba(255,255,255,0.1)",
//             flexWrap: "wrap",
//             minHeight: 44,
//           }}
//           onClick={() => hasChildren && setExpanded(e => !e)}
//         >
//           {hasChildren && <span style={{ fontSize: 10, minWidth: 12 }}>{expanded ? "▼" : "▶"}</span>}
//           {!hasChildren && <span style={{ fontSize: 10, minWidth: 12, opacity: 0.5 }}>●</span>}
//           <span style={{ fontWeight: 700, fontSize: 12 }}>{node.receiver_coupon_no || node.token_number}</span>
//           <span style={{ fontSize: 12 }}>{node.receiver_name}</span>
//           <span style={{ fontSize: 11, opacity: 0.75 }}>{node.receiver_mobile}</span>
//           {hasChildren && (
//             <span style={{ marginLeft: "auto", background: "rgba(255,255,255,0.2)", borderRadius: 99, padding: "1px 8px", fontSize: 11 }}>
//               {node.children.length} direct
//             </span>
//           )}
//           <span style={{
//             background: node.is_approved ? "#16a34a" : "#f59e0b",
//             borderRadius: 99, padding: "1px 8px", fontSize: 10, color: "#fff"
//           }}>
//             {node.is_approved ? "Active" : "Pending"}
//           </span>
//         </div>
//         {expanded && hasChildren && (
//           <div style={{ borderLeft: "2px solid #bfdbfe", marginLeft: 14, paddingLeft: 6, marginTop: 4 }}>
//             {node.children.map(child => (
//               <TreeNode key={child.id || child.token_number} node={child} depth={depth + 1} />
//             ))}
//           </div>
//         )}
//       </div>
//     );
//   };

//   /* ─────────────── RENDER ─────────────── */
//   return (
//     <div style={S.shell}>
//       <GlobalStyles />

//       {/* ══ MOBILE SIDEBAR OVERLAY ══ */}
//       <div className={`sidebar-overlay${sidebarOpen ? " open" : ""}`} onClick={() => setSidebarOpen(false)} />
//       <nav className={`sidebar-drawer${sidebarOpen ? " open" : ""}`}>
//         <div style={{ padding: "14px 16px", borderBottom: "1px solid rgba(255,255,255,.15)", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
//           <div style={{ fontWeight: 800, color: "#fff", fontSize: 14 }}>MERURAM</div>
//           <button onClick={() => setSidebarOpen(false)} style={{ background: "none", border: "none", color: "#93c5fd", fontSize: 20, cursor: "pointer" }}>✕</button>
//         </div>
//         <SidebarContent
//           tab={tab} subTab={subTab} openNav={openNav} setOpenNav={setOpenNav}
//           goTo={goTo} logout={logout} navigate={navigate}
//           onNavClick={() => setSidebarOpen(false)}
//         />
//       </nav>

//       {/* ══ TOP BAR ══ */}
//       <header style={S.topbar}>
//         <div className="topbar-left">
//           <button className="hamburger" onClick={() => setSidebarOpen(true)}>☰</button>
//           <div style={S.logoBadge}>मे</div>
//           <div>
//             <div style={{ fontWeight: 800, fontSize: 15, letterSpacing: .5, color: "#fff" }}>MERURAM</div>
//             <div style={{ fontSize: 9, color: "#93c5fd", letterSpacing: 3 }}>SUPER ADMIN</div>
//           </div>
//         </div>
//         <div className="topbar-right">
//           <span className="super-badge-hide" style={S.superBadge}>👑 SUPER ADMIN</span>
//           <span style={{ fontSize: 12, color: "#ddd" }}>{admin?.full_name || admin?.username}</span>
//           <button style={S.logoutBtn} onClick={() => { logout(); navigate("/superadmin/login"); }}>
//             <span className="logout-text">Logout</span>
//             <span style={{ display: "none" }} className="logout-icon">🚪</span>
//           </button>
//         </div>
//       </header>

//       <div style={{ display: "flex", flex: 1 }}>
//         {/* ══ DESKTOP SIDEBAR ══ */}
//         <nav className="sidebar-desktop">
//           <SidebarContent
//             tab={tab} subTab={subTab} openNav={openNav} setOpenNav={setOpenNav}
//             goTo={goTo} logout={logout} navigate={navigate}
//           />
//         </nav>

//         {/* ══ MAIN CONTENT ══ */}
//         <main style={S.content}>

//           {/* ══════════ DASHBOARD ══════════ */}
//           {tab === "dashboard" && stats && (
//             <div>
//               <div className="page-head">
//                 <div style={{ width: 4, height: 20, background: "#ea580c", borderRadius: 99 }} />
//                 <span style={{ fontWeight: 700, fontSize: 16, color: "#1e293b" }}>Dashboard Overview</span>
//                 <span style={{ fontSize: 11, color: "#94a3b8" }}>{COMPANY_URL}</span>
//               </div>

//               {/* KPI Grid */}
//               <div className="kpi-grid">
//                 {[
//                   { label: "Total Coupons", val: stats.total_members, icon: "🎟", bg: "#1e40af" },
//                   { label: "Approved", val: stats.approved, icon: "✅", bg: "#065f46" },
//                   { label: "Pending", val: stats.pending, icon: "⏳", bg: "#92400e" },
//                   { label: "Pending Payouts", val: stats.pending_payouts, icon: "💸", bg: "#7f1d1d" },
//                   { label: "Total Wallet", val: inr(stats.total_wallet), icon: "💰", bg: "#4c1d95" },
//                   { label: "Commission Paid", val: inr(stats.total_commission), icon: "📈", bg: "#134e4a" },
//                   { label: "Payout Done", val: inr(stats.total_payout_done), icon: "🏦", bg: "#1e1b4b" },
//                   { label: "Pending Salary", val: stats.pending_salary, icon: "📋", bg: "#701a75" },
//                 ].map(c => (
//                   <div key={c.label} style={{ ...S.kpiCard, background: c.bg }}>
//                     <div style={{ fontSize: 22 }}>{c.icon}</div>
//                     <div style={{ fontSize: 18, fontWeight: 800 }}>{c.val}</div>
//                     <div style={{ fontSize: 10, opacity: .8 }}>{c.label}</div>
//                   </div>
//                 ))}
//               </div>

//               {/* ── DATA REPAIR PANEL ── */}
//               <div style={{
//                 background: "linear-gradient(135deg, #1e1b4b 0%, #312e81 100%)",
//                 borderRadius: 12, padding: "16px 20px", marginBottom: 16,
//                 border: "1px solid #4338ca",
//               }}>
//                 <div className="repair-panel">
//                   <div className="repair-left">
//                     <div style={{ fontWeight: 800, color: "#c7d2fe", fontSize: 13, marginBottom: 4 }}>
//                       🔧 Data Repair Tool
//                     </div>
//                     <div style={{ fontSize: 11, color: "#a5b4fc", lineHeight: 1.6 }}>
//                       Run once if members, commissions or ranks are showing blank/zero.
//                       Fixes <code style={{ background: "#1e1b4b", padding: "1px 4px", borderRadius: 3 }}>referred_by</code>,
//                       redistributes missing commissions, recalculates all ranks.
//                     </div>
//                   </div>
//                   <div className="repair-right">
//                     <button
//                       style={{
//                         background: repairing ? "#4338ca" : "#6366f1",
//                         color: "#fff", border: "none", borderRadius: 8,
//                         padding: "10px 20px", fontWeight: 700, fontSize: 13,
//                         cursor: repairing ? "not-allowed" : "pointer",
//                         opacity: repairing ? 0.7 : 1,
//                       }}
//                       onClick={runFullRepair}
//                       disabled={repairing}
//                     >
//                       {repairing ? "⏳ Repairing..." : "🚀 Run Full Data Repair"}
//                     </button>
//                     {repairLog.length > 0 && (
//                       <div style={{
//                         background: "#0f172a", borderRadius: 8, padding: "10px 12px",
//                         fontSize: 11, fontFamily: "monospace", lineHeight: 1.8,
//                         maxHeight: 160, overflowY: "auto", border: "1px solid #334155"
//                       }}>
//                         {repairLog.map((line, i) => (
//                           <div key={i} style={{
//                             color: line.startsWith("✅") ? "#4ade80"
//                                  : line.startsWith("❌") ? "#f87171"
//                                  : line.startsWith("⚠️") ? "#fbbf24"
//                                  : line.startsWith("🎉") ? "#818cf8"
//                                  : "#94a3b8"
//                           }}>{line}</div>
//                         ))}
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               </div>

//               {/* Company-wide Level Summary */}
//               <SectionTitle>💹 Company-wide Level Commission Summary</SectionTitle>
//               <div className="table-scroll" style={{ background: "#fff", borderRadius: 8, border: "1px solid #e2e8f0", marginBottom: 16 }}>
//                 <table style={S.table}>
//                   <THead cols={["Level", "Rate/Join", "Members Benefiting", "Total Paid Out", "Chart"]} />
//                   <tbody>
//                     {levelSummary.map((l, i) => (
//                       <tr key={l.level} style={i % 2 === 0 ? S.trEven : {}}>
//                         <td style={S.td}><b>Level {l.level}</b></td>
//                         <td style={S.td}>₹{l.rate}</td>
//                         <td style={S.td}>{l.members_paid}</td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#16a34a" }}>{inr(l.total)}</td>
//                         <td style={S.td}>
//                           <div style={{ width: Math.min((l.total / (stats.total_commission || 1)) * 200, 140), height: 8, background: PIE_COLORS[i % PIE_COLORS.length], borderRadius: 99 }} />
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>

//               {/* Charts Row */}
//               <div className="card-row">
//                 <div style={{ ...S.card }} className="chart-card">
//                   <CardHead>📅 Daily Registrations (14 days)</CardHead>
//                   <div style={{ padding: 16 }}>
//                     <ResponsiveContainer width="100%" height={180}>
//                       <BarChart data={stats.daily_joins || []}>
//                         <XAxis dataKey="date" tick={{ fontSize: 9 }} />
//                         <YAxis tick={{ fontSize: 9 }} />
//                         <Tooltip />
//                         <Bar dataKey="count" fill="#3b82f6" radius={[3, 3, 0, 0]} name="Joins" />
//                       </BarChart>
//                     </ResponsiveContainer>
//                   </div>
//                 </div>
//                 <div style={{ ...S.card }} className="dist-card">
//                   <CardHead>🏆 Rank Distribution</CardHead>
//                   <div style={{ padding: "8px 0" }}>
//                     {(stats.rank_dist || []).map((r, i) => (
//                       <div key={r.rank} style={{ display: "flex", justifyContent: "space-between", padding: "8px 16px", borderBottom: "1px solid #f1f5f9", alignItems: "center" }}>
//                         <span style={{ fontSize: 12, textTransform: "capitalize", fontWeight: 600 }}>{r.rank}</span>
//                         <span style={{ ...S.badge, background: PIE_COLORS[i % PIE_COLORS.length], color: "#fff" }}>{r.count}</span>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               </div>

//               {/* Top 10 by Income */}
//               <SectionTitle>🥇 Top 10 Members by Total Income</SectionTitle>
//               <div className="table-scroll" style={{ background: "#fff", borderRadius: 8, border: "1px solid #e2e8f0", marginBottom: 16 }}>
//                 <table style={S.table}>
//                   <THead cols={["Rank", "Coupon", "Name", "Direct", "L1", "L2", "L3", "L4", "L5", "L6", "Total Income"]} />
//                   <tbody>
//                     {topByIncome.map((m, i) => (
//                       <tr key={m.id} style={i % 2 === 0 ? S.trEven : {}}>
//                         <td style={{ ...S.td, fontWeight: 800, color: i < 3 ? "#f59e0b" : "#64748b" }}>#{i + 1}</td>
//                         <td style={{ ...S.td, color: "#1d4ed8", fontWeight: 700, cursor: "pointer" }} onClick={() => openDetail(m)}>
//                           {m.receiver_coupon_no}
//                         </td>
//                         <td style={S.td}>{m.receiver_name}</td>
//                         <td style={S.td}>{m.direct_count}</td>
//                         {[1, 2, 3, 4, 5, 6].map(l => (
//                           <td key={l} style={{ ...S.td, fontSize: 11, color: m[`level${l}_income`] > 0 ? "#16a34a" : "#ccc" }}>
//                             {m[`level${l}_income`] > 0 ? inr(m[`level${l}_income`]) : "—"}
//                           </td>
//                         ))}
//                         <td style={{ ...S.td, fontWeight: 800, color: "#7c3aed" }}>{inr(m.total_income)}</td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>

//               {/* Top 10 by Direct */}
//               <SectionTitle>👥 Top 10 Members by Direct Connections</SectionTitle>
//               <div className="table-scroll" style={{ background: "#fff", borderRadius: 8, border: "1px solid #e2e8f0", marginBottom: 16 }}>
//                 <table style={S.table}>
//                   <THead cols={["Rank", "Coupon", "Name", "Mobile", "Direct", "Total Team", "Total Business"]} />
//                   <tbody>
//                     {topByDirect.map((m, i) => (
//                       <tr key={m.id} style={i % 2 === 0 ? S.trEven : {}}>
//                         <td style={{ ...S.td, fontWeight: 800, color: i < 3 ? "#f59e0b" : "#64748b" }}>#{i + 1}</td>
//                         <td style={{ ...S.td, color: "#1d4ed8", fontWeight: 700, cursor: "pointer" }} onClick={() => openDetail(m)}>
//                           {m.receiver_coupon_no}
//                         </td>
//                         <td style={S.td}>{m.receiver_name}</td>
//                         <td style={S.td}>{m.receiver_mobile}</td>
//                         <td style={{ ...S.td, fontWeight: 700 }}>{m.direct_count}</td>
//                         <td style={S.td}>{Number(m.direct_count || 0) + Number(m.indirect_count || 0)}</td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#16a34a" }}>{inr(m.total_income)}</td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}

//           {/* ══════════ ALL MEMBERS ══════════ */}
//           {(subTab === "All Members" || subTab === "Pending Approval" || subTab === "Approved Members") && (
//             <div>
//               <PageHead title={`🎟 ${subTab}`} />
//               <div className="search-row">
//                 <input style={S.searchBox}
//                   placeholder="🔍 Search name, mobile, coupon..."
//                   value={search}
//                   onChange={e => { setSearch(e.target.value); loadMembers(e.target.value); }}
//                 />
//                 <span style={S.countBadge}>Total: {filteredMembers.length}</span>
//                 <span style={{ ...S.countBadge, background: "#dcfce7", color: "#15803d" }}>
//                   Active: {filteredMembers.filter(m => m.is_approved).length}
//                 </span>
//                 <span style={{ ...S.countBadge, background: "#fef9c3", color: "#854d0e" }}>
//                   Pending: {filteredMembers.filter(m => !m.is_approved).length}
//                 </span>
//               </div>
//               <div className="table-scroll" style={{ background: "#fff", borderRadius: 8, border: "1px solid #e2e8f0", marginBottom: 16 }}>
//                 <table style={S.table}>
//                   <THead cols={[
//                     "#", "Coupon", "Name", "Mobile", "Aadhaar", "Giver",
//                     "Payment", "Screenshot", "Wallet", "Rank", "Status", "Date", "Actions"
//                   ]} />
//                   <tbody>
//                     {filteredMembers.map((c, i) => (
//                       <tr key={c.id} style={i % 2 === 0 ? S.trEven : {}}>
//                         <td style={S.td}>{i + 1}</td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#1d4ed8", cursor: "pointer" }}
//                           onClick={() => openDetail(c)}>
//                           {c.receiver_coupon_no || "—"}
//                         </td>
//                         <td style={S.td}>{c.receiver_name}</td>
//                         <td style={S.td}>{c.receiver_mobile}</td>
//                         <td style={{ ...S.td, fontSize: 11 }}>
//                           {c.receiver_aadhaar ? "••••" + String(c.receiver_aadhaar).slice(-4) : "—"}
//                         </td>
//                         <td style={S.td}>{c.giver_name || "—"}</td>
//                         <td style={S.td}>
//                           <span style={S.pill}>{c.payment_cash ? "Cash" : "Online"}</span>
//                         </td>
//                         <td style={S.td}>
//                           {c.screenshot
//                             ? <a href={`/uploads/${c.screenshot}`} target="_blank" rel="noreferrer"
//                                 style={{ color: "#1d4ed8", fontWeight: 600, fontSize: 11 }}>View 📷</a>
//                             : "—"}
//                         </td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#7c3aed" }}>{inr(c.wallet_balance)}</td>
//                         <td style={S.td}><span style={S.pill}>{c.rank || "member"}</span></td>
//                         <td style={S.td}>
//                           <span style={c.is_approved ? S.greenBadge : S.yellowBadge}>
//                             {c.is_approved ? "Active" : "Pending"}
//                           </span>
//                         </td>
//                         <td style={{ ...S.td, fontSize: 11 }}>{fmt(c.created_at)}</td>
//                         <td style={S.td}>
//                           <div className="action-cell">
//                             {!c.is_approved && (
//                               <ActionBtn color="#16a34a" disabled={approving[c.id]}
//                                 onClick={() => approveCoupon(c.id, c)}>
//                                 {approving[c.id] ? "..." : "✅"}
//                               </ActionBtn>
//                             )}
//                             <ActionBtn color="#1d4ed8" onClick={() => openDetail(c)}>👁</ActionBtn>
//                             <ActionBtn color="#25D366" onClick={() =>
//                               whatsapp(c.receiver_mobile,
//                                 `Namaste *${c.receiver_name}*! Your coupon status: ${c.is_approved ? "Active ✅" : "Pending ⏳"}. Visit ${COMPANY_URL}`)
//                             }>📱</ActionBtn>
//                             <ActionBtn color="#dc2626" onClick={() => deleteCoupon(c.id)}>🗑</ActionBtn>
//                           </div>
//                         </td>
//                       </tr>
//                     ))}
//                     {filteredMembers.length === 0 && (
//                       <tr><td colSpan={13} style={{ ...S.td, textAlign: "center", color: "#94a3b8", padding: 40 }}>
//                         No records found
//                       </td></tr>
//                     )}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}

//           {/* ══════════ MEMBER DETAIL ══════════ */}
//           {subTab === "Member Detail" && (
//             <div>
//               <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16, flexWrap: "wrap", gap: 8 }}>
//                 <PageHead title={`👤 Member Detail${memberDetail ? " — " + memberDetail.member?.receiver_name : ""}`} />
//                 <button style={{ ...S.btn, background: "#64748b" }} onClick={() => goTo("members", "All Members")}>← Back</button>
//               </div>

//               {loadingDetail && <div style={{ textAlign: "center", padding: 48, color: "#94a3b8" }}>Loading...</div>}

//               {!loadingDetail && memberDetail && (() => {
//                 const m = memberDetail.member;
//                 const levelBreakdown = memberDetail.level_breakdown || [];
//                 const direct = memberDetail.direct || [];
//                 const memberCommissions = memberDetail.commissions || [];
//                 const wdrawals = memberDetail.withdrawals || [];
//                 const totalEarned = levelBreakdown.reduce((s, l) => s + Number(l.total || 0), 0);
//                 const referralLink = m.reference_token ? `${COMPANY_URL}/register/${m.reference_token}` : null;

//                 return (
//                   <div>
//                     {/* ── Info Chips ── */}
//                     <div className="chip-grid">
//                       {[
//                         ["Coupon No", m.receiver_coupon_no],
//                         ["Name", m.receiver_name],
//                         ["Mobile", m.receiver_mobile],
//                         ["Aadhaar", m.receiver_aadhaar || "—"],
//                         ["Address", m.receiver_address || "—"],
//                         ["Rank", m.rank?.toUpperCase()],
//                         ["Wallet Balance", inr(m.wallet_balance)],
//                         ["Direct Members", direct.length],
//                         ["Total Team", memberDetail.total_team],
//                         ["Total Earned", inr(totalEarned)],
//                         ["Joined", fmt(m.created_at)],
//                         ["Status", m.is_approved ? "Active ✅" : "Pending ⏳"],
//                       ].map(([k, v]) => (
//                         <div key={k} className="info-chip">
//                           <div style={{ fontSize: 10, color: "#64748b" }}>{k}</div>
//                           <div style={{ fontWeight: 700, wordBreak: "break-all" }}>{v}</div>
//                         </div>
//                       ))}
//                     </div>

//                     {/* ── Referral Link Box ── */}
//                     {referralLink && (
//                       <div style={{
//                         background: "linear-gradient(135deg,#1e3a8a,#1d4ed8)",
//                         borderRadius: 10, padding: "14px 18px", marginBottom: 16,
//                         display: "flex", alignItems: "flex-start", gap: 12, flexWrap: "wrap"
//                       }}>
//                         <div style={{ flex: 1, minWidth: 200 }}>
//                           <div style={{ fontSize: 11, color: "#93c5fd", fontWeight: 700, marginBottom: 4 }}>🔗 MEMBER REFERRAL LINK</div>
//                           <div style={{
//                             background: "rgba(0,0,0,.3)", borderRadius: 6, padding: "8px 12px",
//                             fontSize: 12, color: "#e0f2fe", fontFamily: "monospace", wordBreak: "break-all"
//                           }}>
//                             {referralLink}
//                           </div>
//                         </div>
//                         <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
//                           <button style={{ ...S.btn, background: "#f59e0b", color: "#000", fontWeight: 800 }}
//                             onClick={() => { navigator.clipboard.writeText(referralLink); toast.success("✅ Referral link copied!"); }}>
//                             📋 Copy
//                           </button>
//                           <button style={{ ...S.btn, background: "#25D366" }}
//                             onClick={() => whatsapp(m.receiver_mobile,
//                               `Namaste *${m.receiver_name}* 👋\n\nHere is your personal Meruram referral link:\n\n🔗 ${referralLink}\n\nShare this with your friends & family to earn level income! 💰\n\n_${COMPANY}_`)}>
//                             📱 WhatsApp
//                           </button>
//                         </div>
//                       </div>
//                     )}

//                     {/* ── Screenshot & Aadhaar row ── */}
//                     <div className="flex-wrap-row" style={{ marginBottom: 16 }}>
//                       {m.screenshot && (
//                         <div style={{ ...S.card, padding: 14 }}>
//                           <div style={{ fontSize: 11, fontWeight: 700, color: "#64748b", marginBottom: 8 }}>📷 PAYMENT SCREENSHOT</div>
//                           <a href={`/uploads/${m.screenshot}`} target="_blank" rel="noreferrer">
//                             <img src={`/uploads/${m.screenshot}`} alt="Payment screenshot"
//                               style={{ maxWidth: "100%", maxHeight: 180, borderRadius: 6, border: "1px solid #e2e8f0", cursor: "pointer" }} />
//                           </a>
//                           <div style={{ marginTop: 8 }}>
//                             <a href={`/uploads/${m.screenshot}`} target="_blank" rel="noreferrer"
//                               style={{ ...S.btn, background: "#1d4ed8", fontSize: 11, textDecoration: "none", display: "inline-flex" }}>
//                               🔍 View Full Size
//                             </a>
//                           </div>
//                         </div>
//                       )}
//                       <div style={{ ...S.card, padding: 14 }}>
//                         <div style={{ fontSize: 11, fontWeight: 700, color: "#64748b", marginBottom: 8 }}>🪪 AADHAAR DETAILS</div>
//                         <div style={{ fontSize: 13, marginBottom: 6 }}>
//                           <span style={{ color: "#94a3b8", fontSize: 11 }}>Full Aadhaar Number:</span><br />
//                           <span style={{ fontWeight: 800, fontSize: 16, letterSpacing: 2, color: "#1e3a8a" }}>
//                             {m.receiver_aadhaar || "Not provided"}
//                           </span>
//                         </div>
//                         <div style={{ fontSize: 12, color: "#64748b" }}>
//                           <div><b>Name:</b> {m.receiver_name}</div>
//                           <div><b>Address:</b> {m.receiver_address || "—"}</div>
//                           <div><b>Mobile:</b> {m.receiver_mobile}</div>
//                         </div>
//                       </div>
//                       <div style={{ ...S.card, padding: 14 }}>
//                         <div style={{ fontSize: 11, fontWeight: 700, color: "#64748b", marginBottom: 8 }}>🏦 BANK / UPI DETAILS</div>
//                         {(m.bank_name || m.account_number || m.upi_id) ? (
//                           <div style={{ fontSize: 13 }}>
//                             {m.bank_name && <div><span style={{ color: "#94a3b8", fontSize: 11 }}>Bank:</span> <b>{m.bank_name}</b></div>}
//                             {m.account_number && <div><span style={{ color: "#94a3b8", fontSize: 11 }}>A/C No:</span> <b>{m.account_number}</b></div>}
//                             {m.ifsc && <div><span style={{ color: "#94a3b8", fontSize: 11 }}>IFSC:</span> <b>{m.ifsc}</b></div>}
//                             {m.upi_id && <div><span style={{ color: "#94a3b8", fontSize: 11 }}>UPI ID:</span> <b>{m.upi_id}</b></div>}
//                           </div>
//                         ) : (
//                           <div style={{ color: "#94a3b8", fontSize: 12 }}>No bank/UPI details added yet</div>
//                         )}
//                       </div>
//                     </div>

//                     {/* ── Action buttons ── */}
//                     <div style={{ display: "flex", gap: 8, marginBottom: 16, flexWrap: "wrap" }}>
//                       <button style={{ ...S.btn, background: "#25D366" }} onClick={() =>
//                         whatsapp(m.receiver_mobile, `Namaste *${m.receiver_name}*!\n\nYour Meruram account is active ✅.\n\nCoupon: ${m.receiver_coupon_no}\nBalance: ${inr(m.wallet_balance)}\n\nVisit: ${COMPANY_URL}`)}>
//                         📱 Send Account Info
//                       </button>
//                       <button style={{ ...S.btn, background: "#25D366" }} onClick={() =>
//                         whatsapp(m.receiver_mobile, `Namaste *${m.receiver_name}*!\n\nYou have earned *${inr(totalEarned)}* in Level Income from Meruram Lucky Draw 🎉\n\nLogin to check: ${COMPANY_URL}`)}>
//                         📱 Send Income Info
//                       </button>
//                     </div>

//                     <SectionTitle>💹 Level-wise Income</SectionTitle>
//                     <div className="table-scroll" style={{ background: "#fff", borderRadius: 8, border: "1px solid #e2e8f0", marginBottom: 16 }}>
//                       <table style={S.table}>
//                         <THead cols={["Level", "Rate/Join", "Members Joined", "Direct", "Indirect", "Total Earned", "% Share"]} />
//                         <tbody>
//                           {[1, 2, 3, 4, 5, 6].map((level, i) => {
//                             const found = levelBreakdown.find(l => l.level === level);
//                             const earned = Number(found?.total || 0);
//                             const pct = totalEarned > 0 ? ((earned / totalEarned) * 100).toFixed(1) : "0";
//                             const isL1 = level === 1;
//                             return (
//                               <tr key={level} style={i % 2 === 0 ? S.trEven : {}}>
//                                 <td style={S.td}><strong>L{level}</strong> {isL1 ? "🔴" : ""}</td>
//                                 <td style={S.td}>₹{LEVEL_RATE[level]}</td>
//                                 <td style={S.td}>{found?.count || 0}</td>
//                                 <td style={S.td}>{isL1 ? (found?.count || 0) : "—"}</td>
//                                 <td style={S.td}>{!isL1 ? (found?.count || 0) : "—"}</td>
//                                 <td style={{ ...S.td, fontWeight: 700, color: earned > 0 ? "#16a34a" : "#94a3b8" }}>
//                                   {earned > 0 ? inr(earned) : "₹0.00"}
//                                 </td>
//                                 <td style={S.td}>
//                                   <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
//                                     <div style={{ height: 6, borderRadius: 99, background: PIE_COLORS[i], width: `${Math.min(Number(pct), 100)}%`, minWidth: 2 }} />
//                                     <span style={{ fontSize: 11, color: "#64748b", whiteSpace: "nowrap" }}>{pct}%</span>
//                                   </div>
//                                 </td>
//                               </tr>
//                             );
//                           })}
//                           <tr style={{ background: "#f0fdf4" }}>
//                             <td style={{ ...S.td, fontWeight: 800 }} colSpan={2}>TOTAL</td>
//                             <td style={{ ...S.td, fontWeight: 700 }}>{levelBreakdown.reduce((s, l) => s + l.count, 0)}</td>
//                             <td style={S.td}>{direct.length}</td>
//                             <td style={S.td}>{memberDetail.total_team - direct.length}</td>
//                             <td style={{ ...S.td, fontWeight: 800, color: "#15803d", fontSize: 14 }}>{inr(totalEarned)}</td>
//                             <td style={S.td}>100%</td>
//                           </tr>
//                         </tbody>
//                       </table>
//                     </div>

//                     <SectionTitle>👥 Direct Members</SectionTitle>
//                     <div className="table-scroll" style={{ background: "#fff", borderRadius: 8, border: "1px solid #e2e8f0", marginBottom: 16 }}>
//                       <table style={S.table}>
//                         <THead cols={["#", "Coupon", "Name", "Mobile", "Joined", "Their Direct", "Status", "WA"]} />
//                         <tbody>
//                           {direct.map((d, i) => (
//                             <tr key={d.id} style={i % 2 === 0 ? S.trEven : {}}>
//                               <td style={S.td}>{i + 1}</td>
//                               <td style={{ ...S.td, color: "#1d4ed8", fontWeight: 700 }}>{d.receiver_coupon_no}</td>
//                               <td style={S.td}>{d.receiver_name}</td>
//                               <td style={S.td}>{d.receiver_mobile}</td>
//                               <td style={{ ...S.td, fontSize: 11 }}>{fmtTime(d.created_at)}</td>
//                               <td style={{ ...S.td, fontWeight: 700 }}>{d.their_direct}</td>
//                               <td style={S.td}><span style={d.is_approved ? S.greenBadge : S.yellowBadge}>{d.is_approved ? "Active" : "Pending"}</span></td>
//                               <td style={S.td}>
//                                 <button style={{ ...S.btn, background: "#25D366", padding: "4px 8px" }}
//                                   onClick={() => whatsapp(d.receiver_mobile, `Namaste *${d.receiver_name}*! Welcome to Meruram Lucky Draw. Login: ${COMPANY_URL}`)}>
//                                   📱
//                                 </button>
//                               </td>
//                             </tr>
//                           ))}
//                           {direct.length === 0 && <tr><td colSpan={8} style={{ ...S.td, textAlign: "center", color: "#94a3b8" }}>No direct referrals</td></tr>}
//                         </tbody>
//                       </table>
//                     </div>

//                     <SectionTitle>📋 Commission History</SectionTitle>
//                     <div className="table-scroll" style={{ background: "#fff", borderRadius: 8, border: "1px solid #e2e8f0", marginBottom: 16 }}>
//                       <table style={S.table}>
//                         <THead cols={["#", "Date", "Level", "From Coupon", "From Member", "Amount"]} />
//                         <tbody>
//                           {memberCommissions.slice(0, 100).map((c, i) => (
//                             <tr key={c.id} style={i % 2 === 0 ? S.trEven : {}}>
//                               <td style={S.td}>{i + 1}</td>
//                               <td style={{ ...S.td, fontSize: 11 }}>{fmtTime(c.created_at)}</td>
//                               <td style={S.td}><span style={S.pill}>L{c.level}</span></td>
//                               <td style={{ ...S.td, color: "#1d4ed8" }}>{c.from_coupon}</td>
//                               <td style={S.td}>{c.from_name}</td>
//                               <td style={{ ...S.td, fontWeight: 700, color: "#16a34a" }}>{inr(c.amount)}</td>
//                             </tr>
//                           ))}
//                           {memberCommissions.length === 0 && <tr><td colSpan={6} style={{ ...S.td, textAlign: "center", color: "#94a3b8" }}>No commissions yet</td></tr>}
//                         </tbody>
//                       </table>
//                     </div>

//                     <SectionTitle>💸 Withdrawal History</SectionTitle>
//                     <div className="table-scroll" style={{ background: "#fff", borderRadius: 8, border: "1px solid #e2e8f0", marginBottom: 16 }}>
//                       <table style={S.table}>
//                         <THead cols={["#", "Date", "Amount", "Method", "Bank/UPI", "Status"]} />
//                         <tbody>
//                           {wdrawals.map((w, i) => (
//                             <tr key={w.id} style={i % 2 === 0 ? S.trEven : {}}>
//                               <td style={S.td}>{i + 1}</td>
//                               <td style={{ ...S.td, fontSize: 11 }}>{fmt(w.created_at)}</td>
//                               <td style={{ ...S.td, fontWeight: 700 }}>{inr(w.amount)}</td>
//                               <td style={S.td}>{w.method?.toUpperCase()}</td>
//                               <td style={{ ...S.td, fontSize: 11 }}>{w.method === "upi" ? w.upi_id : `${w.bank_name || ""} ${w.account_number || ""}`}</td>
//                               <td style={S.td}><span style={w.status === "approved" ? S.greenBadge : w.status === "rejected" ? S.redBadge : S.yellowBadge}>{w.status}</span></td>
//                             </tr>
//                           ))}
//                           {wdrawals.length === 0 && <tr><td colSpan={6} style={{ ...S.td, textAlign: "center", color: "#94a3b8" }}>No withdrawals</td></tr>}
//                         </tbody>
//                       </table>
//                     </div>
//                   </div>
//                 );
//               })()}
//             </div>
//           )}

//           {/* ══════════ LEVEL INCOME REPORT ══════════ */}
//           {subTab === "Level Income Report" && (
//             <div>
//               <PageHead title="📈 Level Income Report — All Members" />
//               <div className="level-cards">
//                 {[1, 2, 3, 4, 5, 6].map((l, i) => (
//                   <div key={l} style={{ background: PIE_COLORS[i], color: "#fff", borderRadius: 10, padding: "12px 14px", textAlign: "center" }}>
//                     <div style={{ fontSize: 10, opacity: 0.8 }}>L{l} · ₹{LEVEL_RATE[l]}/join</div>
//                     <div style={{ fontSize: 16, fontWeight: 800, marginTop: 4 }}>
//                       {inr(allMembers.reduce((s, m) => s + Number(m[`level${l}_income`] || 0), 0))}
//                     </div>
//                     <div style={{ fontSize: 10, opacity: 0.8, marginTop: 2 }}>
//                       {allMembers.filter(m => Number(m[`level${l}_income`]) > 0).length} members
//                     </div>
//                   </div>
//                 ))}
//               </div>
//               <div className="table-scroll" style={{ background: "#fff", borderRadius: 8, border: "1px solid #e2e8f0", marginBottom: 16 }}>
//                 <table style={S.table}>
//                   <THead cols={["#", "Coupon", "Name", "Mobile", "Sponsor", "Direct", "L1", "L2", "L3", "L4", "L5", "L6", "Total", "Withdrawn"]} />
//                   <tbody>
//                     {allMembers.filter(m => Number(m.total_income) > 0).map((m, i) => (
//                       <tr key={m.id} style={i % 2 === 0 ? S.trEven : {}}>
//                         <td style={S.td}>{i + 1}</td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#1d4ed8", cursor: "pointer" }} onClick={() => openDetail(m)}>{m.receiver_coupon_no}</td>
//                         <td style={S.td}>{m.receiver_name}</td>
//                         <td style={S.td}>{m.receiver_mobile}</td>
//                         <td style={{ ...S.td, fontSize: 11 }}>{m.sponsor_name || "—"}</td>
//                         <td style={S.td}>{m.direct_count}</td>
//                         {[1, 2, 3, 4, 5, 6].map(l => (
//                           <td key={l} style={{ ...S.td, color: m[`level${l}_income`] > 0 ? "#16a34a" : "#d1d5db", fontSize: 11 }}>
//                             {m[`level${l}_income`] > 0 ? inr(m[`level${l}_income`]) : "—"}
//                           </td>
//                         ))}
//                         <td style={{ ...S.td, fontWeight: 800, color: "#7c3aed" }}>{inr(m.total_income)}</td>
//                         <td style={{ ...S.td, color: "#dc2626" }}>{inr(m.total_withdrawn)}</td>
//                       </tr>
//                     ))}
//                     <tr style={{ background: "#eff6ff", fontWeight: 800 }}>
//                       <td style={S.td} colSpan={6}>COMPANY TOTAL</td>
//                       {[1, 2, 3, 4, 5, 6].map(l => (
//                         <td key={l} style={{ ...S.td, color: "#16a34a", fontWeight: 800 }}>
//                           {inr(allMembers.reduce((s, m) => s + Number(m[`level${l}_income`] || 0), 0))}
//                         </td>
//                       ))}
//                       <td style={{ ...S.td, color: "#7c3aed", fontSize: 13 }}>
//                         {inr(allMembers.reduce((s, m) => s + Number(m.total_income || 0), 0))}
//                       </td>
//                       <td style={{ ...S.td, color: "#dc2626" }}>
//                         {inr(allMembers.reduce((s, m) => s + Number(m.total_withdrawn || 0), 0))}
//                       </td>
//                     </tr>
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}

//           {/* ══════════ LEVEL WISE REPORT ══════════ */}
//           {subTab === "Level Wise Report" && (
//             <div>
//               <PageHead title="📊 Level Wise Report — Company Overview" />
//               <div style={{ ...S.card, marginBottom: 16 }}>
//                 <CardHead>Level-wise Commission Distribution</CardHead>
//                 <div style={{ padding: 16 }}>
//                   <ResponsiveContainer width="100%" height={220}>
//                     <BarChart data={levelSummary}>
//                       <XAxis dataKey="level" tickFormatter={v => `L${v}`} tick={{ fontSize: 11 }} />
//                       <YAxis tick={{ fontSize: 10 }} tickFormatter={v => `₹${(v / 1000).toFixed(0)}k`} />
//                       <Tooltip formatter={(v) => inr(v)} labelFormatter={l => `Level ${l}`} />
//                       <Bar dataKey="total" name="Total Paid" radius={[4, 4, 0, 0]}>
//                         {levelSummary.map((entry, i) => <Cell key={i} fill={PIE_COLORS[i % PIE_COLORS.length]} />)}
//                       </Bar>
//                     </BarChart>
//                   </ResponsiveContainer>
//                 </div>
//               </div>

//               <div className="table-scroll" style={{ background: "#fff", borderRadius: 8, border: "1px solid #e2e8f0", marginBottom: 16 }}>
//                 <table style={S.table}>
//                   <THead cols={["Level", "Rate/Join", "Members Benefiting", "Total Paid", "Avg/Member", "% of Total"]} />
//                   <tbody>
//                     {levelSummary.map((l, i) => {
//                       const grandTotal = levelSummary.reduce((s, x) => s + x.total, 0);
//                       const pct = grandTotal > 0 ? ((l.total / grandTotal) * 100).toFixed(1) : "0";
//                       const avg = l.members_paid > 0 ? l.total / l.members_paid : 0;
//                       return (
//                         <tr key={l.level} style={i % 2 === 0 ? S.trEven : {}}>
//                           <td style={S.td}>
//                             <span style={{ ...S.pill, background: PIE_COLORS[i], color: "#fff", fontSize: 12 }}>Level {l.level}</span>
//                           </td>
//                           <td style={{ ...S.td, fontWeight: 700 }}>₹{l.rate}</td>
//                           <td style={{ ...S.td, fontWeight: 700, color: "#1d4ed8" }}>{l.members_paid}</td>
//                           <td style={{ ...S.td, fontWeight: 800, color: "#16a34a", fontSize: 13 }}>{inr(l.total)}</td>
//                           <td style={{ ...S.td, color: "#7c3aed" }}>{inr(avg)}</td>
//                           <td style={S.td}>
//                             <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
//                               <div style={{ height: 8, borderRadius: 99, background: PIE_COLORS[i], width: `${Math.min(Number(pct) * 1.5, 120)}px` }} />
//                               <span style={{ fontSize: 12, fontWeight: 700 }}>{pct}%</span>
//                             </div>
//                           </td>
//                         </tr>
//                       );
//                     })}
//                     <tr style={{ background: "#f0fdf4", fontWeight: 800 }}>
//                       <td style={S.td} colSpan={2}>GRAND TOTAL</td>
//                       <td style={{ ...S.td, color: "#1d4ed8" }}>{levelSummary.reduce((s, l) => s + l.members_paid, 0)}</td>
//                       <td style={{ ...S.td, color: "#16a34a", fontSize: 14 }}>{inr(levelSummary.reduce((s, l) => s + l.total, 0))}</td>
//                       <td style={S.td}>—</td>
//                       <td style={S.td}>100%</td>
//                     </tr>
//                   </tbody>
//                 </table>
//               </div>

//               <SectionTitle>👤 Member-wise Level Breakdown</SectionTitle>
//               <div className="table-scroll" style={{ background: "#fff", borderRadius: 8, border: "1px solid #e2e8f0", marginBottom: 16 }}>
//                 <table style={S.table}>
//                   <THead cols={["#", "Coupon", "Name", "L1", "L2", "L3", "L4", "L5", "L6", "Total", "Rank"]} />
//                   <tbody>
//                     {allMembers.filter(m => Number(m.total_income) > 0)
//                       .sort((a, b) => Number(b.total_income) - Number(a.total_income))
//                       .map((m, i) => (
//                         <tr key={m.id} style={i % 2 === 0 ? S.trEven : {}}>
//                           <td style={S.td}>{i + 1}</td>
//                           <td style={{ ...S.td, color: "#1d4ed8", fontWeight: 700, cursor: "pointer" }} onClick={() => openDetail(m)}>{m.receiver_coupon_no}</td>
//                           <td style={S.td}>{m.receiver_name}</td>
//                           {[1, 2, 3, 4, 5, 6].map(l => (
//                             <td key={l} style={{ ...S.td, fontSize: 11, color: Number(m[`level${l}_income`]) > 0 ? "#16a34a" : "#d1d5db" }}>
//                               {Number(m[`level${l}_income`]) > 0 ? `₹${Number(m[`level${l}_income`]).toFixed(0)}` : "—"}
//                             </td>
//                           ))}
//                           <td style={{ ...S.td, fontWeight: 800, color: "#7c3aed" }}>{inr(m.total_income)}</td>
//                           <td style={S.td}><span style={S.pill}>{m.rank || "—"}</span></td>
//                         </tr>
//                       ))}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}

//           {/* ══════════ COMMISSION REPORT ══════════ */}
//           {subTab === "Commission Report" && (
//             <div>
//               <PageHead title="💰 Commission Report — All Transactions" />
//               <div className="kpi-grid" style={{ marginBottom: 16 }}>
//                 <div style={{ ...S.kpiCard, background: "#1e3a8a" }}>
//                   <div style={{ fontSize: 20 }}>💰</div>
//                   <div style={{ fontSize: 18, fontWeight: 800 }}>{inr(commissions.reduce((s, c) => s + Number(c.amount || 0), 0))}</div>
//                   <div style={{ fontSize: 10, opacity: .8 }}>Total Commission</div>
//                 </div>
//                 <div style={{ ...S.kpiCard, background: "#065f46" }}>
//                   <div style={{ fontSize: 20 }}>📋</div>
//                   <div style={{ fontSize: 18, fontWeight: 800 }}>{commissions.length}</div>
//                   <div style={{ fontSize: 10, opacity: .8 }}>Total Transactions</div>
//                 </div>
//                 {commissionByLevel.map((cl, i) => (
//                   <div key={cl.level} style={{ ...S.kpiCard, background: PIE_COLORS[i % PIE_COLORS.length] }}>
//                     <div style={{ fontSize: 13 }}>Level {cl.level}</div>
//                     <div style={{ fontSize: 15, fontWeight: 800 }}>{inr(cl.total)}</div>
//                     <div style={{ fontSize: 10, opacity: .8 }}>{cl.count} txns</div>
//                   </div>
//                 ))}
//               </div>
//               <div style={{ ...S.card, marginBottom: 16 }}>
//                 <CardHead>Commission by Level</CardHead>
//                 <div style={{ padding: 16 }}>
//                   <ResponsiveContainer width="100%" height={180}>
//                     <BarChart data={commissionByLevel}>
//                       <XAxis dataKey="level" tickFormatter={v => `L${v}`} tick={{ fontSize: 11 }} />
//                       <YAxis tick={{ fontSize: 10 }} tickFormatter={v => `₹${(v / 1000).toFixed(0)}k`} />
//                       <Tooltip formatter={(v) => inr(v)} labelFormatter={l => `Level ${l}`} />
//                       <Bar dataKey="total" name="Commission" radius={[4, 4, 0, 0]}>
//                         {commissionByLevel.map((entry, i) => <Cell key={i} fill={PIE_COLORS[i % PIE_COLORS.length]} />)}
//                       </Bar>
//                     </BarChart>
//                   </ResponsiveContainer>
//                 </div>
//               </div>
//               <div className="table-scroll" style={{ background: "#fff", borderRadius: 8, border: "1px solid #e2e8f0", marginBottom: 16 }}>
//                 <table style={S.table}>
//                   <THead cols={["#", "Date & Time", "Level", "To Coupon", "To Member", "From Coupon", "From Member", "Amount"]} />
//                   <tbody>
//                     {commissions.length === 0 && (
//                       <tr><td colSpan={8} style={{ ...S.td, textAlign: "center", color: "#94a3b8", padding: 40 }}>No commission records found</td></tr>
//                     )}
//                     {commissions.map((c, i) => (
//                       <tr key={c.id} style={i % 2 === 0 ? S.trEven : {}}>
//                         <td style={S.td}>{i + 1}</td>
//                         <td style={{ ...S.td, fontSize: 11 }}>{fmtTime(c.created_at)}</td>
//                         <td style={S.td}>
//                           <span style={{ ...S.pill, background: PIE_COLORS[(c.level - 1) % PIE_COLORS.length], color: "#fff" }}>L{c.level}</span>
//                         </td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#1d4ed8" }}>{c.to_coupon || c.receiver_coupon_no}</td>
//                         <td style={S.td}>{c.to_name || c.receiver_name}</td>
//                         <td style={{ ...S.td, color: "#6366f1" }}>{c.from_coupon}</td>
//                         <td style={S.td}>{c.from_name}</td>
//                         <td style={{ ...S.td, fontWeight: 800, color: "#16a34a", fontSize: 13 }}>{inr(c.amount)}</td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}

//           {/* ══════════ DIRECT BUSINESS REPORT ══════════ */}
//           {subTab === "Direct Business Report" && (
//             <div>
//               <PageHead title="📊 Direct Business Report" />
//               <div className="table-scroll" style={{ background: "#fff", borderRadius: 8, border: "1px solid #e2e8f0", marginBottom: 16 }}>
//                 <table style={S.table}>
//                   <THead cols={["#", "Coupon", "Name", "Mobile", "Direct", "Indirect", "Total Team", "Direct Income", "Total Income"]} />
//                   <tbody>
//                     {[...allMembers].sort((a, b) => Number(b.direct_count) - Number(a.direct_count)).map((m, i) => (
//                       <tr key={m.id} style={i % 2 === 0 ? S.trEven : {}}>
//                         <td style={S.td}>{i + 1}</td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#1d4ed8", cursor: "pointer" }} onClick={() => openDetail(m)}>{m.receiver_coupon_no}</td>
//                         <td style={S.td}>{m.receiver_name}</td>
//                         <td style={S.td}>{m.receiver_mobile}</td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#1d4ed8" }}>{m.direct_count}</td>
//                         <td style={{ ...S.td, color: "#6366f1" }}>{m.indirect_count || 0}</td>
//                         <td style={S.td}>{Number(m.direct_count) + Number(m.indirect_count || 0)}</td>
//                         <td style={{ ...S.td, color: "#16a34a" }}>{inr(Number(m.direct_count) * LEVEL_RATE[1])}</td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#7c3aed" }}>{inr(m.total_income)}</td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}

//           {/* ══════════ BUSINESS REPORT ══════════ */}
//           {subTab === "Business Report" && (
//             <div>
//               <PageHead title="📈 Business Report — Full Company Overview & Profit Analysis" />
//               {(() => {
//                 const JOINING = 3000;
//                 const PRODUCT_COST = 1200;
//                 const MLM_PAYOUT = 750;
//                 const SALARY_AVG = 100;
//                 const REWARDS_AVG = 50;
//                 const TOTAL_EXPENSE = PRODUCT_COST + MLM_PAYOUT + SALARY_AVG + REWARDS_AVG;
//                 const PROFIT_PER = JOINING - TOTAL_EXPENSE;

//                 const totalMembers = allMembers.length;
//                 const activeMembers = allMembers.filter(m => m.is_approved).length;
//                 const totalCollection = activeMembers * JOINING;
//                 const totalMLMPaid = allMembers.reduce((s, m) => s + Number(m.total_income || 0), 0);
//                 const totalWithdrawn = allMembers.reduce((s, m) => s + Number(m.total_withdrawn || 0), 0);
//                 const estimatedProfit = activeMembers * PROFIT_PER;

//                 return (
//                   <div>
//                     <div className="kpi-grid">
//                       {[
//                         { label: "Total Members", val: totalMembers, icon: "👥", bg: "#1e3a8a" },
//                         { label: "Active Members", val: activeMembers, icon: "✅", bg: "#065f46" },
//                         { label: "Total Collection", val: inr(totalCollection), icon: "💼", bg: "#4c1d95" },
//                         { label: "MLM Paid Out", val: inr(totalMLMPaid), icon: "💰", bg: "#134e4a" },
//                         { label: "Total Withdrawn", val: inr(totalWithdrawn), icon: "🏦", bg: "#7f1d1d" },
//                         { label: "Est. Net Profit", val: inr(estimatedProfit), icon: "📈", bg: "#14532d" },
//                       ].map(c => (
//                         <div key={c.label} style={{ ...S.kpiCard, background: c.bg }}>
//                           <div style={{ fontSize: 22 }}>{c.icon}</div>
//                           <div style={{ fontSize: 16, fontWeight: 800 }}>{c.val}</div>
//                           <div style={{ fontSize: 10, opacity: .8 }}>{c.label}</div>
//                         </div>
//                       ))}
//                     </div>

//                     <div className="flex-wrap-row" style={{ marginBottom: 16 }}>
//                       {/* Left panel */}
//                       <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
//                         <div style={{ background: "linear-gradient(135deg,#1e3a8a,#1d4ed8)", borderRadius: 10, padding: "14px 18px", color: "#fff" }}>
//                           <div style={{ fontSize: 13, fontWeight: 800, marginBottom: 10, borderBottom: "1px solid rgba(255,255,255,.2)", paddingBottom: 8 }}>💸 COLLECTION (PER MEMBER)</div>
//                           <div style={{ display: "flex", justifyContent: "space-between", fontSize: 14 }}>
//                             <span>Joining Amount</span>
//                             <span style={{ fontWeight: 900, fontSize: 18, color: "#fbbf24" }}>= ₹{JOINING.toLocaleString()}</span>
//                           </div>
//                         </div>
//                         <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 10, overflow: "hidden" }}>
//                           <div style={{ background: "#dc2626", color: "#fff", padding: "10px 16px", fontWeight: 800, fontSize: 13 }}>🧾 COMPANY GIVES (PER PERSON)</div>
//                           <div style={{ padding: "12px 16px" }}>
//                             <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
//                               <thead><tr style={{ background: "#eff6ff" }}>
//                                 <th style={{ padding: "5px 10px", textAlign: "left", color: "#1d4ed8" }}>Item</th>
//                                 <th style={{ padding: "5px 10px", textAlign: "right", color: "#1d4ed8" }}>Amount</th>
//                               </tr></thead>
//                               <tbody>
//                                 {[["Product / Service", PRODUCT_COST], ...Object.entries(LEVEL_RATE).map(([l, r]) => [`Level ${l}`, r]), ["Salary (avg)", SALARY_AVG], ["Rewards (avg)", REWARDS_AVG]].map(([label, amt], i) => (
//                                   <tr key={label} style={{ background: i % 2 === 0 ? "#f8fafc" : "#fff" }}>
//                                     <td style={{ padding: "5px 10px" }}>{label}</td>
//                                     <td style={{ padding: "5px 10px", textAlign: "right", fontWeight: 700, color: "#16a34a" }}>₹{amt}</td>
//                                   </tr>
//                                 ))}
//                                 <tr style={{ background: "#f0fdf4", fontWeight: 800 }}>
//                                   <td style={{ padding: "6px 10px" }}>👉 Total</td>
//                                   <td style={{ padding: "6px 10px", textAlign: "right", color: "#15803d", fontSize: 14 }}>= ₹{TOTAL_EXPENSE}</td>
//                                 </tr>
//                               </tbody>
//                             </table>
//                           </div>
//                         </div>
//                       </div>

//                       {/* Right panel */}
//                       <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
//                         <div style={{ background: "linear-gradient(135deg,#14532d,#16a34a)", borderRadius: 10, padding: "20px", color: "#fff", textAlign: "center" }}>
//                           <div style={{ fontSize: 13, opacity: .9, marginBottom: 8 }}>💰 COMPANY PROFIT (PER PERSON)</div>
//                           <div style={{ fontSize: 36, fontWeight: 900, color: "#bbf7d0" }}>₹{PROFIT_PER.toLocaleString()}</div>
//                           <div style={{ fontSize: 12, opacity: .8, marginTop: 6 }}>NET PROFIT PER MEMBER</div>
//                         </div>
//                         <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 10, overflow: "hidden" }}>
//                           <div style={{ background: "#7c3aed", color: "#fff", padding: "10px 16px", fontWeight: 800, fontSize: 13 }}>📈 AT SCALE — PROFIT PROJECTIONS</div>
//                           <div style={{ padding: "12px 16px" }}>
//                             {[[activeMembers || 1, "Current members"], [1000, "1,000 members"], [10000, "10,000 members"], [100000, "1,00,000 members"]].map(([count, label], i) => {
//                               const profit = count * PROFIT_PER;
//                               const isActive = i === 0;
//                               return (
//                                 <div key={label} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 12px", borderRadius: 8, marginBottom: 6, background: isActive ? "#f0fdf4" : "#f8fafc", border: isActive ? "2px solid #16a34a" : "1px solid #e2e8f0" }}>
//                                   <div>
//                                     <div style={{ fontWeight: isActive ? 800 : 600, fontSize: 13, color: isActive ? "#15803d" : "#374151" }}>{isActive ? "🔴 " : ""}{label}</div>
//                                     <div style={{ fontSize: 11, color: "#94a3b8" }}>₹{PROFIT_PER} × {count.toLocaleString()}</div>
//                                   </div>
//                                   <div style={{ fontWeight: 900, fontSize: 15, color: isActive ? "#16a34a" : "#7c3aed" }}>
//                                     {profit >= 10000000 ? `₹${(profit / 10000000).toFixed(2)} Cr` : profit >= 100000 ? `₹${(profit / 100000).toFixed(1)} L` : `₹${profit.toLocaleString()}`}
//                                   </div>
//                                 </div>
//                               );
//                             })}
//                           </div>
//                         </div>
//                       </div>
//                     </div>

//                     <SectionTitle>📋 All Members Business Summary</SectionTitle>
//                     <div className="table-scroll" style={{ background: "#fff", borderRadius: 8, border: "1px solid #e2e8f0", marginBottom: 16 }}>
//                       <table style={S.table}>
//                         <THead cols={["#", "Coupon", "Name", "Mobile", "Rank", "Direct", "Team", "Income", "Withdrawn", "Balance", "Status"]} />
//                         <tbody>
//                           {[...allMembers].sort((a, b) => Number(b.total_income || 0) - Number(a.total_income || 0)).map((m, i) => (
//                             <tr key={m.id} style={i % 2 === 0 ? S.trEven : {}}>
//                               <td style={S.td}>{i + 1}</td>
//                               <td style={{ ...S.td, fontWeight: 700, color: "#1d4ed8", cursor: "pointer" }} onClick={() => openDetail(m)}>{m.receiver_coupon_no}</td>
//                               <td style={S.td}>{m.receiver_name}</td>
//                               <td style={S.td}>{m.receiver_mobile}</td>
//                               <td style={S.td}><span style={S.pill}>{m.rank || "member"}</span></td>
//                               <td style={{ ...S.td, fontWeight: 700 }}>{m.direct_count || 0}</td>
//                               <td style={S.td}>{Number(m.direct_count || 0) + Number(m.indirect_count || 0)}</td>
//                               <td style={{ ...S.td, fontWeight: 800, color: "#16a34a" }}>{inr(m.total_income)}</td>
//                               <td style={{ ...S.td, color: "#dc2626" }}>{inr(m.total_withdrawn)}</td>
//                               <td style={{ ...S.td, fontWeight: 700, color: "#7c3aed" }}>{inr(Number(m.total_income || 0) - Number(m.total_withdrawn || 0))}</td>
//                               <td style={S.td}><span style={m.is_approved ? S.greenBadge : S.yellowBadge}>{m.is_approved ? "Active" : "Pending"}</span></td>
//                             </tr>
//                           ))}
//                         </tbody>
//                       </table>
//                     </div>
//                   </div>
//                 );
//               })()}
//             </div>
//           )}

//           {/* ══════════ COMMISSION SUMMARY ══════════ */}
//           {subTab === "Commission Summary" && (
//             <div>
//               <PageHead title="📋 Commission Summary" />
//               <div className="level-cards">
//                 {[1, 2, 3, 4, 5, 6].map((l, i) => (
//                   <div key={l} style={{ background: PIE_COLORS[i], color: "#fff", borderRadius: 10, padding: "12px 14px", textAlign: "center" }}>
//                     <div style={{ fontSize: 10, opacity: 0.8 }}>L{l} (₹{LEVEL_RATE[l]}/join)</div>
//                     <div style={{ fontSize: 16, fontWeight: 800, marginTop: 4 }}>
//                       {inr(allMembers.reduce((s, m) => s + Number(m[`level${l}_income`] || 0), 0))}
//                     </div>
//                     <div style={{ fontSize: 10, opacity: 0.8, marginTop: 2 }}>
//                       {allMembers.filter(m => Number(m[`level${l}_income`]) > 0).length} earners
//                     </div>
//                   </div>
//                 ))}
//               </div>
//               {[1, 2, 3, 4, 5, 6].map((level) => (
//                 <div key={level}>
//                   <SectionTitle>🏆 Top 5 Earners — Level {level} (₹{LEVEL_RATE[level]}/join)</SectionTitle>
//                   <div className="table-scroll" style={{ background: "#fff", borderRadius: 8, border: "1px solid #e2e8f0", marginBottom: 16 }}>
//                     <table style={S.table}>
//                       <THead cols={["Rank", "Coupon", "Name", "Mobile", `L${level} Income`]} />
//                       <tbody>
//                         {[...allMembers].filter(m => Number(m[`level${level}_income`]) > 0)
//                           .sort((a, b) => Number(b[`level${level}_income`]) - Number(a[`level${level}_income`]))
//                           .slice(0, 5)
//                           .map((m, i) => (
//                             <tr key={m.id} style={i % 2 === 0 ? S.trEven : {}}>
//                               <td style={{ ...S.td, fontWeight: 800, color: i < 3 ? "#f59e0b" : "#64748b" }}>#{i + 1}</td>
//                               <td style={{ ...S.td, color: "#1d4ed8", fontWeight: 700, cursor: "pointer" }} onClick={() => openDetail(m)}>{m.receiver_coupon_no}</td>
//                               <td style={S.td}>{m.receiver_name}</td>
//                               <td style={S.td}>{m.receiver_mobile}</td>
//                               <td style={{ ...S.td, fontWeight: 800, color: "#16a34a", fontSize: 13 }}>{inr(m[`level${level}_income`])}</td>
//                             </tr>
//                           ))}
//                       </tbody>
//                     </table>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           )}

//           {/* ══════════ DAILY JOINS ══════════ */}
//           {subTab === "Daily Joins" && (
//             <div>
//               <PageHead title="📅 Daily Joins Report — Last 30 Days" />
//               {dailyJoins.length === 0 ? (
//                 <div style={{ textAlign: "center", padding: 60, color: "#94a3b8", background: "#f8fafc", borderRadius: 8, border: "2px dashed #e2e8f0" }}>
//                   <div style={{ fontSize: 40, marginBottom: 12 }}>📅</div>
//                   <div style={{ fontWeight: 700, fontSize: 15 }}>Loading or no join data for last 30 days</div>
//                   <button style={{ ...S.btn, background: "#1e3a8a", marginTop: 16 }} onClick={loadDailyJoins}>🔄 Reload</button>
//                 </div>
//               ) : (
//                 <>
//                   <div className="kpi-grid">
//                     {[
//                       { icon: "📅", label: "Total Joins", val: dailyJoins.reduce((s, d) => s + Number(d.count || 0), 0), bg: "#1e3a8a" },
//                       { icon: "✅", label: "Approved", val: dailyJoins.reduce((s, d) => s + Number(d.approved || 0), 0), bg: "#065f46" },
//                       { icon: "⏳", label: "Pending", val: dailyJoins.reduce((s, d) => s + Number(d.pending || 0), 0), bg: "#92400e" },
//                       { icon: "📈", label: "Avg / Day", val: dailyJoins.length > 0 ? Math.round(dailyJoins.reduce((s, d) => s + Number(d.count || 0), 0) / dailyJoins.length) : 0, bg: "#4c1d95" },
//                       { icon: "🏆", label: "Best Day", val: Math.max(...dailyJoins.map(d => Number(d.count || 0))), bg: "#134e4a" },
//                     ].map(c => (
//                       <div key={c.label} style={{ ...S.kpiCard, background: c.bg }}>
//                         <div style={{ fontSize: 22 }}>{c.icon}</div>
//                         <div style={{ fontSize: 18, fontWeight: 800 }}>{c.val}</div>
//                         <div style={{ fontSize: 10, opacity: .8 }}>{c.label}</div>
//                       </div>
//                     ))}
//                   </div>
//                   <div style={{ ...S.card, marginBottom: 16 }}>
//                     <CardHead>📈 Daily Registration Trend</CardHead>
//                     <div style={{ padding: 16 }}>
//                       <ResponsiveContainer width="100%" height={240}>
//                         <BarChart data={dailyJoins}>
//                           <XAxis dataKey="date" tick={{ fontSize: 9 }} />
//                           <YAxis tick={{ fontSize: 9 }} allowDecimals={false} />
//                           <Tooltip /><Legend />
//                           <Bar dataKey="approved" name="Approved" stackId="a" fill="#10b981" />
//                           <Bar dataKey="pending" name="Pending" stackId="a" fill="#f59e0b" radius={[4, 4, 0, 0]} />
//                         </BarChart>
//                       </ResponsiveContainer>
//                     </div>
//                   </div>
//                   <div className="table-scroll" style={{ background: "#fff", borderRadius: 8, border: "1px solid #e2e8f0", marginBottom: 16 }}>
//                     <table style={S.table}>
//                       <THead cols={["#", "Date", "Total", "Approved", "Pending", "Running Total", "Bar"]} />
//                       <tbody>
//                         {(() => {
//                           let running = 0;
//                           const maxCount = Math.max(...dailyJoins.map(d => Number(d.count || 0)), 1);
//                           return dailyJoins.map((d, i) => {
//                             running += Number(d.count || 0);
//                             const isMax = Number(d.count) === maxCount;
//                             return (
//                               <tr key={i} style={i % 2 === 0 ? S.trEven : {}}>
//                                 <td style={S.td}>{i + 1}</td>
//                                 <td style={{ ...S.td, fontWeight: 600 }}>{d.date}</td>
//                                 <td style={{ ...S.td, fontWeight: 800, color: isMax ? "#f59e0b" : "#1d4ed8", fontSize: 14 }}>{d.count} {isMax ? "🏆" : ""}</td>
//                                 <td style={{ ...S.td, color: "#16a34a", fontWeight: 700 }}>{d.approved || 0}</td>
//                                 <td style={{ ...S.td, color: "#f59e0b", fontWeight: 700 }}>{d.pending || 0}</td>
//                                 <td style={{ ...S.td, color: "#7c3aed" }}>{running}</td>
//                                 <td style={S.td}>
//                                   <div style={{ height: 10, borderRadius: 99, background: isMax ? "#f59e0b" : "#3b82f6", width: `${(Number(d.count) / maxCount) * 120}px`, minWidth: 4 }} />
//                                 </td>
//                               </tr>
//                             );
//                           });
//                         })()}
//                       </tbody>
//                     </table>
//                   </div>
//                 </>
//               )}
//             </div>
//           )}

//           {/* ══════════ NETWORK TREE ══════════ */}
//           {subTab === "Network Tree" && (
//             <div>
//               <PageHead title="🌳 Network Tree — Member Downline" />
//               <div style={{ ...S.card, marginBottom: 16 }}>
//                 <CardHead>Search Member Network</CardHead>
//                 <div style={{ padding: 16 }}>
//                   <div className="search-row">
//                     <input
//                       style={{ ...S.searchBox }}
//                       placeholder="Enter Coupon No (e.g. MR001)..."
//                       value={networkToken}
//                       onChange={e => setNetworkToken(e.target.value)}
//                       onKeyDown={e => e.key === "Enter" && loadNetworkTree(networkToken)}
//                     />
//                     <button style={{ ...S.btn, background: "#1e3a8a", padding: "9px 20px" }} onClick={() => loadNetworkTree(networkToken)}>
//                       🔍 Load Tree
//                     </button>
//                     {networkTree && (
//                       <button style={{ ...S.btn, background: "#64748b" }} onClick={() => { setNetworkTree(null); setNetworkToken(""); }}>
//                         ✕ Clear
//                       </button>
//                     )}
//                   </div>
//                   {networkTree && (
//                     <span style={{ ...S.countBadge, background: "#dcfce7", color: "#15803d" }}>
//                       Showing: <b>{networkTree.receiver_coupon_no || networkTree.token_number}</b>
//                     </span>
//                   )}
//                 </div>
//               </div>
//               {networkTree ? (
//                 <div style={{ ...S.card, padding: 12, maxHeight: 620, overflowY: "auto", overflowX: "auto" }}>
//                   <TreeNode node={networkTree} depth={0} />
//                 </div>
//               ) : (
//                 <div style={{ textAlign: "center", padding: 60, color: "#94a3b8", background: "#f8fafc", borderRadius: 8, border: "2px dashed #e2e8f0" }}>
//                   <div style={{ fontSize: 48, marginBottom: 12 }}>🌳</div>
//                   <div style={{ fontWeight: 700, fontSize: 16, marginBottom: 6 }}>Enter a coupon number above</div>
//                   <div style={{ fontSize: 12 }}>Tree shows downline up to 6 levels. Click any node to expand.</div>
//                 </div>
//               )}
//             </div>
//           )}

//           {/* ══════════ WITHDRAWAL REQUESTS ══════════ */}
//           {subTab === "Withdrawal Requests" && (
//             <div>
//               <PageHead title="💸 Withdrawal Requests — Pending">
//                 <span style={{ ...S.countBadge, background: "#fee2e2", color: "#991b1b", marginLeft: "auto" }}>
//                   {withdrawals.length} Pending
//                 </span>
//               </PageHead>
//               <div className="table-scroll" style={{ background: "#fff", borderRadius: 8, border: "1px solid #e2e8f0", marginBottom: 16 }}>
//                 <table style={S.table}>
//                   <THead cols={["#", "Coupon", "Member", "Mobile", "Amount", "Method", "Bank/UPI", "Requested", "Actions"]} />
//                   <tbody>
//                     {withdrawals.map((w, i) => (
//                       <tr key={w.id} style={i % 2 === 0 ? S.trEven : {}}>
//                         <td style={S.td}>{i + 1}</td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#1d4ed8" }}>{w.receiver_coupon_no}</td>
//                         <td style={S.td}>{w.receiver_name}</td>
//                         <td style={S.td}>{w.receiver_mobile}</td>
//                         <td style={{ ...S.td, fontWeight: 800, color: "#16a34a", fontSize: 13 }}>{inr(w.amount)}</td>
//                         <td style={S.td}>{w.method?.toUpperCase()}</td>
//                         <td style={{ ...S.td, fontSize: 11 }}>
//                           {w.method === "bank"
//                             ? <><b>{w.bank_name}</b><br />A/c: {w.account_number}<br />IFSC: {w.ifsc}</>
//                             : <><b>UPI:</b> {w.upi_id}</>}
//                         </td>
//                         <td style={{ ...S.td, fontSize: 11 }}>{fmtTime(w.created_at)}</td>
//                         <td style={S.td}>
//                           <div style={{ display: "flex", gap: 4, flexDirection: "column" }}>
//                             <button style={{ ...S.btn, background: "#16a34a", fontSize: 11 }} onClick={() => processWithdrawal(w.id, "approved", w)}>✅ Approve + 📱</button>
//                             <button style={{ ...S.btn, background: "#dc2626", fontSize: 11 }} onClick={() => processWithdrawal(w.id, "rejected", w)}>❌ Reject</button>
//                           </div>
//                         </td>
//                       </tr>
//                     ))}
//                     {withdrawals.length === 0 && (
//                       <tr><td colSpan={9} style={{ ...S.td, textAlign: "center", color: "#94a3b8", padding: 40 }}>🎉 No pending withdrawal requests!</td></tr>
//                     )}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}

//           {/* ══════════ PAYMENT HISTORY ══════════ */}
//           {subTab === "Payment History" && (
//             <div>
//               <PageHead title="📋 Payment History — All Payouts" />
//               <div className="level-cards">
//                 {[1, 2, 3, 4, 5, 6].map(l => (
//                   <div key={l} style={{ background: "#1e3a8a", color: "#fff", borderRadius: 8, padding: "10px 12px", textAlign: "center" }}>
//                     <div style={{ fontSize: 10, opacity: .7 }}>L{l} (₹{LEVEL_RATE[l]}/join)</div>
//                     <div style={{ fontSize: 14, fontWeight: 800 }}>
//                       {inr(allMembers.reduce((s, m) => s + Number(m[`level${l}_income`] || 0), 0))}
//                     </div>
//                   </div>
//                 ))}
//               </div>
//               <div className="table-scroll" style={{ background: "#fff", borderRadius: 8, border: "1px solid #e2e8f0", marginBottom: 16 }}>
//                 <table style={S.table}>
//                   <THead cols={["#", "Coupon", "Member", "Mobile", "Amount", "Method", "Status", "Processed", "Date", "WA"]} />
//                   <tbody>
//                     {payHistory.map((w, i) => (
//                       <tr key={w.id} style={i % 2 === 0 ? S.trEven : {}}>
//                         <td style={S.td}>{i + 1}</td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#1d4ed8" }}>{w.receiver_coupon_no}</td>
//                         <td style={S.td}>{w.receiver_name}</td>
//                         <td style={S.td}>{w.receiver_mobile}</td>
//                         <td style={{ ...S.td, fontWeight: 800, color: "#16a34a" }}>{inr(w.amount)}</td>
//                         <td style={S.td}>{w.method?.toUpperCase()}</td>
//                         <td style={S.td}><span style={w.status === "approved" ? S.greenBadge : w.status === "rejected" ? S.redBadge : S.yellowBadge}>{w.status}</span></td>
//                         <td style={{ ...S.td, fontSize: 11 }}>{w.processed_at ? fmt(w.processed_at) : "—"}</td>
//                         <td style={{ ...S.td, fontSize: 11 }}>{fmt(w.created_at)}</td>
//                         <td style={S.td}>
//                           <button style={{ ...S.btn, background: "#25D366", padding: "4px 8px" }}
//                             onClick={() => whatsapp(w.receiver_mobile, `💸 Namaste *${w.receiver_name}*!\n\nYour payout of *${inr(w.amount)}* is *${w.status.toUpperCase()}*.\n\n_${COMPANY}_\n${COMPANY_URL}`)}>
//                             📱
//                           </button>
//                         </td>
//                       </tr>
//                     ))}
//                     {payHistory.length === 0 && <tr><td colSpan={10} style={{ ...S.td, textAlign: "center", color: "#94a3b8", padding: 40 }}>No payment history</td></tr>}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}

//           {/* ══════════ ADD FUND TO MEMBER ══════════ */}
//           {subTab === "Add Fund to Member" && (
//             <div>
//               <PageHead title="➕ Add Fund to Member Wallet" />
//               <div style={{ ...S.card, maxWidth: 480 }}>
//                 <CardHead>Manually Add Amount</CardHead>
//                 <div style={{ padding: 20 }}>
//                   <p style={{ fontSize: 12, color: "#64748b", marginBottom: 16, padding: "10px 14px", background: "#fefce8", borderRadius: 8, border: "1px solid #fde68a" }}>
//                     ⚠️ Use this to record an amount received from a member. It will be credited directly to their wallet.
//                   </p>
//                   {[
//                     ["Member Token / Coupon No *", "token_number", "text", "Enter member token or coupon number"],
//                     ["Amount Received (₹) *", "amount", "number", "Enter amount"],
//                     ["Description *", "description", "text", "e.g. Cash received, Online payment ref #123"],
//                   ].map(([label, key, type, placeholder]) => (
//                     <div key={key} style={{ marginBottom: 14 }}>
//                       <label style={S.label}>{label}</label>
//                       <input style={S.input} type={type} placeholder={placeholder}
//                         value={addFundForm[key]} onChange={e => setAddFundForm({ ...addFundForm, [key]: e.target.value })} />
//                     </div>
//                   ))}
//                   <button style={{ ...S.btn, background: "#1e3a8a", width: "100%", padding: 12, fontSize: 14 }} onClick={addFund}>
//                     ➕ Credit to Member Wallet
//                   </button>
//                 </div>
//               </div>
//             </div>
//           )}

//           {/* ══════════ SALARY LIST ══════════ */}
//           {subTab === "Salary List" && (
//             <div>
//               <PageHead title="💰 Salary List" />
//               <div className="kpi-grid">
//                 {[
//                   { icon: "📋", label: "Total Records", val: salaries.length, bg: "#1e3a8a" },
//                   { icon: "✅", label: "Paid", val: salaries.filter(s => s.is_approved).length, bg: "#065f46" },
//                   { icon: "⏳", label: "Pending", val: salaries.filter(s => !s.is_approved).length, bg: "#92400e" },
//                   { icon: "💰", label: "Total Amount", val: inr(salaries.reduce((s, x) => s + Number(x.amount || 0), 0)), bg: "#4c1d95" },
//                 ].map(c => (
//                   <div key={c.label} style={{ ...S.kpiCard, background: c.bg }}>
//                     <div style={{ fontSize: 20 }}>{c.icon}</div>
//                     <div style={{ fontSize: 18, fontWeight: 800 }}>{c.val}</div>
//                     <div style={{ fontSize: 10, opacity: .8 }}>{c.label}</div>
//                   </div>
//                 ))}
//               </div>
//               <div className="table-scroll" style={{ background: "#fff", borderRadius: 8, border: "1px solid #e2e8f0", marginBottom: 16 }}>
//                 <table style={S.table}>
//                   <THead cols={["#", "Coupon", "Member", "Mobile", "Rank", "Amount", "Month", "Status", "Action"]} />
//                   <tbody>
//                     {salaries.map((s, i) => (
//                       <tr key={s.id} style={i % 2 === 0 ? S.trEven : {}}>
//                         <td style={S.td}>{i + 1}</td>
//                         <td style={{ ...S.td, fontWeight: 700 }}>{s.receiver_coupon_no || s.token_number}</td>
//                         <td style={S.td}>{s.receiver_name}</td>
//                         <td style={S.td}>{s.receiver_mobile}</td>
//                         <td style={S.td}><span style={{ ...S.pill, textTransform: "capitalize" }}>{s.rank}</span></td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#16a34a" }}>{inr(s.amount)}</td>
//                         <td style={S.td}>{s.month}</td>
//                         <td style={S.td}><span style={s.is_approved ? S.greenBadge : S.yellowBadge}>{s.is_approved ? "Paid ✅" : "Pending"}</span></td>
//                         <td style={S.td}>
//                           {!s.is_approved && (
//                             <button style={{ ...S.btn, background: "#16a34a", fontSize: 11 }} onClick={() => approveSalary(s.id, s)}>Approve + 📱</button>
//                           )}
//                           {s.is_approved && (
//                             <button style={{ ...S.btn, background: "#25D366", fontSize: 11 }}
//                               onClick={() => whatsapp(s.receiver_mobile, `💰 Namaste *${s.receiver_name}*!\n\nSalary of *${inr(s.amount)}* for ${s.month} credited ✅\n\n_${COMPANY}_`)}>
//                               📱 WA
//                             </button>
//                           )}
//                         </td>
//                       </tr>
//                     ))}
//                     {salaries.length === 0 && (
//                       <tr><td colSpan={9} style={{ ...S.td, textAlign: "center", color: "#94a3b8", padding: 40 }}>No records. Generate salary first.</td></tr>
//                     )}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}

//           {/* ══════════ GENERATE SALARY ══════════ */}
//           {subTab === "Generate Salary" && (
//             <div>
//               <PageHead title="💰 Generate Monthly Salary" />
//               <div className="flex-wrap-row">
//                 <div style={{ ...S.card, maxWidth: 520 }}>
//                   <CardHead>Salary Generation</CardHead>
//                   <div style={{ padding: 20 }}>
//                     <p style={{ fontSize: 12, color: "#64748b", marginBottom: 16, padding: "10px 14px", background: "#f0fdf4", borderRadius: 8, border: "1px solid #bbf7d0" }}>
//                       ℹ️ Generates salary records for all eligible members based on current rank.
//                     </p>
//                     <SectionTitle>Salary Rates by Rank</SectionTitle>
//                     {Object.entries(RANK_SALARY).map(([rank, amt]) => (
//                       <div key={rank} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 12px", borderBottom: "1px solid #f1f5f9", fontSize: 13 }}>
//                         <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
//                           <div style={{ width: 10, height: 10, borderRadius: "50%", background: rank === "diamond" ? "#06b6d4" : rank === "platinum" ? "#8b5cf6" : rank === "gold" ? "#f59e0b" : "#94a3b8" }} />
//                           <span style={{ textTransform: "capitalize", fontWeight: 600 }}>{rank}</span>
//                         </div>
//                         <span style={{ color: "#16a34a", fontWeight: 700 }}>{inr(amt)} / month</span>
//                       </div>
//                     ))}
//                     <div style={{ marginTop: 20 }}>
//                       <button
//                         style={{ ...S.btn, background: generatingSalary ? "#64748b" : "#1e3a8a", width: "100%", padding: 14, fontSize: 15 }}
//                         onClick={generateSalary} disabled={generatingSalary}
//                       >
//                         {generatingSalary ? "⏳ Generating..." : "🚀 Generate This Month's Salary"}
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//                 <div style={{ ...S.card }}>
//                   <CardHead>👥 Eligible Members Preview</CardHead>
//                   <div style={{ padding: "8px 0", maxHeight: 380, overflowY: "auto" }}>
//                     {Object.keys(RANK_SALARY).map(rank => {
//                       const eligible = allMembers.filter(m => m.rank === rank && m.is_approved);
//                       if (eligible.length === 0) return null;
//                       return (
//                         <div key={rank}>
//                           <div style={{ padding: "8px 16px", background: "#f8fafc", fontSize: 11, fontWeight: 700, color: "#475569", textTransform: "uppercase", letterSpacing: 1 }}>
//                             {rank} — {inr(RANK_SALARY[rank])}/mo × {eligible.length} = {inr(RANK_SALARY[rank] * eligible.length)}
//                           </div>
//                           {eligible.slice(0, 3).map(m => (
//                             <div key={m.id} style={{ padding: "6px 16px", borderBottom: "1px solid #f1f5f9", fontSize: 12, display: "flex", justifyContent: "space-between" }}>
//                               <span>{m.receiver_name}</span>
//                               <span style={{ color: "#16a34a", fontWeight: 700 }}>{inr(RANK_SALARY[rank])}</span>
//                             </div>
//                           ))}
//                           {eligible.length > 3 && <div style={{ padding: "4px 16px", fontSize: 11, color: "#94a3b8" }}>+{eligible.length - 3} more...</div>}
//                         </div>
//                       );
//                     })}
//                   </div>
//                 </div>
//               </div>
//             </div>
//           )}

//           {/* ══════════ ALL ADMINS ══════════ */}
//           {subTab === "All Admins" && (
//             <div>
//               <PageHead title="🛡 All Admins" />
//               <div className="table-scroll" style={{ background: "#fff", borderRadius: 8, border: "1px solid #e2e8f0", marginBottom: 16 }}>
//                 <table style={S.table}>
//                   <THead cols={["#", "Username", "Full Name", "Mobile", "Role", "Status", "Created"]} />
//                   <tbody>
//                     {adminList.map((a, i) => (
//                       <tr key={a.id} style={i % 2 === 0 ? S.trEven : {}}>
//                         <td style={S.td}>{i + 1}</td>
//                         <td style={{ ...S.td, fontWeight: 700 }}>{a.username}</td>
//                         <td style={S.td}>{a.full_name}</td>
//                         <td style={S.td}>{a.mobile}</td>
//                         <td style={S.td}><span style={a.role === "superadmin" ? S.greenBadge : S.pill}>{a.role}</span></td>
//                         <td style={S.td}><span style={a.is_active ? S.greenBadge : S.redBadge}>{a.is_active ? "Active" : "Inactive"}</span></td>
//                         <td style={{ ...S.td, fontSize: 11 }}>{fmt(a.created_at)}</td>
//                       </tr>
//                     ))}
//                     {adminList.length === 0 && <tr><td colSpan={7} style={{ ...S.td, textAlign: "center", color: "#94a3b8" }}>No admins</td></tr>}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}

//           {/* ══════════ CREATE ADMIN ══════════ */}
//           {subTab === "Create Admin" && (
//             <div>
//               <PageHead title="➕ Create New Admin" />
//               <div style={{ ...S.card, maxWidth: 480 }}>
//                 <CardHead>Admin Account Details</CardHead>
//                 <div style={{ padding: 20 }}>
//                   {[["Username *", "username", "text"], ["Password *", "password", "password"],
//                     ["Full Name", "full_name", "text"], ["Mobile", "mobile", "text"]].map(([label, key, type]) => (
//                     <div key={key} style={{ marginBottom: 14 }}>
//                       <label style={S.label}>{label}</label>
//                       <input style={S.input} type={type} value={newAdmin[key]}
//                         onChange={e => setNewAdmin({ ...newAdmin, [key]: e.target.value })} />
//                     </div>
//                   ))}
//                   <div style={{ marginBottom: 16 }}>
//                     <label style={S.label}>Role</label>
//                     <select style={S.input} value={newAdmin.role} onChange={e => setNewAdmin({ ...newAdmin, role: e.target.value })}>
//                       <option value="admin">Admin</option>
//                       <option value="superadmin">Super Admin</option>
//                     </select>
//                   </div>
//                   <button style={{ ...S.btn, background: "#1e3a8a", width: "100%", padding: 12 }} onClick={createAdmin}>
//                     Create Admin Account
//                   </button>
//                 </div>
//               </div>
//             </div>
//           )}

//           {tab !== "dashboard" && !subTab && (
//             <div style={{ padding: 60, textAlign: "center", color: "#94a3b8" }}>
//               Select a submenu item from the sidebar.
//             </div>
//           )}
//         </main>
//       </div>
//     </div>
//   );
// }

// /* ── Sub-components ── */
// function PageHead({ title, sub, children }) {
//   return (
//     <div className="page-head">
//       <div style={{ width: 4, height: 20, background: "#ea580c", borderRadius: 99, flexShrink: 0 }} />
//       <span style={{ fontWeight: 700, fontSize: 16, color: "#1e293b" }}>{title}</span>
//       {sub && <span style={{ fontSize: 11, color: "#94a3b8" }}>{sub}</span>}
//       {children}
//     </div>
//   );
// }
// function SectionTitle({ children }) {
//   return <div style={{ fontWeight: 700, fontSize: 13, color: "#1e3a8a", margin: "18px 0 8px", borderLeft: "4px solid #ea580c", paddingLeft: 10 }}>{children}</div>;
// }
// function CardHead({ children }) {
//   return <div style={{ background: "#1e3a8a", color: "#fff", padding: "10px 16px", fontWeight: 700, fontSize: 13 }}>{children}</div>;
// }
// function THead({ cols }) {
//   return (
//     <thead>
//       <tr style={{ background: "#1e3a8a", color: "#fff" }}>
//         {cols.map(c => <th key={c} style={{ padding: "10px 12px", textAlign: "left", fontSize: 11, fontWeight: 700, whiteSpace: "nowrap" }}>{c}</th>)}
//       </tr>
//     </thead>
//   );
// }
// function ActionBtn({ color, onClick, disabled, children }) {
//   return (
//     <button onClick={onClick} disabled={disabled}
//       style={{ background: color, color: "#fff", border: "none", padding: "6px 10px", borderRadius: 5, cursor: "pointer", fontSize: 13, fontWeight: 700, opacity: disabled ? .6 : 1, minHeight: 36, minWidth: 36 }}>
//       {children}
//     </button>
//   );
// }

// /* ── Styles ── */
// const S = {
//   shell: { display: "flex", flexDirection: "column", minHeight: "100vh", fontFamily: "'Segoe UI', system-ui, sans-serif", fontSize: 13, background: "#f1f5f9" },
//   topbar: { background: "linear-gradient(90deg,#1e3a8a 0%,#1e40af 100%)", color: "#fff", display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 16px", position: "sticky", top: 0, zIndex: 100, boxShadow: "0 2px 10px rgba(0,0,0,.3)" },
//   logoBadge: { width: 38, height: 38, borderRadius: 10, background: "linear-gradient(135deg,#f97316,#ea580c)", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 900, fontSize: 17, color: "#fff" },
//   superBadge: { background: "rgba(255,255,255,.15)", border: "1px solid rgba(255,255,255,.3)", borderRadius: 99, padding: "3px 12px", fontSize: 11, fontWeight: 700, color: "#fef3c7", letterSpacing: .5 },
//   logoutBtn: { background: "rgba(239,68,68,.85)", border: "none", color: "#fff", padding: "6px 14px", borderRadius: 6, cursor: "pointer", fontWeight: 600, fontSize: 12, whiteSpace: "nowrap" },
//   navItem: { color: "#bfdbfe", padding: "11px 16px", cursor: "pointer", display: "flex", alignItems: "center", fontSize: 13, borderBottom: "1px solid rgba(255,255,255,.06)", fontWeight: 500 },
//   navActive: { background: "#ea580c", color: "#fff" },
//   navSub: { color: "#93c5fd", padding: "9px 16px 9px 28px", cursor: "pointer", fontSize: 12, background: "rgba(0,0,0,.25)", borderBottom: "1px solid rgba(255,255,255,.04)" },
//   navSubActive: { background: "#ea580c", color: "#fff", fontWeight: 700 },
//   content: { flex: 1, padding: 16, overflowX: "hidden", minWidth: 0 },
//   kpiCard: { color: "#fff", borderRadius: 10, padding: "12px 14px", display: "flex", flexDirection: "column", gap: 4, boxShadow: "0 2px 8px rgba(0,0,0,.15)" },
//   card: { background: "#fff", border: "1px solid #e2e8f0", borderRadius: 8, overflow: "hidden", marginBottom: 16 },
//   table: { width: "100%", borderCollapse: "collapse" },
//   td: { padding: "9px 12px", fontSize: 12, borderBottom: "1px solid #f1f5f9", verticalAlign: "middle" },
//   trEven: { background: "#f8fafc" },
//   infoChip: { background: "#f0f9ff", border: "1px solid #bae6fd", borderRadius: 8, padding: "8px 12px" },
//   searchBox: { border: "1px solid #e2e8f0", borderRadius: 6, padding: "8px 12px", fontSize: 13, outline: "none", background: "#fff", width: "100%" },
//   countBadge: { background: "#eff6ff", color: "#1d4ed8", padding: "5px 12px", borderRadius: 99, fontWeight: 700, fontSize: 12, whiteSpace: "nowrap" },
//   pill: { background: "#eff6ff", color: "#1d4ed8", padding: "2px 8px", borderRadius: 99, fontSize: 11, fontWeight: 600 },
//   greenBadge: { background: "#dcfce7", color: "#15803d", padding: "2px 8px", borderRadius: 99, fontSize: 11, fontWeight: 700 },
//   yellowBadge: { background: "#fef9c3", color: "#854d0e", padding: "2px 8px", borderRadius: 99, fontSize: 11, fontWeight: 700 },
//   redBadge: { background: "#fee2e2", color: "#991b1b", padding: "2px 8px", borderRadius: 99, fontSize: 11, fontWeight: 700 },
//   badge: { padding: "2px 8px", borderRadius: 99, fontSize: 11, fontWeight: 600 },
//   label: { display: "block", fontSize: 12, color: "#475569", marginBottom: 4, fontWeight: 600 },
//   input: { border: "1px solid #e2e8f0", padding: "9px 12px", width: "100%", fontSize: 13, borderRadius: 6, outline: "none", boxSizing: "border-box" },
//   btn: { color: "#fff", border: "none", padding: "7px 14px", borderRadius: 6, cursor: "pointer", fontWeight: 600, fontSize: 13, display: "inline-flex", alignItems: "center", gap: 4 },
// };






// import { useState, useEffect, useCallback, useMemo } from "react";
// import { useNavigate } from "react-router-dom";
// import { useAuth } from "../context/AuthContext";
// import {
//   BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer,
//   PieChart, Pie, Cell, Legend, LineChart, Line
// } from "recharts";
// import api from "../api";
// import toast from "react-hot-toast";

// /* ─── Constants ─── */
// const LEVEL_RATE = { 1: 300, 2: 150, 3: 120, 4: 90, 5: 60, 6: 30 };
// const RANK_SALARY = { silver: 1000, gold: 3000, platinum: 7000, diamond: 15000 };
// const PIE_COLORS = ["#3b82f6", "#10b981", "#f59e0b", "#ef4444", "#8b5cf6", "#06b6d4"];
// const COMPANY = "Meruram Lucky Draw";
// const COMPANY_URL = "https://meruram.in";

// /* ─── WhatsApp helper ─── */
// const whatsapp = (mobile, msg) => {
//   if (!mobile) { toast.error("No mobile number!"); return; }
//   window.open(`https://wa.me/91${mobile.replace(/\D/g, "")}?text=${encodeURIComponent(msg)}`, "_blank");
// };

// /* ─── Format helpers ─── */
// const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
// const fmt = (d) => d ? new Date(d).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : "—";
// const fmtTime = (d) => d ? new Date(d).toLocaleString("en-IN") : "—";

// /* ─── Sidebar nav ─── */
// const NAV = [
//   { label: "📊 Dashboard", key: "dashboard" },
//   {
//     label: "🎟 Members", key: "members",
//     children: ["All Members", "Pending Approval", "Approved Members", "Member Detail"],
//   },
//   {
//     label: "💹 Income & Business", key: "income",
//     children: [
//       "Level Income Report",
//       "Level Wise Report",
//       "Commission Report",
//       "Direct Business Report",
//       "Business Report",
//       "Commission Summary",
//       "Daily Joins",
//       "Network Tree",
//     ],
//   },
//   {
//     label: "💸 Payments", key: "payments",
//     children: ["Withdrawal Requests", "Payment History", "Add Fund to Member"],
//   },
//   {
//     label: "💰 Salary", key: "salary",
//     children: ["Salary List", "Generate Salary"],
//   },
//   {
//     label: "🛡 Admin Mgmt", key: "admins",
//     children: ["All Admins", "Create Admin"],
//   },
//   {
//     label: "🖼 Gallery", key: "gallery",
//     children: ["Gallery Manager"],
//   },
// ];

// /* ══════════════════════════════════════════════
//    RESPONSIVE STYLES (injected once)
// ══════════════════════════════════════════════ */
// const GLOBAL_CSS = `
//   * { box-sizing: border-box; }
//   body { margin: 0; }

//   /* ── Scrollable table wrapper ── */
//   .table-scroll { overflow-x: auto; -webkit-overflow-scrolling: touch; }
//   .table-scroll table { min-width: 600px; }

//   /* ── Mobile sidebar overlay ── */
//   .sidebar-overlay {
//     display: none;
//     position: fixed; inset: 0;
//     background: rgba(0,0,0,.5);
//     z-index: 200;
//   }
//   .sidebar-overlay.open { display: block; }

//   /* ── Sidebar drawer ── */
//   .sidebar-drawer {
//     position: fixed;
//     top: 0; left: 0; bottom: 0;
//     width: 220px;
//     background: #1e3a8a;
//     z-index: 201;
//     overflow-y: auto;
//     transform: translateX(-100%);
//     transition: transform .25s ease;
//   }
//   .sidebar-drawer.open { transform: translateX(0); }

//   /* ── Hamburger button ── */
//   .hamburger {
//     display: none;
//     background: rgba(255,255,255,.15);
//     border: none;
//     color: #fff;
//     font-size: 20px;
//     padding: 6px 10px;
//     border-radius: 6px;
//     cursor: pointer;
//     line-height: 1;
//   }

//   /* ── Desktop sidebar ── */
//   .sidebar-desktop {
//     width: 205px;
//     background: #1e3a8a;
//     min-height: calc(100vh - 60px);
//     flex-shrink: 0;
//     overflow-y: auto;
//   }

//   /* ── KPI grid responsive ── */
//   .kpi-grid {
//     display: grid;
//     grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
//     gap: 10px;
//     margin-bottom: 16px;
//   }

//   /* ── Info chip grid ── */
//   .chip-grid {
//     display: flex;
//     flex-wrap: wrap;
//     gap: 10px;
//     margin-bottom: 16px;
//   }
//   .info-chip {
//     background: #f0f9ff;
//     border: 1px solid #bae6fd;
//     border-radius: 8px;
//     padding: 8px 12px;
//     min-width: 120px;
//     flex: 1 1 120px;
//     max-width: 200px;
//   }

//   /* ── Flex row that wraps on mobile ── */
//   .flex-wrap-row {
//     display: flex;
//     gap: 14px;
//     flex-wrap: wrap;
//   }
//   .flex-wrap-row > * { min-width: 260px; flex: 1; }

//   /* ── Action buttons in table ── */
//   .action-cell { display: flex; gap: 4px; flex-wrap: wrap; }

//   /* ── Search bar row ── */
//   .search-row {
//     display: flex;
//     gap: 10px;
//     margin-bottom: 12px;
//     flex-wrap: wrap;
//     align-items: center;
//   }
//   .search-row input { flex: 1; min-width: 200px; }

//   /* ── Page head ── */
//   .page-head {
//     display: flex;
//     align-items: center;
//     gap: 10px;
//     margin-bottom: 16px;
//     padding-bottom: 12px;
//     border-bottom: 2px solid #e2e8f0;
//     flex-wrap: wrap;
//   }

//   /* ── Card row wraps ── */
//   .card-row {
//     display: flex;
//     gap: 14px;
//     margin-top: 4px;
//     flex-wrap: wrap;
//   }
//   .card-row .chart-card { flex: 2; min-width: 260px; }
//   .card-row .dist-card  { flex: 1; min-width: 200px; }

//   /* ── Responsive topbar ── */
//   .topbar-left { display: flex; align-items: center; gap: 12px; }
//   .topbar-right { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }
//   .super-badge-hide { display: inline; }

//   /* ── Level cards row ── */
//   .level-cards {
//     display: flex;
//     gap: 8px;
//     margin-bottom: 16px;
//     flex-wrap: wrap;
//   }
//   .level-cards > div { min-width: 100px; flex: 1; }

//   /* ── Repair panel ── */
//   .repair-panel {
//     display: flex;
//     gap: 16px;
//     align-items: flex-start;
//     flex-wrap: wrap;
//   }
//   .repair-panel .repair-left  { flex: 1; min-width: 220px; }
//   .repair-panel .repair-right { display: flex; flex-direction: column; gap: 8px; min-width: 200px; }

//   /* ─────────── MOBILE BREAKPOINT ─────────── */
//   @media (max-width: 768px) {
//     .hamburger { display: block; }
//     .sidebar-desktop { display: none; }

//     .super-badge-hide { display: none; }

//     .kpi-grid {
//       grid-template-columns: repeat(2, 1fr);
//     }

//     .info-chip { max-width: 100%; }

//     .flex-wrap-row > * { min-width: 100%; }

//     .card-row .chart-card,
//     .card-row .dist-card { min-width: 100%; }

//     .level-cards > div { min-width: calc(50% - 8px); }

//     .repair-panel { flex-direction: column; }
//     .repair-panel .repair-right { min-width: 100%; }

//     /* Make table font smaller on mobile */
//     .table-scroll table { font-size: 11px; }
//     .table-scroll th, .table-scroll td { padding: 7px 8px !important; }
//   }

//   @media (max-width: 480px) {
//     .kpi-grid { grid-template-columns: repeat(2, 1fr); }
//     .level-cards > div { min-width: 100%; }
//     .topbar-right .logout-text { display: none; }
//     .gallery-grid { grid-template-columns: repeat(2, 1fr) !important; }
//   }
// `;

// function GlobalStyles() {
//   useEffect(() => {
//     const id = "sad-responsive-styles";
//     if (!document.getElementById(id)) {
//       const el = document.createElement("style");
//       el.id = id;
//       el.textContent = GLOBAL_CSS;
//       document.head.appendChild(el);
//     }
//     return () => {
//       const el = document.getElementById(id);
//       if (el) el.remove();
//     };
//   }, []);
//   return null;
// }

// /* ══════════════════════════════════════════════
//    SIDEBAR CONTENT (shared between desktop + mobile drawer)
// ══════════════════════════════════════════════ */
// function SidebarContent({ tab, subTab, openNav, setOpenNav, goTo, logout, navigate, onNavClick }) {
//   return (
//     <>
//       {NAV.map(n => (
//         <div key={n.key}>
//           <div
//             style={{ ...S.navItem, ...(tab === n.key && !subTab && !n.children ? S.navActive : {}) }}
//             onClick={() => {
//               if (n.children) {
//                 setOpenNav(p => ({ ...p, [n.key]: !p[n.key] }));
//               } else {
//                 goTo(n.key);
//                 onNavClick && onNavClick();
//               }
//             }}
//           >
//             <span style={{ flex: 1 }}>{n.label}</span>
//             {n.children && <span style={{ fontSize: 10, opacity: .6 }}>{openNav[n.key] ? "▾" : "▸"}</span>}
//           </div>
//           {n.children && openNav[n.key] && n.children
//             .filter(c => c !== "Member Detail")
//             .map(child => (
//               <div key={child}
//                 style={{ ...S.navSub, ...(subTab === child ? S.navSubActive : {}) }}
//                 onClick={() => { goTo(n.key, child); onNavClick && onNavClick(); }}
//               >{child}</div>
//             ))}
//         </div>
//       ))}
//       <div style={S.navItem} onClick={() => { logout(); navigate("/superadmin/login"); }}>
//         🚪 Logout
//       </div>
//     </>
//   );
// }

// /* ══════════════════════════════════════════════
//    MAIN COMPONENT
// ══════════════════════════════════════════════ */
// export default function SuperAdminDashboard() {
//   const { admin, logout } = useAuth();
//   const navigate = useNavigate();

//   /* State */
//   const [stats, setStats] = useState(null);
//   const [allMembers, setAllMembers] = useState([]);
//   const [withdrawals, setWithdrawals] = useState([]);
//   const [payHistory, setPayHistory] = useState([]);
//   const [salaries, setSalaries] = useState([]);
//   const [adminList, setAdminList] = useState([]);
//   const [selectedMember, setSelectedMember] = useState(null);
//   const [memberDetail, setMemberDetail] = useState(null);
//   const [loadingDetail, setLoadingDetail] = useState(false);
//   const [commissions, setCommissions] = useState([]);
//   const [networkTree, setNetworkTree] = useState(null);
//   const [networkToken, setNetworkToken] = useState("");
//   const [dailyJoins, setDailyJoins] = useState([]);
//   const [generatingSalary, setGeneratingSalary] = useState(false);
//   const [repairing, setRepairing] = useState(false);
//   const [repairLog, setRepairLog] = useState([]);

//   const [tab, setTab] = useState("dashboard");
//   const [subTab, setSubTab] = useState("");
//   const [openNav, setOpenNav] = useState({ dashboard: true });
//   const [search, setSearch] = useState("");
//   const [approving, setApproving] = useState({});
//   const [sidebarOpen, setSidebarOpen] = useState(false);

//   const [addFundForm, setAddFundForm] = useState({ token_number: "", amount: "", description: "Fund added by admin" });
//   const [newAdmin, setNewAdmin] = useState({ username: "", password: "", full_name: "", mobile: "", role: "admin" });

//   /* ── Gallery state ── */
//   const [gallery, setGallery] = useState([]);
//   const [galleryHeading, setGalleryHeading] = useState("");
//   const [galleryImage, setGalleryImage] = useState(null);
//   const [galleryEditingId, setGalleryEditingId] = useState(null);
//   const [galleryLoading, setGalleryLoading] = useState(false);

//   /* ── Fetch functions ── */
//   const loadStats = useCallback(async () => {
//     try { const r = await api.get("/mlm/super-stats"); setStats(r.data); } catch { toast.error("Stats load failed"); }
//   }, []);

//   const loadMembers = useCallback(async (q = "") => {
//     try {
//       const r = await api.get(`/coupons/all?search=${encodeURIComponent(q)}&limit=500`);
//       setAllMembers(r.data.rows || []);
//     } catch { toast.error("Members load failed"); }
//   }, []);

//   const loadWithdrawals = useCallback(async () => {
//     try { const r = await api.get("/wallet/withdrawals/all?status=pending"); setWithdrawals(r.data.rows || []); } catch {}
//   }, []);

//   const loadPayHistory = useCallback(async () => {
//     try { const r = await api.get("/mlm/payment-history"); setPayHistory(r.data.rows || []); } catch {}
//   }, []);

//   const loadSalaries = useCallback(async () => {
//     try { const r = await api.get("/mlm/salary/list"); setSalaries(r.data.rows || []); } catch {}
//   }, []);

//   const loadAdmins = useCallback(async () => {
//     try { const r = await api.get("/auth/admins"); setAdminList(r.data || []); } catch {}
//   }, []);

//   const GALLERY_BASE = "https://luckydraw.hoppersdome.com/api/gallery";
//   const GALLERY_IMG = "https://luckydraw.hoppersdome.com/uploads/gallery";

//   const loadGallery = useCallback(async () => {
//     try {
//       const r = await api.get("/gallery/all");
//       setGallery(r.data || []);
//     } catch { toast.error("Gallery load failed"); }
//   }, []);

//   const addGalleryItem = async () => {
//     if (!galleryImage) { toast.error("Please select an image"); return; }
//     setGalleryLoading(true);
//     try {
//       const fd = new FormData();
//       fd.append("heading", galleryHeading);
//       fd.append("image", galleryImage);
//       await api.post("/gallery/add", fd, { headers: { "Content-Type": "multipart/form-data" } });
//       toast.success("✅ Image added!");
//       setGalleryHeading(""); setGalleryImage(null);
//       document.getElementById("gallery-file-input").value = "";
//       loadGallery();
//     } catch (err) { toast.error(err.response?.data?.message || "Add failed"); }
//     setGalleryLoading(false);
//   };

//   const updateGalleryItem = async () => {
//     setGalleryLoading(true);
//     try {
//       const fd = new FormData();
//       fd.append("heading", galleryHeading);
//       if (galleryImage) fd.append("image", galleryImage);
//       await api.put(`/gallery/update/${galleryEditingId}`, fd, { headers: { "Content-Type": "multipart/form-data" } });
//       toast.success("✅ Updated!");
//       setGalleryHeading(""); setGalleryImage(null); setGalleryEditingId(null);
//       const el = document.getElementById("gallery-file-input");
//       if (el) el.value = "";
//       loadGallery();
//     } catch (err) { toast.error(err.response?.data?.message || "Update failed"); }
//     setGalleryLoading(false);
//   };

//   const deleteGalleryItem = async (id) => {
//     if (!window.confirm("Delete this image permanently?")) return;
//     try {
//       await api.delete(`/gallery/delete/${id}`);
//       toast.success("Deleted");
//       loadGallery();
//     } catch { toast.error("Delete failed"); }
//   };

//   const editGalleryItem = (g) => {
//     setGalleryEditingId(g.id);
//     setGalleryHeading(g.heading || "");
//     setGalleryImage(null);
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   };

//   const loadMemberDetail = useCallback(async (token) => {
//     if (!token) return;
//     setLoadingDetail(true);
//     try {
//       const r = await api.get(`/mlm/member-detail/${token}`);
//       if (r.data.success) {
//         setMemberDetail(r.data);
//       } else {
//         toast.error("Member not found");
//       }
//     } catch { toast.error("Failed to load member detail"); }
//     setLoadingDetail(false);
//   }, []);

//   const loadCommissions = useCallback(async () => {
//     try {
//       const r = await api.get("/mlm/commissions/all?limit=500");
//       setCommissions(r.data.rows || []);
//     } catch { toast.error("Commissions load failed"); }
//   }, []);

//   const loadDailyJoins = useCallback(async () => {
//     try {
//       const r = await api.get("/mlm/daily-joins?days=30");
//       setDailyJoins(r.data.rows || []);
//     } catch (e) { toast.error("Daily joins load failed"); }
//   }, []);

//   const loadNetworkTree = useCallback(async (token) => {
//     if (!token) { toast.error("Enter a token/coupon number"); return; }
//     try {
//       const r = await api.get(`/mlm/network-tree/${token}`);
//       if (r.data.success && r.data.token_number) {
//         setNetworkTree(r.data);
//       } else if (r.data.tree) {
//         setNetworkTree(r.data.tree);
//       } else {
//         toast.error("Member not found");
//       }
//     } catch { toast.error("Network tree load failed"); }
//   }, []);

//   useEffect(() => {
//     Promise.all([loadStats(), loadMembers(), loadWithdrawals()]);
//   }, []);

//   /* ── Navigation ── */
//   const goTo = useCallback((t, s = "") => {
//     setTab(t); setSubTab(s);
//     if (t === "admins") loadAdmins();
//     if (t === "gallery" || s === "Gallery Manager") loadGallery();
//     if (s === "Withdrawal Requests") loadWithdrawals();
//     if (s === "Payment History") loadPayHistory();
//     if (s === "Salary List" || s === "Generate Salary") loadSalaries();
//     if (s === "Commission Report") loadCommissions();
//     if (s === "Daily Joins") loadDailyJoins();
//     if (
//       s === "All Members" || s === "Pending Approval" || s === "Approved Members" ||
//       s === "Level Income Report" || s === "Level Wise Report" ||
//       s === "Direct Business Report" || s === "Business Report" ||
//       s === "Commission Summary" || s === "Commission Report"
//     ) loadMembers(search);
//   }, [search, loadAdmins, loadWithdrawals, loadPayHistory, loadSalaries, loadMembers, loadCommissions, loadDailyJoins]);

//   /* ── Actions ── */
//   const approveCoupon = async (id, row) => {
//     setApproving(p => ({ ...p, [id]: true }));
//     try {
//       await api.post(`/coupons/approve/${id}`);
//       toast.success("✅ Approved!");
//       await Promise.all([loadMembers(search), loadStats()]);
//       if (row?.receiver_mobile) {
//         const message = `Welcome ${row.receiver_name} 🎉\n\nYour ID ${row.receiver_coupon_no || ""} has been approved successfully.\n\nWelcome to Meruram family 🚀\n\n${COMPANY_URL}`;
//         window.open(`https://wa.me/91${row.receiver_mobile.replace(/\D/g, "")}?text=${encodeURIComponent(message)}`, "_blank");
//       }
//     } catch (err) { toast.error(err.response?.data?.message || "Error"); }
//     setApproving(p => ({ ...p, [id]: false }));
//   };

//   const deleteCoupon = async (id) => {
//     if (!window.confirm("Delete this coupon permanently?")) return;
//     try { await api.delete(`/coupons/delete/${id}`); toast.success("Deleted"); loadMembers(search); loadStats(); }
//     catch { toast.error("Delete failed"); }
//   };

//   const processWithdrawal = async (id, action, row) => {
//     try {
//       await api.put(`/wallet/withdrawals/${id}`, { action });
//       if (action === "approved") {
//         toast.success("✅ Approved! Sending WhatsApp...");
//         whatsapp(row.receiver_mobile,
//           `💸 Namaste *${row.receiver_name}*!\n\nYour withdrawal request of *${inr(row.amount)}* has been *APPROVED & PROCESSED* ✅\n\nPayment via: *${(row.method || "").toUpperCase()}*\n${row.method === "upi" ? `UPI: ${row.upi_id || "—"}` : `Bank: ${row.bank_name || "—"} | Acc: ${row.account_number || "—"}`}\n\n_${COMPANY}_\n${COMPANY_URL}`
//         );
//       } else {
//         toast.error("❌ Withdrawal rejected");
//       }
//       loadWithdrawals(); loadPayHistory(); loadStats();
//     } catch (err) { toast.error(err.response?.data?.message || "Error"); }
//   };

//   const approveSalary = async (id, row) => {
//     try {
//       await api.put(`/mlm/salary/approve/${id}`);
//       toast.success("Salary credited!");
//       if (row?.receiver_mobile) {
//         whatsapp(row.receiver_mobile,
//           `💰 Namaste *${row.receiver_name}*!\n\nYour *${row.rank?.toUpperCase()} Rank Salary* of *${inr(row.amount)}* for ${row.month} has been credited to your wallet ✅\n\n_${COMPANY}_\n${COMPANY_URL}`
//         );
//       }
//       loadSalaries();
//     } catch (err) { toast.error(err.response?.data?.message || "Error"); }
//   };

//   const generateSalary = async () => {
//     setGeneratingSalary(true);
//     try {
//       const r = await api.post("/mlm/salary/generate");
//       toast.success(r.data.message || "Salary generated!");
//       loadSalaries();
//       goTo("salary", "Salary List");
//     } catch (err) { toast.error(err.response?.data?.message || "Error"); }
//     setGeneratingSalary(false);
//   };

//   const runFullRepair = async () => {
//     if (!window.confirm(
//       "⚠️ This will:\n1. Fix referred_by for all members\n2. Redistribute missing commissions\n3. Recalculate all ranks\n\nSafe to run multiple times. Continue?"
//     )) return;

//     setRepairing(true);
//     setRepairLog([]);
//     const log = [];

//     try {
//       log.push("🔧 Step 1: Fixing referred_by links...");
//       setRepairLog([...log]);
//       const r1 = await api.post("/mlm/fix-referred-by");
//       log.push(`✅ Step 1 done: ${r1.data.fixed} members linked, ${r1.data.skipped} skipped`);
//       setRepairLog([...log]);

//       log.push("💰 Step 2: Redistributing commissions...");
//       setRepairLog([...log]);
//       const r2 = await api.post("/mlm/redistribute-commissions");
//       log.push(`✅ Step 2 done: commissions distributed for ${r2.data.processed} members`);
//       if (r2.data.errors?.length) log.push(`⚠️ ${r2.data.errors.length} errors (check server logs)`);
//       setRepairLog([...log]);

//       log.push("🏆 Step 3: Recalculating all ranks...");
//       setRepairLog([...log]);
//       const r3 = await api.post("/mlm/recalculate-all-ranks");
//       const rankSummary = Object.entries(r3.data.summary || {}).map(([rank, count]) => `${rank}: ${count}`).join(", ");
//       log.push(`✅ Step 3 done: ${r3.data.message} → ${rankSummary}`);
//       setRepairLog([...log]);

//       log.push("🎉 All repairs complete! Reloading data...");
//       setRepairLog([...log]);

//       await Promise.all([loadStats(), loadMembers()]);
//       toast.success("✅ Data repair complete!");
//     } catch (err) {
//       log.push(`❌ Error: ${err.response?.data?.message || err.message}`);
//       setRepairLog([...log]);
//       toast.error("Repair failed — check log");
//     }
//     setRepairing(false);
//   };

//   const addFund = async () => {
//     if (!addFundForm.token_number || !addFundForm.amount) { toast.error("Fill all fields"); return; }
//     try {
//       const r = await api.post("/mlm/add-fund", addFundForm);
//       toast.success(r.data.message);
//       setAddFundForm({ token_number: "", amount: "", description: "Fund added by admin" });
//       loadMembers(); loadStats();
//     } catch (err) { toast.error(err.response?.data?.message || "Error"); }
//   };

//   const createAdmin = async () => {
//     if (!newAdmin.username || !newAdmin.password) { toast.error("Username & password required"); return; }
//     try {
//       await api.post("/auth/create-admin", newAdmin);
//       toast.success("Admin created!");
//       setNewAdmin({ username: "", password: "", full_name: "", mobile: "", role: "admin" });
//       loadAdmins();
//     } catch (err) { toast.error(err.response?.data?.message || "Error"); }
//   };

//   const openDetail = async (row) => {
//     const tokenToLoad = row.token_number || row.token;
//     setSelectedMember(row);
//     setTab("members"); setSubTab("Member Detail");
//     await loadMemberDetail(tokenToLoad);
//   };

//   /* ── Filtered member lists ── */
//   const filteredMembers = useMemo(() => {
//     if (subTab === "Pending Approval") return allMembers.filter(c => !c.is_approved);
//     if (subTab === "Approved Members") return allMembers.filter(c => c.is_approved);
//     return allMembers;
//   }, [allMembers, subTab]);

//   const topByIncome = useMemo(() =>
//     [...allMembers].sort((a, b) => Number(b.total_income || 0) - Number(a.total_income || 0)).slice(0, 10),
//     [allMembers]
//   );

//   const topByDirect = useMemo(() =>
//     [...allMembers].sort((a, b) => Number(b.direct_count || 0) - Number(a.direct_count || 0)).slice(0, 10),
//     [allMembers]
//   );

//   const levelSummary = useMemo(() => {
//     const map = {};
//     allMembers.forEach(m => {
//       for (let l = 1; l <= 6; l++) {
//         const earned = Number(m[`level${l}_income`] || 0);
//         if (!map[l]) map[l] = { level: l, total: 0, members_paid: 0, rate: LEVEL_RATE[l] };
//         if (earned > 0) { map[l].total += earned; map[l].members_paid++; }
//       }
//     });
//     return Object.values(map);
//   }, [allMembers]);

//   const commissionByLevel = useMemo(() => {
//     const map = {};
//     commissions.forEach(c => {
//       const l = c.level;
//       if (!map[l]) map[l] = { level: l, count: 0, total: 0 };
//       map[l].count++;
//       map[l].total += Number(c.amount || 0);
//     });
//     return Object.values(map).sort((a, b) => a.level - b.level);
//   }, [commissions]);

//   /* ── Network Tree recursive renderer ── */
//   const TreeNode = ({ node, depth = 0 }) => {
//     const [expanded, setExpanded] = useState(depth < 2);
//     if (!node) return null;
//     const hasChildren = node.children && node.children.length > 0;
//     return (
//       <div style={{ marginLeft: depth * 16, marginBottom: 4 }}>
//         <div
//           style={{
//             display: "flex", alignItems: "center", gap: 6, padding: "8px 10px",
//             background: depth === 0 ? "#1e3a8a" : depth === 1 ? "#1d4ed8" : depth === 2 ? "#3b82f6" : "#eff6ff",
//             color: depth < 3 ? "#fff" : "#1e3a8a",
//             borderRadius: 8, cursor: hasChildren ? "pointer" : "default",
//             border: "1px solid rgba(255,255,255,0.1)",
//             flexWrap: "wrap",
//             minHeight: 44,
//           }}
//           onClick={() => hasChildren && setExpanded(e => !e)}
//         >
//           {hasChildren && <span style={{ fontSize: 10, minWidth: 12 }}>{expanded ? "▼" : "▶"}</span>}
//           {!hasChildren && <span style={{ fontSize: 10, minWidth: 12, opacity: 0.5 }}>●</span>}
//           <span style={{ fontWeight: 700, fontSize: 12 }}>{node.receiver_coupon_no || node.token_number}</span>
//           <span style={{ fontSize: 12 }}>{node.receiver_name}</span>
//           <span style={{ fontSize: 11, opacity: 0.75 }}>{node.receiver_mobile}</span>
//           {hasChildren && (
//             <span style={{ marginLeft: "auto", background: "rgba(255,255,255,0.2)", borderRadius: 99, padding: "1px 8px", fontSize: 11 }}>
//               {node.children.length} direct
//             </span>
//           )}
//           <span style={{
//             background: node.is_approved ? "#16a34a" : "#f59e0b",
//             borderRadius: 99, padding: "1px 8px", fontSize: 10, color: "#fff"
//           }}>
//             {node.is_approved ? "Active" : "Pending"}
//           </span>
//         </div>
//         {expanded && hasChildren && (
//           <div style={{ borderLeft: "2px solid #bfdbfe", marginLeft: 14, paddingLeft: 6, marginTop: 4 }}>
//             {node.children.map(child => (
//               <TreeNode key={child.id || child.token_number} node={child} depth={depth + 1} />
//             ))}
//           </div>
//         )}
//       </div>
//     );
//   };

//   /* ─────────────── RENDER ─────────────── */
//   return (
//     <div style={S.shell}>
//       <GlobalStyles />

//       {/* ══ MOBILE SIDEBAR OVERLAY ══ */}
//       <div className={`sidebar-overlay${sidebarOpen ? " open" : ""}`} onClick={() => setSidebarOpen(false)} />
//       <nav className={`sidebar-drawer${sidebarOpen ? " open" : ""}`}>
//         <div style={{ padding: "14px 16px", borderBottom: "1px solid rgba(255,255,255,.15)", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
//           <div style={{ fontWeight: 800, color: "#fff", fontSize: 14 }}>MERURAM</div>
//           <button onClick={() => setSidebarOpen(false)} style={{ background: "none", border: "none", color: "#93c5fd", fontSize: 20, cursor: "pointer" }}>✕</button>
//         </div>
//         <SidebarContent
//           tab={tab} subTab={subTab} openNav={openNav} setOpenNav={setOpenNav}
//           goTo={goTo} logout={logout} navigate={navigate}
//           onNavClick={() => setSidebarOpen(false)}
//         />
//       </nav>

//       {/* ══ TOP BAR ══ */}
//       <header style={S.topbar}>
//         <div className="topbar-left">
//           <button className="hamburger" onClick={() => setSidebarOpen(true)}>☰</button>
//           <div style={S.logoBadge}>मे</div>
//           <div>
//             <div style={{ fontWeight: 800, fontSize: 15, letterSpacing: .5, color: "#fff" }}>MERURAM</div>
//             <div style={{ fontSize: 9, color: "#93c5fd", letterSpacing: 3 }}>SUPER ADMIN</div>
//           </div>
//         </div>
//         <div className="topbar-right">
//           <span className="super-badge-hide" style={S.superBadge}>👑 SUPER ADMIN</span>
//           <span style={{ fontSize: 12, color: "#ddd" }}>{admin?.full_name || admin?.username}</span>
//           <button style={S.logoutBtn} onClick={() => { logout(); navigate("/superadmin/login"); }}>
//             <span className="logout-text">Logout</span>
//             <span style={{ display: "none" }} className="logout-icon">🚪</span>
//           </button>
//         </div>
//       </header>

//       <div style={{ display: "flex", flex: 1 }}>
//         {/* ══ DESKTOP SIDEBAR ══ */}
//         <nav className="sidebar-desktop">
//           <SidebarContent
//             tab={tab} subTab={subTab} openNav={openNav} setOpenNav={setOpenNav}
//             goTo={goTo} logout={logout} navigate={navigate}
//           />
//         </nav>

//         {/* ══ MAIN CONTENT ══ */}
//         <main style={S.content}>

//           {/* ══════════ DASHBOARD ══════════ */}
//           {tab === "dashboard" && stats && (
//             <div>
//               <div className="page-head">
//                 <div style={{ width: 4, height: 20, background: "#ea580c", borderRadius: 99 }} />
//                 <span style={{ fontWeight: 700, fontSize: 16, color: "#1e293b" }}>Dashboard Overview</span>
//                 <span style={{ fontSize: 11, color: "#94a3b8" }}>{COMPANY_URL}</span>
//               </div>

//               {/* KPI Grid */}
//               <div className="kpi-grid">
//                 {[
//                   { label: "Total Coupons", val: stats.total_members, icon: "🎟", bg: "#1e40af" },
//                   { label: "Approved", val: stats.approved, icon: "✅", bg: "#065f46" },
//                   { label: "Pending", val: stats.pending, icon: "⏳", bg: "#92400e" },
//                   { label: "Pending Payouts", val: stats.pending_payouts, icon: "💸", bg: "#7f1d1d" },
//                   { label: "Total Wallet", val: inr(stats.total_wallet), icon: "💰", bg: "#4c1d95" },
//                   { label: "Commission Paid", val: inr(stats.total_commission), icon: "📈", bg: "#134e4a" },
//                   { label: "Payout Done", val: inr(stats.total_payout_done), icon: "🏦", bg: "#1e1b4b" },
//                   { label: "Pending Salary", val: stats.pending_salary, icon: "📋", bg: "#701a75" },
//                 ].map(c => (
//                   <div key={c.label} style={{ ...S.kpiCard, background: c.bg }}>
//                     <div style={{ fontSize: 22 }}>{c.icon}</div>
//                     <div style={{ fontSize: 18, fontWeight: 800 }}>{c.val}</div>
//                     <div style={{ fontSize: 10, opacity: .8 }}>{c.label}</div>
//                   </div>
//                 ))}
//               </div>

//               {/* ── DATA REPAIR PANEL ── */}
//               <div style={{
//                 background: "linear-gradient(135deg, #1e1b4b 0%, #312e81 100%)",
//                 borderRadius: 12, padding: "16px 20px", marginBottom: 16,
//                 border: "1px solid #4338ca",
//               }}>
//                 <div className="repair-panel">
//                   <div className="repair-left">
//                     <div style={{ fontWeight: 800, color: "#c7d2fe", fontSize: 13, marginBottom: 4 }}>
//                       🔧 Data Repair Tool
//                     </div>
//                     <div style={{ fontSize: 11, color: "#a5b4fc", lineHeight: 1.6 }}>
//                       Run once if members, commissions or ranks are showing blank/zero.
//                       Fixes <code style={{ background: "#1e1b4b", padding: "1px 4px", borderRadius: 3 }}>referred_by</code>,
//                       redistributes missing commissions, recalculates all ranks.
//                     </div>
//                   </div>
//                   <div className="repair-right">
//                     <button
//                       style={{
//                         background: repairing ? "#4338ca" : "#6366f1",
//                         color: "#fff", border: "none", borderRadius: 8,
//                         padding: "10px 20px", fontWeight: 700, fontSize: 13,
//                         cursor: repairing ? "not-allowed" : "pointer",
//                         opacity: repairing ? 0.7 : 1,
//                       }}
//                       onClick={runFullRepair}
//                       disabled={repairing}
//                     >
//                       {repairing ? "⏳ Repairing..." : "🚀 Run Full Data Repair"}
//                     </button>
//                     {repairLog.length > 0 && (
//                       <div style={{
//                         background: "#0f172a", borderRadius: 8, padding: "10px 12px",
//                         fontSize: 11, fontFamily: "monospace", lineHeight: 1.8,
//                         maxHeight: 160, overflowY: "auto", border: "1px solid #334155"
//                       }}>
//                         {repairLog.map((line, i) => (
//                           <div key={i} style={{
//                             color: line.startsWith("✅") ? "#4ade80"
//                                  : line.startsWith("❌") ? "#f87171"
//                                  : line.startsWith("⚠️") ? "#fbbf24"
//                                  : line.startsWith("🎉") ? "#818cf8"
//                                  : "#94a3b8"
//                           }}>{line}</div>
//                         ))}
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               </div>

//               {/* Company-wide Level Summary */}
//               <SectionTitle>💹 Company-wide Level Commission Summary</SectionTitle>
//               <div className="table-scroll" style={{ background: "#fff", borderRadius: 8, border: "1px solid #e2e8f0", marginBottom: 16 }}>
//                 <table style={S.table}>
//                   <THead cols={["Level", "Rate/Join", "Members Benefiting", "Total Paid Out", "Chart"]} />
//                   <tbody>
//                     {levelSummary.map((l, i) => (
//                       <tr key={l.level} style={i % 2 === 0 ? S.trEven : {}}>
//                         <td style={S.td}><b>Level {l.level}</b></td>
//                         <td style={S.td}>₹{l.rate}</td>
//                         <td style={S.td}>{l.members_paid}</td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#16a34a" }}>{inr(l.total)}</td>
//                         <td style={S.td}>
//                           <div style={{ width: Math.min((l.total / (stats.total_commission || 1)) * 200, 140), height: 8, background: PIE_COLORS[i % PIE_COLORS.length], borderRadius: 99 }} />
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>

//               {/* Charts Row */}
//               <div className="card-row">
//                 <div style={{ ...S.card }} className="chart-card">
//                   <CardHead>📅 Daily Registrations (14 days)</CardHead>
//                   <div style={{ padding: 16 }}>
//                     <ResponsiveContainer width="100%" height={180}>
//                       <BarChart data={stats.daily_joins || []}>
//                         <XAxis dataKey="date" tick={{ fontSize: 9 }} />
//                         <YAxis tick={{ fontSize: 9 }} />
//                         <Tooltip />
//                         <Bar dataKey="count" fill="#3b82f6" radius={[3, 3, 0, 0]} name="Joins" />
//                       </BarChart>
//                     </ResponsiveContainer>
//                   </div>
//                 </div>
//                 <div style={{ ...S.card }} className="dist-card">
//                   <CardHead>🏆 Rank Distribution</CardHead>
//                   <div style={{ padding: "8px 0" }}>
//                     {(stats.rank_dist || []).map((r, i) => (
//                       <div key={r.rank} style={{ display: "flex", justifyContent: "space-between", padding: "8px 16px", borderBottom: "1px solid #f1f5f9", alignItems: "center" }}>
//                         <span style={{ fontSize: 12, textTransform: "capitalize", fontWeight: 600 }}>{r.rank}</span>
//                         <span style={{ ...S.badge, background: PIE_COLORS[i % PIE_COLORS.length], color: "#fff" }}>{r.count}</span>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               </div>

//               {/* Top 10 by Income */}
//               <SectionTitle>🥇 Top 10 Members by Total Income</SectionTitle>
//               <div className="table-scroll" style={{ background: "#fff", borderRadius: 8, border: "1px solid #e2e8f0", marginBottom: 16 }}>
//                 <table style={S.table}>
//                   <THead cols={["Rank", "Coupon", "Name", "Direct", "L1", "L2", "L3", "L4", "L5", "L6", "Total Income"]} />
//                   <tbody>
//                     {topByIncome.map((m, i) => (
//                       <tr key={m.id} style={i % 2 === 0 ? S.trEven : {}}>
//                         <td style={{ ...S.td, fontWeight: 800, color: i < 3 ? "#f59e0b" : "#64748b" }}>#{i + 1}</td>
//                         <td style={{ ...S.td, color: "#1d4ed8", fontWeight: 700, cursor: "pointer" }} onClick={() => openDetail(m)}>
//                           {m.receiver_coupon_no}
//                         </td>
//                         <td style={S.td}>{m.receiver_name}</td>
//                         <td style={S.td}>{m.direct_count}</td>
//                         {[1, 2, 3, 4, 5, 6].map(l => (
//                           <td key={l} style={{ ...S.td, fontSize: 11, color: m[`level${l}_income`] > 0 ? "#16a34a" : "#ccc" }}>
//                             {m[`level${l}_income`] > 0 ? inr(m[`level${l}_income`]) : "—"}
//                           </td>
//                         ))}
//                         <td style={{ ...S.td, fontWeight: 800, color: "#7c3aed" }}>{inr(m.total_income)}</td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>

//               {/* Top 10 by Direct */}
//               <SectionTitle>👥 Top 10 Members by Direct Connections</SectionTitle>
//               <div className="table-scroll" style={{ background: "#fff", borderRadius: 8, border: "1px solid #e2e8f0", marginBottom: 16 }}>
//                 <table style={S.table}>
//                   <THead cols={["Rank", "Coupon", "Name", "Mobile", "Direct", "Total Team", "Total Business"]} />
//                   <tbody>
//                     {topByDirect.map((m, i) => (
//                       <tr key={m.id} style={i % 2 === 0 ? S.trEven : {}}>
//                         <td style={{ ...S.td, fontWeight: 800, color: i < 3 ? "#f59e0b" : "#64748b" }}>#{i + 1}</td>
//                         <td style={{ ...S.td, color: "#1d4ed8", fontWeight: 700, cursor: "pointer" }} onClick={() => openDetail(m)}>
//                           {m.receiver_coupon_no}
//                         </td>
//                         <td style={S.td}>{m.receiver_name}</td>
//                         <td style={S.td}>{m.receiver_mobile}</td>
//                         <td style={{ ...S.td, fontWeight: 700 }}>{m.direct_count}</td>
//                         <td style={S.td}>{Number(m.direct_count || 0) + Number(m.indirect_count || 0)}</td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#16a34a" }}>{inr(m.total_income)}</td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}

//           {/* ══════════ ALL MEMBERS ══════════ */}
//           {(subTab === "All Members" || subTab === "Pending Approval" || subTab === "Approved Members") && (
//             <div>
//               <PageHead title={`🎟 ${subTab}`} />
//               <div className="search-row">
//                 <input style={S.searchBox}
//                   placeholder="🔍 Search name, mobile, coupon..."
//                   value={search}
//                   onChange={e => { setSearch(e.target.value); loadMembers(e.target.value); }}
//                 />
//                 <span style={S.countBadge}>Total: {filteredMembers.length}</span>
//                 <span style={{ ...S.countBadge, background: "#dcfce7", color: "#15803d" }}>
//                   Active: {filteredMembers.filter(m => m.is_approved).length}
//                 </span>
//                 <span style={{ ...S.countBadge, background: "#fef9c3", color: "#854d0e" }}>
//                   Pending: {filteredMembers.filter(m => !m.is_approved).length}
//                 </span>
//               </div>
//               <div className="table-scroll" style={{ background: "#fff", borderRadius: 8, border: "1px solid #e2e8f0", marginBottom: 16 }}>
//                 <table style={S.table}>
//                   <THead cols={[
//                     "#", "Coupon", "Name", "Mobile", "Aadhaar", "Giver",
//                     "Payment", "Screenshot", "Wallet", "Rank", "Status", "Date", "Actions"
//                   ]} />
//                   <tbody>
//                     {filteredMembers.map((c, i) => (
//                       <tr key={c.id} style={i % 2 === 0 ? S.trEven : {}}>
//                         <td style={S.td}>{i + 1}</td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#1d4ed8", cursor: "pointer" }}
//                           onClick={() => openDetail(c)}>
//                           {c.receiver_coupon_no || "—"}
//                         </td>
//                         <td style={S.td}>{c.receiver_name}</td>
//                         <td style={S.td}>{c.receiver_mobile}</td>
//                         <td style={{ ...S.td, fontSize: 11 }}>
//                           {c.receiver_aadhaar ? "••••" + String(c.receiver_aadhaar).slice(-4) : "—"}
//                         </td>
//                         <td style={S.td}>{c.giver_name || "—"}</td>
//                         <td style={S.td}>
//                           <span style={S.pill}>{c.payment_cash ? "Cash" : "Online"}</span>
//                         </td>
//                         <td style={S.td}>
//                           {c.screenshot
//                             ? <a href={`/uploads/${c.screenshot}`} target="_blank" rel="noreferrer"
//                                 style={{ color: "#1d4ed8", fontWeight: 600, fontSize: 11 }}>View 📷</a>
//                             : "—"}
//                         </td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#7c3aed" }}>{inr(c.wallet_balance)}</td>
//                         <td style={S.td}><span style={S.pill}>{c.rank || "member"}</span></td>
//                         <td style={S.td}>
//                           <span style={c.is_approved ? S.greenBadge : S.yellowBadge}>
//                             {c.is_approved ? "Active" : "Pending"}
//                           </span>
//                         </td>
//                         <td style={{ ...S.td, fontSize: 11 }}>{fmt(c.created_at)}</td>
//                         <td style={S.td}>
//                           <div className="action-cell">
//                             {!c.is_approved && (
//                               <ActionBtn color="#16a34a" disabled={approving[c.id]}
//                                 onClick={() => approveCoupon(c.id, c)}>
//                                 {approving[c.id] ? "..." : "✅"}
//                               </ActionBtn>
//                             )}
//                             <ActionBtn color="#1d4ed8" onClick={() => openDetail(c)}>👁</ActionBtn>
//                             <ActionBtn color="#25D366" onClick={() =>
//                               whatsapp(c.receiver_mobile,
//                                 `Namaste *${c.receiver_name}*! Your coupon status: ${c.is_approved ? "Active ✅" : "Pending ⏳"}. Visit ${COMPANY_URL}`)
//                             }>📱</ActionBtn>
//                             <ActionBtn color="#dc2626" onClick={() => deleteCoupon(c.id)}>🗑</ActionBtn>
//                           </div>
//                         </td>
//                       </tr>
//                     ))}
//                     {filteredMembers.length === 0 && (
//                       <tr><td colSpan={13} style={{ ...S.td, textAlign: "center", color: "#94a3b8", padding: 40 }}>
//                         No records found
//                       </td></tr>
//                     )}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}

//           {/* ══════════ MEMBER DETAIL ══════════ */}
//           {subTab === "Member Detail" && (
//             <div>
//               <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16, flexWrap: "wrap", gap: 8 }}>
//                 <PageHead title={`👤 Member Detail${memberDetail ? " — " + memberDetail.member?.receiver_name : ""}`} />
//                 <button style={{ ...S.btn, background: "#64748b" }} onClick={() => goTo("members", "All Members")}>← Back</button>
//               </div>

//               {loadingDetail && <div style={{ textAlign: "center", padding: 48, color: "#94a3b8" }}>Loading...</div>}

//               {!loadingDetail && memberDetail && (() => {
//                 const m = memberDetail.member;
//                 const levelBreakdown = memberDetail.level_breakdown || [];
//                 const direct = memberDetail.direct || [];
//                 const memberCommissions = memberDetail.commissions || [];
//                 const wdrawals = memberDetail.withdrawals || [];
//                 const totalEarned = levelBreakdown.reduce((s, l) => s + Number(l.total || 0), 0);
//                 const referralLink = m.reference_token ? `${COMPANY_URL}/register/${m.reference_token}` : null;

//                 return (
//                   <div>
//                     {/* ── Info Chips ── */}
//                     <div className="chip-grid">
//                       {[
//                         ["Coupon No", m.receiver_coupon_no],
//                         ["Name", m.receiver_name],
//                         ["Mobile", m.receiver_mobile],
//                         ["Aadhaar", m.receiver_aadhaar || "—"],
//                         ["Address", m.receiver_address || "—"],
//                         ["Rank", m.rank?.toUpperCase()],
//                         ["Wallet Balance", inr(m.wallet_balance)],
//                         ["Direct Members", direct.length],
//                         ["Total Team", memberDetail.total_team],
//                         ["Total Earned", inr(totalEarned)],
//                         ["Joined", fmt(m.created_at)],
//                         ["Status", m.is_approved ? "Active ✅" : "Pending ⏳"],
//                       ].map(([k, v]) => (
//                         <div key={k} className="info-chip">
//                           <div style={{ fontSize: 10, color: "#64748b" }}>{k}</div>
//                           <div style={{ fontWeight: 700, wordBreak: "break-all" }}>{v}</div>
//                         </div>
//                       ))}
//                     </div>

//                     {/* ── Referral Link Box ── */}
//                     {referralLink && (
//                       <div style={{
//                         background: "linear-gradient(135deg,#1e3a8a,#1d4ed8)",
//                         borderRadius: 10, padding: "14px 18px", marginBottom: 16,
//                         display: "flex", alignItems: "flex-start", gap: 12, flexWrap: "wrap"
//                       }}>
//                         <div style={{ flex: 1, minWidth: 200 }}>
//                           <div style={{ fontSize: 11, color: "#93c5fd", fontWeight: 700, marginBottom: 4 }}>🔗 MEMBER REFERRAL LINK</div>
//                           <div style={{
//                             background: "rgba(0,0,0,.3)", borderRadius: 6, padding: "8px 12px",
//                             fontSize: 12, color: "#e0f2fe", fontFamily: "monospace", wordBreak: "break-all"
//                           }}>
//                             {referralLink}
//                           </div>
//                         </div>
//                         <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
//                           <button style={{ ...S.btn, background: "#f59e0b", color: "#000", fontWeight: 800 }}
//                             onClick={() => { navigator.clipboard.writeText(referralLink); toast.success("✅ Referral link copied!"); }}>
//                             📋 Copy
//                           </button>
//                           <button style={{ ...S.btn, background: "#25D366" }}
//                             onClick={() => whatsapp(m.receiver_mobile,
//                               `Namaste *${m.receiver_name}* 👋\n\nHere is your personal Meruram referral link:\n\n🔗 ${referralLink}\n\nShare this with your friends & family to earn level income! 💰\n\n_${COMPANY}_`)}>
//                             📱 WhatsApp
//                           </button>
//                         </div>
//                       </div>
//                     )}

//                     {/* ── Screenshot & Aadhaar row ── */}
//                     <div className="flex-wrap-row" style={{ marginBottom: 16 }}>
//                       {m.screenshot && (
//                         <div style={{ ...S.card, padding: 14 }}>
//                           <div style={{ fontSize: 11, fontWeight: 700, color: "#64748b", marginBottom: 8 }}>📷 PAYMENT SCREENSHOT</div>
//                           <a href={`/uploads/${m.screenshot}`} target="_blank" rel="noreferrer">
//                             <img src={`/uploads/${m.screenshot}`} alt="Payment screenshot"
//                               style={{ maxWidth: "100%", maxHeight: 180, borderRadius: 6, border: "1px solid #e2e8f0", cursor: "pointer" }} />
//                           </a>
//                           <div style={{ marginTop: 8 }}>
//                             <a href={`/uploads/${m.screenshot}`} target="_blank" rel="noreferrer"
//                               style={{ ...S.btn, background: "#1d4ed8", fontSize: 11, textDecoration: "none", display: "inline-flex" }}>
//                               🔍 View Full Size
//                             </a>
//                           </div>
//                         </div>
//                       )}
//                       <div style={{ ...S.card, padding: 14 }}>
//                         <div style={{ fontSize: 11, fontWeight: 700, color: "#64748b", marginBottom: 8 }}>🪪 AADHAAR DETAILS</div>
//                         <div style={{ fontSize: 13, marginBottom: 6 }}>
//                           <span style={{ color: "#94a3b8", fontSize: 11 }}>Full Aadhaar Number:</span><br />
//                           <span style={{ fontWeight: 800, fontSize: 16, letterSpacing: 2, color: "#1e3a8a" }}>
//                             {m.receiver_aadhaar || "Not provided"}
//                           </span>
//                         </div>
//                         <div style={{ fontSize: 12, color: "#64748b" }}>
//                           <div><b>Name:</b> {m.receiver_name}</div>
//                           <div><b>Address:</b> {m.receiver_address || "—"}</div>
//                           <div><b>Mobile:</b> {m.receiver_mobile}</div>
//                         </div>
//                       </div>
//                       <div style={{ ...S.card, padding: 14 }}>
//                         <div style={{ fontSize: 11, fontWeight: 700, color: "#64748b", marginBottom: 8 }}>🏦 BANK / UPI DETAILS</div>
//                         {(m.bank_name || m.account_number || m.upi_id) ? (
//                           <div style={{ fontSize: 13 }}>
//                             {m.bank_name && <div><span style={{ color: "#94a3b8", fontSize: 11 }}>Bank:</span> <b>{m.bank_name}</b></div>}
//                             {m.account_number && <div><span style={{ color: "#94a3b8", fontSize: 11 }}>A/C No:</span> <b>{m.account_number}</b></div>}
//                             {m.ifsc && <div><span style={{ color: "#94a3b8", fontSize: 11 }}>IFSC:</span> <b>{m.ifsc}</b></div>}
//                             {m.upi_id && <div><span style={{ color: "#94a3b8", fontSize: 11 }}>UPI ID:</span> <b>{m.upi_id}</b></div>}
//                           </div>
//                         ) : (
//                           <div style={{ color: "#94a3b8", fontSize: 12 }}>No bank/UPI details added yet</div>
//                         )}
//                       </div>
//                     </div>

//                     {/* ── Action buttons ── */}
//                     <div style={{ display: "flex", gap: 8, marginBottom: 16, flexWrap: "wrap" }}>
//                       <button style={{ ...S.btn, background: "#25D366" }} onClick={() =>
//                         whatsapp(m.receiver_mobile, `Namaste *${m.receiver_name}*!\n\nYour Meruram account is active ✅.\n\nCoupon: ${m.receiver_coupon_no}\nBalance: ${inr(m.wallet_balance)}\n\nVisit: ${COMPANY_URL}`)}>
//                         📱 Send Account Info
//                       </button>
//                       <button style={{ ...S.btn, background: "#25D366" }} onClick={() =>
//                         whatsapp(m.receiver_mobile, `Namaste *${m.receiver_name}*!\n\nYou have earned *${inr(totalEarned)}* in Level Income from Meruram Lucky Draw 🎉\n\nLogin to check: ${COMPANY_URL}`)}>
//                         📱 Send Income Info
//                       </button>
//                     </div>

//                     <SectionTitle>💹 Level-wise Income</SectionTitle>
//                     <div className="table-scroll" style={{ background: "#fff", borderRadius: 8, border: "1px solid #e2e8f0", marginBottom: 16 }}>
//                       <table style={S.table}>
//                         <THead cols={["Level", "Rate/Join", "Members Joined", "Direct", "Indirect", "Total Earned", "% Share"]} />
//                         <tbody>
//                           {[1, 2, 3, 4, 5, 6].map((level, i) => {
//                             const found = levelBreakdown.find(l => l.level === level);
//                             const earned = Number(found?.total || 0);
//                             const pct = totalEarned > 0 ? ((earned / totalEarned) * 100).toFixed(1) : "0";
//                             const isL1 = level === 1;
//                             return (
//                               <tr key={level} style={i % 2 === 0 ? S.trEven : {}}>
//                                 <td style={S.td}><strong>L{level}</strong> {isL1 ? "🔴" : ""}</td>
//                                 <td style={S.td}>₹{LEVEL_RATE[level]}</td>
//                                 <td style={S.td}>{found?.count || 0}</td>
//                                 <td style={S.td}>{isL1 ? (found?.count || 0) : "—"}</td>
//                                 <td style={S.td}>{!isL1 ? (found?.count || 0) : "—"}</td>
//                                 <td style={{ ...S.td, fontWeight: 700, color: earned > 0 ? "#16a34a" : "#94a3b8" }}>
//                                   {earned > 0 ? inr(earned) : "₹0.00"}
//                                 </td>
//                                 <td style={S.td}>
//                                   <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
//                                     <div style={{ height: 6, borderRadius: 99, background: PIE_COLORS[i], width: `${Math.min(Number(pct), 100)}%`, minWidth: 2 }} />
//                                     <span style={{ fontSize: 11, color: "#64748b", whiteSpace: "nowrap" }}>{pct}%</span>
//                                   </div>
//                                 </td>
//                               </tr>
//                             );
//                           })}
//                           <tr style={{ background: "#f0fdf4" }}>
//                             <td style={{ ...S.td, fontWeight: 800 }} colSpan={2}>TOTAL</td>
//                             <td style={{ ...S.td, fontWeight: 700 }}>{levelBreakdown.reduce((s, l) => s + l.count, 0)}</td>
//                             <td style={S.td}>{direct.length}</td>
//                             <td style={S.td}>{memberDetail.total_team - direct.length}</td>
//                             <td style={{ ...S.td, fontWeight: 800, color: "#15803d", fontSize: 14 }}>{inr(totalEarned)}</td>
//                             <td style={S.td}>100%</td>
//                           </tr>
//                         </tbody>
//                       </table>
//                     </div>

//                     <SectionTitle>👥 Direct Members</SectionTitle>
//                     <div className="table-scroll" style={{ background: "#fff", borderRadius: 8, border: "1px solid #e2e8f0", marginBottom: 16 }}>
//                       <table style={S.table}>
//                         <THead cols={["#", "Coupon", "Name", "Mobile", "Joined", "Their Direct", "Status", "WA"]} />
//                         <tbody>
//                           {direct.map((d, i) => (
//                             <tr key={d.id} style={i % 2 === 0 ? S.trEven : {}}>
//                               <td style={S.td}>{i + 1}</td>
//                               <td style={{ ...S.td, color: "#1d4ed8", fontWeight: 700 }}>{d.receiver_coupon_no}</td>
//                               <td style={S.td}>{d.receiver_name}</td>
//                               <td style={S.td}>{d.receiver_mobile}</td>
//                               <td style={{ ...S.td, fontSize: 11 }}>{fmtTime(d.created_at)}</td>
//                               <td style={{ ...S.td, fontWeight: 700 }}>{d.their_direct}</td>
//                               <td style={S.td}><span style={d.is_approved ? S.greenBadge : S.yellowBadge}>{d.is_approved ? "Active" : "Pending"}</span></td>
//                               <td style={S.td}>
//                                 <button style={{ ...S.btn, background: "#25D366", padding: "4px 8px" }}
//                                   onClick={() => whatsapp(d.receiver_mobile, `Namaste *${d.receiver_name}*! Welcome to Meruram Lucky Draw. Login: ${COMPANY_URL}`)}>
//                                   📱
//                                 </button>
//                               </td>
//                             </tr>
//                           ))}
//                           {direct.length === 0 && <tr><td colSpan={8} style={{ ...S.td, textAlign: "center", color: "#94a3b8" }}>No direct referrals</td></tr>}
//                         </tbody>
//                       </table>
//                     </div>

//                     <SectionTitle>📋 Commission History</SectionTitle>
//                     <div className="table-scroll" style={{ background: "#fff", borderRadius: 8, border: "1px solid #e2e8f0", marginBottom: 16 }}>
//                       <table style={S.table}>
//                         <THead cols={["#", "Date", "Level", "From Coupon", "From Member", "Amount"]} />
//                         <tbody>
//                           {memberCommissions.slice(0, 100).map((c, i) => (
//                             <tr key={c.id} style={i % 2 === 0 ? S.trEven : {}}>
//                               <td style={S.td}>{i + 1}</td>
//                               <td style={{ ...S.td, fontSize: 11 }}>{fmtTime(c.created_at)}</td>
//                               <td style={S.td}><span style={S.pill}>L{c.level}</span></td>
//                               <td style={{ ...S.td, color: "#1d4ed8" }}>{c.from_coupon}</td>
//                               <td style={S.td}>{c.from_name}</td>
//                               <td style={{ ...S.td, fontWeight: 700, color: "#16a34a" }}>{inr(c.amount)}</td>
//                             </tr>
//                           ))}
//                           {memberCommissions.length === 0 && <tr><td colSpan={6} style={{ ...S.td, textAlign: "center", color: "#94a3b8" }}>No commissions yet</td></tr>}
//                         </tbody>
//                       </table>
//                     </div>

//                     <SectionTitle>💸 Withdrawal History</SectionTitle>
//                     <div className="table-scroll" style={{ background: "#fff", borderRadius: 8, border: "1px solid #e2e8f0", marginBottom: 16 }}>
//                       <table style={S.table}>
//                         <THead cols={["#", "Date", "Amount", "Method", "Bank/UPI", "Status"]} />
//                         <tbody>
//                           {wdrawals.map((w, i) => (
//                             <tr key={w.id} style={i % 2 === 0 ? S.trEven : {}}>
//                               <td style={S.td}>{i + 1}</td>
//                               <td style={{ ...S.td, fontSize: 11 }}>{fmt(w.created_at)}</td>
//                               <td style={{ ...S.td, fontWeight: 700 }}>{inr(w.amount)}</td>
//                               <td style={S.td}>{w.method?.toUpperCase()}</td>
//                               <td style={{ ...S.td, fontSize: 11 }}>{w.method === "upi" ? w.upi_id : `${w.bank_name || ""} ${w.account_number || ""}`}</td>
//                               <td style={S.td}><span style={w.status === "approved" ? S.greenBadge : w.status === "rejected" ? S.redBadge : S.yellowBadge}>{w.status}</span></td>
//                             </tr>
//                           ))}
//                           {wdrawals.length === 0 && <tr><td colSpan={6} style={{ ...S.td, textAlign: "center", color: "#94a3b8" }}>No withdrawals</td></tr>}
//                         </tbody>
//                       </table>
//                     </div>
//                   </div>
//                 );
//               })()}
//             </div>
//           )}

//           {/* ══════════ LEVEL INCOME REPORT ══════════ */}
//           {subTab === "Level Income Report" && (
//             <div>
//               <PageHead title="📈 Level Income Report — All Members" />
//               <div className="level-cards">
//                 {[1, 2, 3, 4, 5, 6].map((l, i) => (
//                   <div key={l} style={{ background: PIE_COLORS[i], color: "#fff", borderRadius: 10, padding: "12px 14px", textAlign: "center" }}>
//                     <div style={{ fontSize: 10, opacity: 0.8 }}>L{l} · ₹{LEVEL_RATE[l]}/join</div>
//                     <div style={{ fontSize: 16, fontWeight: 800, marginTop: 4 }}>
//                       {inr(allMembers.reduce((s, m) => s + Number(m[`level${l}_income`] || 0), 0))}
//                     </div>
//                     <div style={{ fontSize: 10, opacity: 0.8, marginTop: 2 }}>
//                       {allMembers.filter(m => Number(m[`level${l}_income`]) > 0).length} members
//                     </div>
//                   </div>
//                 ))}
//               </div>
//               <div className="table-scroll" style={{ background: "#fff", borderRadius: 8, border: "1px solid #e2e8f0", marginBottom: 16 }}>
//                 <table style={S.table}>
//                   <THead cols={["#", "Coupon", "Name", "Mobile", "Sponsor", "Direct", "L1", "L2", "L3", "L4", "L5", "L6", "Total", "Withdrawn"]} />
//                   <tbody>
//                     {allMembers.filter(m => Number(m.total_income) > 0).map((m, i) => (
//                       <tr key={m.id} style={i % 2 === 0 ? S.trEven : {}}>
//                         <td style={S.td}>{i + 1}</td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#1d4ed8", cursor: "pointer" }} onClick={() => openDetail(m)}>{m.receiver_coupon_no}</td>
//                         <td style={S.td}>{m.receiver_name}</td>
//                         <td style={S.td}>{m.receiver_mobile}</td>
//                         <td style={{ ...S.td, fontSize: 11 }}>{m.sponsor_name || "—"}</td>
//                         <td style={S.td}>{m.direct_count}</td>
//                         {[1, 2, 3, 4, 5, 6].map(l => (
//                           <td key={l} style={{ ...S.td, color: m[`level${l}_income`] > 0 ? "#16a34a" : "#d1d5db", fontSize: 11 }}>
//                             {m[`level${l}_income`] > 0 ? inr(m[`level${l}_income`]) : "—"}
//                           </td>
//                         ))}
//                         <td style={{ ...S.td, fontWeight: 800, color: "#7c3aed" }}>{inr(m.total_income)}</td>
//                         <td style={{ ...S.td, color: "#dc2626" }}>{inr(m.total_withdrawn)}</td>
//                       </tr>
//                     ))}
//                     <tr style={{ background: "#eff6ff", fontWeight: 800 }}>
//                       <td style={S.td} colSpan={6}>COMPANY TOTAL</td>
//                       {[1, 2, 3, 4, 5, 6].map(l => (
//                         <td key={l} style={{ ...S.td, color: "#16a34a", fontWeight: 800 }}>
//                           {inr(allMembers.reduce((s, m) => s + Number(m[`level${l}_income`] || 0), 0))}
//                         </td>
//                       ))}
//                       <td style={{ ...S.td, color: "#7c3aed", fontSize: 13 }}>
//                         {inr(allMembers.reduce((s, m) => s + Number(m.total_income || 0), 0))}
//                       </td>
//                       <td style={{ ...S.td, color: "#dc2626" }}>
//                         {inr(allMembers.reduce((s, m) => s + Number(m.total_withdrawn || 0), 0))}
//                       </td>
//                     </tr>
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}

//           {/* ══════════ LEVEL WISE REPORT ══════════ */}
//           {subTab === "Level Wise Report" && (
//             <div>
//               <PageHead title="📊 Level Wise Report — Company Overview" />
//               <div style={{ ...S.card, marginBottom: 16 }}>
//                 <CardHead>Level-wise Commission Distribution</CardHead>
//                 <div style={{ padding: 16 }}>
//                   <ResponsiveContainer width="100%" height={220}>
//                     <BarChart data={levelSummary}>
//                       <XAxis dataKey="level" tickFormatter={v => `L${v}`} tick={{ fontSize: 11 }} />
//                       <YAxis tick={{ fontSize: 10 }} tickFormatter={v => `₹${(v / 1000).toFixed(0)}k`} />
//                       <Tooltip formatter={(v) => inr(v)} labelFormatter={l => `Level ${l}`} />
//                       <Bar dataKey="total" name="Total Paid" radius={[4, 4, 0, 0]}>
//                         {levelSummary.map((entry, i) => <Cell key={i} fill={PIE_COLORS[i % PIE_COLORS.length]} />)}
//                       </Bar>
//                     </BarChart>
//                   </ResponsiveContainer>
//                 </div>
//               </div>

//               <div className="table-scroll" style={{ background: "#fff", borderRadius: 8, border: "1px solid #e2e8f0", marginBottom: 16 }}>
//                 <table style={S.table}>
//                   <THead cols={["Level", "Rate/Join", "Members Benefiting", "Total Paid", "Avg/Member", "% of Total"]} />
//                   <tbody>
//                     {levelSummary.map((l, i) => {
//                       const grandTotal = levelSummary.reduce((s, x) => s + x.total, 0);
//                       const pct = grandTotal > 0 ? ((l.total / grandTotal) * 100).toFixed(1) : "0";
//                       const avg = l.members_paid > 0 ? l.total / l.members_paid : 0;
//                       return (
//                         <tr key={l.level} style={i % 2 === 0 ? S.trEven : {}}>
//                           <td style={S.td}>
//                             <span style={{ ...S.pill, background: PIE_COLORS[i], color: "#fff", fontSize: 12 }}>Level {l.level}</span>
//                           </td>
//                           <td style={{ ...S.td, fontWeight: 700 }}>₹{l.rate}</td>
//                           <td style={{ ...S.td, fontWeight: 700, color: "#1d4ed8" }}>{l.members_paid}</td>
//                           <td style={{ ...S.td, fontWeight: 800, color: "#16a34a", fontSize: 13 }}>{inr(l.total)}</td>
//                           <td style={{ ...S.td, color: "#7c3aed" }}>{inr(avg)}</td>
//                           <td style={S.td}>
//                             <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
//                               <div style={{ height: 8, borderRadius: 99, background: PIE_COLORS[i], width: `${Math.min(Number(pct) * 1.5, 120)}px` }} />
//                               <span style={{ fontSize: 12, fontWeight: 700 }}>{pct}%</span>
//                             </div>
//                           </td>
//                         </tr>
//                       );
//                     })}
//                     <tr style={{ background: "#f0fdf4", fontWeight: 800 }}>
//                       <td style={S.td} colSpan={2}>GRAND TOTAL</td>
//                       <td style={{ ...S.td, color: "#1d4ed8" }}>{levelSummary.reduce((s, l) => s + l.members_paid, 0)}</td>
//                       <td style={{ ...S.td, color: "#16a34a", fontSize: 14 }}>{inr(levelSummary.reduce((s, l) => s + l.total, 0))}</td>
//                       <td style={S.td}>—</td>
//                       <td style={S.td}>100%</td>
//                     </tr>
//                   </tbody>
//                 </table>
//               </div>

//               <SectionTitle>👤 Member-wise Level Breakdown</SectionTitle>
//               <div className="table-scroll" style={{ background: "#fff", borderRadius: 8, border: "1px solid #e2e8f0", marginBottom: 16 }}>
//                 <table style={S.table}>
//                   <THead cols={["#", "Coupon", "Name", "L1", "L2", "L3", "L4", "L5", "L6", "Total", "Rank"]} />
//                   <tbody>
//                     {allMembers.filter(m => Number(m.total_income) > 0)
//                       .sort((a, b) => Number(b.total_income) - Number(a.total_income))
//                       .map((m, i) => (
//                         <tr key={m.id} style={i % 2 === 0 ? S.trEven : {}}>
//                           <td style={S.td}>{i + 1}</td>
//                           <td style={{ ...S.td, color: "#1d4ed8", fontWeight: 700, cursor: "pointer" }} onClick={() => openDetail(m)}>{m.receiver_coupon_no}</td>
//                           <td style={S.td}>{m.receiver_name}</td>
//                           {[1, 2, 3, 4, 5, 6].map(l => (
//                             <td key={l} style={{ ...S.td, fontSize: 11, color: Number(m[`level${l}_income`]) > 0 ? "#16a34a" : "#d1d5db" }}>
//                               {Number(m[`level${l}_income`]) > 0 ? `₹${Number(m[`level${l}_income`]).toFixed(0)}` : "—"}
//                             </td>
//                           ))}
//                           <td style={{ ...S.td, fontWeight: 800, color: "#7c3aed" }}>{inr(m.total_income)}</td>
//                           <td style={S.td}><span style={S.pill}>{m.rank || "—"}</span></td>
//                         </tr>
//                       ))}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}

//           {/* ══════════ COMMISSION REPORT ══════════ */}
//           {subTab === "Commission Report" && (
//             <div>
//               <PageHead title="💰 Commission Report — All Transactions" />
//               <div className="kpi-grid" style={{ marginBottom: 16 }}>
//                 <div style={{ ...S.kpiCard, background: "#1e3a8a" }}>
//                   <div style={{ fontSize: 20 }}>💰</div>
//                   <div style={{ fontSize: 18, fontWeight: 800 }}>{inr(commissions.reduce((s, c) => s + Number(c.amount || 0), 0))}</div>
//                   <div style={{ fontSize: 10, opacity: .8 }}>Total Commission</div>
//                 </div>
//                 <div style={{ ...S.kpiCard, background: "#065f46" }}>
//                   <div style={{ fontSize: 20 }}>📋</div>
//                   <div style={{ fontSize: 18, fontWeight: 800 }}>{commissions.length}</div>
//                   <div style={{ fontSize: 10, opacity: .8 }}>Total Transactions</div>
//                 </div>
//                 {commissionByLevel.map((cl, i) => (
//                   <div key={cl.level} style={{ ...S.kpiCard, background: PIE_COLORS[i % PIE_COLORS.length] }}>
//                     <div style={{ fontSize: 13 }}>Level {cl.level}</div>
//                     <div style={{ fontSize: 15, fontWeight: 800 }}>{inr(cl.total)}</div>
//                     <div style={{ fontSize: 10, opacity: .8 }}>{cl.count} txns</div>
//                   </div>
//                 ))}
//               </div>
//               <div style={{ ...S.card, marginBottom: 16 }}>
//                 <CardHead>Commission by Level</CardHead>
//                 <div style={{ padding: 16 }}>
//                   <ResponsiveContainer width="100%" height={180}>
//                     <BarChart data={commissionByLevel}>
//                       <XAxis dataKey="level" tickFormatter={v => `L${v}`} tick={{ fontSize: 11 }} />
//                       <YAxis tick={{ fontSize: 10 }} tickFormatter={v => `₹${(v / 1000).toFixed(0)}k`} />
//                       <Tooltip formatter={(v) => inr(v)} labelFormatter={l => `Level ${l}`} />
//                       <Bar dataKey="total" name="Commission" radius={[4, 4, 0, 0]}>
//                         {commissionByLevel.map((entry, i) => <Cell key={i} fill={PIE_COLORS[i % PIE_COLORS.length]} />)}
//                       </Bar>
//                     </BarChart>
//                   </ResponsiveContainer>
//                 </div>
//               </div>
//               <div className="table-scroll" style={{ background: "#fff", borderRadius: 8, border: "1px solid #e2e8f0", marginBottom: 16 }}>
//                 <table style={S.table}>
//                   <THead cols={["#", "Date & Time", "Level", "To Coupon", "To Member", "From Coupon", "From Member", "Amount"]} />
//                   <tbody>
//                     {commissions.length === 0 && (
//                       <tr><td colSpan={8} style={{ ...S.td, textAlign: "center", color: "#94a3b8", padding: 40 }}>No commission records found</td></tr>
//                     )}
//                     {commissions.map((c, i) => (
//                       <tr key={c.id} style={i % 2 === 0 ? S.trEven : {}}>
//                         <td style={S.td}>{i + 1}</td>
//                         <td style={{ ...S.td, fontSize: 11 }}>{fmtTime(c.created_at)}</td>
//                         <td style={S.td}>
//                           <span style={{ ...S.pill, background: PIE_COLORS[(c.level - 1) % PIE_COLORS.length], color: "#fff" }}>L{c.level}</span>
//                         </td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#1d4ed8" }}>{c.to_coupon || c.receiver_coupon_no}</td>
//                         <td style={S.td}>{c.to_name || c.receiver_name}</td>
//                         <td style={{ ...S.td, color: "#6366f1" }}>{c.from_coupon}</td>
//                         <td style={S.td}>{c.from_name}</td>
//                         <td style={{ ...S.td, fontWeight: 800, color: "#16a34a", fontSize: 13 }}>{inr(c.amount)}</td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}

//           {/* ══════════ DIRECT BUSINESS REPORT ══════════ */}
//           {subTab === "Direct Business Report" && (
//             <div>
//               <PageHead title="📊 Direct Business Report" />
//               <div className="table-scroll" style={{ background: "#fff", borderRadius: 8, border: "1px solid #e2e8f0", marginBottom: 16 }}>
//                 <table style={S.table}>
//                   <THead cols={["#", "Coupon", "Name", "Mobile", "Direct", "Indirect", "Total Team", "Direct Income", "Total Income"]} />
//                   <tbody>
//                     {[...allMembers].sort((a, b) => Number(b.direct_count) - Number(a.direct_count)).map((m, i) => (
//                       <tr key={m.id} style={i % 2 === 0 ? S.trEven : {}}>
//                         <td style={S.td}>{i + 1}</td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#1d4ed8", cursor: "pointer" }} onClick={() => openDetail(m)}>{m.receiver_coupon_no}</td>
//                         <td style={S.td}>{m.receiver_name}</td>
//                         <td style={S.td}>{m.receiver_mobile}</td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#1d4ed8" }}>{m.direct_count}</td>
//                         <td style={{ ...S.td, color: "#6366f1" }}>{m.indirect_count || 0}</td>
//                         <td style={S.td}>{Number(m.direct_count) + Number(m.indirect_count || 0)}</td>
//                         <td style={{ ...S.td, color: "#16a34a" }}>{inr(Number(m.direct_count) * LEVEL_RATE[1])}</td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#7c3aed" }}>{inr(m.total_income)}</td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}

//           {/* ══════════ BUSINESS REPORT ══════════ */}
//           {subTab === "Business Report" && (
//             <div>
//               <PageHead title="📈 Business Report — Full Company Overview & Profit Analysis" />
//               {(() => {
//                 const JOINING = 3000;
//                 const PRODUCT_COST = 1200;
//                 const MLM_PAYOUT = 750;
//                 const SALARY_AVG = 100;
//                 const REWARDS_AVG = 50;
//                 const TOTAL_EXPENSE = PRODUCT_COST + MLM_PAYOUT + SALARY_AVG + REWARDS_AVG;
//                 const PROFIT_PER = JOINING - TOTAL_EXPENSE;

//                 const totalMembers = allMembers.length;
//                 const activeMembers = allMembers.filter(m => m.is_approved).length;
//                 const totalCollection = activeMembers * JOINING;
//                 const totalMLMPaid = allMembers.reduce((s, m) => s + Number(m.total_income || 0), 0);
//                 const totalWithdrawn = allMembers.reduce((s, m) => s + Number(m.total_withdrawn || 0), 0);
//                 const estimatedProfit = activeMembers * PROFIT_PER;

//                 return (
//                   <div>
//                     <div className="kpi-grid">
//                       {[
//                         { label: "Total Members", val: totalMembers, icon: "👥", bg: "#1e3a8a" },
//                         { label: "Active Members", val: activeMembers, icon: "✅", bg: "#065f46" },
//                         { label: "Total Collection", val: inr(totalCollection), icon: "💼", bg: "#4c1d95" },
//                         { label: "MLM Paid Out", val: inr(totalMLMPaid), icon: "💰", bg: "#134e4a" },
//                         { label: "Total Withdrawn", val: inr(totalWithdrawn), icon: "🏦", bg: "#7f1d1d" },
//                         { label: "Est. Net Profit", val: inr(estimatedProfit), icon: "📈", bg: "#14532d" },
//                       ].map(c => (
//                         <div key={c.label} style={{ ...S.kpiCard, background: c.bg }}>
//                           <div style={{ fontSize: 22 }}>{c.icon}</div>
//                           <div style={{ fontSize: 16, fontWeight: 800 }}>{c.val}</div>
//                           <div style={{ fontSize: 10, opacity: .8 }}>{c.label}</div>
//                         </div>
//                       ))}
//                     </div>

//                     <div className="flex-wrap-row" style={{ marginBottom: 16 }}>
//                       {/* Left panel */}
//                       <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
//                         <div style={{ background: "linear-gradient(135deg,#1e3a8a,#1d4ed8)", borderRadius: 10, padding: "14px 18px", color: "#fff" }}>
//                           <div style={{ fontSize: 13, fontWeight: 800, marginBottom: 10, borderBottom: "1px solid rgba(255,255,255,.2)", paddingBottom: 8 }}>💸 COLLECTION (PER MEMBER)</div>
//                           <div style={{ display: "flex", justifyContent: "space-between", fontSize: 14 }}>
//                             <span>Joining Amount</span>
//                             <span style={{ fontWeight: 900, fontSize: 18, color: "#fbbf24" }}>= ₹{JOINING.toLocaleString()}</span>
//                           </div>
//                         </div>
//                         <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 10, overflow: "hidden" }}>
//                           <div style={{ background: "#dc2626", color: "#fff", padding: "10px 16px", fontWeight: 800, fontSize: 13 }}>🧾 COMPANY GIVES (PER PERSON)</div>
//                           <div style={{ padding: "12px 16px" }}>
//                             <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
//                               <thead><tr style={{ background: "#eff6ff" }}>
//                                 <th style={{ padding: "5px 10px", textAlign: "left", color: "#1d4ed8" }}>Item</th>
//                                 <th style={{ padding: "5px 10px", textAlign: "right", color: "#1d4ed8" }}>Amount</th>
//                               </tr></thead>
//                               <tbody>
//                                 {[["Product / Service", PRODUCT_COST], ...Object.entries(LEVEL_RATE).map(([l, r]) => [`Level ${l}`, r]), ["Salary (avg)", SALARY_AVG], ["Rewards (avg)", REWARDS_AVG]].map(([label, amt], i) => (
//                                   <tr key={label} style={{ background: i % 2 === 0 ? "#f8fafc" : "#fff" }}>
//                                     <td style={{ padding: "5px 10px" }}>{label}</td>
//                                     <td style={{ padding: "5px 10px", textAlign: "right", fontWeight: 700, color: "#16a34a" }}>₹{amt}</td>
//                                   </tr>
//                                 ))}
//                                 <tr style={{ background: "#f0fdf4", fontWeight: 800 }}>
//                                   <td style={{ padding: "6px 10px" }}>👉 Total</td>
//                                   <td style={{ padding: "6px 10px", textAlign: "right", color: "#15803d", fontSize: 14 }}>= ₹{TOTAL_EXPENSE}</td>
//                                 </tr>
//                               </tbody>
//                             </table>
//                           </div>
//                         </div>
//                       </div>

//                       {/* Right panel */}
//                       <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
//                         <div style={{ background: "linear-gradient(135deg,#14532d,#16a34a)", borderRadius: 10, padding: "20px", color: "#fff", textAlign: "center" }}>
//                           <div style={{ fontSize: 13, opacity: .9, marginBottom: 8 }}>💰 COMPANY PROFIT (PER PERSON)</div>
//                           <div style={{ fontSize: 36, fontWeight: 900, color: "#bbf7d0" }}>₹{PROFIT_PER.toLocaleString()}</div>
//                           <div style={{ fontSize: 12, opacity: .8, marginTop: 6 }}>NET PROFIT PER MEMBER</div>
//                         </div>
//                         <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 10, overflow: "hidden" }}>
//                           <div style={{ background: "#7c3aed", color: "#fff", padding: "10px 16px", fontWeight: 800, fontSize: 13 }}>📈 AT SCALE — PROFIT PROJECTIONS</div>
//                           <div style={{ padding: "12px 16px" }}>
//                             {[[activeMembers || 1, "Current members"], [1000, "1,000 members"], [10000, "10,000 members"], [100000, "1,00,000 members"]].map(([count, label], i) => {
//                               const profit = count * PROFIT_PER;
//                               const isActive = i === 0;
//                               return (
//                                 <div key={label} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 12px", borderRadius: 8, marginBottom: 6, background: isActive ? "#f0fdf4" : "#f8fafc", border: isActive ? "2px solid #16a34a" : "1px solid #e2e8f0" }}>
//                                   <div>
//                                     <div style={{ fontWeight: isActive ? 800 : 600, fontSize: 13, color: isActive ? "#15803d" : "#374151" }}>{isActive ? "🔴 " : ""}{label}</div>
//                                     <div style={{ fontSize: 11, color: "#94a3b8" }}>₹{PROFIT_PER} × {count.toLocaleString()}</div>
//                                   </div>
//                                   <div style={{ fontWeight: 900, fontSize: 15, color: isActive ? "#16a34a" : "#7c3aed" }}>
//                                     {profit >= 10000000 ? `₹${(profit / 10000000).toFixed(2)} Cr` : profit >= 100000 ? `₹${(profit / 100000).toFixed(1)} L` : `₹${profit.toLocaleString()}`}
//                                   </div>
//                                 </div>
//                               );
//                             })}
//                           </div>
//                         </div>
//                       </div>
//                     </div>

//                     <SectionTitle>📋 All Members Business Summary</SectionTitle>
//                     <div className="table-scroll" style={{ background: "#fff", borderRadius: 8, border: "1px solid #e2e8f0", marginBottom: 16 }}>
//                       <table style={S.table}>
//                         <THead cols={["#", "Coupon", "Name", "Mobile", "Rank", "Direct", "Team", "Income", "Withdrawn", "Balance", "Status"]} />
//                         <tbody>
//                           {[...allMembers].sort((a, b) => Number(b.total_income || 0) - Number(a.total_income || 0)).map((m, i) => (
//                             <tr key={m.id} style={i % 2 === 0 ? S.trEven : {}}>
//                               <td style={S.td}>{i + 1}</td>
//                               <td style={{ ...S.td, fontWeight: 700, color: "#1d4ed8", cursor: "pointer" }} onClick={() => openDetail(m)}>{m.receiver_coupon_no}</td>
//                               <td style={S.td}>{m.receiver_name}</td>
//                               <td style={S.td}>{m.receiver_mobile}</td>
//                               <td style={S.td}><span style={S.pill}>{m.rank || "member"}</span></td>
//                               <td style={{ ...S.td, fontWeight: 700 }}>{m.direct_count || 0}</td>
//                               <td style={S.td}>{Number(m.direct_count || 0) + Number(m.indirect_count || 0)}</td>
//                               <td style={{ ...S.td, fontWeight: 800, color: "#16a34a" }}>{inr(m.total_income)}</td>
//                               <td style={{ ...S.td, color: "#dc2626" }}>{inr(m.total_withdrawn)}</td>
//                               <td style={{ ...S.td, fontWeight: 700, color: "#7c3aed" }}>{inr(Number(m.total_income || 0) - Number(m.total_withdrawn || 0))}</td>
//                               <td style={S.td}><span style={m.is_approved ? S.greenBadge : S.yellowBadge}>{m.is_approved ? "Active" : "Pending"}</span></td>
//                             </tr>
//                           ))}
//                         </tbody>
//                       </table>
//                     </div>
//                   </div>
//                 );
//               })()}
//             </div>
//           )}

//           {/* ══════════ COMMISSION SUMMARY ══════════ */}
//           {subTab === "Commission Summary" && (
//             <div>
//               <PageHead title="📋 Commission Summary" />
//               <div className="level-cards">
//                 {[1, 2, 3, 4, 5, 6].map((l, i) => (
//                   <div key={l} style={{ background: PIE_COLORS[i], color: "#fff", borderRadius: 10, padding: "12px 14px", textAlign: "center" }}>
//                     <div style={{ fontSize: 10, opacity: 0.8 }}>L{l} (₹{LEVEL_RATE[l]}/join)</div>
//                     <div style={{ fontSize: 16, fontWeight: 800, marginTop: 4 }}>
//                       {inr(allMembers.reduce((s, m) => s + Number(m[`level${l}_income`] || 0), 0))}
//                     </div>
//                     <div style={{ fontSize: 10, opacity: 0.8, marginTop: 2 }}>
//                       {allMembers.filter(m => Number(m[`level${l}_income`]) > 0).length} earners
//                     </div>
//                   </div>
//                 ))}
//               </div>
//               {[1, 2, 3, 4, 5, 6].map((level) => (
//                 <div key={level}>
//                   <SectionTitle>🏆 Top 5 Earners — Level {level} (₹{LEVEL_RATE[level]}/join)</SectionTitle>
//                   <div className="table-scroll" style={{ background: "#fff", borderRadius: 8, border: "1px solid #e2e8f0", marginBottom: 16 }}>
//                     <table style={S.table}>
//                       <THead cols={["Rank", "Coupon", "Name", "Mobile", `L${level} Income`]} />
//                       <tbody>
//                         {[...allMembers].filter(m => Number(m[`level${level}_income`]) > 0)
//                           .sort((a, b) => Number(b[`level${level}_income`]) - Number(a[`level${level}_income`]))
//                           .slice(0, 5)
//                           .map((m, i) => (
//                             <tr key={m.id} style={i % 2 === 0 ? S.trEven : {}}>
//                               <td style={{ ...S.td, fontWeight: 800, color: i < 3 ? "#f59e0b" : "#64748b" }}>#{i + 1}</td>
//                               <td style={{ ...S.td, color: "#1d4ed8", fontWeight: 700, cursor: "pointer" }} onClick={() => openDetail(m)}>{m.receiver_coupon_no}</td>
//                               <td style={S.td}>{m.receiver_name}</td>
//                               <td style={S.td}>{m.receiver_mobile}</td>
//                               <td style={{ ...S.td, fontWeight: 800, color: "#16a34a", fontSize: 13 }}>{inr(m[`level${level}_income`])}</td>
//                             </tr>
//                           ))}
//                       </tbody>
//                     </table>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           )}

//           {/* ══════════ DAILY JOINS ══════════ */}
//           {subTab === "Daily Joins" && (
//             <div>
//               <PageHead title="📅 Daily Joins Report — Last 30 Days" />
//               {dailyJoins.length === 0 ? (
//                 <div style={{ textAlign: "center", padding: 60, color: "#94a3b8", background: "#f8fafc", borderRadius: 8, border: "2px dashed #e2e8f0" }}>
//                   <div style={{ fontSize: 40, marginBottom: 12 }}>📅</div>
//                   <div style={{ fontWeight: 700, fontSize: 15 }}>Loading or no join data for last 30 days</div>
//                   <button style={{ ...S.btn, background: "#1e3a8a", marginTop: 16 }} onClick={loadDailyJoins}>🔄 Reload</button>
//                 </div>
//               ) : (
//                 <>
//                   <div className="kpi-grid">
//                     {[
//                       { icon: "📅", label: "Total Joins", val: dailyJoins.reduce((s, d) => s + Number(d.count || 0), 0), bg: "#1e3a8a" },
//                       { icon: "✅", label: "Approved", val: dailyJoins.reduce((s, d) => s + Number(d.approved || 0), 0), bg: "#065f46" },
//                       { icon: "⏳", label: "Pending", val: dailyJoins.reduce((s, d) => s + Number(d.pending || 0), 0), bg: "#92400e" },
//                       { icon: "📈", label: "Avg / Day", val: dailyJoins.length > 0 ? Math.round(dailyJoins.reduce((s, d) => s + Number(d.count || 0), 0) / dailyJoins.length) : 0, bg: "#4c1d95" },
//                       { icon: "🏆", label: "Best Day", val: Math.max(...dailyJoins.map(d => Number(d.count || 0))), bg: "#134e4a" },
//                     ].map(c => (
//                       <div key={c.label} style={{ ...S.kpiCard, background: c.bg }}>
//                         <div style={{ fontSize: 22 }}>{c.icon}</div>
//                         <div style={{ fontSize: 18, fontWeight: 800 }}>{c.val}</div>
//                         <div style={{ fontSize: 10, opacity: .8 }}>{c.label}</div>
//                       </div>
//                     ))}
//                   </div>
//                   <div style={{ ...S.card, marginBottom: 16 }}>
//                     <CardHead>📈 Daily Registration Trend</CardHead>
//                     <div style={{ padding: 16 }}>
//                       <ResponsiveContainer width="100%" height={240}>
//                         <BarChart data={dailyJoins}>
//                           <XAxis dataKey="date" tick={{ fontSize: 9 }} />
//                           <YAxis tick={{ fontSize: 9 }} allowDecimals={false} />
//                           <Tooltip /><Legend />
//                           <Bar dataKey="approved" name="Approved" stackId="a" fill="#10b981" />
//                           <Bar dataKey="pending" name="Pending" stackId="a" fill="#f59e0b" radius={[4, 4, 0, 0]} />
//                         </BarChart>
//                       </ResponsiveContainer>
//                     </div>
//                   </div>
//                   <div className="table-scroll" style={{ background: "#fff", borderRadius: 8, border: "1px solid #e2e8f0", marginBottom: 16 }}>
//                     <table style={S.table}>
//                       <THead cols={["#", "Date", "Total", "Approved", "Pending", "Running Total", "Bar"]} />
//                       <tbody>
//                         {(() => {
//                           let running = 0;
//                           const maxCount = Math.max(...dailyJoins.map(d => Number(d.count || 0)), 1);
//                           return dailyJoins.map((d, i) => {
//                             running += Number(d.count || 0);
//                             const isMax = Number(d.count) === maxCount;
//                             return (
//                               <tr key={i} style={i % 2 === 0 ? S.trEven : {}}>
//                                 <td style={S.td}>{i + 1}</td>
//                                 <td style={{ ...S.td, fontWeight: 600 }}>{d.date}</td>
//                                 <td style={{ ...S.td, fontWeight: 800, color: isMax ? "#f59e0b" : "#1d4ed8", fontSize: 14 }}>{d.count} {isMax ? "🏆" : ""}</td>
//                                 <td style={{ ...S.td, color: "#16a34a", fontWeight: 700 }}>{d.approved || 0}</td>
//                                 <td style={{ ...S.td, color: "#f59e0b", fontWeight: 700 }}>{d.pending || 0}</td>
//                                 <td style={{ ...S.td, color: "#7c3aed" }}>{running}</td>
//                                 <td style={S.td}>
//                                   <div style={{ height: 10, borderRadius: 99, background: isMax ? "#f59e0b" : "#3b82f6", width: `${(Number(d.count) / maxCount) * 120}px`, minWidth: 4 }} />
//                                 </td>
//                               </tr>
//                             );
//                           });
//                         })()}
//                       </tbody>
//                     </table>
//                   </div>
//                 </>
//               )}
//             </div>
//           )}

//           {/* ══════════ NETWORK TREE ══════════ */}
//           {subTab === "Network Tree" && (
//             <div>
//               <PageHead title="🌳 Network Tree — Member Downline" />
//               <div style={{ ...S.card, marginBottom: 16 }}>
//                 <CardHead>Search Member Network</CardHead>
//                 <div style={{ padding: 16 }}>
//                   <div className="search-row">
//                     <input
//                       style={{ ...S.searchBox }}
//                       placeholder="Enter Coupon No (e.g. MR001)..."
//                       value={networkToken}
//                       onChange={e => setNetworkToken(e.target.value)}
//                       onKeyDown={e => e.key === "Enter" && loadNetworkTree(networkToken)}
//                     />
//                     <button style={{ ...S.btn, background: "#1e3a8a", padding: "9px 20px" }} onClick={() => loadNetworkTree(networkToken)}>
//                       🔍 Load Tree
//                     </button>
//                     {networkTree && (
//                       <button style={{ ...S.btn, background: "#64748b" }} onClick={() => { setNetworkTree(null); setNetworkToken(""); }}>
//                         ✕ Clear
//                       </button>
//                     )}
//                   </div>
//                   {networkTree && (
//                     <span style={{ ...S.countBadge, background: "#dcfce7", color: "#15803d" }}>
//                       Showing: <b>{networkTree.receiver_coupon_no || networkTree.token_number}</b>
//                     </span>
//                   )}
//                 </div>
//               </div>
//               {networkTree ? (
//                 <div style={{ ...S.card, padding: 12, maxHeight: 620, overflowY: "auto", overflowX: "auto" }}>
//                   <TreeNode node={networkTree} depth={0} />
//                 </div>
//               ) : (
//                 <div style={{ textAlign: "center", padding: 60, color: "#94a3b8", background: "#f8fafc", borderRadius: 8, border: "2px dashed #e2e8f0" }}>
//                   <div style={{ fontSize: 48, marginBottom: 12 }}>🌳</div>
//                   <div style={{ fontWeight: 700, fontSize: 16, marginBottom: 6 }}>Enter a coupon number above</div>
//                   <div style={{ fontSize: 12 }}>Tree shows downline up to 6 levels. Click any node to expand.</div>
//                 </div>
//               )}
//             </div>
//           )}

//           {/* ══════════ WITHDRAWAL REQUESTS ══════════ */}
//           {subTab === "Withdrawal Requests" && (
//             <div>
//               <PageHead title="💸 Withdrawal Requests — Pending">
//                 <span style={{ ...S.countBadge, background: "#fee2e2", color: "#991b1b", marginLeft: "auto" }}>
//                   {withdrawals.length} Pending
//                 </span>
//               </PageHead>
//               <div className="table-scroll" style={{ background: "#fff", borderRadius: 8, border: "1px solid #e2e8f0", marginBottom: 16 }}>
//                 <table style={S.table}>
//                   <THead cols={["#", "Coupon", "Member", "Mobile", "Amount", "Method", "Bank/UPI", "Requested", "Actions"]} />
//                   <tbody>
//                     {withdrawals.map((w, i) => (
//                       <tr key={w.id} style={i % 2 === 0 ? S.trEven : {}}>
//                         <td style={S.td}>{i + 1}</td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#1d4ed8" }}>{w.receiver_coupon_no}</td>
//                         <td style={S.td}>{w.receiver_name}</td>
//                         <td style={S.td}>{w.receiver_mobile}</td>
//                         <td style={{ ...S.td, fontWeight: 800, color: "#16a34a", fontSize: 13 }}>{inr(w.amount)}</td>
//                         <td style={S.td}>{w.method?.toUpperCase()}</td>
//                         <td style={{ ...S.td, fontSize: 11 }}>
//                           {w.method === "bank"
//                             ? <><b>{w.bank_name}</b><br />A/c: {w.account_number}<br />IFSC: {w.ifsc}</>
//                             : <><b>UPI:</b> {w.upi_id}</>}
//                         </td>
//                         <td style={{ ...S.td, fontSize: 11 }}>{fmtTime(w.created_at)}</td>
//                         <td style={S.td}>
//                           <div style={{ display: "flex", gap: 4, flexDirection: "column" }}>
//                             <button style={{ ...S.btn, background: "#16a34a", fontSize: 11 }} onClick={() => processWithdrawal(w.id, "approved", w)}>✅ Approve + 📱</button>
//                             <button style={{ ...S.btn, background: "#dc2626", fontSize: 11 }} onClick={() => processWithdrawal(w.id, "rejected", w)}>❌ Reject</button>
//                           </div>
//                         </td>
//                       </tr>
//                     ))}
//                     {withdrawals.length === 0 && (
//                       <tr><td colSpan={9} style={{ ...S.td, textAlign: "center", color: "#94a3b8", padding: 40 }}>🎉 No pending withdrawal requests!</td></tr>
//                     )}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}

//           {/* ══════════ PAYMENT HISTORY ══════════ */}
//           {subTab === "Payment History" && (
//             <div>
//               <PageHead title="📋 Payment History — All Payouts" />
//               <div className="level-cards">
//                 {[1, 2, 3, 4, 5, 6].map(l => (
//                   <div key={l} style={{ background: "#1e3a8a", color: "#fff", borderRadius: 8, padding: "10px 12px", textAlign: "center" }}>
//                     <div style={{ fontSize: 10, opacity: .7 }}>L{l} (₹{LEVEL_RATE[l]}/join)</div>
//                     <div style={{ fontSize: 14, fontWeight: 800 }}>
//                       {inr(allMembers.reduce((s, m) => s + Number(m[`level${l}_income`] || 0), 0))}
//                     </div>
//                   </div>
//                 ))}
//               </div>
//               <div className="table-scroll" style={{ background: "#fff", borderRadius: 8, border: "1px solid #e2e8f0", marginBottom: 16 }}>
//                 <table style={S.table}>
//                   <THead cols={["#", "Coupon", "Member", "Mobile", "Amount", "Method", "Status", "Processed", "Date", "WA"]} />
//                   <tbody>
//                     {payHistory.map((w, i) => (
//                       <tr key={w.id} style={i % 2 === 0 ? S.trEven : {}}>
//                         <td style={S.td}>{i + 1}</td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#1d4ed8" }}>{w.receiver_coupon_no}</td>
//                         <td style={S.td}>{w.receiver_name}</td>
//                         <td style={S.td}>{w.receiver_mobile}</td>
//                         <td style={{ ...S.td, fontWeight: 800, color: "#16a34a" }}>{inr(w.amount)}</td>
//                         <td style={S.td}>{w.method?.toUpperCase()}</td>
//                         <td style={S.td}><span style={w.status === "approved" ? S.greenBadge : w.status === "rejected" ? S.redBadge : S.yellowBadge}>{w.status}</span></td>
//                         <td style={{ ...S.td, fontSize: 11 }}>{w.processed_at ? fmt(w.processed_at) : "—"}</td>
//                         <td style={{ ...S.td, fontSize: 11 }}>{fmt(w.created_at)}</td>
//                         <td style={S.td}>
//                           <button style={{ ...S.btn, background: "#25D366", padding: "4px 8px" }}
//                             onClick={() => whatsapp(w.receiver_mobile, `💸 Namaste *${w.receiver_name}*!\n\nYour payout of *${inr(w.amount)}* is *${w.status.toUpperCase()}*.\n\n_${COMPANY}_\n${COMPANY_URL}`)}>
//                             📱
//                           </button>
//                         </td>
//                       </tr>
//                     ))}
//                     {payHistory.length === 0 && <tr><td colSpan={10} style={{ ...S.td, textAlign: "center", color: "#94a3b8", padding: 40 }}>No payment history</td></tr>}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}

//           {/* ══════════ ADD FUND TO MEMBER ══════════ */}
//           {subTab === "Add Fund to Member" && (
//             <div>
//               <PageHead title="➕ Add Fund to Member Wallet" />
//               <div style={{ ...S.card, maxWidth: 480 }}>
//                 <CardHead>Manually Add Amount</CardHead>
//                 <div style={{ padding: 20 }}>
//                   <p style={{ fontSize: 12, color: "#64748b", marginBottom: 16, padding: "10px 14px", background: "#fefce8", borderRadius: 8, border: "1px solid #fde68a" }}>
//                     ⚠️ Use this to record an amount received from a member. It will be credited directly to their wallet.
//                   </p>
//                   {[
//                     ["Member Token / Coupon No *", "token_number", "text", "Enter member token or coupon number"],
//                     ["Amount Received (₹) *", "amount", "number", "Enter amount"],
//                     ["Description *", "description", "text", "e.g. Cash received, Online payment ref #123"],
//                   ].map(([label, key, type, placeholder]) => (
//                     <div key={key} style={{ marginBottom: 14 }}>
//                       <label style={S.label}>{label}</label>
//                       <input style={S.input} type={type} placeholder={placeholder}
//                         value={addFundForm[key]} onChange={e => setAddFundForm({ ...addFundForm, [key]: e.target.value })} />
//                     </div>
//                   ))}
//                   <button style={{ ...S.btn, background: "#1e3a8a", width: "100%", padding: 12, fontSize: 14 }} onClick={addFund}>
//                     ➕ Credit to Member Wallet
//                   </button>
//                 </div>
//               </div>
//             </div>
//           )}

//           {/* ══════════ SALARY LIST ══════════ */}
//           {subTab === "Salary List" && (
//             <div>
//               <PageHead title="💰 Salary List" />
//               <div className="kpi-grid">
//                 {[
//                   { icon: "📋", label: "Total Records", val: salaries.length, bg: "#1e3a8a" },
//                   { icon: "✅", label: "Paid", val: salaries.filter(s => s.is_approved).length, bg: "#065f46" },
//                   { icon: "⏳", label: "Pending", val: salaries.filter(s => !s.is_approved).length, bg: "#92400e" },
//                   { icon: "💰", label: "Total Amount", val: inr(salaries.reduce((s, x) => s + Number(x.amount || 0), 0)), bg: "#4c1d95" },
//                 ].map(c => (
//                   <div key={c.label} style={{ ...S.kpiCard, background: c.bg }}>
//                     <div style={{ fontSize: 20 }}>{c.icon}</div>
//                     <div style={{ fontSize: 18, fontWeight: 800 }}>{c.val}</div>
//                     <div style={{ fontSize: 10, opacity: .8 }}>{c.label}</div>
//                   </div>
//                 ))}
//               </div>
//               <div className="table-scroll" style={{ background: "#fff", borderRadius: 8, border: "1px solid #e2e8f0", marginBottom: 16 }}>
//                 <table style={S.table}>
//                   <THead cols={["#", "Coupon", "Member", "Mobile", "Rank", "Amount", "Month", "Status", "Action"]} />
//                   <tbody>
//                     {salaries.map((s, i) => (
//                       <tr key={s.id} style={i % 2 === 0 ? S.trEven : {}}>
//                         <td style={S.td}>{i + 1}</td>
//                         <td style={{ ...S.td, fontWeight: 700 }}>{s.receiver_coupon_no || s.token_number}</td>
//                         <td style={S.td}>{s.receiver_name}</td>
//                         <td style={S.td}>{s.receiver_mobile}</td>
//                         <td style={S.td}><span style={{ ...S.pill, textTransform: "capitalize" }}>{s.rank}</span></td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#16a34a" }}>{inr(s.amount)}</td>
//                         <td style={S.td}>{s.month}</td>
//                         <td style={S.td}><span style={s.is_approved ? S.greenBadge : S.yellowBadge}>{s.is_approved ? "Paid ✅" : "Pending"}</span></td>
//                         <td style={S.td}>
//                           {!s.is_approved && (
//                             <button style={{ ...S.btn, background: "#16a34a", fontSize: 11 }} onClick={() => approveSalary(s.id, s)}>Approve + 📱</button>
//                           )}
//                           {s.is_approved && (
//                             <button style={{ ...S.btn, background: "#25D366", fontSize: 11 }}
//                               onClick={() => whatsapp(s.receiver_mobile, `💰 Namaste *${s.receiver_name}*!\n\nSalary of *${inr(s.amount)}* for ${s.month} credited ✅\n\n_${COMPANY}_`)}>
//                               📱 WA
//                             </button>
//                           )}
//                         </td>
//                       </tr>
//                     ))}
//                     {salaries.length === 0 && (
//                       <tr><td colSpan={9} style={{ ...S.td, textAlign: "center", color: "#94a3b8", padding: 40 }}>No records. Generate salary first.</td></tr>
//                     )}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}

//           {/* ══════════ GENERATE SALARY ══════════ */}
//           {subTab === "Generate Salary" && (
//             <div>
//               <PageHead title="💰 Generate Monthly Salary" />
//               <div className="flex-wrap-row">
//                 <div style={{ ...S.card, maxWidth: 520 }}>
//                   <CardHead>Salary Generation</CardHead>
//                   <div style={{ padding: 20 }}>
//                     <p style={{ fontSize: 12, color: "#64748b", marginBottom: 16, padding: "10px 14px", background: "#f0fdf4", borderRadius: 8, border: "1px solid #bbf7d0" }}>
//                       ℹ️ Generates salary records for all eligible members based on current rank.
//                     </p>
//                     <SectionTitle>Salary Rates by Rank</SectionTitle>
//                     {Object.entries(RANK_SALARY).map(([rank, amt]) => (
//                       <div key={rank} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 12px", borderBottom: "1px solid #f1f5f9", fontSize: 13 }}>
//                         <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
//                           <div style={{ width: 10, height: 10, borderRadius: "50%", background: rank === "diamond" ? "#06b6d4" : rank === "platinum" ? "#8b5cf6" : rank === "gold" ? "#f59e0b" : "#94a3b8" }} />
//                           <span style={{ textTransform: "capitalize", fontWeight: 600 }}>{rank}</span>
//                         </div>
//                         <span style={{ color: "#16a34a", fontWeight: 700 }}>{inr(amt)} / month</span>
//                       </div>
//                     ))}
//                     <div style={{ marginTop: 20 }}>
//                       <button
//                         style={{ ...S.btn, background: generatingSalary ? "#64748b" : "#1e3a8a", width: "100%", padding: 14, fontSize: 15 }}
//                         onClick={generateSalary} disabled={generatingSalary}
//                       >
//                         {generatingSalary ? "⏳ Generating..." : "🚀 Generate This Month's Salary"}
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//                 <div style={{ ...S.card }}>
//                   <CardHead>👥 Eligible Members Preview</CardHead>
//                   <div style={{ padding: "8px 0", maxHeight: 380, overflowY: "auto" }}>
//                     {Object.keys(RANK_SALARY).map(rank => {
//                       const eligible = allMembers.filter(m => m.rank === rank && m.is_approved);
//                       if (eligible.length === 0) return null;
//                       return (
//                         <div key={rank}>
//                           <div style={{ padding: "8px 16px", background: "#f8fafc", fontSize: 11, fontWeight: 700, color: "#475569", textTransform: "uppercase", letterSpacing: 1 }}>
//                             {rank} — {inr(RANK_SALARY[rank])}/mo × {eligible.length} = {inr(RANK_SALARY[rank] * eligible.length)}
//                           </div>
//                           {eligible.slice(0, 3).map(m => (
//                             <div key={m.id} style={{ padding: "6px 16px", borderBottom: "1px solid #f1f5f9", fontSize: 12, display: "flex", justifyContent: "space-between" }}>
//                               <span>{m.receiver_name}</span>
//                               <span style={{ color: "#16a34a", fontWeight: 700 }}>{inr(RANK_SALARY[rank])}</span>
//                             </div>
//                           ))}
//                           {eligible.length > 3 && <div style={{ padding: "4px 16px", fontSize: 11, color: "#94a3b8" }}>+{eligible.length - 3} more...</div>}
//                         </div>
//                       );
//                     })}
//                   </div>
//                 </div>
//               </div>
//             </div>
//           )}

//           {/* ══════════ ALL ADMINS ══════════ */}
//           {subTab === "All Admins" && (
//             <div>
//               <PageHead title="🛡 All Admins" />
//               <div className="table-scroll" style={{ background: "#fff", borderRadius: 8, border: "1px solid #e2e8f0", marginBottom: 16 }}>
//                 <table style={S.table}>
//                   <THead cols={["#", "Username", "Full Name", "Mobile", "Role", "Status", "Created"]} />
//                   <tbody>
//                     {adminList.map((a, i) => (
//                       <tr key={a.id} style={i % 2 === 0 ? S.trEven : {}}>
//                         <td style={S.td}>{i + 1}</td>
//                         <td style={{ ...S.td, fontWeight: 700 }}>{a.username}</td>
//                         <td style={S.td}>{a.full_name}</td>
//                         <td style={S.td}>{a.mobile}</td>
//                         <td style={S.td}><span style={a.role === "superadmin" ? S.greenBadge : S.pill}>{a.role}</span></td>
//                         <td style={S.td}><span style={a.is_active ? S.greenBadge : S.redBadge}>{a.is_active ? "Active" : "Inactive"}</span></td>
//                         <td style={{ ...S.td, fontSize: 11 }}>{fmt(a.created_at)}</td>
//                       </tr>
//                     ))}
//                     {adminList.length === 0 && <tr><td colSpan={7} style={{ ...S.td, textAlign: "center", color: "#94a3b8" }}>No admins</td></tr>}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}

//           {/* ══════════ CREATE ADMIN ══════════ */}
//           {subTab === "Create Admin" && (
//             <div>
//               <PageHead title="➕ Create New Admin" />
//               <div style={{ ...S.card, maxWidth: 480 }}>
//                 <CardHead>Admin Account Details</CardHead>
//                 <div style={{ padding: 20 }}>
//                   {[["Username *", "username", "text"], ["Password *", "password", "password"],
//                     ["Full Name", "full_name", "text"], ["Mobile", "mobile", "text"]].map(([label, key, type]) => (
//                     <div key={key} style={{ marginBottom: 14 }}>
//                       <label style={S.label}>{label}</label>
//                       <input style={S.input} type={type} value={newAdmin[key]}
//                         onChange={e => setNewAdmin({ ...newAdmin, [key]: e.target.value })} />
//                     </div>
//                   ))}
//                   <div style={{ marginBottom: 16 }}>
//                     <label style={S.label}>Role</label>
//                     <select style={S.input} value={newAdmin.role} onChange={e => setNewAdmin({ ...newAdmin, role: e.target.value })}>
//                       <option value="admin">Admin</option>
//                       <option value="superadmin">Super Admin</option>
//                     </select>
//                   </div>
//                   <button style={{ ...S.btn, background: "#1e3a8a", width: "100%", padding: 12 }} onClick={createAdmin}>
//                     Create Admin Account
//                   </button>
//                 </div>
//               </div>
//             </div>
//           )}

//           {tab !== "dashboard" && !subTab && (
//             <div style={{ padding: 60, textAlign: "center", color: "#94a3b8" }}>
//               Select a submenu item from the sidebar.
//             </div>
//           )}

//           {/* ══════════ GALLERY MANAGER ══════════ */}
//           {subTab === "Gallery Manager" && (
//             <div>
//               <PageHead title="🖼 Gallery Manager" />

//               {/* ── Add / Edit Form ── */}
//               <div style={{ ...S.card, maxWidth: 560, marginBottom: 24 }}>
//                 <CardHead>{galleryEditingId ? "✏️ Edit Image" : "➕ Add New Image"}</CardHead>
//                 <div style={{ padding: 20 }}>
//                   <div style={{ marginBottom: 14 }}>
//                     <label style={S.label}>Heading (optional)</label>
//                     <input
//                       style={S.input}
//                       placeholder="Enter image heading..."
//                       value={galleryHeading}
//                       onChange={e => setGalleryHeading(e.target.value)}
//                     />
//                   </div>
//                   <div style={{ marginBottom: 18 }}>
//                     <label style={S.label}>{galleryEditingId ? "Replace Image (optional)" : "Image *"}</label>
//                     <input
//                       id="gallery-file-input"
//                       type="file"
//                       accept="image/*"
//                       style={{ ...S.input, padding: "7px 10px", cursor: "pointer" }}
//                       onChange={e => setGalleryImage(e.target.files[0])}
//                     />
//                     {galleryImage && (
//                       <div style={{ marginTop: 8, fontSize: 11, color: "#64748b" }}>
//                         📎 Selected: {galleryImage.name}
//                       </div>
//                     )}
//                   </div>
//                   <div style={{ display: "flex", gap: 10 }}>
//                     {galleryEditingId ? (
//                       <>
//                         <button
//                           style={{ ...S.btn, background: galleryLoading ? "#64748b" : "#16a34a", flex: 1, padding: 12, justifyContent: "center" }}
//                           onClick={updateGalleryItem}
//                           disabled={galleryLoading}
//                         >
//                           {galleryLoading ? "⏳ Updating..." : "✅ Update Image"}
//                         </button>
//                         <button
//                           style={{ ...S.btn, background: "#64748b", padding: 12 }}
//                           onClick={() => { setGalleryEditingId(null); setGalleryHeading(""); setGalleryImage(null); }}
//                         >
//                           Cancel
//                         </button>
//                       </>
//                     ) : (
//                       <button
//                         style={{ ...S.btn, background: galleryLoading ? "#64748b" : "#1e3a8a", flex: 1, padding: 12, justifyContent: "center" }}
//                         onClick={addGalleryItem}
//                         disabled={galleryLoading}
//                       >
//                         {galleryLoading ? "⏳ Uploading..." : "🖼 Add Image"}
//                       </button>
//                     )}
//                     <button
//                       style={{ ...S.btn, background: "#0369a1", padding: "12px 16px" }}
//                       onClick={loadGallery}
//                     >
//                       🔄
//                     </button>
//                   </div>
//                 </div>
//               </div>

//               {/* ── Gallery count ── */}
//               <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 14 }}>
//                 <SectionTitle>📸 All Gallery Images</SectionTitle>
//                 <span style={{ ...S.countBadge }}>{gallery.length} images</span>
//               </div>

//               {gallery.length === 0 ? (
//                 <div style={{ textAlign: "center", padding: 60, color: "#94a3b8", background: "#f8fafc", borderRadius: 8, border: "2px dashed #e2e8f0" }}>
//                   <div style={{ fontSize: 48, marginBottom: 12 }}>🖼</div>
//                   <div style={{ fontWeight: 700, fontSize: 15 }}>No images yet</div>
//                   <div style={{ fontSize: 12, marginTop: 6 }}>Add your first image using the form above</div>
//                 </div>
//               ) : (
//                 <div style={{
//                   display: "grid",
//                   gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
//                   gap: 16,
//                 }}>
//                   {gallery.map(g => (
//                     <div key={g.id} style={{
//                       background: "#fff",
//                       border: "1px solid #e2e8f0",
//                       borderRadius: 10,
//                       overflow: "hidden",
//                       boxShadow: "0 1px 4px rgba(0,0,0,.07)",
//                       display: "flex",
//                       flexDirection: "column",
//                     }}>
//                       {/* Image */}
//                       <div style={{ position: "relative", paddingTop: "66%", background: "#f1f5f9" }}>
//                         <img
//                           src={`${GALLERY_IMG}/${g.image}`}
//                           alt={g.heading || "Gallery image"}
//                           style={{
//                             position: "absolute", top: 0, left: 0,
//                             width: "100%", height: "100%",
//                             objectFit: "cover",
//                           }}
//                           onError={e => { e.target.style.display = "none"; }}
//                         />
//                         {/* ID badge */}
//                         <span style={{
//                           position: "absolute", top: 8, left: 8,
//                           background: "rgba(0,0,0,.55)", color: "#fff",
//                           fontSize: 10, borderRadius: 99, padding: "2px 8px", fontWeight: 700,
//                         }}>#{g.id}</span>
//                       </div>

//                       {/* Info */}
//                       <div style={{ padding: "10px 12px", flex: 1 }}>
//                         {g.heading ? (
//                           <div style={{ fontWeight: 700, fontSize: 13, color: "#1e293b", marginBottom: 4, wordBreak: "break-word" }}>
//                             {g.heading}
//                           </div>
//                         ) : (
//                           <div style={{ fontSize: 11, color: "#94a3b8", marginBottom: 4, fontStyle: "italic" }}>No heading</div>
//                         )}
//                         <div style={{ fontSize: 10, color: "#94a3b8", wordBreak: "break-all" }}>{g.image}</div>
//                       </div>

//                       {/* Actions */}
//                       <div style={{ display: "flex", gap: 0, borderTop: "1px solid #f1f5f9" }}>
//                         <button
//                           style={{
//                             flex: 1, background: "#fef9c3", color: "#92400e",
//                             border: "none", padding: "9px 0", fontWeight: 700,
//                             fontSize: 12, cursor: "pointer", borderRight: "1px solid #f1f5f9",
//                           }}
//                           onClick={() => editGalleryItem(g)}
//                         >
//                           ✏️ Edit
//                         </button>
//                         <a
//                           href={`${GALLERY_IMG}/${g.image}`}
//                           target="_blank"
//                           rel="noreferrer"
//                           style={{
//                             flex: 1, background: "#eff6ff", color: "#1d4ed8",
//                             border: "none", padding: "9px 0", fontWeight: 700,
//                             fontSize: 12, cursor: "pointer", textDecoration: "none",
//                             display: "flex", alignItems: "center", justifyContent: "center",
//                             borderRight: "1px solid #f1f5f9",
//                           }}
//                         >
//                           👁 View
//                         </a>
//                         <button
//                           style={{
//                             flex: 1, background: "#fee2e2", color: "#991b1b",
//                             border: "none", padding: "9px 0", fontWeight: 700,
//                             fontSize: 12, cursor: "pointer",
//                           }}
//                           onClick={() => deleteGalleryItem(g.id)}
//                         >
//                           🗑 Delete
//                         </button>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               )}
//             </div>
//           )}
//         </main>
//       </div>
//     </div>
//   );
// }

// /* ── Sub-components ── */
// function PageHead({ title, sub, children }) {
//   return (
//     <div className="page-head">
//       <div style={{ width: 4, height: 20, background: "#ea580c", borderRadius: 99, flexShrink: 0 }} />
//       <span style={{ fontWeight: 700, fontSize: 16, color: "#1e293b" }}>{title}</span>
//       {sub && <span style={{ fontSize: 11, color: "#94a3b8" }}>{sub}</span>}
//       {children}
//     </div>
//   );
// }
// function SectionTitle({ children }) {
//   return <div style={{ fontWeight: 700, fontSize: 13, color: "#1e3a8a", margin: "18px 0 8px", borderLeft: "4px solid #ea580c", paddingLeft: 10 }}>{children}</div>;
// }
// function CardHead({ children }) {
//   return <div style={{ background: "#1e3a8a", color: "#fff", padding: "10px 16px", fontWeight: 700, fontSize: 13 }}>{children}</div>;
// }
// function THead({ cols }) {
//   return (
//     <thead>
//       <tr style={{ background: "#1e3a8a", color: "#fff" }}>
//         {cols.map(c => <th key={c} style={{ padding: "10px 12px", textAlign: "left", fontSize: 11, fontWeight: 700, whiteSpace: "nowrap" }}>{c}</th>)}
//       </tr>
//     </thead>
//   );
// }
// function ActionBtn({ color, onClick, disabled, children }) {
//   return (
//     <button onClick={onClick} disabled={disabled}
//       style={{ background: color, color: "#fff", border: "none", padding: "6px 10px", borderRadius: 5, cursor: "pointer", fontSize: 13, fontWeight: 700, opacity: disabled ? .6 : 1, minHeight: 36, minWidth: 36 }}>
//       {children}
//     </button>
//   );
// }

// /* ── Styles ── */
// const S = {
//   shell: { display: "flex", flexDirection: "column", minHeight: "100vh", fontFamily: "'Segoe UI', system-ui, sans-serif", fontSize: 13, background: "#f1f5f9" },
//   topbar: { background: "linear-gradient(90deg,#1e3a8a 0%,#1e40af 100%)", color: "#fff", display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 16px", position: "sticky", top: 0, zIndex: 100, boxShadow: "0 2px 10px rgba(0,0,0,.3)" },
//   logoBadge: { width: 38, height: 38, borderRadius: 10, background: "linear-gradient(135deg,#f97316,#ea580c)", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 900, fontSize: 17, color: "#fff" },
//   superBadge: { background: "rgba(255,255,255,.15)", border: "1px solid rgba(255,255,255,.3)", borderRadius: 99, padding: "3px 12px", fontSize: 11, fontWeight: 700, color: "#fef3c7", letterSpacing: .5 },
//   logoutBtn: { background: "rgba(239,68,68,.85)", border: "none", color: "#fff", padding: "6px 14px", borderRadius: 6, cursor: "pointer", fontWeight: 600, fontSize: 12, whiteSpace: "nowrap" },
//   navItem: { color: "#bfdbfe", padding: "11px 16px", cursor: "pointer", display: "flex", alignItems: "center", fontSize: 13, borderBottom: "1px solid rgba(255,255,255,.06)", fontWeight: 500 },
//   navActive: { background: "#ea580c", color: "#fff" },
//   navSub: { color: "#93c5fd", padding: "9px 16px 9px 28px", cursor: "pointer", fontSize: 12, background: "rgba(0,0,0,.25)", borderBottom: "1px solid rgba(255,255,255,.04)" },
//   navSubActive: { background: "#ea580c", color: "#fff", fontWeight: 700 },
//   content: { flex: 1, padding: 16, overflowX: "hidden", minWidth: 0 },
//   kpiCard: { color: "#fff", borderRadius: 10, padding: "12px 14px", display: "flex", flexDirection: "column", gap: 4, boxShadow: "0 2px 8px rgba(0,0,0,.15)" },
//   card: { background: "#fff", border: "1px solid #e2e8f0", borderRadius: 8, overflow: "hidden", marginBottom: 16 },
//   table: { width: "100%", borderCollapse: "collapse" },
//   td: { padding: "9px 12px", fontSize: 12, borderBottom: "1px solid #f1f5f9", verticalAlign: "middle" },
//   trEven: { background: "#f8fafc" },
//   infoChip: { background: "#f0f9ff", border: "1px solid #bae6fd", borderRadius: 8, padding: "8px 12px" },
//   searchBox: { border: "1px solid #e2e8f0", borderRadius: 6, padding: "8px 12px", fontSize: 13, outline: "none", background: "#fff", width: "100%" },
//   countBadge: { background: "#eff6ff", color: "#1d4ed8", padding: "5px 12px", borderRadius: 99, fontWeight: 700, fontSize: 12, whiteSpace: "nowrap" },
//   pill: { background: "#eff6ff", color: "#1d4ed8", padding: "2px 8px", borderRadius: 99, fontSize: 11, fontWeight: 600 },
//   greenBadge: { background: "#dcfce7", color: "#15803d", padding: "2px 8px", borderRadius: 99, fontSize: 11, fontWeight: 700 },
//   yellowBadge: { background: "#fef9c3", color: "#854d0e", padding: "2px 8px", borderRadius: 99, fontSize: 11, fontWeight: 700 },
//   redBadge: { background: "#fee2e2", color: "#991b1b", padding: "2px 8px", borderRadius: 99, fontSize: 11, fontWeight: 700 },
//   badge: { padding: "2px 8px", borderRadius: 99, fontSize: 11, fontWeight: 600 },
//   label: { display: "block", fontSize: 12, color: "#475569", marginBottom: 4, fontWeight: 600 },
//   input: { border: "1px solid #e2e8f0", padding: "9px 12px", width: "100%", fontSize: 13, borderRadius: 6, outline: "none", boxSizing: "border-box" },
//   btn: { color: "#fff", border: "none", padding: "7px 14px", borderRadius: 6, cursor: "pointer", fontWeight: 600, fontSize: 13, display: "inline-flex", alignItems: "center", gap: 4 },
// };



import { useState, useEffect, useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import {
  BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer,
  PieChart, Pie, Cell, Legend, LineChart, Line
} from "recharts";
import api from "../api";
import toast from "react-hot-toast";

/* ─── Constants ─── */
const LEVEL_RATE = { 1: 300, 2: 150, 3: 120, 4: 90, 5: 60, 6: 30 };
const RANK_SALARY = { silver: 1000, gold: 3000, platinum: 7000, diamond: 15000 };
const PIE_COLORS = ["#3b82f6", "#10b981", "#f59e0b", "#ef4444", "#8b5cf6", "#06b6d4"];
const COMPANY = "Meruram Lucky Draw";
const COMPANY_URL = "https://meruram.in";

/* ─── WhatsApp helper ─── */
const whatsapp = (mobile, msg) => {
  if (!mobile) { toast.error("No mobile number!"); return; }
  window.open(`https://wa.me/91${mobile.replace(/\D/g, "")}?text=${encodeURIComponent(msg)}`, "_blank");
};

/* ─── Format helpers ─── */
const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const fmt = (d) => d ? new Date(d).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : "—";
const fmtTime = (d) => d ? new Date(d).toLocaleString("en-IN") : "—";

/* ─── Sidebar nav ─── */
const NAV = [
  { label: "📊 Dashboard", key: "dashboard" },
  {
    label: "🎟 Members", key: "members",
    children: ["All Members", "Pending Approval", "Approved Members", "Member Detail"],
  },
  {
    label: "💹 Income & Business", key: "income",
    children: [
      "Level Income Report",
      "Level Wise Report",
      "Commission Report",
      "Direct Business Report",
      "Business Report",
      "Commission Summary",
      "Daily Joins",
      "Network Tree",
    ],
  },
  {
    label: "💸 Payments", key: "payments",
    children: ["Withdrawal Requests", "Payment History", "Add Fund to Member"],
  },
  {
    label: "💰 Salary", key: "salary",
    children: ["Salary List", "Generate Salary"],
  },
  {
    label: "🛡 Admin Mgmt", key: "admins",
    children: ["All Admins", "Create Admin"],
  },
  {
    label: "🖼 Gallery", key: "gallery",
    children: ["Gallery Manager"],
  },
];

/* ══════════════════════════════════════════════
   RESPONSIVE STYLES (injected once)
══════════════════════════════════════════════ */
const GLOBAL_CSS = `
  * { box-sizing: border-box; }
  body { margin: 0; }

  .table-scroll { overflow-x: auto; -webkit-overflow-scrolling: touch; }
  .table-scroll table { min-width: 600px; }

  .sidebar-overlay {
    display: none;
    position: fixed; inset: 0;
    background: rgba(0,0,0,.5);
    z-index: 200;
  }
  .sidebar-overlay.open { display: block; }

  .sidebar-drawer {
    position: fixed;
    top: 0; left: 0; bottom: 0;
    width: 220px;
    background: #1e3a8a;
    z-index: 201;
    overflow-y: auto;
    transform: translateX(-100%);
    transition: transform .25s ease;
  }
  .sidebar-drawer.open { transform: translateX(0); }

  .hamburger {
    display: none;
    background: rgba(255,255,255,.15);
    border: none;
    color: #fff;
    font-size: 20px;
    padding: 6px 10px;
    border-radius: 6px;
    cursor: pointer;
    line-height: 1;
  }

  .sidebar-desktop {
    width: 205px;
    background: #1e3a8a;
    min-height: calc(100vh - 60px);
    flex-shrink: 0;
    overflow-y: auto;
  }

  .kpi-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
    gap: 10px;
    margin-bottom: 16px;
  }

  .chip-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 16px;
  }
  .info-chip {
    background: #f0f9ff;
    border: 1px solid #bae6fd;
    border-radius: 8px;
    padding: 8px 12px;
    min-width: 120px;
    flex: 1 1 120px;
    max-width: 200px;
  }

  .flex-wrap-row {
    display: flex;
    gap: 14px;
    flex-wrap: wrap;
  }
  .flex-wrap-row > * { min-width: 260px; flex: 1; }

  /* Action buttons - always wrap nicely */
  .action-cell { display: flex; gap: 4px; flex-wrap: wrap; min-width: 140px; }
  .action-cell button { flex-shrink: 0; }

  .search-row {
    display: flex;
    gap: 10px;
    margin-bottom: 12px;
    flex-wrap: wrap;
    align-items: center;
  }
  .search-row input { flex: 1; min-width: 200px; }

  .page-head {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 16px;
    padding-bottom: 12px;
    border-bottom: 2px solid #e2e8f0;
    flex-wrap: wrap;
  }

  .card-row {
    display: flex;
    gap: 14px;
    margin-top: 4px;
    flex-wrap: wrap;
  }
  .card-row .chart-card { flex: 2; min-width: 260px; }
  .card-row .dist-card  { flex: 1; min-width: 200px; }

  .topbar-left { display: flex; align-items: center; gap: 12px; }
  .topbar-right { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }
  .super-badge-hide { display: inline; }

  .level-cards {
    display: flex;
    gap: 8px;
    margin-bottom: 16px;
    flex-wrap: wrap;
  }
  .level-cards > div { min-width: 100px; flex: 1; }

  .repair-panel {
    display: flex;
    gap: 16px;
    align-items: flex-start;
    flex-wrap: wrap;
  }
  .repair-panel .repair-left  { flex: 1; min-width: 220px; }
  .repair-panel .repair-right { display: flex; flex-direction: column; gap: 8px; min-width: 200px; }

  /* ── Image Lightbox Modal ── */
  .img-modal-overlay {
    display: none;
    position: fixed; inset: 0;
    background: rgba(0,0,0,.85);
    z-index: 9000;
    align-items: center;
    justify-content: center;
    padding: 16px;
  }
  .img-modal-overlay.open { display: flex; }
  .img-modal-box {
    position: relative;
    max-width: 90vw;
    max-height: 90vh;
    background: #0f172a;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 25px 60px rgba(0,0,0,.7);
  }
  .img-modal-box img {
    display: block;
    max-width: 90vw;
    max-height: 82vh;
    object-fit: contain;
  }
  .img-modal-close {
    position: absolute; top: 10px; right: 10px;
    background: rgba(239,68,68,.9); color: #fff;
    border: none; border-radius: 50%;
    width: 36px; height: 36px;
    font-size: 18px; cursor: pointer;
    display: flex; align-items: center; justify-content: center;
    font-weight: 900; z-index: 1;
  }
  .img-modal-caption {
    padding: 10px 16px;
    color: #94a3b8;
    font-size: 12px;
    text-align: center;
    background: #0f172a;
  }

  /* ── Edit Member Modal ── */
  .edit-modal-overlay {
    display: none;
    position: fixed; inset: 0;
    background: rgba(0,0,0,.6);
    z-index: 8000;
    align-items: center;
    justify-content: center;
    padding: 16px;
  }
  .edit-modal-overlay.open { display: flex; }
  .edit-modal-box {
    background: #fff;
    border-radius: 12px;
    width: 100%;
    max-width: 500px;
    max-height: 90vh;
    overflow-y: auto;
    box-shadow: 0 25px 60px rgba(0,0,0,.5);
  }
  .edit-modal-header {
    background: #1e3a8a;
    color: #fff;
    padding: 14px 18px;
    font-weight: 800;
    font-size: 14px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: sticky; top: 0;
  }
  .edit-modal-header button {
    background: rgba(239,68,68,.8);
    border: none; color: #fff;
    border-radius: 50%; width: 30px; height: 30px;
    font-size: 16px; cursor: pointer;
    display: flex; align-items: center; justify-content: center;
  }

  @media (max-width: 768px) {
    .hamburger { display: block; }
    .sidebar-desktop { display: none; }
    .super-badge-hide { display: none; }
    .kpi-grid { grid-template-columns: repeat(2, 1fr); }
    .info-chip { max-width: 100%; }
    .flex-wrap-row > * { min-width: 100%; }
    .card-row .chart-card, .card-row .dist-card { min-width: 100%; }
    .level-cards > div { min-width: calc(50% - 8px); }
    .repair-panel { flex-direction: column; }
    .repair-panel .repair-right { min-width: 100%; }
    .table-scroll table { font-size: 11px; }
    .table-scroll th, .table-scroll td { padding: 7px 8px !important; }
    .action-cell { min-width: 120px; }
  }

  @media (max-width: 480px) {
    .kpi-grid { grid-template-columns: repeat(2, 1fr); }
    .level-cards > div { min-width: 100%; }
    .topbar-right .logout-text { display: none; }
    .gallery-grid { grid-template-columns: repeat(2, 1fr) !important; }
  }
`;

function GlobalStyles() {
  useEffect(() => {
    const id = "sad-responsive-styles";
    if (!document.getElementById(id)) {
      const el = document.createElement("style");
      el.id = id;
      el.textContent = GLOBAL_CSS;
      document.head.appendChild(el);
    }
    return () => { const el = document.getElementById(id); if (el) el.remove(); };
  }, []);
  return null;
}

/* ══════════ IMAGE LIGHTBOX ══════════ */
function ImageModal({ src, caption, onClose }) {
  useEffect(() => {
    const handler = (e) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", handler);
    return () => document.removeEventListener("keydown", handler);
  }, [onClose]);

  if (!src) return null;
  return (
    <div className={`img-modal-overlay${src ? " open" : ""}`} onClick={onClose}>
      <div className="img-modal-box" onClick={e => e.stopPropagation()}>
        <button className="img-modal-close" onClick={onClose}>✕</button>
        <img src={src} alt={caption || "Screenshot"} />
        {caption && <div className="img-modal-caption">{caption}</div>}
      </div>
    </div>
  );
}

/* ══════════ EDIT MEMBER MODAL ══════════ */
function EditMemberModal({ member, onClose, onSave }) {
  const [form, setForm] = useState({
    receiver_name: member?.receiver_name || "",
    receiver_mobile: member?.receiver_mobile || "",
    receiver_aadhaar: member?.receiver_aadhaar || "",
    receiver_address: member?.receiver_address || "",

    bank_name: member?.bank_name || "",
    account_number: member?.account_number || "",
    ifsc: member?.ifsc || "",
    upi_id: member?.upi_id || "",

    giver_name: member?.giver_name || "",
    giver_mobile: member?.giver_mobile || "",

    screenshot: null, // 👈 add this
  });
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
  setSaving(true);

  try {
    const formData = new FormData();

    Object.keys(form).forEach(key => {
      if (key === "screenshot") {
        // Only send file if selected
        if (form.screenshot) {
          formData.append("screenshot", form.screenshot);
        }
      } else {
        formData.append(key, form[key]);
      }
    });

    await api.put(`/coupons/edit/${member.id}`, formData, {
      headers: { "Content-Type": "multipart/form-data" }
    });

    toast.success("✅ Member updated!");
    onSave();
    onClose();
  } catch (err) {
    toast.error(err.response?.data?.message || "Update failed");
  }

  setSaving(false);
};
  if (!member) return null;
 const fields = [
  ["Full Name", "receiver_name", "text"],
  ["Mobile Number", "receiver_mobile", "text"],
  ["Aadhaar Number", "receiver_aadhaar", "text"],
  ["Address", "receiver_address", "text"],

  ["Giver Name", "giver_name", "text"],
  ["Giver Mobile Number", "giver_mobile", "text"],

  ["Payment Screenshot", "screenshot", "file"], // 👈 added
];

{fields.map(([label, key, type]) => (
  <div key={key} style={{ marginBottom: 12 }}>
    <label style={S.label}>{label}</label>

    {type === "file" ? (
      <>
        {/* Show current image */}
        {member?.screenshot && (
          <img
            src={`https://luckydraw.hoppersdome.com/uploads/${member.screenshot}`}
            alt="Current"
            style={{ width: 120, marginBottom: 8, display: "block" }}
          />
        )}

        <input
          type="file"
          accept="image/*"
          style={S.input}
          onChange={e =>
            setForm({ ...form, screenshot: e.target.files[0] })
          }
        />
      </>
    ) : (
      <input
        style={S.input}
        type={type}
        value={form[key]}
        onChange={e =>
          setForm({ ...form, [key]: e.target.value })
        }
      />
    )}
  </div>
))}
  return (
    <div className="edit-modal-overlay open" onClick={onClose}>
      <div className="edit-modal-box" onClick={e => e.stopPropagation()}>
        <div className="edit-modal-header">
          <span>✏️ Edit Member — {member.receiver_coupon_no}</span>
          <button onClick={onClose}>✕</button>
        </div>
        <div style={{ padding: 20 }}>
          <div style={{ padding: "8px 12px", background: "#fef9c3", borderRadius: 8, fontSize: 12, color: "#854d0e", marginBottom: 16, border: "1px solid #fde68a" }}>
            ⚠️ Editing member: <b>{member.receiver_coupon_no}</b> — {member.receiver_name}
          </div>
          {fields.map(([label, key, type]) => (
            <div key={key} style={{ marginBottom: 12 }}>
              <label style={S.label}>{label}</label>
              <input style={S.input} type={type} value={form[key]}
                onChange={e => setForm({ ...form, [key]: e.target.value })} />
            </div>
          ))}
          <div style={{ display: "flex", gap: 10, marginTop: 20 }}>
            <button style={{ ...S.btn, background: saving ? "#64748b" : "#16a34a", flex: 1, padding: 12, justifyContent: "center" }}
              onClick={handleSave} disabled={saving}>
              {saving ? "⏳ Saving..." : "✅ Save Changes"}
            </button>
            <button style={{ ...S.btn, background: "#64748b", padding: 12 }} onClick={onClose}>Cancel</button>
          </div>
        </div>
      </div>
    </div>
  );
}

/* ══════════════════════════════════════════════
   SIDEBAR CONTENT
══════════════════════════════════════════════ */
function SidebarContent({ tab, subTab, openNav, setOpenNav, goTo, logout, navigate, onNavClick }) {
  return (
    <>
      {NAV.map(n => (
        <div key={n.key}>
          <div
            style={{ ...S.navItem, ...(tab === n.key && !subTab && !n.children ? S.navActive : {}) }}
            onClick={() => {
              if (n.children) {
                setOpenNav(p => ({ ...p, [n.key]: !p[n.key] }));
              } else {
                goTo(n.key);
                onNavClick && onNavClick();
              }
            }}
          >
            <span style={{ flex: 1 }}>{n.label}</span>
            {n.children && <span style={{ fontSize: 10, opacity: .6 }}>{openNav[n.key] ? "▾" : "▸"}</span>}
          </div>
          {n.children && openNav[n.key] && n.children
            .filter(c => c !== "Member Detail")
            .map(child => (
              <div key={child}
                style={{ ...S.navSub, ...(subTab === child ? S.navSubActive : {}) }}
                onClick={() => { goTo(n.key, child); onNavClick && onNavClick(); }}
              >{child}</div>
            ))}
        </div>
      ))}
      <div style={S.navItem} onClick={() => { logout(); navigate("/superadmin/login"); }}>
        🚪 Logout
      </div>
    </>
  );
}

/* ══════════════════════════════════════════════
   MAIN COMPONENT
══════════════════════════════════════════════ */
export default function SuperAdminDashboard() {
  const { admin, logout } = useAuth();
  const navigate = useNavigate();

  /* State */
  const [stats, setStats] = useState(null);
  const [allMembers, setAllMembers] = useState([]);
  const [withdrawals, setWithdrawals] = useState([]);
  const [payHistory, setPayHistory] = useState([]);
  const [salaries, setSalaries] = useState([]);
  const [adminList, setAdminList] = useState([]);
  const [selectedMember, setSelectedMember] = useState(null);
  const [memberDetail, setMemberDetail] = useState(null);
  const [loadingDetail, setLoadingDetail] = useState(false);
  const [commissions, setCommissions] = useState([]);
  const [networkTree, setNetworkTree] = useState(null);
  const [networkToken, setNetworkToken] = useState("");
  const [dailyJoins, setDailyJoins] = useState([]);
  const [generatingSalary, setGeneratingSalary] = useState(false);
  const [repairing, setRepairing] = useState(false);
  const [repairLog, setRepairLog] = useState([]);

  const [tab, setTab] = useState("dashboard");
  const [subTab, setSubTab] = useState("");
  const [openNav, setOpenNav] = useState({ dashboard: true });
  const [search, setSearch] = useState("");
  const [approving, setApproving] = useState({});
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [membersPage, setMembersPage] = useState(1);
  const [membersTotal, setMembersTotal] = useState(0);
  const MEMBERS_PER_PAGE = 10;

  /* ── NEW: Image lightbox state ── */
  const [lightboxSrc, setLightboxSrc] = useState(null);
  const [lightboxCaption, setLightboxCaption] = useState("");

  /* ── NEW: Edit member modal state ── */
  const [editingMember, setEditingMember] = useState(null);

  const [addFundForm, setAddFundForm] = useState({ token_number: "", amount: "", description: "Fund added by admin" });
  const [newAdmin, setNewAdmin] = useState({ username: "", password: "", full_name: "", mobile: "", role: "admin" });

  /* ── Gallery state ── */
  const [gallery, setGallery] = useState([]);
  const [galleryHeading, setGalleryHeading] = useState("");
  const [galleryImage, setGalleryImage] = useState(null);
  const [galleryEditingId, setGalleryEditingId] = useState(null);
  const [galleryLoading, setGalleryLoading] = useState(false);

  /* ── Helper: open lightbox ── */
  const openLightbox = (src, caption = "") => {
    setLightboxSrc(src);
    setLightboxCaption(caption);
  };

  /* ── Fetch functions ── */
  const loadStats = useCallback(async () => {
    try { const r = await api.get("/mlm/super-stats"); setStats(r.data); } catch { toast.error("Stats load failed"); }
  }, []);

  const loadMembers = useCallback(async (q = "", pg = 1) => {
    try {
      const r = await api.get(`/coupons/all?search=${encodeURIComponent(q)}&limit=10&page=${pg}`);
      setAllMembers(r.data.rows || []);
      setMembersTotal(r.data.total || 0);
      setMembersPage(pg);
    } catch (e) { toast.error("Members load failed: " + (e.response?.data?.message || e.message)); }
  }, []);

  const loadWithdrawals = useCallback(async () => {
    try { const r = await api.get("/wallet/withdrawals/all?status=pending"); setWithdrawals(r.data.rows || []); } catch {}
  }, []);

  const loadPayHistory = useCallback(async () => {
    try { const r = await api.get("/mlm/payment-history"); setPayHistory(r.data.rows || []); } catch {}
  }, []);

  const loadSalaries = useCallback(async () => {
    try { const r = await api.get("/mlm/salary/list"); setSalaries(r.data.rows || []); } catch {}
  }, []);

  const loadAdmins = useCallback(async () => {
    try { const r = await api.get("/auth/admins"); setAdminList(r.data || []); } catch {}
  }, []);

  const GALLERY_IMG = "https://luckydraw.hoppersdome.com/uploads/gallery";

  const loadGallery = useCallback(async () => {
    try {
      const r = await api.get("/gallery/all");
      setGallery(r.data || []);
    } catch { toast.error("Gallery load failed"); }
  }, []);

  const addGalleryItem = async () => {
    if (!galleryImage) { toast.error("Please select an image"); return; }
    setGalleryLoading(true);
    try {
      const fd = new FormData();
      fd.append("heading", galleryHeading);
      fd.append("image", galleryImage);
      await api.post("/gallery/add", fd, { headers: { "Content-Type": "multipart/form-data" } });
      toast.success("✅ Image added!");
      setGalleryHeading(""); setGalleryImage(null);
      document.getElementById("gallery-file-input").value = "";
      loadGallery();
    } catch (err) { toast.error(err.response?.data?.message || "Add failed"); }
    setGalleryLoading(false);
  };

  const updateGalleryItem = async () => {
    setGalleryLoading(true);
    try {
      const fd = new FormData();
      fd.append("heading", galleryHeading);
      if (galleryImage) fd.append("image", galleryImage);
      await api.put(`/gallery/update/${galleryEditingId}`, fd, { headers: { "Content-Type": "multipart/form-data" } });
      toast.success("✅ Updated!");
      setGalleryHeading(""); setGalleryImage(null); setGalleryEditingId(null);
      const el = document.getElementById("gallery-file-input");
      if (el) el.value = "";
      loadGallery();
    } catch (err) { toast.error(err.response?.data?.message || "Update failed"); }
    setGalleryLoading(false);
  };

  const deleteGalleryItem = async (id) => {
    if (!window.confirm("Delete this image permanently?")) return;
    try {
      await api.delete(`/gallery/delete/${id}`);
      toast.success("Deleted");
      loadGallery();
    } catch { toast.error("Delete failed"); }
  };

  const editGalleryItem = (g) => {
    setGalleryEditingId(g.id);
    setGalleryHeading(g.heading || "");
    setGalleryImage(null);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const loadMemberDetail = useCallback(async (token) => {
    if (!token) return;
    setLoadingDetail(true);
    try {
      const r = await api.get(`/mlm/member-detail/${token}`);
      if (r.data.success) {
        setMemberDetail(r.data);
      } else {
        toast.error("Member not found");
      }
    } catch { toast.error("Failed to load member detail"); }
    setLoadingDetail(false);
  }, []);

  const loadCommissions = useCallback(async () => {
    try {
      const r = await api.get("/mlm/commissions/all?limit=500");
      setCommissions(r.data.rows || []);
    } catch { toast.error("Commissions load failed"); }
  }, []);

  const loadDailyJoins = useCallback(async () => {
    try {
      const r = await api.get("/mlm/daily-joins?days=30");
      setDailyJoins(r.data.rows || []);
    } catch (e) { toast.error("Daily joins load failed"); }
  }, []);

  const loadNetworkTree = useCallback(async (token) => {
    if (!token) { toast.error("Enter a token/coupon number"); return; }
    try {
      const r = await api.get(`/mlm/network-tree/${token}`);
      if (r.data.success && r.data.token_number) {
        setNetworkTree(r.data);
      } else if (r.data.tree) {
        setNetworkTree(r.data.tree);
      } else {
        toast.error("Member not found");
      }
    } catch { toast.error("Network tree load failed"); }
  }, []);

  useEffect(() => {
    Promise.all([loadStats(), loadMembers(), loadWithdrawals()]);
  }, []);

  /* ── Navigation ── */
  const goTo = useCallback((t, s = "") => {
    setTab(t); setSubTab(s);
    if (t === "admins") loadAdmins();
    if (t === "gallery" || s === "Gallery Manager") loadGallery();
    if (s === "Withdrawal Requests") loadWithdrawals();
    if (s === "Payment History") loadPayHistory();
    if (s === "Salary List" || s === "Generate Salary") loadSalaries();
    if (s === "Commission Report") loadCommissions();
    if (s === "Daily Joins") loadDailyJoins();
    if (
      s === "All Members" || s === "Pending Approval" || s === "Approved Members" ||
      s === "Level Income Report" || s === "Level Wise Report" ||
      s === "Direct Business Report" || s === "Business Report" ||
      s === "Commission Summary" || s === "Commission Report"
    ) { setMembersPage(1); loadMembers(search, 1); }
  }, [search, loadAdmins, loadWithdrawals, loadPayHistory, loadSalaries, loadMembers, loadCommissions, loadDailyJoins]);

  /* ── Actions ── */
  const approveCoupon = async (id, row) => {
    setApproving(p => ({ ...p, [id]: true }));
    try {
      await api.post(`/coupons/approve/${id}`);
      toast.success("✅ Approved!");
      await Promise.all([loadMembers(search), loadStats()]);
      if (row?.receiver_mobile) {
        const message = `Welcome ${row.receiver_name} 🎉\n\nYour ID ${row.receiver_coupon_no || ""} has been approved successfully.\n\nWelcome to Meruram family 🚀\n\n${COMPANY_URL}`;
        window.open(`https://wa.me/91${row.receiver_mobile.replace(/\D/g, "")}?text=${encodeURIComponent(message)}`, "_blank");
      }
    } catch (err) { toast.error(err.response?.data?.message || "Error"); }
    setApproving(p => ({ ...p, [id]: false }));
  };

  const deleteCoupon = async (id) => {
    if (!window.confirm("Delete this coupon permanently?")) return;
    try { await api.delete(`/coupons/delete/${id}`); toast.success("Deleted"); loadMembers(search); loadStats(); }
    catch { toast.error("Delete failed"); }
  };

  /* ── NEW: Delete Admin ── */
  const deleteAdmin = async (id, username) => {
    if (!window.confirm(`Delete admin "${username}" permanently? This cannot be undone.`)) return;
    try {
      await api.delete(`/auth/admin/${id}`);
      toast.success("Admin deleted");
      loadAdmins();
    } catch (err) { toast.error(err.response?.data?.message || "Delete failed"); }
  };

  const processWithdrawal = async (id, action, row) => {
    try {
      await api.put(`/wallet/withdrawals/${id}`, { action });
      if (action === "approved") {
        toast.success("✅ Approved! Sending WhatsApp...");
        whatsapp(row.receiver_mobile,
          `💸 Namaste *${row.receiver_name}*!\n\nYour withdrawal request of *${inr(row.amount)}* has been *APPROVED & PROCESSED* ✅\n\nPayment via: *${(row.method || "").toUpperCase()}*\n${row.method === "upi" ? `UPI: ${row.upi_id || "—"}` : `Bank: ${row.bank_name || "—"} | Acc: ${row.account_number || "—"}`}\n\n_${COMPANY}_\n${COMPANY_URL}`
        );
      } else {
        toast.error("❌ Withdrawal rejected");
      }
      loadWithdrawals(); loadPayHistory(); loadStats();
    } catch (err) { toast.error(err.response?.data?.message || "Error"); }
  };

  const approveSalary = async (id, row) => {
    try {
      await api.put(`/mlm/salary/approve/${id}`);
      toast.success("Salary credited!");
      if (row?.receiver_mobile) {
        whatsapp(row.receiver_mobile,
          `💰 Namaste *${row.receiver_name}*!\n\nYour *${row.rank?.toUpperCase()} Rank Salary* of *${inr(row.amount)}* for ${row.month} has been credited to your wallet ✅\n\n_${COMPANY}_\n${COMPANY_URL}`
        );
      }
      loadSalaries();
    } catch (err) { toast.error(err.response?.data?.message || "Error"); }
  };

  const generateSalary = async () => {
    setGeneratingSalary(true);
    try {
      const r = await api.post("/mlm/salary/generate");
      toast.success(r.data.message || "Salary generated!");
      loadSalaries();
      goTo("salary", "Salary List");
    } catch (err) { toast.error(err.response?.data?.message || "Error"); }
    setGeneratingSalary(false);
  };

  const runFullRepair = async () => {
    if (!window.confirm(
      "⚠️ This will:\n1. Fix referred_by for all members\n2. Redistribute missing commissions\n3. Recalculate all ranks\n\nSafe to run multiple times. Continue?"
    )) return;

    setRepairing(true);
    setRepairLog([]);
    const log = [];

    try {
      log.push("🔧 Step 1: Fixing referred_by links...");
      setRepairLog([...log]);
      const r1 = await api.post("/mlm/fix-referred-by");
      log.push(`✅ Step 1 done: ${r1.data.fixed} members linked, ${r1.data.skipped} skipped`);
      setRepairLog([...log]);

      log.push("💰 Step 2: Redistributing commissions...");
      setRepairLog([...log]);
      const r2 = await api.post("/mlm/redistribute-commissions");
      log.push(`✅ Step 2 done: commissions distributed for ${r2.data.processed} members`);
      if (r2.data.errors?.length) log.push(`⚠️ ${r2.data.errors.length} errors (check server logs)`);
      setRepairLog([...log]);

      log.push("🏆 Step 3: Recalculating all ranks...");
      setRepairLog([...log]);
      const r3 = await api.post("/mlm/recalculate-all-ranks");
      const rankSummary = Object.entries(r3.data.summary || {}).map(([rank, count]) => `${rank}: ${count}`).join(", ");
      log.push(`✅ Step 3 done: ${r3.data.message} → ${rankSummary}`);
      setRepairLog([...log]);

      log.push("🎉 All repairs complete! Reloading data...");
      setRepairLog([...log]);

      await Promise.all([loadStats(), loadMembers()]);
      toast.success("✅ Data repair complete!");
    } catch (err) {
      log.push(`❌ Error: ${err.response?.data?.message || err.message}`);
      setRepairLog([...log]);
      toast.error("Repair failed — check log");
    }
    setRepairing(false);
  };

  const addFund = async () => {
    if (!addFundForm.token_number || !addFundForm.amount) { toast.error("Fill all fields"); return; }
    try {
      const r = await api.post("/mlm/add-fund", addFundForm);
      toast.success(r.data.message);
      setAddFundForm({ token_number: "", amount: "", description: "Fund added by admin" });
      loadMembers(); loadStats();
    } catch (err) { toast.error(err.response?.data?.message || "Error"); }
  };

  const createAdmin = async () => {
    if (!newAdmin.username || !newAdmin.password) { toast.error("Username & password required"); return; }
    try {
      await api.post("/auth/create-admin", newAdmin);
      toast.success("Admin created!");
      setNewAdmin({ username: "", password: "", full_name: "", mobile: "", role: "admin" });
      loadAdmins();
    } catch (err) { toast.error(err.response?.data?.message || "Error"); }
  };

  const openDetail = async (row) => {
    const tokenToLoad = row.token_number || row.token;
    setSelectedMember(row);
    setTab("members"); setSubTab("Member Detail");
    await loadMemberDetail(tokenToLoad);
  };

  /* ── Filtered member lists ── */
  const filteredMembers = useMemo(() => {
    // Server already paginates; client-side filter only for approval status tabs
    if (subTab === "Pending Approval") return allMembers.filter(c => !c.is_approved);
    if (subTab === "Approved Members") return allMembers.filter(c => c.is_approved);
    return allMembers;
  }, [allMembers, subTab]);

  // Total pages from server count (for All Members) or filtered client count
  const totalPagesDisplay = useMemo(() => {
    if (subTab === "Pending Approval" || subTab === "Approved Members")
      return Math.ceil(filteredMembers.length / MEMBERS_PER_PAGE) || 1;
    return Math.ceil(membersTotal / MEMBERS_PER_PAGE) || 1;
  }, [filteredMembers, membersTotal, subTab, MEMBERS_PER_PAGE]);

  const topByIncome = useMemo(() =>
    [...allMembers].sort((a, b) => Number(b.total_income || 0) - Number(a.total_income || 0)).slice(0, 10),
    [allMembers]
  );

  const topByDirect = useMemo(() =>
    [...allMembers].sort((a, b) => Number(b.direct_count || 0) - Number(a.direct_count || 0)).slice(0, 10),
    [allMembers]
  );

  const levelSummary = useMemo(() => {
    const map = {};
    allMembers.forEach(m => {
      for (let l = 1; l <= 6; l++) {
        const earned = Number(m[`level${l}_income`] || 0);
        if (!map[l]) map[l] = { level: l, total: 0, members_paid: 0, rate: LEVEL_RATE[l] };
        if (earned > 0) { map[l].total += earned; map[l].members_paid++; }
      }
    });
    return Object.values(map);
  }, [allMembers]);

  const commissionByLevel = useMemo(() => {
    const map = {};
    commissions.forEach(c => {
      const l = c.level;
      if (!map[l]) map[l] = { level: l, count: 0, total: 0 };
      map[l].count++;
      map[l].total += Number(c.amount || 0);
    });
    return Object.values(map).sort((a, b) => a.level - b.level);
  }, [commissions]);

  /* ── Network Tree recursive renderer ── */
  const TreeNode = ({ node, depth = 0 }) => {
    const [expanded, setExpanded] = useState(depth < 2);
    if (!node) return null;
    const hasChildren = node.children && node.children.length > 0;
    return (
      <div style={{ marginLeft: depth * 16, marginBottom: 4 }}>
        <div
          style={{
            display: "flex", alignItems: "center", gap: 6, padding: "8px 10px",
            background: depth === 0 ? "#1e3a8a" : depth === 1 ? "#1d4ed8" : depth === 2 ? "#3b82f6" : "#eff6ff",
            color: depth < 3 ? "#fff" : "#1e3a8a",
            borderRadius: 8, cursor: hasChildren ? "pointer" : "default",
            border: "1px solid rgba(255,255,255,0.1)",
            flexWrap: "wrap",
            minHeight: 44,
          }}
          onClick={() => hasChildren && setExpanded(e => !e)}
        >
          {hasChildren && <span style={{ fontSize: 10, minWidth: 12 }}>{expanded ? "▼" : "▶"}</span>}
          {!hasChildren && <span style={{ fontSize: 10, minWidth: 12, opacity: 0.5 }}>●</span>}
          <span style={{ fontWeight: 700, fontSize: 12 }}>{node.receiver_coupon_no || node.token_number}</span>
          <span style={{ fontSize: 12 }}>{node.receiver_name}</span>
          <span style={{ fontSize: 11, opacity: 0.75 }}>{node.receiver_mobile}</span>
          {hasChildren && (
            <span style={{ marginLeft: "auto", background: "rgba(255,255,255,0.2)", borderRadius: 99, padding: "1px 8px", fontSize: 11 }}>
              {node.children.length} direct
            </span>
          )}
          <span style={{
            background: node.is_approved ? "#16a34a" : "#f59e0b",
            borderRadius: 99, padding: "1px 8px", fontSize: 10, color: "#fff"
          }}>
            {node.is_approved ? "Active" : "Pending"}
          </span>
        </div>
        {expanded && hasChildren && (
          <div style={{ borderLeft: "2px solid #bfdbfe", marginLeft: 14, paddingLeft: 6, marginTop: 4 }}>
            {node.children.map(child => (
              <TreeNode key={child.id || child.token_number} node={child} depth={depth + 1} />
            ))}
          </div>
        )}
      </div>
    );
  };

  /* ─────────────── RENDER ─────────────── */
  return (
    <div style={S.shell}>
      <GlobalStyles />

      {/* ── Image Lightbox ── */}
      <ImageModal
        src={lightboxSrc}
        caption={lightboxCaption}
        onClose={() => setLightboxSrc(null)}
      />

      {/* ── Edit Member Modal ── */}
      {editingMember && (
        <EditMemberModal
          member={editingMember}
          onClose={() => setEditingMember(null)}
          onSave={() => { loadMembers(search); loadStats(); }}
        />
      )}

      {/* ══ MOBILE SIDEBAR OVERLAY ══ */}
      <div className={`sidebar-overlay${sidebarOpen ? " open" : ""}`} onClick={() => setSidebarOpen(false)} />
      <nav className={`sidebar-drawer${sidebarOpen ? " open" : ""}`}>
        <div style={{ padding: "14px 16px", borderBottom: "1px solid rgba(255,255,255,.15)", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div style={{ fontWeight: 800, color: "#fff", fontSize: 14 }}>MERURAM</div>
          <button onClick={() => setSidebarOpen(false)} style={{ background: "none", border: "none", color: "#93c5fd", fontSize: 20, cursor: "pointer" }}>✕</button>
        </div>
        <SidebarContent
          tab={tab} subTab={subTab} openNav={openNav} setOpenNav={setOpenNav}
          goTo={goTo} logout={logout} navigate={navigate}
          onNavClick={() => setSidebarOpen(false)}
        />
      </nav>

      {/* ══ TOP BAR ══ */}
      <header style={S.topbar}>
        <div className="topbar-left">
          <button className="hamburger" onClick={() => setSidebarOpen(true)}>☰</button>
          <div style={S.logoBadge}>मे</div>
          <div>
            <div style={{ fontWeight: 800, fontSize: 15, letterSpacing: .5, color: "#fff" }}>MERURAM</div>
            <div style={{ fontSize: 9, color: "#93c5fd", letterSpacing: 3 }}>SUPER ADMIN</div>
          </div>
        </div>
        <div className="topbar-right">
          <span className="super-badge-hide" style={S.superBadge}>👑 SUPER ADMIN</span>
          <span style={{ fontSize: 12, color: "#ddd" }}>{admin?.full_name || admin?.username}</span>
          <button style={S.logoutBtn} onClick={() => { logout(); navigate("/superadmin/login"); }}>
            <span className="logout-text">Logout</span>
            <span style={{ display: "none" }} className="logout-icon">🚪</span>
          </button>
        </div>
      </header>

      <div style={{ display: "flex", flex: 1 }}>
        {/* ══ DESKTOP SIDEBAR ══ */}
        <nav className="sidebar-desktop">
          <SidebarContent
            tab={tab} subTab={subTab} openNav={openNav} setOpenNav={setOpenNav}
            goTo={goTo} logout={logout} navigate={navigate}
          />
        </nav>

        {/* ══ MAIN CONTENT ══ */}
        <main style={S.content}>

          {/* ══════════ DASHBOARD ══════════ */}
          {tab === "dashboard" && stats && (
            <div>
              <div className="page-head">
                <div style={{ width: 4, height: 20, background: "#ea580c", borderRadius: 99 }} />
                <span style={{ fontWeight: 700, fontSize: 16, color: "#1e293b" }}>Dashboard Overview</span>
                <span style={{ fontSize: 11, color: "#94a3b8" }}>{COMPANY_URL}</span>
              </div>

              {/* KPI Grid */}
              <div className="kpi-grid">
                {[
                  { label: "Total Coupons", val: stats.total_members, icon: "🎟", bg: "#1e40af" },
                  { label: "Approved", val: stats.approved, icon: "✅", bg: "#065f46" },
                  { label: "Pending", val: stats.pending, icon: "⏳", bg: "#92400e" },
                  { label: "Pending Payouts", val: stats.pending_payouts, icon: "💸", bg: "#7f1d1d" },
                  { label: "Total Wallet", val: inr(stats.total_wallet), icon: "💰", bg: "#4c1d95" },
                  { label: "Commission Paid", val: inr(stats.total_commission), icon: "📈", bg: "#134e4a" },
                  { label: "Payout Done", val: inr(stats.total_payout_done), icon: "🏦", bg: "#1e1b4b" },
                  { label: "Pending Salary", val: stats.pending_salary, icon: "📋", bg: "#701a75" },
                ].map(c => (
                  <div key={c.label} style={{ ...S.kpiCard, background: c.bg }}>
                    <div style={{ fontSize: 22 }}>{c.icon}</div>
                    <div style={{ fontSize: 18, fontWeight: 800 }}>{c.val}</div>
                    <div style={{ fontSize: 10, opacity: .8 }}>{c.label}</div>
                  </div>
                ))}
              </div>

              {/* ── DATA REPAIR PANEL ── */}
              <div style={{
                background: "linear-gradient(135deg, #1e1b4b 0%, #312e81 100%)",
                borderRadius: 12, padding: "16px 20px", marginBottom: 16,
                border: "1px solid #4338ca",
              }}>
                <div className="repair-panel">
                  <div className="repair-left">
                    <div style={{ fontWeight: 800, color: "#c7d2fe", fontSize: 13, marginBottom: 4 }}>
                      🔧 Data Repair Tool
                    </div>
                    <div style={{ fontSize: 11, color: "#a5b4fc", lineHeight: 1.6 }}>
                      Run once if members, commissions or ranks are showing blank/zero.
                      Fixes <code style={{ background: "#1e1b4b", padding: "1px 4px", borderRadius: 3 }}>referred_by</code>,
                      redistributes missing commissions, recalculates all ranks.
                    </div>
                  </div>
                  <div className="repair-right">
                    <button
                      style={{
                        background: repairing ? "#4338ca" : "#6366f1",
                        color: "#fff", border: "none", borderRadius: 8,
                        padding: "10px 20px", fontWeight: 700, fontSize: 13,
                        cursor: repairing ? "not-allowed" : "pointer",
                        opacity: repairing ? 0.7 : 1,
                      }}
                      onClick={runFullRepair}
                      disabled={repairing}
                    >
                      {repairing ? "⏳ Repairing..." : "🚀 Run Full Data Repair"}
                    </button>
                    {repairLog.length > 0 && (
                      <div style={{
                        background: "#0f172a", borderRadius: 8, padding: "10px 12px",
                        fontSize: 11, fontFamily: "monospace", lineHeight: 1.8,
                        maxHeight: 160, overflowY: "auto", border: "1px solid #334155"
                      }}>
                        {repairLog.map((line, i) => (
                          <div key={i} style={{
                            color: line.startsWith("✅") ? "#4ade80"
                                 : line.startsWith("❌") ? "#f87171"
                                 : line.startsWith("⚠️") ? "#fbbf24"
                                 : line.startsWith("🎉") ? "#818cf8"
                                 : "#94a3b8"
                          }}>{line}</div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Company-wide Level Summary */}
              <SectionTitle>💹 Company-wide Level Commission Summary</SectionTitle>
              <div className="table-scroll" style={{ background: "#fff", borderRadius: 8, border: "1px solid #e2e8f0", marginBottom: 16 }}>
                <table style={S.table}>
                  <THead cols={["Level", "Rate/Join", "Members Benefiting", "Total Paid Out", "Chart"]} />
                  <tbody>
                    {levelSummary.map((l, i) => (
                      <tr key={l.level} style={i % 2 === 0 ? S.trEven : {}}>
                        <td style={S.td}><b>Level {l.level}</b></td>
                        <td style={S.td}>₹{l.rate}</td>
                        <td style={S.td}>{l.members_paid}</td>
                        <td style={{ ...S.td, fontWeight: 700, color: "#16a34a" }}>{inr(l.total)}</td>
                        <td style={S.td}>
                          <div style={{ width: Math.min((l.total / (stats.total_commission || 1)) * 200, 140), height: 8, background: PIE_COLORS[i % PIE_COLORS.length], borderRadius: 99 }} />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Charts Row */}
              <div className="card-row">
                <div style={{ ...S.card }} className="chart-card">
                  <CardHead>📅 Daily Registrations (14 days)</CardHead>
                  <div style={{ padding: 16 }}>
                    <ResponsiveContainer width="100%" height={180}>
                      <BarChart data={stats.daily_joins || []}>
                        <XAxis dataKey="date" tick={{ fontSize: 9 }} />
                        <YAxis tick={{ fontSize: 9 }} />
                        <Tooltip />
                        <Bar dataKey="count" fill="#3b82f6" radius={[3, 3, 0, 0]} name="Joins" />
                      </BarChart>
                    </ResponsiveContainer>
                  </div>
                </div>
                <div style={{ ...S.card }} className="dist-card">
                  <CardHead>🏆 Rank Distribution</CardHead>
                  <div style={{ padding: "8px 0" }}>
                    {(stats.rank_dist || []).map((r, i) => (
                      <div key={r.rank} style={{ display: "flex", justifyContent: "space-between", padding: "8px 16px", borderBottom: "1px solid #f1f5f9", alignItems: "center" }}>
                        <span style={{ fontSize: 12, textTransform: "capitalize", fontWeight: 600 }}>{r.rank}</span>
                        <span style={{ ...S.badge, background: PIE_COLORS[i % PIE_COLORS.length], color: "#fff" }}>{r.count}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* Top 10 by Income */}
              <SectionTitle>🥇 Top 10 Members by Total Income</SectionTitle>
              <div className="table-scroll" style={{ background: "#fff", borderRadius: 8, border: "1px solid #e2e8f0", marginBottom: 16 }}>
                <table style={S.table}>
                  <THead cols={["Rank", "Coupon", "Name", "Direct", "L1", "L2", "L3", "L4", "L5", "L6", "Total Income"]} />
                  <tbody>
                    {topByIncome.map((m, i) => (
                      <tr key={m.id} style={i % 2 === 0 ? S.trEven : {}}>
                        <td style={{ ...S.td, fontWeight: 800, color: i < 3 ? "#f59e0b" : "#64748b" }}>#{i + 1}</td>
                        <td style={{ ...S.td, color: "#1d4ed8", fontWeight: 700, cursor: "pointer" }} onClick={() => openDetail(m)}>
                          {m.receiver_coupon_no}
                        </td>
                        <td style={S.td}>{m.receiver_name}</td>
                        <td style={S.td}>{m.direct_count}</td>
                        {[1, 2, 3, 4, 5, 6].map(l => (
                          <td key={l} style={{ ...S.td, fontSize: 11, color: m[`level${l}_income`] > 0 ? "#16a34a" : "#ccc" }}>
                            {m[`level${l}_income`] > 0 ? inr(m[`level${l}_income`]) : "—"}
                          </td>
                        ))}
                        <td style={{ ...S.td, fontWeight: 800, color: "#7c3aed" }}>{inr(m.total_income)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Top 10 by Direct */}
              <SectionTitle>👥 Top 10 Members by Direct Connections</SectionTitle>
              <div className="table-scroll" style={{ background: "#fff", borderRadius: 8, border: "1px solid #e2e8f0", marginBottom: 16 }}>
                <table style={S.table}>
                  <THead cols={["Rank", "Coupon", "Name", "Mobile", "Direct", "Total Team", "Total Business"]} />
                  <tbody>
                    {topByDirect.map((m, i) => (
                      <tr key={m.id} style={i % 2 === 0 ? S.trEven : {}}>
                        <td style={{ ...S.td, fontWeight: 800, color: i < 3 ? "#f59e0b" : "#64748b" }}>#{i + 1}</td>
                        <td style={{ ...S.td, color: "#1d4ed8", fontWeight: 700, cursor: "pointer" }} onClick={() => openDetail(m)}>
                          {m.receiver_coupon_no}
                        </td>
                        <td style={S.td}>{m.receiver_name}</td>
                        <td style={S.td}>{m.receiver_mobile}</td>
                        <td style={{ ...S.td, fontWeight: 700 }}>{m.direct_count}</td>
                        <td style={S.td}>{Number(m.direct_count || 0) + Number(m.indirect_count || 0)}</td>
                        <td style={{ ...S.td, fontWeight: 700, color: "#16a34a" }}>{inr(m.total_income)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* ══════════ ALL MEMBERS ══════════ */}
          {(subTab === "All Members" || subTab === "Pending Approval" || subTab === "Approved Members") && (
            <div>
              <PageHead title={`🎟 ${subTab}`} />
              <div className="search-row">
                <input style={S.searchBox}
                  placeholder="🔍 Search name, mobile, coupon..."
                  value={search}
                  onChange={e => { setSearch(e.target.value); setMembersPage(1); loadMembers(e.target.value, 1); }}
                />
                <span style={S.countBadge}>Total: {membersTotal}</span>
                <span style={{ ...S.countBadge, background: "#dcfce7", color: "#15803d" }}>
                  Active: {filteredMembers.filter(m => m.is_approved).length}
                </span>
                <span style={{ ...S.countBadge, background: "#fef9c3", color: "#854d0e" }}>
                  Pending: {filteredMembers.filter(m => !m.is_approved).length}
                </span>
              </div>
              <div className="table-scroll" style={{ background: "#fff", borderRadius: 8, border: "1px solid #e2e8f0", marginBottom: 0 }}>
                <table style={S.table}>
                  <THead cols={[
                    "#", "Coupon", "Name", "Mobile", "Aadhaar", "Giver",
                    "Payment", "Screenshot", "Wallet", "Rank", "Status", "Date", "Actions"
                  ]} />
                  <tbody>
                    {filteredMembers.map((c, i) => (
                      <tr key={c.id} style={i % 2 === 0 ? S.trEven : {}}>
                        <td style={S.td}>{(membersPage - 1) * MEMBERS_PER_PAGE + i + 1}</td>
                        <td style={{ ...S.td, fontWeight: 700, color: "#1d4ed8", cursor: "pointer" }}
                          onClick={() => openDetail(c)}>
                          {c.receiver_coupon_no || "—"}
                        </td>
                        <td style={S.td}>{c.receiver_name}</td>
                        <td style={S.td}>{c.receiver_mobile}</td>
                        <td style={{ ...S.td, fontSize: 11 }}>
                          {c.receiver_aadhaar ? "••••" + String(c.receiver_aadhaar).slice(-4) : "—"}
                        </td>
                        <td style={S.td}>
                          {/* ── GIVER INFO: name + mobile + token ── */}
                          {c.giver_name ? (
                            <div>
                              <div style={{ fontWeight: 600 }}>{c.giver_name}</div>
                              {c.giver_mobile && <div style={{ fontSize: 10, color: "#64748b" }}>{c.giver_mobile}</div>}
                              {(c.giver_coupon_no || c.sponsor_coupon) && <div style={{ fontSize: 10, color: "#1d4ed8", fontWeight: 700 }}>{c.giver_coupon_no || c.sponsor_coupon}</div>}
                            </div>
                          ) : "—"}
                        </td>
                        <td style={S.td}>
                          <span style={S.pill}>{c.payment_cash ? "Cash" : "Online"}</span>
                        </td>
                        <td style={S.td}>
  {c.screenshot ? (
    <div style={{ display: "flex", flexDirection: "column", gap: 4, alignItems: "flex-start" }}>
      <img
        src={`https://luckydraw.hoppersdome.com/uploads/${c.screenshot}`}
        alt="screenshot thumb"
        style={{
          width: 48,
          height: 36,
          objectFit: "cover",
          borderRadius: 4,
          border: "2px solid #bfdbfe",
          cursor: "pointer"
        }}
        onClick={() =>
          openLightbox(
            `https://luckydraw.hoppersdome.com/uploads/${c.screenshot}`,
            `${c.receiver_name} — Payment Screenshot`
          )
        }
        onError={e => { e.target.style.display = "none"; }}
      />

      <button
        style={{ ...S.btn, background: "#1d4ed8", padding: "3px 8px", fontSize: 10 }}
        onClick={() =>
          openLightbox(
            `https://luckydraw.hoppersdome.com/uploads/${c.screenshot}`,
            `${c.receiver_name} — Payment Screenshot`
          )
        }
      >
        📷 View
      </button>
    </div>
  ) : "—"}
</td>
                        <td style={{ ...S.td, fontWeight: 700, color: "#7c3aed" }}>{inr(c.wallet_balance)}</td>
                        <td style={S.td}><span style={S.pill}>{c.rank || "member"}</span></td>
                        <td style={S.td}>
                          <span style={c.is_approved ? S.greenBadge : S.yellowBadge}>
                            {c.is_approved ? "Active" : "Pending"}
                          </span>
                        </td>
                        <td style={{ ...S.td, fontSize: 11 }}>{fmt(c.created_at)}</td>
                        <td style={S.td}>
                          {/* ── ACTIONS: all 5 buttons, always visible ── */}
                          <div className="action-cell">
                            {!c.is_approved && (
                              <ActionBtn color="#16a34a" disabled={approving[c.id]}
                                onClick={() => approveCoupon(c.id, c)}
                                title="Approve">
                                {approving[c.id] ? "⏳" : "✅"}
                              </ActionBtn>
                            )}
                            <ActionBtn color="#1d4ed8" onClick={() => openDetail(c)} title="View Detail">👁</ActionBtn>
                            <ActionBtn color="#f59e0b" onClick={() => setEditingMember(c)} title="Edit Member">✏️</ActionBtn>
                            <ActionBtn color="#25D366" onClick={() =>
                              whatsapp(c.receiver_mobile,
                                `Namaste *${c.receiver_name}*! Your coupon status: ${c.is_approved ? "Active ✅" : "Pending ⏳"}. Visit ${COMPANY_URL}`)
                            } title="WhatsApp">📱</ActionBtn>
                            <ActionBtn color="#dc2626" onClick={() => deleteCoupon(c.id)} title="Delete">🗑</ActionBtn>
                          </div>
                        </td>
                      </tr>
                    ))}
                    {filteredMembers.length === 0 && (
                      <tr><td colSpan={13} style={{ ...S.td, textAlign: "center", color: "#94a3b8", padding: 40 }}>
                        No records found
                      </td></tr>
                    )}
                  </tbody>
                </table>
              </div>

              {/* ── PAGINATION BAR ── */}
              <div style={{
                display: "flex", alignItems: "center", justifyContent: "space-between",
                flexWrap: "wrap", gap: 8,
                background: "#fff", border: "1px solid #e2e8f0", borderTop: "2px solid #e2e8f0",
                borderRadius: "0 0 8px 8px", padding: "10px 16px", marginBottom: 16,
              }}>
                <div style={{ fontSize: 12, color: "#64748b" }}>
                  Page <b>{membersPage}</b> of <b>{totalPagesDisplay}</b>
                  &nbsp;·&nbsp; Showing <b>{filteredMembers.length}</b> of <b>{membersTotal}</b> records
                </div>
                <div style={{ display: "flex", gap: 6, flexWrap: "wrap", alignItems: "center" }}>
                  {/* First */}
                  <button
                    style={{ ...S.pgBtn, opacity: membersPage <= 1 ? 0.4 : 1 }}
                    disabled={membersPage <= 1}
                    onClick={() => { setMembersPage(1); loadMembers(search, 1); }}
                  >«</button>
                  {/* Prev */}
                  <button
                    style={{ ...S.pgBtn, opacity: membersPage <= 1 ? 0.4 : 1 }}
                    disabled={membersPage <= 1}
                    onClick={() => { const p = membersPage - 1; setMembersPage(p); loadMembers(search, p); }}
                  >‹ Prev</button>

                  {/* Page number pills */}
                  {Array.from({ length: Math.min(totalPagesDisplay, 7) }, (_, idx) => {
                    let pg;
                    if (totalPagesDisplay <= 7) {
                      pg = idx + 1;
                    } else if (membersPage <= 4) {
                      pg = idx + 1;
                    } else if (membersPage >= totalPagesDisplay - 3) {
                      pg = totalPagesDisplay - 6 + idx;
                    } else {
                      pg = membersPage - 3 + idx;
                    }
                    return (
                      <button key={pg}
                        style={{
                          ...S.pgBtn,
                          background: pg === membersPage ? "#1e3a8a" : "#f1f5f9",
                          color: pg === membersPage ? "#fff" : "#374151",
                          fontWeight: pg === membersPage ? 800 : 500,
                          minWidth: 34,
                        }}
                        onClick={() => { setMembersPage(pg); loadMembers(search, pg); }}
                      >{pg}</button>
                    );
                  })}

                  {/* Next */}
                  <button
                    style={{ ...S.pgBtn, opacity: membersPage >= totalPagesDisplay ? 0.4 : 1 }}
                    disabled={membersPage >= totalPagesDisplay}
                    onClick={() => { const p = membersPage + 1; setMembersPage(p); loadMembers(search, p); }}
                  >Next ›</button>
                  {/* Last */}
                  <button
                    style={{ ...S.pgBtn, opacity: membersPage >= totalPagesDisplay ? 0.4 : 1 }}
                    disabled={membersPage >= totalPagesDisplay}
                    onClick={() => { setMembersPage(totalPagesDisplay); loadMembers(search, totalPagesDisplay); }}
                  >»</button>
                </div>
              </div>
            </div>
          )}

          {/* ══════════ MEMBER DETAIL ══════════ */}
          {subTab === "Member Detail" && (
            <div>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16, flexWrap: "wrap", gap: 8 }}>
                <PageHead title={`👤 Member Detail${memberDetail ? " — " + memberDetail.member?.receiver_name : ""}`} />
                <div style={{ display: "flex", gap: 8 }}>
                  {memberDetail && (
                    <button style={{ ...S.btn, background: "#f59e0b" }} onClick={() => setEditingMember(memberDetail.member)}>✏️ Edit</button>
                  )}
                  <button style={{ ...S.btn, background: "#64748b" }} onClick={() => goTo("members", "All Members")}>← Back</button>
                </div>
              </div>

              {loadingDetail && <div style={{ textAlign: "center", padding: 48, color: "#94a3b8" }}>Loading...</div>}

              {!loadingDetail && memberDetail && (() => {
                const m = memberDetail.member;
                const levelBreakdown = memberDetail.level_breakdown || [];
                const direct = memberDetail.direct || [];
                const memberCommissions = memberDetail.commissions || [];
                const wdrawals = memberDetail.withdrawals || [];
                const totalEarned = levelBreakdown.reduce((s, l) => s + Number(l.total || 0), 0);
                const referralLink = m.reference_token ? `${COMPANY_URL}/register/${m.reference_token}` : null;

                return (
                  <div>
                    {/* ── Info Chips ── */}
                    <div className="chip-grid">
                      {[
                        ["Coupon No", m.receiver_coupon_no],
                        ["Name", m.receiver_name],
                        ["Mobile", m.receiver_mobile],
                        ["Aadhaar", m.receiver_aadhaar || "—"],
                        ["Address", m.receiver_address || "—"],
                        ["Rank", m.rank?.toUpperCase()],
                        ["Wallet Balance", inr(m.wallet_balance)],
                        ["Direct Members", direct.length],
                        ["Total Team", memberDetail.total_team],
                        ["Total Earned", inr(totalEarned)],
                        ["Joined", fmt(m.created_at)],
                        ["Status", m.is_approved ? "Active ✅" : "Pending ⏳"],
                      ].map(([k, v]) => (
                        <div key={k} className="info-chip">
                          <div style={{ fontSize: 10, color: "#64748b" }}>{k}</div>
                          <div style={{ fontWeight: 700, wordBreak: "break-all" }}>{v}</div>
                        </div>
                      ))}
                    </div>

                    {/* ── GIVER / SPONSOR INFO BOX ── */}
                    {(m.giver_name || m.sponsor_name || m.referred_by) && (
                      <div style={{
                        background: "linear-gradient(135deg, #065f46, #047857)",
                        borderRadius: 10, padding: "14px 18px", marginBottom: 16,
                        display: "flex", alignItems: "flex-start", gap: 16, flexWrap: "wrap"
                      }}>
                        <div style={{ fontSize: 32 }}>🤝</div>
                        <div style={{ flex: 1 }}>
                          <div style={{ fontSize: 11, color: "#6ee7b7", fontWeight: 700, marginBottom: 6 }}>REFERRED / JOINED UNDER (GIVER/SPONSOR)</div>
                          <div className="chip-grid" style={{ gap: 8 }}>
                            {[
                              ["Name", m.giver_name || m.sponsor_name || "—"],
                              ["Mobile", m.giver_mobile || "—"],
                              ["Token / Coupon", m.giver_coupon_no || m.sponsor_coupon || m.referred_by || "—"],
                            ].map(([k, v]) => (
                              <div key={k} style={{ background: "rgba(255,255,255,.15)", borderRadius: 8, padding: "8px 12px", minWidth: 120 }}>
                                <div style={{ fontSize: 10, color: "#a7f3d0" }}>{k}</div>
                                <div style={{ fontWeight: 800, color: "#fff", fontSize: 13 }}>{v}</div>
                              </div>
                            ))}
                          </div>
                        </div>
                        {m.giver_mobile && (
                          <button style={{ ...S.btn, background: "#25D366", alignSelf: "flex-end" }}
                            onClick={() => whatsapp(m.giver_mobile,
                              `Namaste *${m.giver_name || ""}*!\n\nYour referral *${m.receiver_name}* (${m.receiver_coupon_no}) has been ${m.is_approved ? "approved ✅" : "registered ⏳"}.\n\n_${COMPANY}_`)}>
                            📱 WA Sponsor
                          </button>
                        )}
                      </div>
                    )}

                    {/* ── Referral Link Box ── */}
                    {referralLink && (
                      <div style={{
                        background: "linear-gradient(135deg,#1e3a8a,#1d4ed8)",
                        borderRadius: 10, padding: "14px 18px", marginBottom: 16,
                        display: "flex", alignItems: "flex-start", gap: 12, flexWrap: "wrap"
                      }}>
                        <div style={{ flex: 1, minWidth: 200 }}>
                          <div style={{ fontSize: 11, color: "#93c5fd", fontWeight: 700, marginBottom: 4 }}>🔗 MEMBER REFERRAL LINK</div>
                          <div style={{
                            background: "rgba(0,0,0,.3)", borderRadius: 6, padding: "8px 12px",
                            fontSize: 12, color: "#e0f2fe", fontFamily: "monospace", wordBreak: "break-all"
                          }}>
                            {referralLink}
                          </div>
                        </div>
                        <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                          <button style={{ ...S.btn, background: "#f59e0b", color: "#000", fontWeight: 800 }}
                            onClick={() => { navigator.clipboard.writeText(referralLink); toast.success("✅ Referral link copied!"); }}>
                            📋 Copy
                          </button>
                          <button style={{ ...S.btn, background: "#25D366" }}
                            onClick={() => whatsapp(m.receiver_mobile,
                              `Namaste *${m.receiver_name}* 👋\n\nHere is your personal Meruram referral link:\n\n🔗 ${referralLink}\n\nShare this with your friends & family to earn level income! 💰\n\n_${COMPANY}_`)}>
                            📱 WhatsApp
                          </button>
                        </div>
                      </div>
                    )}

                    {/* ── Screenshot & Aadhaar row ── */}
                    <div className="flex-wrap-row" style={{ marginBottom: 16 }}>
                      {m.screenshot && (
  <div style={{ ...S.card, padding: 14 }}>
    <div style={{ fontSize: 11, fontWeight: 700, color: "#64748b", marginBottom: 8 }}>
      📷 PAYMENT SCREENSHOT
    </div>

    <img
      src={`https://luckydraw.hoppersdome.com/uploads/${m.screenshot}`}
      alt="Payment screenshot"
      style={{
        maxWidth: "100%",
        maxHeight: 180,
        borderRadius: 6,
        border: "2px solid #bfdbfe",
        cursor: "pointer",
        display: "block"
      }}
      onClick={() =>
        openLightbox(
          `https://luckydraw.hoppersdome.com/uploads/${m.screenshot}`,
          `${m.receiver_name} — Payment Screenshot`
        )
      }
      onError={e => { e.target.style.display = "none"; }}
    />

    <div style={{ marginTop: 8 }}>
      <button
        style={{ ...S.btn, background: "#1d4ed8", fontSize: 11 }}
        onClick={() =>
          openLightbox(
            `https://luckydraw.hoppersdome.com/uploads/${m.screenshot}`,
            `${m.receiver_name} — Payment Screenshot`
          )
        }
      >
        🔍 View Full Size
      </button>
    </div>
  </div>
)}
                      <div style={{ ...S.card, padding: 14 }}>
                        <div style={{ fontSize: 11, fontWeight: 700, color: "#64748b", marginBottom: 8 }}>🪪 AADHAAR DETAILS</div>
                        <div style={{ fontSize: 13, marginBottom: 6 }}>
                          <span style={{ color: "#94a3b8", fontSize: 11 }}>Full Aadhaar Number:</span><br />
                          <span style={{ fontWeight: 800, fontSize: 16, letterSpacing: 2, color: "#1e3a8a" }}>
                            {m.receiver_aadhaar || "Not provided"}
                          </span>
                        </div>
                        <div style={{ fontSize: 12, color: "#64748b" }}>
                          <div><b>Name:</b> {m.receiver_name}</div>
                          <div><b>Address:</b> {m.receiver_address || "—"}</div>
                          <div><b>Mobile:</b> {m.receiver_mobile}</div>
                        </div>
                      </div>
                      <div style={{ ...S.card, padding: 14 }}>
                        <div style={{ fontSize: 11, fontWeight: 700, color: "#64748b", marginBottom: 8 }}>🏦 BANK / UPI DETAILS</div>
                        {(m.bank_name || m.account_number || m.upi_id) ? (
                          <div style={{ fontSize: 13 }}>
                            {m.bank_name && <div><span style={{ color: "#94a3b8", fontSize: 11 }}>Bank:</span> <b>{m.bank_name}</b></div>}
                            {m.account_number && <div><span style={{ color: "#94a3b8", fontSize: 11 }}>A/C No:</span> <b>{m.account_number}</b></div>}
                            {m.ifsc && <div><span style={{ color: "#94a3b8", fontSize: 11 }}>IFSC:</span> <b>{m.ifsc}</b></div>}
                            {m.upi_id && <div><span style={{ color: "#94a3b8", fontSize: 11 }}>UPI ID:</span> <b>{m.upi_id}</b></div>}
                          </div>
                        ) : (
                          <div style={{ color: "#94a3b8", fontSize: 12 }}>No bank/UPI details added yet</div>
                        )}
                      </div>
                    </div>

                    {/* ── Action buttons ── */}
                    <div style={{ display: "flex", gap: 8, marginBottom: 16, flexWrap: "wrap" }}>
                      <button style={{ ...S.btn, background: "#25D366" }} onClick={() =>
                        whatsapp(m.receiver_mobile, `Namaste *${m.receiver_name}*!\n\nYour Meruram account is active ✅.\n\nCoupon: ${m.receiver_coupon_no}\nBalance: ${inr(m.wallet_balance)}\n\nVisit: ${COMPANY_URL}`)}>
                        📱 Send Account Info
                      </button>
                      <button style={{ ...S.btn, background: "#25D366" }} onClick={() =>
                        whatsapp(m.receiver_mobile, `Namaste *${m.receiver_name}*!\n\nYou have earned *${inr(totalEarned)}* in Level Income from Meruram Lucky Draw 🎉\n\nLogin to check: ${COMPANY_URL}`)}>
                        📱 Send Income Info
                      </button>
                    </div>

                    <SectionTitle>💹 Level-wise Income</SectionTitle>
                    <div className="table-scroll" style={{ background: "#fff", borderRadius: 8, border: "1px solid #e2e8f0", marginBottom: 16 }}>
                      <table style={S.table}>
                        <THead cols={["Level", "Rate/Join", "Members Joined", "Direct", "Indirect", "Total Earned", "% Share"]} />
                        <tbody>
                          {[1, 2, 3, 4, 5, 6].map((level, i) => {
                            const found = levelBreakdown.find(l => l.level === level);
                            const earned = Number(found?.total || 0);
                            const pct = totalEarned > 0 ? ((earned / totalEarned) * 100).toFixed(1) : "0";
                            const isL1 = level === 1;
                            return (
                              <tr key={level} style={i % 2 === 0 ? S.trEven : {}}>
                                <td style={S.td}><strong>L{level}</strong> {isL1 ? "🔴" : ""}</td>
                                <td style={S.td}>₹{LEVEL_RATE[level]}</td>
                                <td style={S.td}>{found?.count || 0}</td>
                                <td style={S.td}>{isL1 ? (found?.count || 0) : "—"}</td>
                                <td style={S.td}>{!isL1 ? (found?.count || 0) : "—"}</td>
                                <td style={{ ...S.td, fontWeight: 700, color: earned > 0 ? "#16a34a" : "#94a3b8" }}>
                                  {earned > 0 ? inr(earned) : "₹0.00"}
                                </td>
                                <td style={S.td}>
                                  <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                                    <div style={{ height: 6, borderRadius: 99, background: PIE_COLORS[i], width: `${Math.min(Number(pct), 100)}%`, minWidth: 2 }} />
                                    <span style={{ fontSize: 11, color: "#64748b", whiteSpace: "nowrap" }}>{pct}%</span>
                                  </div>
                                </td>
                              </tr>
                            );
                          })}
                          <tr style={{ background: "#f0fdf4" }}>
                            <td style={{ ...S.td, fontWeight: 800 }} colSpan={2}>TOTAL</td>
                            <td style={{ ...S.td, fontWeight: 700 }}>{levelBreakdown.reduce((s, l) => s + l.count, 0)}</td>
                            <td style={S.td}>{direct.length}</td>
                            <td style={S.td}>{memberDetail.total_team - direct.length}</td>
                            <td style={{ ...S.td, fontWeight: 800, color: "#15803d", fontSize: 14 }}>{inr(totalEarned)}</td>
                            <td style={S.td}>100%</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <SectionTitle>👥 Direct Members</SectionTitle>
                    <div className="table-scroll" style={{ background: "#fff", borderRadius: 8, border: "1px solid #e2e8f0", marginBottom: 16 }}>
                      <table style={S.table}>
                        <THead cols={["#", "Coupon", "Name", "Mobile", "Joined", "Their Direct", "Status", "WA"]} />
                        <tbody>
                          {direct.map((d, i) => (
                            <tr key={d.id} style={i % 2 === 0 ? S.trEven : {}}>
                              <td style={S.td}>{i + 1}</td>
                              <td style={{ ...S.td, color: "#1d4ed8", fontWeight: 700 }}>{d.receiver_coupon_no}</td>
                              <td style={S.td}>{d.receiver_name}</td>
                              <td style={S.td}>{d.receiver_mobile}</td>
                              <td style={{ ...S.td, fontSize: 11 }}>{fmtTime(d.created_at)}</td>
                              <td style={{ ...S.td, fontWeight: 700 }}>{d.their_direct}</td>
                              <td style={S.td}><span style={d.is_approved ? S.greenBadge : S.yellowBadge}>{d.is_approved ? "Active" : "Pending"}</span></td>
                              <td style={S.td}>
                                <button style={{ ...S.btn, background: "#25D366", padding: "4px 8px" }}
                                  onClick={() => whatsapp(d.receiver_mobile, `Namaste *${d.receiver_name}*! Welcome to Meruram Lucky Draw. Login: ${COMPANY_URL}`)}>
                                  📱
                                </button>
                              </td>
                            </tr>
                          ))}
                          {direct.length === 0 && <tr><td colSpan={8} style={{ ...S.td, textAlign: "center", color: "#94a3b8" }}>No direct referrals</td></tr>}
                        </tbody>
                      </table>
                    </div>

                    <SectionTitle>📋 Commission History</SectionTitle>
                    <div className="table-scroll" style={{ background: "#fff", borderRadius: 8, border: "1px solid #e2e8f0", marginBottom: 16 }}>
                      <table style={S.table}>
                        <THead cols={["#", "Date", "Level", "From Coupon", "From Member", "Amount"]} />
                        <tbody>
                          {memberCommissions.slice(0, 100).map((c, i) => (
                            <tr key={c.id} style={i % 2 === 0 ? S.trEven : {}}>
                              <td style={S.td}>{i + 1}</td>
                              <td style={{ ...S.td, fontSize: 11 }}>{fmtTime(c.created_at)}</td>
                              <td style={S.td}><span style={S.pill}>L{c.level}</span></td>
                              <td style={{ ...S.td, color: "#1d4ed8" }}>{c.from_coupon}</td>
                              <td style={S.td}>{c.from_name}</td>
                              <td style={{ ...S.td, fontWeight: 700, color: "#16a34a" }}>{inr(c.amount)}</td>
                            </tr>
                          ))}
                          {memberCommissions.length === 0 && <tr><td colSpan={6} style={{ ...S.td, textAlign: "center", color: "#94a3b8" }}>No commissions yet</td></tr>}
                        </tbody>
                      </table>
                    </div>

                    <SectionTitle>💸 Withdrawal History</SectionTitle>
                    <div className="table-scroll" style={{ background: "#fff", borderRadius: 8, border: "1px solid #e2e8f0", marginBottom: 16 }}>
                      <table style={S.table}>
                        <THead cols={["#", "Date", "Amount", "Method", "Bank/UPI", "Status"]} />
                        <tbody>
                          {wdrawals.map((w, i) => (
                            <tr key={w.id} style={i % 2 === 0 ? S.trEven : {}}>
                              <td style={S.td}>{i + 1}</td>
                              <td style={{ ...S.td, fontSize: 11 }}>{fmt(w.created_at)}</td>
                              <td style={{ ...S.td, fontWeight: 700 }}>{inr(w.amount)}</td>
                              <td style={S.td}>{w.method?.toUpperCase()}</td>
                              <td style={{ ...S.td, fontSize: 11 }}>{w.method === "upi" ? w.upi_id : `${w.bank_name || ""} ${w.account_number || ""}`}</td>
                              <td style={S.td}><span style={w.status === "approved" ? S.greenBadge : w.status === "rejected" ? S.redBadge : S.yellowBadge}>{w.status}</span></td>
                            </tr>
                          ))}
                          {wdrawals.length === 0 && <tr><td colSpan={6} style={{ ...S.td, textAlign: "center", color: "#94a3b8" }}>No withdrawals</td></tr>}
                        </tbody>
                      </table>
                    </div>
                  </div>
                );
              })()}
            </div>
          )}

          {/* ══════════ LEVEL INCOME REPORT ══════════ */}
          {subTab === "Level Income Report" && (
            <div>
              <PageHead title="📈 Level Income Report — All Members" />
              <div className="level-cards">
                {[1, 2, 3, 4, 5, 6].map((l, i) => (
                  <div key={l} style={{ background: PIE_COLORS[i], color: "#fff", borderRadius: 10, padding: "12px 14px", textAlign: "center" }}>
                    <div style={{ fontSize: 10, opacity: 0.8 }}>L{l} · ₹{LEVEL_RATE[l]}/join</div>
                    <div style={{ fontSize: 16, fontWeight: 800, marginTop: 4 }}>
                      {inr(allMembers.reduce((s, m) => s + Number(m[`level${l}_income`] || 0), 0))}
                    </div>
                    <div style={{ fontSize: 10, opacity: 0.8, marginTop: 2 }}>
                      {allMembers.filter(m => Number(m[`level${l}_income`]) > 0).length} members
                    </div>
                  </div>
                ))}
              </div>
              <div className="table-scroll" style={{ background: "#fff", borderRadius: 8, border: "1px solid #e2e8f0", marginBottom: 16 }}>
                <table style={S.table}>
                  <THead cols={["#", "Coupon", "Name", "Mobile", "Sponsor", "Direct", "L1", "L2", "L3", "L4", "L5", "L6", "Total", "Withdrawn"]} />
                  <tbody>
                    {allMembers.filter(m => Number(m.total_income) > 0).map((m, i) => (
                      <tr key={m.id} style={i % 2 === 0 ? S.trEven : {}}>
                        <td style={S.td}>{i + 1}</td>
                        <td style={{ ...S.td, fontWeight: 700, color: "#1d4ed8", cursor: "pointer" }} onClick={() => openDetail(m)}>{m.receiver_coupon_no}</td>
                        <td style={S.td}>{m.receiver_name}</td>
                        <td style={S.td}>{m.receiver_mobile}</td>
                        <td style={{ ...S.td, fontSize: 11 }}>{m.sponsor_name || "—"}</td>
                        <td style={S.td}>{m.direct_count}</td>
                        {[1, 2, 3, 4, 5, 6].map(l => (
                          <td key={l} style={{ ...S.td, color: m[`level${l}_income`] > 0 ? "#16a34a" : "#d1d5db", fontSize: 11 }}>
                            {m[`level${l}_income`] > 0 ? inr(m[`level${l}_income`]) : "—"}
                          </td>
                        ))}
                        <td style={{ ...S.td, fontWeight: 800, color: "#7c3aed" }}>{inr(m.total_income)}</td>
                        <td style={{ ...S.td, color: "#dc2626" }}>{inr(m.total_withdrawn)}</td>
                      </tr>
                    ))}
                    <tr style={{ background: "#eff6ff", fontWeight: 800 }}>
                      <td style={S.td} colSpan={6}>COMPANY TOTAL</td>
                      {[1, 2, 3, 4, 5, 6].map(l => (
                        <td key={l} style={{ ...S.td, color: "#16a34a", fontWeight: 800 }}>
                          {inr(allMembers.reduce((s, m) => s + Number(m[`level${l}_income`] || 0), 0))}
                        </td>
                      ))}
                      <td style={{ ...S.td, color: "#7c3aed", fontSize: 13 }}>
                        {inr(allMembers.reduce((s, m) => s + Number(m.total_income || 0), 0))}
                      </td>
                      <td style={{ ...S.td, color: "#dc2626" }}>
                        {inr(allMembers.reduce((s, m) => s + Number(m.total_withdrawn || 0), 0))}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* ══════════ LEVEL WISE REPORT ══════════ */}
          {subTab === "Level Wise Report" && (
            <div>
              <PageHead title="📊 Level Wise Report — Company Overview" />
              <div style={{ ...S.card, marginBottom: 16 }}>
                <CardHead>Level-wise Commission Distribution</CardHead>
                <div style={{ padding: 16 }}>
                  <ResponsiveContainer width="100%" height={220}>
                    <BarChart data={levelSummary}>
                      <XAxis dataKey="level" tickFormatter={v => `L${v}`} tick={{ fontSize: 11 }} />
                      <YAxis tick={{ fontSize: 10 }} tickFormatter={v => `₹${(v / 1000).toFixed(0)}k`} />
                      <Tooltip formatter={(v) => inr(v)} labelFormatter={l => `Level ${l}`} />
                      <Bar dataKey="total" name="Total Paid" radius={[4, 4, 0, 0]}>
                        {levelSummary.map((entry, i) => <Cell key={i} fill={PIE_COLORS[i % PIE_COLORS.length]} />)}
                      </Bar>
                    </BarChart>
                  </ResponsiveContainer>
                </div>
              </div>
              <div className="table-scroll" style={{ background: "#fff", borderRadius: 8, border: "1px solid #e2e8f0", marginBottom: 16 }}>
                <table style={S.table}>
                  <THead cols={["Level", "Rate/Join", "Members Benefiting", "Total Paid", "Avg/Member", "% of Total"]} />
                  <tbody>
                    {levelSummary.map((l, i) => {
                      const grandTotal = levelSummary.reduce((s, x) => s + x.total, 0);
                      const pct = grandTotal > 0 ? ((l.total / grandTotal) * 100).toFixed(1) : "0";
                      const avg = l.members_paid > 0 ? l.total / l.members_paid : 0;
                      return (
                        <tr key={l.level} style={i % 2 === 0 ? S.trEven : {}}>
                          <td style={S.td}>
                            <span style={{ ...S.pill, background: PIE_COLORS[i], color: "#fff", fontSize: 12 }}>Level {l.level}</span>
                          </td>
                          <td style={{ ...S.td, fontWeight: 700 }}>₹{l.rate}</td>
                          <td style={{ ...S.td, fontWeight: 700, color: "#1d4ed8" }}>{l.members_paid}</td>
                          <td style={{ ...S.td, fontWeight: 800, color: "#16a34a", fontSize: 13 }}>{inr(l.total)}</td>
                          <td style={{ ...S.td, color: "#7c3aed" }}>{inr(avg)}</td>
                          <td style={S.td}>
                            <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                              <div style={{ height: 8, borderRadius: 99, background: PIE_COLORS[i], width: `${Math.min(Number(pct) * 1.5, 120)}px` }} />
                              <span style={{ fontSize: 12, fontWeight: 700 }}>{pct}%</span>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                    <tr style={{ background: "#f0fdf4", fontWeight: 800 }}>
                      <td style={S.td} colSpan={2}>GRAND TOTAL</td>
                      <td style={{ ...S.td, color: "#1d4ed8" }}>{levelSummary.reduce((s, l) => s + l.members_paid, 0)}</td>
                      <td style={{ ...S.td, color: "#16a34a", fontSize: 14 }}>{inr(levelSummary.reduce((s, l) => s + l.total, 0))}</td>
                      <td style={S.td}>—</td>
                      <td style={S.td}>100%</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <SectionTitle>👤 Member-wise Level Breakdown</SectionTitle>
              <div className="table-scroll" style={{ background: "#fff", borderRadius: 8, border: "1px solid #e2e8f0", marginBottom: 16 }}>
                <table style={S.table}>
                  <THead cols={["#", "Coupon", "Name", "L1", "L2", "L3", "L4", "L5", "L6", "Total", "Rank"]} />
                  <tbody>
                    {allMembers.filter(m => Number(m.total_income) > 0)
                      .sort((a, b) => Number(b.total_income) - Number(a.total_income))
                      .map((m, i) => (
                        <tr key={m.id} style={i % 2 === 0 ? S.trEven : {}}>
                          <td style={S.td}>{i + 1}</td>
                          <td style={{ ...S.td, color: "#1d4ed8", fontWeight: 700, cursor: "pointer" }} onClick={() => openDetail(m)}>{m.receiver_coupon_no}</td>
                          <td style={S.td}>{m.receiver_name}</td>
                          {[1, 2, 3, 4, 5, 6].map(l => (
                            <td key={l} style={{ ...S.td, fontSize: 11, color: Number(m[`level${l}_income`]) > 0 ? "#16a34a" : "#d1d5db" }}>
                              {Number(m[`level${l}_income`]) > 0 ? `₹${Number(m[`level${l}_income`]).toFixed(0)}` : "—"}
                            </td>
                          ))}
                          <td style={{ ...S.td, fontWeight: 800, color: "#7c3aed" }}>{inr(m.total_income)}</td>
                          <td style={S.td}><span style={S.pill}>{m.rank || "—"}</span></td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* ══════════ COMMISSION REPORT ══════════ */}
          {subTab === "Commission Report" && (
            <div>
              <PageHead title="💰 Commission Report — All Transactions" />
              <div className="kpi-grid" style={{ marginBottom: 16 }}>
                <div style={{ ...S.kpiCard, background: "#1e3a8a" }}>
                  <div style={{ fontSize: 20 }}>💰</div>
                  <div style={{ fontSize: 18, fontWeight: 800 }}>{inr(commissions.reduce((s, c) => s + Number(c.amount || 0), 0))}</div>
                  <div style={{ fontSize: 10, opacity: .8 }}>Total Commission</div>
                </div>
                <div style={{ ...S.kpiCard, background: "#065f46" }}>
                  <div style={{ fontSize: 20 }}>📋</div>
                  <div style={{ fontSize: 18, fontWeight: 800 }}>{commissions.length}</div>
                  <div style={{ fontSize: 10, opacity: .8 }}>Total Transactions</div>
                </div>
                {commissionByLevel.map((cl, i) => (
                  <div key={cl.level} style={{ ...S.kpiCard, background: PIE_COLORS[i % PIE_COLORS.length] }}>
                    <div style={{ fontSize: 13 }}>Level {cl.level}</div>
                    <div style={{ fontSize: 15, fontWeight: 800 }}>{inr(cl.total)}</div>
                    <div style={{ fontSize: 10, opacity: .8 }}>{cl.count} txns</div>
                  </div>
                ))}
              </div>
              <div style={{ ...S.card, marginBottom: 16 }}>
                <CardHead>Commission by Level</CardHead>
                <div style={{ padding: 16 }}>
                  <ResponsiveContainer width="100%" height={180}>
                    <BarChart data={commissionByLevel}>
                      <XAxis dataKey="level" tickFormatter={v => `L${v}`} tick={{ fontSize: 11 }} />
                      <YAxis tick={{ fontSize: 10 }} tickFormatter={v => `₹${(v / 1000).toFixed(0)}k`} />
                      <Tooltip formatter={(v) => inr(v)} labelFormatter={l => `Level ${l}`} />
                      <Bar dataKey="total" name="Commission" radius={[4, 4, 0, 0]}>
                        {commissionByLevel.map((entry, i) => <Cell key={i} fill={PIE_COLORS[i % PIE_COLORS.length]} />)}
                      </Bar>
                    </BarChart>
                  </ResponsiveContainer>
                </div>
              </div>
              <div className="table-scroll" style={{ background: "#fff", borderRadius: 8, border: "1px solid #e2e8f0", marginBottom: 16 }}>
                <table style={S.table}>
                  <THead cols={["#", "Date & Time", "Level", "To Coupon", "To Member", "From Coupon", "From Member", "Amount"]} />
                  <tbody>
                    {commissions.length === 0 && (
                      <tr><td colSpan={8} style={{ ...S.td, textAlign: "center", color: "#94a3b8", padding: 40 }}>No commission records found</td></tr>
                    )}
                    {commissions.map((c, i) => (
                      <tr key={c.id} style={i % 2 === 0 ? S.trEven : {}}>
                        <td style={S.td}>{i + 1}</td>
                        <td style={{ ...S.td, fontSize: 11 }}>{fmtTime(c.created_at)}</td>
                        <td style={S.td}>
                          <span style={{ ...S.pill, background: PIE_COLORS[(c.level - 1) % PIE_COLORS.length], color: "#fff" }}>L{c.level}</span>
                        </td>
                        <td style={{ ...S.td, fontWeight: 700, color: "#1d4ed8" }}>{c.to_coupon || c.receiver_coupon_no}</td>
                        <td style={S.td}>{c.to_name || c.receiver_name}</td>
                        <td style={{ ...S.td, color: "#6366f1" }}>{c.from_coupon}</td>
                        <td style={S.td}>{c.from_name}</td>
                        <td style={{ ...S.td, fontWeight: 800, color: "#16a34a", fontSize: 13 }}>{inr(c.amount)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* ══════════ DIRECT BUSINESS REPORT ══════════ */}
          {subTab === "Direct Business Report" && (
            <div>
              <PageHead title="📊 Direct Business Report" />
              <div className="table-scroll" style={{ background: "#fff", borderRadius: 8, border: "1px solid #e2e8f0", marginBottom: 16 }}>
                <table style={S.table}>
                  <THead cols={["#", "Coupon", "Name", "Mobile", "Direct", "Indirect", "Total Team", "Direct Income", "Total Income"]} />
                  <tbody>
                    {[...allMembers].sort((a, b) => Number(b.direct_count) - Number(a.direct_count)).map((m, i) => (
                      <tr key={m.id} style={i % 2 === 0 ? S.trEven : {}}>
                        <td style={S.td}>{i + 1}</td>
                        <td style={{ ...S.td, fontWeight: 700, color: "#1d4ed8", cursor: "pointer" }} onClick={() => openDetail(m)}>{m.receiver_coupon_no}</td>
                        <td style={S.td}>{m.receiver_name}</td>
                        <td style={S.td}>{m.receiver_mobile}</td>
                        <td style={{ ...S.td, fontWeight: 700, color: "#1d4ed8" }}>{m.direct_count}</td>
                        <td style={{ ...S.td, color: "#6366f1" }}>{m.indirect_count || 0}</td>
                        <td style={S.td}>{Number(m.direct_count) + Number(m.indirect_count || 0)}</td>
                        <td style={{ ...S.td, color: "#16a34a" }}>{inr(Number(m.direct_count) * LEVEL_RATE[1])}</td>
                        <td style={{ ...S.td, fontWeight: 700, color: "#7c3aed" }}>{inr(m.total_income)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* ══════════ BUSINESS REPORT ══════════ */}
          {subTab === "Business Report" && (
            <div>
              <PageHead title="📈 Business Report — Full Company Overview & Profit Analysis" />
              {(() => {
                const JOINING = 3000;
                const PRODUCT_COST = 1200;
                const MLM_PAYOUT = 750;
                const SALARY_AVG = 100;
                const REWARDS_AVG = 50;
                const TOTAL_EXPENSE = PRODUCT_COST + MLM_PAYOUT + SALARY_AVG + REWARDS_AVG;
                const PROFIT_PER = JOINING - TOTAL_EXPENSE;

                const totalMembers = allMembers.length;
                const activeMembers = allMembers.filter(m => m.is_approved).length;
                const totalCollection = activeMembers * JOINING;
                const totalMLMPaid = allMembers.reduce((s, m) => s + Number(m.total_income || 0), 0);
                const totalWithdrawn = allMembers.reduce((s, m) => s + Number(m.total_withdrawn || 0), 0);
                const estimatedProfit = activeMembers * PROFIT_PER;

                return (
                  <div>
                    <div className="kpi-grid">
                      {[
                        { label: "Total Members", val: totalMembers, icon: "👥", bg: "#1e3a8a" },
                        { label: "Active Members", val: activeMembers, icon: "✅", bg: "#065f46" },
                        { label: "Total Collection", val: inr(totalCollection), icon: "💼", bg: "#4c1d95" },
                        { label: "MLM Paid Out", val: inr(totalMLMPaid), icon: "💰", bg: "#134e4a" },
                        { label: "Total Withdrawn", val: inr(totalWithdrawn), icon: "🏦", bg: "#7f1d1d" },
                        { label: "Est. Net Profit", val: inr(estimatedProfit), icon: "📈", bg: "#14532d" },
                      ].map(c => (
                        <div key={c.label} style={{ ...S.kpiCard, background: c.bg }}>
                          <div style={{ fontSize: 22 }}>{c.icon}</div>
                          <div style={{ fontSize: 16, fontWeight: 800 }}>{c.val}</div>
                          <div style={{ fontSize: 10, opacity: .8 }}>{c.label}</div>
                        </div>
                      ))}
                    </div>
                    <div className="flex-wrap-row" style={{ marginBottom: 16 }}>
                      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                        <div style={{ background: "linear-gradient(135deg,#1e3a8a,#1d4ed8)", borderRadius: 10, padding: "14px 18px", color: "#fff" }}>
                          <div style={{ fontSize: 13, fontWeight: 800, marginBottom: 10, borderBottom: "1px solid rgba(255,255,255,.2)", paddingBottom: 8 }}>💸 COLLECTION (PER MEMBER)</div>
                          <div style={{ display: "flex", justifyContent: "space-between", fontSize: 14 }}>
                            <span>Joining Amount</span>
                            <span style={{ fontWeight: 900, fontSize: 18, color: "#fbbf24" }}>= ₹{JOINING.toLocaleString()}</span>
                          </div>
                        </div>
                        <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 10, overflow: "hidden" }}>
                          <div style={{ background: "#dc2626", color: "#fff", padding: "10px 16px", fontWeight: 800, fontSize: 13 }}>🧾 COMPANY GIVES (PER PERSON)</div>
                          <div style={{ padding: "12px 16px" }}>
                            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
                              <thead><tr style={{ background: "#eff6ff" }}>
                                <th style={{ padding: "5px 10px", textAlign: "left", color: "#1d4ed8" }}>Item</th>
                                <th style={{ padding: "5px 10px", textAlign: "right", color: "#1d4ed8" }}>Amount</th>
                              </tr></thead>
                              <tbody>
                                {[["Product / Service", PRODUCT_COST], ...Object.entries(LEVEL_RATE).map(([l, r]) => [`Level ${l}`, r]), ["Salary (avg)", SALARY_AVG], ["Rewards (avg)", REWARDS_AVG]].map(([label, amt], i) => (
                                  <tr key={label} style={{ background: i % 2 === 0 ? "#f8fafc" : "#fff" }}>
                                    <td style={{ padding: "5px 10px" }}>{label}</td>
                                    <td style={{ padding: "5px 10px", textAlign: "right", fontWeight: 700, color: "#16a34a" }}>₹{amt}</td>
                                  </tr>
                                ))}
                                <tr style={{ background: "#f0fdf4", fontWeight: 800 }}>
                                  <td style={{ padding: "6px 10px" }}>👉 Total</td>
                                  <td style={{ padding: "6px 10px", textAlign: "right", color: "#15803d", fontSize: 14 }}>= ₹{TOTAL_EXPENSE}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                        <div style={{ background: "linear-gradient(135deg,#14532d,#16a34a)", borderRadius: 10, padding: "20px", color: "#fff", textAlign: "center" }}>
                          <div style={{ fontSize: 13, opacity: .9, marginBottom: 8 }}>💰 COMPANY PROFIT (PER PERSON)</div>
                          <div style={{ fontSize: 36, fontWeight: 900, color: "#bbf7d0" }}>₹{PROFIT_PER.toLocaleString()}</div>
                          <div style={{ fontSize: 12, opacity: .8, marginTop: 6 }}>NET PROFIT PER MEMBER</div>
                        </div>
                        <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 10, overflow: "hidden" }}>
                          <div style={{ background: "#7c3aed", color: "#fff", padding: "10px 16px", fontWeight: 800, fontSize: 13 }}>📈 AT SCALE — PROFIT PROJECTIONS</div>
                          <div style={{ padding: "12px 16px" }}>
                            {[[activeMembers || 1, "Current members"], [1000, "1,000 members"], [10000, "10,000 members"], [100000, "1,00,000 members"]].map(([count, label], i) => {
                              const profit = count * PROFIT_PER;
                              const isActive = i === 0;
                              return (
                                <div key={label} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 12px", borderRadius: 8, marginBottom: 6, background: isActive ? "#f0fdf4" : "#f8fafc", border: isActive ? "2px solid #16a34a" : "1px solid #e2e8f0" }}>
                                  <div>
                                    <div style={{ fontWeight: isActive ? 800 : 600, fontSize: 13, color: isActive ? "#15803d" : "#374151" }}>{isActive ? "🔴 " : ""}{label}</div>
                                    <div style={{ fontSize: 11, color: "#94a3b8" }}>₹{PROFIT_PER} × {count.toLocaleString()}</div>
                                  </div>
                                  <div style={{ fontWeight: 900, fontSize: 15, color: isActive ? "#16a34a" : "#7c3aed" }}>
                                    {profit >= 10000000 ? `₹${(profit / 10000000).toFixed(2)} Cr` : profit >= 100000 ? `₹${(profit / 100000).toFixed(1)} L` : `₹${profit.toLocaleString()}`}
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    </div>
                    <SectionTitle>📋 All Members Business Summary</SectionTitle>
                    <div className="table-scroll" style={{ background: "#fff", borderRadius: 8, border: "1px solid #e2e8f0", marginBottom: 16 }}>
                      <table style={S.table}>
                        <THead cols={["#", "Coupon", "Name", "Mobile", "Rank", "Direct", "Team", "Income", "Withdrawn", "Balance", "Status"]} />
                        <tbody>
                          {[...allMembers].sort((a, b) => Number(b.total_income || 0) - Number(a.total_income || 0)).map((m, i) => (
                            <tr key={m.id} style={i % 2 === 0 ? S.trEven : {}}>
                              <td style={S.td}>{i + 1}</td>
                              <td style={{ ...S.td, fontWeight: 700, color: "#1d4ed8", cursor: "pointer" }} onClick={() => openDetail(m)}>{m.receiver_coupon_no}</td>
                              <td style={S.td}>{m.receiver_name}</td>
                              <td style={S.td}>{m.receiver_mobile}</td>
                              <td style={S.td}><span style={S.pill}>{m.rank || "member"}</span></td>
                              <td style={{ ...S.td, fontWeight: 700 }}>{m.direct_count || 0}</td>
                              <td style={S.td}>{Number(m.direct_count || 0) + Number(m.indirect_count || 0)}</td>
                              <td style={{ ...S.td, fontWeight: 800, color: "#16a34a" }}>{inr(m.total_income)}</td>
                              <td style={{ ...S.td, color: "#dc2626" }}>{inr(m.total_withdrawn)}</td>
                              <td style={{ ...S.td, fontWeight: 700, color: "#7c3aed" }}>{inr(Number(m.total_income || 0) - Number(m.total_withdrawn || 0))}</td>
                              <td style={S.td}><span style={m.is_approved ? S.greenBadge : S.yellowBadge}>{m.is_approved ? "Active" : "Pending"}</span></td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                );
              })()}
            </div>
          )}

          {/* ══════════ COMMISSION SUMMARY ══════════ */}
          {subTab === "Commission Summary" && (
            <div>
              <PageHead title="📋 Commission Summary" />
              <div className="level-cards">
                {[1, 2, 3, 4, 5, 6].map((l, i) => (
                  <div key={l} style={{ background: PIE_COLORS[i], color: "#fff", borderRadius: 10, padding: "12px 14px", textAlign: "center" }}>
                    <div style={{ fontSize: 10, opacity: 0.8 }}>L{l} (₹{LEVEL_RATE[l]}/join)</div>
                    <div style={{ fontSize: 16, fontWeight: 800, marginTop: 4 }}>
                      {inr(allMembers.reduce((s, m) => s + Number(m[`level${l}_income`] || 0), 0))}
                    </div>
                    <div style={{ fontSize: 10, opacity: 0.8, marginTop: 2 }}>
                      {allMembers.filter(m => Number(m[`level${l}_income`]) > 0).length} earners
                    </div>
                  </div>
                ))}
              </div>
              {[1, 2, 3, 4, 5, 6].map((level) => (
                <div key={level}>
                  <SectionTitle>🏆 Top 5 Earners — Level {level} (₹{LEVEL_RATE[level]}/join)</SectionTitle>
                  <div className="table-scroll" style={{ background: "#fff", borderRadius: 8, border: "1px solid #e2e8f0", marginBottom: 16 }}>
                    <table style={S.table}>
                      <THead cols={["Rank", "Coupon", "Name", "Mobile", `L${level} Income`]} />
                      <tbody>
                        {[...allMembers].filter(m => Number(m[`level${level}_income`]) > 0)
                          .sort((a, b) => Number(b[`level${level}_income`]) - Number(a[`level${level}_income`]))
                          .slice(0, 5)
                          .map((m, i) => (
                            <tr key={m.id} style={i % 2 === 0 ? S.trEven : {}}>
                              <td style={{ ...S.td, fontWeight: 800, color: i < 3 ? "#f59e0b" : "#64748b" }}>#{i + 1}</td>
                              <td style={{ ...S.td, color: "#1d4ed8", fontWeight: 700, cursor: "pointer" }} onClick={() => openDetail(m)}>{m.receiver_coupon_no}</td>
                              <td style={S.td}>{m.receiver_name}</td>
                              <td style={S.td}>{m.receiver_mobile}</td>
                              <td style={{ ...S.td, fontWeight: 800, color: "#16a34a", fontSize: 13 }}>{inr(m[`level${level}_income`])}</td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* ══════════ DAILY JOINS ══════════ */}
          {subTab === "Daily Joins" && (
            <div>
              <PageHead title="📅 Daily Joins Report — Last 30 Days" />
              {dailyJoins.length === 0 ? (
                <div style={{ textAlign: "center", padding: 60, color: "#94a3b8", background: "#f8fafc", borderRadius: 8, border: "2px dashed #e2e8f0" }}>
                  <div style={{ fontSize: 40, marginBottom: 12 }}>📅</div>
                  <div style={{ fontWeight: 700, fontSize: 15 }}>Loading or no join data for last 30 days</div>
                  <button style={{ ...S.btn, background: "#1e3a8a", marginTop: 16 }} onClick={loadDailyJoins}>🔄 Reload</button>
                </div>
              ) : (
                <>
                  <div className="kpi-grid">
                    {[
                      { icon: "📅", label: "Total Joins", val: dailyJoins.reduce((s, d) => s + Number(d.count || 0), 0), bg: "#1e3a8a" },
                      { icon: "✅", label: "Approved", val: dailyJoins.reduce((s, d) => s + Number(d.approved || 0), 0), bg: "#065f46" },
                      { icon: "⏳", label: "Pending", val: dailyJoins.reduce((s, d) => s + Number(d.pending || 0), 0), bg: "#92400e" },
                      { icon: "📈", label: "Avg / Day", val: dailyJoins.length > 0 ? Math.round(dailyJoins.reduce((s, d) => s + Number(d.count || 0), 0) / dailyJoins.length) : 0, bg: "#4c1d95" },
                      { icon: "🏆", label: "Best Day", val: Math.max(...dailyJoins.map(d => Number(d.count || 0))), bg: "#134e4a" },
                    ].map(c => (
                      <div key={c.label} style={{ ...S.kpiCard, background: c.bg }}>
                        <div style={{ fontSize: 22 }}>{c.icon}</div>
                        <div style={{ fontSize: 18, fontWeight: 800 }}>{c.val}</div>
                        <div style={{ fontSize: 10, opacity: .8 }}>{c.label}</div>
                      </div>
                    ))}
                  </div>
                  <div style={{ ...S.card, marginBottom: 16 }}>
                    <CardHead>📈 Daily Registration Trend</CardHead>
                    <div style={{ padding: 16 }}>
                      <ResponsiveContainer width="100%" height={240}>
                        <BarChart data={dailyJoins}>
                          <XAxis dataKey="date" tick={{ fontSize: 9 }} />
                          <YAxis tick={{ fontSize: 9 }} allowDecimals={false} />
                          <Tooltip /><Legend />
                          <Bar dataKey="approved" name="Approved" stackId="a" fill="#10b981" />
                          <Bar dataKey="pending" name="Pending" stackId="a" fill="#f59e0b" radius={[4, 4, 0, 0]} />
                        </BarChart>
                      </ResponsiveContainer>
                    </div>
                  </div>
                  <div className="table-scroll" style={{ background: "#fff", borderRadius: 8, border: "1px solid #e2e8f0", marginBottom: 16 }}>
                    <table style={S.table}>
                      <THead cols={["#", "Date", "Total", "Approved", "Pending", "Running Total", "Bar"]} />
                      <tbody>
                        {(() => {
                          let running = 0;
                          const maxCount = Math.max(...dailyJoins.map(d => Number(d.count || 0)), 1);
                          return dailyJoins.map((d, i) => {
                            running += Number(d.count || 0);
                            const isMax = Number(d.count) === maxCount;
                            return (
                              <tr key={i} style={i % 2 === 0 ? S.trEven : {}}>
                                <td style={S.td}>{i + 1}</td>
                                <td style={{ ...S.td, fontWeight: 600 }}>{d.date}</td>
                                <td style={{ ...S.td, fontWeight: 800, color: isMax ? "#f59e0b" : "#1d4ed8", fontSize: 14 }}>{d.count} {isMax ? "🏆" : ""}</td>
                                <td style={{ ...S.td, color: "#16a34a", fontWeight: 700 }}>{d.approved || 0}</td>
                                <td style={{ ...S.td, color: "#f59e0b", fontWeight: 700 }}>{d.pending || 0}</td>
                                <td style={{ ...S.td, color: "#7c3aed" }}>{running}</td>
                                <td style={S.td}>
                                  <div style={{ height: 10, borderRadius: 99, background: isMax ? "#f59e0b" : "#3b82f6", width: `${(Number(d.count) / maxCount) * 120}px`, minWidth: 4 }} />
                                </td>
                              </tr>
                            );
                          });
                        })()}
                      </tbody>
                    </table>
                  </div>
                </>
              )}
            </div>
          )}

          {/* ══════════ NETWORK TREE ══════════ */}
          {subTab === "Network Tree" && (
            <div>
              <PageHead title="🌳 Network Tree — Member Downline" />
              <div style={{ ...S.card, marginBottom: 16 }}>
                <CardHead>Search Member Network</CardHead>
                <div style={{ padding: 16 }}>
                  <div className="search-row">
                    <input
                      style={{ ...S.searchBox }}
                      placeholder="Enter Coupon No (e.g. MR001)..."
                      value={networkToken}
                      onChange={e => setNetworkToken(e.target.value)}
                      onKeyDown={e => e.key === "Enter" && loadNetworkTree(networkToken)}
                    />
                    <button style={{ ...S.btn, background: "#1e3a8a", padding: "9px 20px" }} onClick={() => loadNetworkTree(networkToken)}>
                      🔍 Load Tree
                    </button>
                    {networkTree && (
                      <button style={{ ...S.btn, background: "#64748b" }} onClick={() => { setNetworkTree(null); setNetworkToken(""); }}>
                        ✕ Clear
                      </button>
                    )}
                  </div>
                  {networkTree && (
                    <span style={{ ...S.countBadge, background: "#dcfce7", color: "#15803d" }}>
                      Showing: <b>{networkTree.receiver_coupon_no || networkTree.token_number}</b>
                    </span>
                  )}
                </div>
              </div>
              {networkTree ? (
                <div style={{ ...S.card, padding: 12, maxHeight: 620, overflowY: "auto", overflowX: "auto" }}>
                  <TreeNode node={networkTree} depth={0} />
                </div>
              ) : (
                <div style={{ textAlign: "center", padding: 60, color: "#94a3b8", background: "#f8fafc", borderRadius: 8, border: "2px dashed #e2e8f0" }}>
                  <div style={{ fontSize: 48, marginBottom: 12 }}>🌳</div>
                  <div style={{ fontWeight: 700, fontSize: 16, marginBottom: 6 }}>Enter a coupon number above</div>
                  <div style={{ fontSize: 12 }}>Tree shows downline up to 6 levels. Click any node to expand.</div>
                </div>
              )}
            </div>
          )}

          {/* ══════════ WITHDRAWAL REQUESTS ══════════ */}
          {subTab === "Withdrawal Requests" && (
            <div>
              <PageHead title="💸 Withdrawal Requests — Pending">
                <span style={{ ...S.countBadge, background: "#fee2e2", color: "#991b1b", marginLeft: "auto" }}>
                  {withdrawals.length} Pending
                </span>
              </PageHead>
              <div className="table-scroll" style={{ background: "#fff", borderRadius: 8, border: "1px solid #e2e8f0", marginBottom: 16 }}>
                <table style={S.table}>
                  <THead cols={["#", "Coupon", "Member", "Mobile", "Amount", "Method", "Bank/UPI", "Requested", "Actions"]} />
                  <tbody>
                    {withdrawals.map((w, i) => (
                      <tr key={w.id} style={i % 2 === 0 ? S.trEven : {}}>
                        <td style={S.td}>{i + 1}</td>
                        <td style={{ ...S.td, fontWeight: 700, color: "#1d4ed8" }}>{w.receiver_coupon_no}</td>
                        <td style={S.td}>{w.receiver_name}</td>
                        <td style={S.td}>{w.receiver_mobile}</td>
                        <td style={{ ...S.td, fontWeight: 800, color: "#16a34a", fontSize: 13 }}>{inr(w.amount)}</td>
                        <td style={S.td}>{w.method?.toUpperCase()}</td>
                        <td style={{ ...S.td, fontSize: 11 }}>
                          {w.method === "bank"
                            ? <><b>{w.bank_name}</b><br />A/c: {w.account_number}<br />IFSC: {w.ifsc}</>
                            : <><b>UPI:</b> {w.upi_id}</>}
                        </td>
                        <td style={{ ...S.td, fontSize: 11 }}>{fmtTime(w.created_at)}</td>
                        <td style={S.td}>
                          <div style={{ display: "flex", gap: 4, flexDirection: "column" }}>
                            <button style={{ ...S.btn, background: "#16a34a", fontSize: 11 }} onClick={() => processWithdrawal(w.id, "approved", w)}>✅ Approve + 📱</button>
                            <button style={{ ...S.btn, background: "#dc2626", fontSize: 11 }} onClick={() => processWithdrawal(w.id, "rejected", w)}>❌ Reject</button>
                          </div>
                        </td>
                      </tr>
                    ))}
                    {withdrawals.length === 0 && (
                      <tr><td colSpan={9} style={{ ...S.td, textAlign: "center", color: "#94a3b8", padding: 40 }}>🎉 No pending withdrawal requests!</td></tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* ══════════ PAYMENT HISTORY ══════════ */}
          {subTab === "Payment History" && (
            <div>
              <PageHead title="📋 Payment History — All Payouts" />
              <div className="level-cards">
                {[1, 2, 3, 4, 5, 6].map(l => (
                  <div key={l} style={{ background: "#1e3a8a", color: "#fff", borderRadius: 8, padding: "10px 12px", textAlign: "center" }}>
                    <div style={{ fontSize: 10, opacity: .7 }}>L{l} (₹{LEVEL_RATE[l]}/join)</div>
                    <div style={{ fontSize: 14, fontWeight: 800 }}>
                      {inr(allMembers.reduce((s, m) => s + Number(m[`level${l}_income`] || 0), 0))}
                    </div>
                  </div>
                ))}
              </div>
              <div className="table-scroll" style={{ background: "#fff", borderRadius: 8, border: "1px solid #e2e8f0", marginBottom: 16 }}>
                <table style={S.table}>
                  <THead cols={["#", "Coupon", "Member", "Mobile", "Amount", "Method", "Status", "Processed", "Date", "WA"]} />
                  <tbody>
                    {payHistory.map((w, i) => (
                      <tr key={w.id} style={i % 2 === 0 ? S.trEven : {}}>
                        <td style={S.td}>{i + 1}</td>
                        <td style={{ ...S.td, fontWeight: 700, color: "#1d4ed8" }}>{w.receiver_coupon_no}</td>
                        <td style={S.td}>{w.receiver_name}</td>
                        <td style={S.td}>{w.receiver_mobile}</td>
                        <td style={{ ...S.td, fontWeight: 800, color: "#16a34a" }}>{inr(w.amount)}</td>
                        <td style={S.td}>{w.method?.toUpperCase()}</td>
                        <td style={S.td}><span style={w.status === "approved" ? S.greenBadge : w.status === "rejected" ? S.redBadge : S.yellowBadge}>{w.status}</span></td>
                        <td style={{ ...S.td, fontSize: 11 }}>{w.processed_at ? fmt(w.processed_at) : "—"}</td>
                        <td style={{ ...S.td, fontSize: 11 }}>{fmt(w.created_at)}</td>
                        <td style={S.td}>
                          <button style={{ ...S.btn, background: "#25D366", padding: "4px 8px" }}
                            onClick={() => whatsapp(w.receiver_mobile, `💸 Namaste *${w.receiver_name}*!\n\nYour payout of *${inr(w.amount)}* is *${w.status.toUpperCase()}*.\n\n_${COMPANY}_\n${COMPANY_URL}`)}>
                            📱
                          </button>
                        </td>
                      </tr>
                    ))}
                    {payHistory.length === 0 && <tr><td colSpan={10} style={{ ...S.td, textAlign: "center", color: "#94a3b8", padding: 40 }}>No payment history</td></tr>}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* ══════════ ADD FUND TO MEMBER ══════════ */}
          {subTab === "Add Fund to Member" && (
            <div>
              <PageHead title="➕ Add Fund to Member Wallet" />
              <div style={{ ...S.card, maxWidth: 480 }}>
                <CardHead>Manually Add Amount</CardHead>
                <div style={{ padding: 20 }}>
                  <p style={{ fontSize: 12, color: "#64748b", marginBottom: 16, padding: "10px 14px", background: "#fefce8", borderRadius: 8, border: "1px solid #fde68a" }}>
                    ⚠️ Use this to record an amount received from a member. It will be credited directly to their wallet.
                  </p>
                  {[
                    ["Member Token / Coupon No *", "token_number", "text", "Enter member token or coupon number"],
                    ["Amount Received (₹) *", "amount", "number", "Enter amount"],
                    ["Description *", "description", "text", "e.g. Cash received, Online payment ref #123"],
                  ].map(([label, key, type, placeholder]) => (
                    <div key={key} style={{ marginBottom: 14 }}>
                      <label style={S.label}>{label}</label>
                      <input style={S.input} type={type} placeholder={placeholder}
                        value={addFundForm[key]} onChange={e => setAddFundForm({ ...addFundForm, [key]: e.target.value })} />
                    </div>
                  ))}
                  <button style={{ ...S.btn, background: "#1e3a8a", width: "100%", padding: 12, fontSize: 14 }} onClick={addFund}>
                    ➕ Credit to Member Wallet
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* ══════════ SALARY LIST ══════════ */}
          {subTab === "Salary List" && (
            <div>
              <PageHead title="💰 Salary List" />
              <div className="kpi-grid">
                {[
                  { icon: "📋", label: "Total Records", val: salaries.length, bg: "#1e3a8a" },
                  { icon: "✅", label: "Paid", val: salaries.filter(s => s.is_approved).length, bg: "#065f46" },
                  { icon: "⏳", label: "Pending", val: salaries.filter(s => !s.is_approved).length, bg: "#92400e" },
                  { icon: "💰", label: "Total Amount", val: inr(salaries.reduce((s, x) => s + Number(x.amount || 0), 0)), bg: "#4c1d95" },
                ].map(c => (
                  <div key={c.label} style={{ ...S.kpiCard, background: c.bg }}>
                    <div style={{ fontSize: 20 }}>{c.icon}</div>
                    <div style={{ fontSize: 18, fontWeight: 800 }}>{c.val}</div>
                    <div style={{ fontSize: 10, opacity: .8 }}>{c.label}</div>
                  </div>
                ))}
              </div>
              <div className="table-scroll" style={{ background: "#fff", borderRadius: 8, border: "1px solid #e2e8f0", marginBottom: 16 }}>
                <table style={S.table}>
                  <THead cols={["#", "Coupon", "Member", "Mobile", "Rank", "Amount", "Month", "Status", "Action"]} />
                  <tbody>
                    {salaries.map((s, i) => (
                      <tr key={s.id} style={i % 2 === 0 ? S.trEven : {}}>
                        <td style={S.td}>{i + 1}</td>
                        <td style={{ ...S.td, fontWeight: 700 }}>{s.receiver_coupon_no || s.token_number}</td>
                        <td style={S.td}>{s.receiver_name}</td>
                        <td style={S.td}>{s.receiver_mobile}</td>
                        <td style={S.td}><span style={{ ...S.pill, textTransform: "capitalize" }}>{s.rank}</span></td>
                        <td style={{ ...S.td, fontWeight: 700, color: "#16a34a" }}>{inr(s.amount)}</td>
                        <td style={S.td}>{s.month}</td>
                        <td style={S.td}><span style={s.is_approved ? S.greenBadge : S.yellowBadge}>{s.is_approved ? "Paid ✅" : "Pending"}</span></td>
                        <td style={S.td}>
                          {!s.is_approved && (
                            <button style={{ ...S.btn, background: "#16a34a", fontSize: 11 }} onClick={() => approveSalary(s.id, s)}>Approve + 📱</button>
                          )}
                          {s.is_approved && (
                            <button style={{ ...S.btn, background: "#25D366", fontSize: 11 }}
                              onClick={() => whatsapp(s.receiver_mobile, `💰 Namaste *${s.receiver_name}*!\n\nSalary of *${inr(s.amount)}* for ${s.month} credited ✅\n\n_${COMPANY}_`)}>
                              📱 WA
                            </button>
                          )}
                        </td>
                      </tr>
                    ))}
                    {salaries.length === 0 && (
                      <tr><td colSpan={9} style={{ ...S.td, textAlign: "center", color: "#94a3b8", padding: 40 }}>No records. Generate salary first.</td></tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* ══════════ GENERATE SALARY ══════════ */}
          {subTab === "Generate Salary" && (
            <div>
              <PageHead title="💰 Generate Monthly Salary" />
              <div className="flex-wrap-row">
                <div style={{ ...S.card, maxWidth: 520 }}>
                  <CardHead>Salary Generation</CardHead>
                  <div style={{ padding: 20 }}>
                    <p style={{ fontSize: 12, color: "#64748b", marginBottom: 16, padding: "10px 14px", background: "#f0fdf4", borderRadius: 8, border: "1px solid #bbf7d0" }}>
                      ℹ️ Generates salary records for all eligible members based on current rank.
                    </p>
                    <SectionTitle>Salary Rates by Rank</SectionTitle>
                    {Object.entries(RANK_SALARY).map(([rank, amt]) => (
                      <div key={rank} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 12px", borderBottom: "1px solid #f1f5f9", fontSize: 13 }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                          <div style={{ width: 10, height: 10, borderRadius: "50%", background: rank === "diamond" ? "#06b6d4" : rank === "platinum" ? "#8b5cf6" : rank === "gold" ? "#f59e0b" : "#94a3b8" }} />
                          <span style={{ textTransform: "capitalize", fontWeight: 600 }}>{rank}</span>
                        </div>
                        <span style={{ color: "#16a34a", fontWeight: 700 }}>{inr(amt)} / month</span>
                      </div>
                    ))}
                    <div style={{ marginTop: 20 }}>
                      <button
                        style={{ ...S.btn, background: generatingSalary ? "#64748b" : "#1e3a8a", width: "100%", padding: 14, fontSize: 15 }}
                        onClick={generateSalary} disabled={generatingSalary}
                      >
                        {generatingSalary ? "⏳ Generating..." : "🚀 Generate This Month's Salary"}
                      </button>
                    </div>
                  </div>
                </div>
                <div style={{ ...S.card }}>
                  <CardHead>👥 Eligible Members Preview</CardHead>
                  <div style={{ padding: "8px 0", maxHeight: 380, overflowY: "auto" }}>
                    {Object.keys(RANK_SALARY).map(rank => {
                      const eligible = allMembers.filter(m => m.rank === rank && m.is_approved);
                      if (eligible.length === 0) return null;
                      return (
                        <div key={rank}>
                          <div style={{ padding: "8px 16px", background: "#f8fafc", fontSize: 11, fontWeight: 700, color: "#475569", textTransform: "uppercase", letterSpacing: 1 }}>
                            {rank} — {inr(RANK_SALARY[rank])}/mo × {eligible.length} = {inr(RANK_SALARY[rank] * eligible.length)}
                          </div>
                          {eligible.slice(0, 3).map(m => (
                            <div key={m.id} style={{ padding: "6px 16px", borderBottom: "1px solid #f1f5f9", fontSize: 12, display: "flex", justifyContent: "space-between" }}>
                              <span>{m.receiver_name}</span>
                              <span style={{ color: "#16a34a", fontWeight: 700 }}>{inr(RANK_SALARY[rank])}</span>
                            </div>
                          ))}
                          {eligible.length > 3 && <div style={{ padding: "4px 16px", fontSize: 11, color: "#94a3b8" }}>+{eligible.length - 3} more...</div>}
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* ══════════ ALL ADMINS ══════════ */}
          {subTab === "All Admins" && (
            <div>
              <PageHead title="🛡 All Admins" />
              <div className="table-scroll" style={{ background: "#fff", borderRadius: 8, border: "1px solid #e2e8f0", marginBottom: 16 }}>
                <table style={S.table}>
                  <THead cols={["#", "Username", "Full Name", "Mobile", "Role", "Status", "Created", "Action"]} />
                  <tbody>
                    {adminList.map((a, i) => (
                      <tr key={a.id} style={i % 2 === 0 ? S.trEven : {}}>
                        <td style={S.td}>{i + 1}</td>
                        <td style={{ ...S.td, fontWeight: 700 }}>{a.username}</td>
                        <td style={S.td}>{a.full_name}</td>
                        <td style={S.td}>{a.mobile}</td>
                        <td style={S.td}><span style={a.role === "superadmin" ? S.greenBadge : S.pill}>{a.role}</span></td>
                        <td style={S.td}><span style={a.is_active ? S.greenBadge : S.redBadge}>{a.is_active ? "Active" : "Inactive"}</span></td>
                        <td style={{ ...S.td, fontSize: 11 }}>{fmt(a.created_at)}</td>
                        <td style={S.td}>
                          {/* ── DELETE ADMIN — protected: don't allow deleting superadmin or self ── */}
                          {a.role !== "superadmin" ? (
                            <ActionBtn color="#dc2626" onClick={() => deleteAdmin(a.id, a.username)} title="Delete Admin">
                              🗑 Delete
                            </ActionBtn>
                          ) : (
                            <span style={{ fontSize: 11, color: "#94a3b8" }}>Protected</span>
                          )}
                        </td>
                      </tr>
                    ))}
                    {adminList.length === 0 && <tr><td colSpan={8} style={{ ...S.td, textAlign: "center", color: "#94a3b8" }}>No admins</td></tr>}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* ══════════ CREATE ADMIN ══════════ */}
          {subTab === "Create Admin" && (
            <div>
              <PageHead title="➕ Create New Admin" />
              <div style={{ ...S.card, maxWidth: 480 }}>
                <CardHead>Admin Account Details</CardHead>
                <div style={{ padding: 20 }}>
                  {[["Username *", "username", "text"], ["Password *", "password", "password"],
                    ["Full Name", "full_name", "text"], ["Mobile", "mobile", "text"]].map(([label, key, type]) => (
                    <div key={key} style={{ marginBottom: 14 }}>
                      <label style={S.label}>{label}</label>
                      <input style={S.input} type={type} value={newAdmin[key]}
                        onChange={e => setNewAdmin({ ...newAdmin, [key]: e.target.value })} />
                    </div>
                  ))}
                  <div style={{ marginBottom: 16 }}>
                    <label style={S.label}>Role</label>
                    <select style={S.input} value={newAdmin.role} onChange={e => setNewAdmin({ ...newAdmin, role: e.target.value })}>
                      <option value="admin">Admin</option>
                      <option value="superadmin">Super Admin</option>
                    </select>
                  </div>
                  <button style={{ ...S.btn, background: "#1e3a8a", width: "100%", padding: 12 }} onClick={createAdmin}>
                    Create Admin Account
                  </button>
                </div>
              </div>
            </div>
          )}

          {tab !== "dashboard" && !subTab && (
            <div style={{ padding: 60, textAlign: "center", color: "#94a3b8" }}>
              Select a submenu item from the sidebar.
            </div>
          )}

          {/* ══════════ GALLERY MANAGER ══════════ */}
          {subTab === "Gallery Manager" && (
            <div>
              <PageHead title="🖼 Gallery Manager" />
              <div style={{ ...S.card, maxWidth: 560, marginBottom: 24 }}>
                <CardHead>{galleryEditingId ? "✏️ Edit Image" : "➕ Add New Image"}</CardHead>
                <div style={{ padding: 20 }}>
                  <div style={{ marginBottom: 14 }}>
                    <label style={S.label}>Heading (optional)</label>
                    <input style={S.input} placeholder="Enter image heading..." value={galleryHeading}
                      onChange={e => setGalleryHeading(e.target.value)} />
                  </div>
                  <div style={{ marginBottom: 18 }}>
                    <label style={S.label}>{galleryEditingId ? "Replace Image (optional)" : "Image *"}</label>
                    <input id="gallery-file-input" type="file" accept="image/*"
                      style={{ ...S.input, padding: "7px 10px", cursor: "pointer" }}
                      onChange={e => setGalleryImage(e.target.files[0])} />
                    {galleryImage && <div style={{ marginTop: 8, fontSize: 11, color: "#64748b" }}>📎 Selected: {galleryImage.name}</div>}
                  </div>
                  <div style={{ display: "flex", gap: 10 }}>
                    {galleryEditingId ? (
                      <>
                        <button style={{ ...S.btn, background: galleryLoading ? "#64748b" : "#16a34a", flex: 1, padding: 12, justifyContent: "center" }}
                          onClick={updateGalleryItem} disabled={galleryLoading}>
                          {galleryLoading ? "⏳ Updating..." : "✅ Update Image"}
                        </button>
                        <button style={{ ...S.btn, background: "#64748b", padding: 12 }}
                          onClick={() => { setGalleryEditingId(null); setGalleryHeading(""); setGalleryImage(null); }}>
                          Cancel
                        </button>
                      </>
                    ) : (
                      <button style={{ ...S.btn, background: galleryLoading ? "#64748b" : "#1e3a8a", flex: 1, padding: 12, justifyContent: "center" }}
                        onClick={addGalleryItem} disabled={galleryLoading}>
                        {galleryLoading ? "⏳ Uploading..." : "🖼 Add Image"}
                      </button>
                    )}
                    <button style={{ ...S.btn, background: "#0369a1", padding: "12px 16px" }} onClick={loadGallery}>🔄</button>
                  </div>
                </div>
              </div>

              <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 14 }}>
                <SectionTitle>📸 All Gallery Images</SectionTitle>
                <span style={{ ...S.countBadge }}>{gallery.length} images</span>
              </div>

              {gallery.length === 0 ? (
                <div style={{ textAlign: "center", padding: 60, color: "#94a3b8", background: "#f8fafc", borderRadius: 8, border: "2px dashed #e2e8f0" }}>
                  <div style={{ fontSize: 48, marginBottom: 12 }}>🖼</div>
                  <div style={{ fontWeight: 700, fontSize: 15 }}>No images yet</div>
                  <div style={{ fontSize: 12, marginTop: 6 }}>Add your first image using the form above</div>
                </div>
              ) : (
                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))", gap: 16 }}>
                  {gallery.map(g => (
                    <div key={g.id} style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 10, overflow: "hidden", boxShadow: "0 1px 4px rgba(0,0,0,.07)", display: "flex", flexDirection: "column" }}>
                      <div style={{ position: "relative", paddingTop: "66%", background: "#f1f5f9" }}>
                        <img src={`${GALLERY_IMG}/${g.image}`} alt={g.heading || "Gallery image"}
                          style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", objectFit: "cover", cursor: "pointer" }}
                          onClick={() => openLightbox(`${GALLERY_IMG}/${g.image}`, g.heading)}
                          onError={e => { e.target.style.display = "none"; }} />
                        <span style={{ position: "absolute", top: 8, left: 8, background: "rgba(0,0,0,.55)", color: "#fff", fontSize: 10, borderRadius: 99, padding: "2px 8px", fontWeight: 700 }}>#{g.id}</span>
                      </div>
                      <div style={{ padding: "10px 12px", flex: 1 }}>
                        {g.heading ? <div style={{ fontWeight: 700, fontSize: 13, color: "#1e293b", marginBottom: 4, wordBreak: "break-word" }}>{g.heading}</div>
                          : <div style={{ fontSize: 11, color: "#94a3b8", marginBottom: 4, fontStyle: "italic" }}>No heading</div>}
                        <div style={{ fontSize: 10, color: "#94a3b8", wordBreak: "break-all" }}>{g.image}</div>
                      </div>
                      <div style={{ display: "flex", gap: 0, borderTop: "1px solid #f1f5f9" }}>
                        <button style={{ flex: 1, background: "#fef9c3", color: "#92400e", border: "none", padding: "9px 0", fontWeight: 700, fontSize: 12, cursor: "pointer", borderRight: "1px solid #f1f5f9" }}
                          onClick={() => editGalleryItem(g)}>✏️ Edit</button>
                        <button style={{ flex: 1, background: "#eff6ff", color: "#1d4ed8", border: "none", padding: "9px 0", fontWeight: 700, fontSize: 12, cursor: "pointer", borderRight: "1px solid #f1f5f9" }}
                          onClick={() => openLightbox(`${GALLERY_IMG}/${g.image}`, g.heading)}>👁 View</button>
                        <button style={{ flex: 1, background: "#fee2e2", color: "#991b1b", border: "none", padding: "9px 0", fontWeight: 700, fontSize: 12, cursor: "pointer" }}
                          onClick={() => deleteGalleryItem(g.id)}>🗑 Delete</button>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
        </main>
      </div>
    </div>
  );
}

/* ── Sub-components ── */
function PageHead({ title, sub, children }) {
  return (
    <div className="page-head">
      <div style={{ width: 4, height: 20, background: "#ea580c", borderRadius: 99, flexShrink: 0 }} />
      <span style={{ fontWeight: 700, fontSize: 16, color: "#1e293b" }}>{title}</span>
      {sub && <span style={{ fontSize: 11, color: "#94a3b8" }}>{sub}</span>}
      {children}
    </div>
  );
}
function SectionTitle({ children }) {
  return <div style={{ fontWeight: 700, fontSize: 13, color: "#1e3a8a", margin: "18px 0 8px", borderLeft: "4px solid #ea580c", paddingLeft: 10 }}>{children}</div>;
}
function CardHead({ children }) {
  return <div style={{ background: "#1e3a8a", color: "#fff", padding: "10px 16px", fontWeight: 700, fontSize: 13 }}>{children}</div>;
}
function THead({ cols }) {
  return (
    <thead>
      <tr style={{ background: "#1e3a8a", color: "#fff" }}>
        {cols.map(c => <th key={c} style={{ padding: "10px 12px", textAlign: "left", fontSize: 11, fontWeight: 700, whiteSpace: "nowrap" }}>{c}</th>)}
      </tr>
    </thead>
  );
}
function ActionBtn({ color, onClick, disabled, children, title }) {
  return (
    <button onClick={onClick} disabled={disabled} title={title}
      style={{ background: color, color: "#fff", border: "none", padding: "6px 10px", borderRadius: 5, cursor: "pointer", fontSize: 13, fontWeight: 700, opacity: disabled ? .6 : 1, minHeight: 36, minWidth: 36, whiteSpace: "nowrap" }}>
      {children}
    </button>
  );
}

/* ── Styles ── */
const S = {
  shell: { display: "flex", flexDirection: "column", minHeight: "100vh", fontFamily: "'Segoe UI', system-ui, sans-serif", fontSize: 13, background: "#f1f5f9" },
  topbar: { background: "linear-gradient(90deg,#1e3a8a 0%,#1e40af 100%)", color: "#fff", display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 16px", position: "sticky", top: 0, zIndex: 100, boxShadow: "0 2px 10px rgba(0,0,0,.3)" },
  logoBadge: { width: 38, height: 38, borderRadius: 10, background: "linear-gradient(135deg,#f97316,#ea580c)", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 900, fontSize: 17, color: "#fff" },
  superBadge: { background: "rgba(255,255,255,.15)", border: "1px solid rgba(255,255,255,.3)", borderRadius: 99, padding: "3px 12px", fontSize: 11, fontWeight: 700, color: "#fef3c7", letterSpacing: .5 },
  logoutBtn: { background: "rgba(239,68,68,.85)", border: "none", color: "#fff", padding: "6px 14px", borderRadius: 6, cursor: "pointer", fontWeight: 600, fontSize: 12, whiteSpace: "nowrap" },
  navItem: { color: "#bfdbfe", padding: "11px 16px", cursor: "pointer", display: "flex", alignItems: "center", fontSize: 13, borderBottom: "1px solid rgba(255,255,255,.06)", fontWeight: 500 },
  navActive: { background: "#ea580c", color: "#fff" },
  navSub: { color: "#93c5fd", padding: "9px 16px 9px 28px", cursor: "pointer", fontSize: 12, background: "rgba(0,0,0,.25)", borderBottom: "1px solid rgba(255,255,255,.04)" },
  navSubActive: { background: "#ea580c", color: "#fff", fontWeight: 700 },
  content: { flex: 1, padding: 16, overflowX: "hidden", minWidth: 0 },
  kpiCard: { color: "#fff", borderRadius: 10, padding: "12px 14px", display: "flex", flexDirection: "column", gap: 4, boxShadow: "0 2px 8px rgba(0,0,0,.15)" },
  card: { background: "#fff", border: "1px solid #e2e8f0", borderRadius: 8, overflow: "hidden", marginBottom: 16 },
  table: { width: "100%", borderCollapse: "collapse" },
  td: { padding: "9px 12px", fontSize: 12, borderBottom: "1px solid #f1f5f9", verticalAlign: "middle" },
  trEven: { background: "#f8fafc" },
  searchBox: { border: "1px solid #e2e8f0", borderRadius: 6, padding: "8px 12px", fontSize: 13, outline: "none", background: "#fff", width: "100%" },
  countBadge: { background: "#eff6ff", color: "#1d4ed8", padding: "5px 12px", borderRadius: 99, fontWeight: 700, fontSize: 12, whiteSpace: "nowrap" },
  pill: { background: "#eff6ff", color: "#1d4ed8", padding: "2px 8px", borderRadius: 99, fontSize: 11, fontWeight: 600 },
  greenBadge: { background: "#dcfce7", color: "#15803d", padding: "2px 8px", borderRadius: 99, fontSize: 11, fontWeight: 700 },
  yellowBadge: { background: "#fef9c3", color: "#854d0e", padding: "2px 8px", borderRadius: 99, fontSize: 11, fontWeight: 700 },
  redBadge: { background: "#fee2e2", color: "#991b1b", padding: "2px 8px", borderRadius: 99, fontSize: 11, fontWeight: 700 },
  badge: { padding: "2px 8px", borderRadius: 99, fontSize: 11, fontWeight: 600 },
  label: { display: "block", fontSize: 12, color: "#475569", marginBottom: 4, fontWeight: 600 },
  input: { border: "1px solid #e2e8f0", padding: "9px 12px", width: "100%", fontSize: 13, borderRadius: 6, outline: "none", boxSizing: "border-box" },
  btn: { color: "#fff", border: "none", padding: "7px 14px", borderRadius: 6, cursor: "pointer", fontWeight: 600, fontSize: 13, display: "inline-flex", alignItems: "center", gap: 4 },
  pgBtn: { background: "#f1f5f9", color: "#374151", border: "1px solid #e2e8f0", padding: "6px 12px", borderRadius: 6, cursor: "pointer", fontWeight: 500, fontSize: 12, display: "inline-flex", alignItems: "center", gap: 2, minHeight: 34, whiteSpace: "nowrap" },
};
